var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import React, { PureComponent, createElement, Component } from "react";
import "amazon-connect-streams";
import { c as commonjsGlobal } from "./lodash-CSqUlqk3.mjs";
import classNames from "classnames";
import "react-player";
import "react-spinners";
import Button from "./Button.mjs";
import "react-accessible-headings";
import Checkbox from "./Checkbox.mjs";
import { F as FormConsumer } from "./context-jqLAdImf.mjs";
import Form from "./Form.mjs";
import forwardRef$1 from "./Input.mjs";
import "./LexicalEditor.mjs";
import "react-redux";
import "lodash.debounce";
/* empty css                */
import "./Popup.mjs";
import ReactDatePicker from "./ReactDatePicker.mjs";
import Tooltip from "./Tooltip.mjs";
import TriggeredPopup from "./TriggeredPopup.mjs";
import "draft-js";
import "react-draft-wysiwyg";
/* empty css                       */
import SearchableDropdown from "./SearchableDropdown.mjs";
import Tag from "./Tag.mjs";
import ConditionalWrapper from "./ConditionalWrapper.mjs";
import { S as SUBMIT_KEYS } from "./index-BBDie59p.mjs";
var amazonConnectChat = {};
var hasRequiredAmazonConnectChat;
function requireAmazonConnectChat() {
  if (hasRequiredAmazonConnectChat)
    return amazonConnectChat;
  hasRequiredAmazonConnectChat = 1;
  (() => {
    var e = { 228: (e2, t2, n2) => {
      var r;
      !function e3(t3, n3, r2) {
        function i(s2, a) {
          if (!n3[s2]) {
            if (!t3[s2]) {
              if (o)
                return o(s2, true);
              var c = new Error("Cannot find module '" + s2 + "'");
              throw c.code = "MODULE_NOT_FOUND", c;
            }
            var u = n3[s2] = { exports: {} };
            t3[s2][0].call(u.exports, function(e4) {
              return i(t3[s2][1][e4] || e4);
            }, u, u.exports, e3, t3, n3, r2);
          }
          return n3[s2].exports;
        }
        for (var o = void 0, s = 0; s < r2.length; s++)
          i(r2[s]);
        return i;
      }({ 1: [function(e3, t3, n3) {
        t3.exports = { version: "2.0", metadata: { apiVersion: "2014-06-30", endpointPrefix: "cognito-identity", jsonVersion: "1.1", protocol: "json", serviceFullName: "Amazon Cognito Identity", serviceId: "Cognito Identity", signatureVersion: "v4", targetPrefix: "AWSCognitoIdentityService", uid: "cognito-identity-2014-06-30" }, operations: { CreateIdentityPool: { input: { type: "structure", required: ["IdentityPoolName", "AllowUnauthenticatedIdentities"], members: { IdentityPoolName: {}, AllowUnauthenticatedIdentities: { type: "boolean" }, AllowClassicFlow: { type: "boolean" }, SupportedLoginProviders: { shape: "S5" }, DeveloperProviderName: {}, OpenIdConnectProviderARNs: { shape: "S9" }, CognitoIdentityProviders: { shape: "Sb" }, SamlProviderARNs: { shape: "Sg" }, IdentityPoolTags: { shape: "Sh" } } }, output: { shape: "Sk" } }, DeleteIdentities: { input: { type: "structure", required: ["IdentityIdsToDelete"], members: { IdentityIdsToDelete: { type: "list", member: {} } } }, output: { type: "structure", members: { UnprocessedIdentityIds: { type: "list", member: { type: "structure", members: { IdentityId: {}, ErrorCode: {} } } } } } }, DeleteIdentityPool: { input: { type: "structure", required: ["IdentityPoolId"], members: { IdentityPoolId: {} } } }, DescribeIdentity: { input: { type: "structure", required: ["IdentityId"], members: { IdentityId: {} } }, output: { shape: "Sv" } }, DescribeIdentityPool: { input: { type: "structure", required: ["IdentityPoolId"], members: { IdentityPoolId: {} } }, output: { shape: "Sk" } }, GetCredentialsForIdentity: { input: { type: "structure", required: ["IdentityId"], members: { IdentityId: {}, Logins: { shape: "S10" }, CustomRoleArn: {} } }, output: { type: "structure", members: { IdentityId: {}, Credentials: { type: "structure", members: { AccessKeyId: {}, SecretKey: {}, SessionToken: {}, Expiration: { type: "timestamp" } } } } } }, GetId: { input: { type: "structure", required: ["IdentityPoolId"], members: { AccountId: {}, IdentityPoolId: {}, Logins: { shape: "S10" } } }, output: { type: "structure", members: { IdentityId: {} } } }, GetIdentityPoolRoles: { input: { type: "structure", required: ["IdentityPoolId"], members: { IdentityPoolId: {} } }, output: { type: "structure", members: { IdentityPoolId: {}, Roles: { shape: "S1c" }, RoleMappings: { shape: "S1e" } } } }, GetOpenIdToken: { input: { type: "structure", required: ["IdentityId"], members: { IdentityId: {}, Logins: { shape: "S10" } } }, output: { type: "structure", members: { IdentityId: {}, Token: {} } } }, GetOpenIdTokenForDeveloperIdentity: { input: { type: "structure", required: ["IdentityPoolId", "Logins"], members: { IdentityPoolId: {}, IdentityId: {}, Logins: { shape: "S10" }, TokenDuration: { type: "long" } } }, output: { type: "structure", members: { IdentityId: {}, Token: {} } } }, ListIdentities: { input: { type: "structure", required: ["IdentityPoolId", "MaxResults"], members: { IdentityPoolId: {}, MaxResults: { type: "integer" }, NextToken: {}, HideDisabled: { type: "boolean" } } }, output: { type: "structure", members: { IdentityPoolId: {}, Identities: { type: "list", member: { shape: "Sv" } }, NextToken: {} } } }, ListIdentityPools: { input: { type: "structure", required: ["MaxResults"], members: { MaxResults: { type: "integer" }, NextToken: {} } }, output: { type: "structure", members: { IdentityPools: { type: "list", member: { type: "structure", members: { IdentityPoolId: {}, IdentityPoolName: {} } } }, NextToken: {} } } }, ListTagsForResource: { input: { type: "structure", required: ["ResourceArn"], members: { ResourceArn: {} } }, output: { type: "structure", members: { Tags: { shape: "Sh" } } } }, LookupDeveloperIdentity: { input: { type: "structure", required: ["IdentityPoolId"], members: { IdentityPoolId: {}, IdentityId: {}, DeveloperUserIdentifier: {}, MaxResults: { type: "integer" }, NextToken: {} } }, output: { type: "structure", members: { IdentityId: {}, DeveloperUserIdentifierList: { type: "list", member: {} }, NextToken: {} } } }, MergeDeveloperIdentities: { input: { type: "structure", required: ["SourceUserIdentifier", "DestinationUserIdentifier", "DeveloperProviderName", "IdentityPoolId"], members: { SourceUserIdentifier: {}, DestinationUserIdentifier: {}, DeveloperProviderName: {}, IdentityPoolId: {} } }, output: { type: "structure", members: { IdentityId: {} } } }, SetIdentityPoolRoles: { input: { type: "structure", required: ["IdentityPoolId", "Roles"], members: { IdentityPoolId: {}, Roles: { shape: "S1c" }, RoleMappings: { shape: "S1e" } } } }, TagResource: { input: { type: "structure", required: ["ResourceArn", "Tags"], members: { ResourceArn: {}, Tags: { shape: "Sh" } } }, output: { type: "structure", members: {} } }, UnlinkDeveloperIdentity: { input: { type: "structure", required: ["IdentityId", "IdentityPoolId", "DeveloperProviderName", "DeveloperUserIdentifier"], members: { IdentityId: {}, IdentityPoolId: {}, DeveloperProviderName: {}, DeveloperUserIdentifier: {} } } }, UnlinkIdentity: { input: { type: "structure", required: ["IdentityId", "Logins", "LoginsToRemove"], members: { IdentityId: {}, Logins: { shape: "S10" }, LoginsToRemove: { shape: "Sw" } } } }, UntagResource: { input: { type: "structure", required: ["ResourceArn", "TagKeys"], members: { ResourceArn: {}, TagKeys: { type: "list", member: {} } } }, output: { type: "structure", members: {} } }, UpdateIdentityPool: { input: { shape: "Sk" }, output: { shape: "Sk" } } }, shapes: { S5: { type: "map", key: {}, value: {} }, S9: { type: "list", member: {} }, Sb: { type: "list", member: { type: "structure", members: { ProviderName: {}, ClientId: {}, ServerSideTokenCheck: { type: "boolean" } } } }, Sg: { type: "list", member: {} }, Sh: { type: "map", key: {}, value: {} }, Sk: { type: "structure", required: ["IdentityPoolId", "IdentityPoolName", "AllowUnauthenticatedIdentities"], members: { IdentityPoolId: {}, IdentityPoolName: {}, AllowUnauthenticatedIdentities: { type: "boolean" }, AllowClassicFlow: { type: "boolean" }, SupportedLoginProviders: { shape: "S5" }, DeveloperProviderName: {}, OpenIdConnectProviderARNs: { shape: "S9" }, CognitoIdentityProviders: { shape: "Sb" }, SamlProviderARNs: { shape: "Sg" }, IdentityPoolTags: { shape: "Sh" } } }, Sv: { type: "structure", members: { IdentityId: {}, Logins: { shape: "Sw" }, CreationDate: { type: "timestamp" }, LastModifiedDate: { type: "timestamp" } } }, Sw: { type: "list", member: {} }, S10: { type: "map", key: {}, value: {} }, S1c: { type: "map", key: {}, value: {} }, S1e: { type: "map", key: {}, value: { type: "structure", required: ["Type"], members: { Type: {}, AmbiguousRoleResolution: {}, RulesConfiguration: { type: "structure", required: ["Rules"], members: { Rules: { type: "list", member: { type: "structure", required: ["Claim", "MatchType", "Value", "RoleARN"], members: { Claim: {}, MatchType: {}, Value: {}, RoleARN: {} } } } } } } } } } };
      }, {}], 2: [function(e3, t3, n3) {
        t3.exports = { pagination: {} };
      }, {}], 3: [function(e3, t3, n3) {
        t3.exports = { version: "2.0", metadata: { apiVersion: "2018-09-07", endpointPrefix: "participant.connect", jsonVersion: "1.1", protocol: "rest-json", serviceAbbreviation: "Amazon Connect Participant", serviceFullName: "Amazon Connect Participant Service", serviceId: "ConnectParticipant", signatureVersion: "v4", signingName: "execute-api", uid: "connectparticipant-2018-09-07" }, operations: { CompleteAttachmentUpload: { http: { requestUri: "/participant/complete-attachment-upload" }, input: { type: "structure", required: ["AttachmentIds", "ClientToken", "ConnectionToken"], members: { AttachmentIds: { type: "list", member: {} }, ClientToken: { idempotencyToken: true }, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: {} } }, CreateParticipantConnection: { http: { requestUri: "/participant/connection" }, input: { type: "structure", required: ["ParticipantToken"], members: { Type: { type: "list", member: {} }, ParticipantToken: { location: "header", locationName: "X-Amz-Bearer" }, ConnectParticipant: { type: "boolean" } } }, output: { type: "structure", members: { Websocket: { type: "structure", members: { Url: {}, ConnectionExpiry: {} } }, ConnectionCredentials: { type: "structure", members: { ConnectionToken: {}, Expiry: {} } } } } }, DisconnectParticipant: { http: { requestUri: "/participant/disconnect" }, input: { type: "structure", required: ["ConnectionToken"], members: { ClientToken: { idempotencyToken: true }, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: {} } }, GetAttachment: { http: { requestUri: "/participant/attachment" }, input: { type: "structure", required: ["AttachmentId", "ConnectionToken"], members: { AttachmentId: {}, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: { Url: {}, UrlExpiry: {} } } }, GetTranscript: { http: { requestUri: "/participant/transcript" }, input: { type: "structure", required: ["ConnectionToken"], members: { ContactId: {}, MaxResults: { type: "integer" }, NextToken: {}, ScanDirection: {}, SortOrder: {}, StartPosition: { type: "structure", members: { Id: {}, AbsoluteTime: {}, MostRecent: { type: "integer" } } }, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: { InitialContactId: {}, Transcript: { type: "list", member: { type: "structure", members: { AbsoluteTime: {}, Content: {}, ContentType: {}, Id: {}, Type: {}, ParticipantId: {}, DisplayName: {}, ParticipantRole: {}, Attachments: { type: "list", member: { type: "structure", members: { ContentType: {}, AttachmentId: {}, AttachmentName: {}, Status: {} } } }, MessageMetadata: { type: "structure", members: { MessageId: {}, Receipts: { type: "list", member: { type: "structure", members: { DeliveredTimestamp: {}, ReadTimestamp: {}, RecipientParticipantId: {} } } } } } } } }, NextToken: {} } } }, SendEvent: { http: { requestUri: "/participant/event" }, input: { type: "structure", required: ["ContentType", "ConnectionToken"], members: { ContentType: {}, Content: {}, ClientToken: { idempotencyToken: true }, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: { Id: {}, AbsoluteTime: {} } } }, SendMessage: { http: { requestUri: "/participant/message" }, input: { type: "structure", required: ["ContentType", "Content", "ConnectionToken"], members: { ContentType: {}, Content: {}, ClientToken: { idempotencyToken: true }, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: { Id: {}, AbsoluteTime: {} } } }, StartAttachmentUpload: { http: { requestUri: "/participant/start-attachment-upload" }, input: { type: "structure", required: ["ContentType", "AttachmentSizeInBytes", "AttachmentName", "ClientToken", "ConnectionToken"], members: { ContentType: {}, AttachmentSizeInBytes: { type: "long" }, AttachmentName: {}, ClientToken: { idempotencyToken: true }, ConnectionToken: { location: "header", locationName: "X-Amz-Bearer" } } }, output: { type: "structure", members: { AttachmentId: {}, UploadMetadata: { type: "structure", members: { Url: {}, UrlExpiry: {}, HeadersToInclude: { type: "map", key: {}, value: {} } } } } } } }, shapes: {} };
      }, {}], 4: [function(e3, t3, n3) {
        t3.exports = { pagination: { GetTranscript: { input_token: "NextToken", output_token: "NextToken", limit_key: "MaxResults" } } };
      }, {}], 5: [function(e3, t3, n3) {
        t3.exports = { acm: { name: "ACM", cors: true }, apigateway: { name: "APIGateway", cors: true }, applicationautoscaling: { prefix: "application-autoscaling", name: "ApplicationAutoScaling", cors: true }, appstream: { name: "AppStream" }, autoscaling: { name: "AutoScaling", cors: true }, batch: { name: "Batch" }, budgets: { name: "Budgets" }, clouddirectory: { name: "CloudDirectory", versions: ["2016-05-10*"] }, cloudformation: { name: "CloudFormation", cors: true }, cloudfront: { name: "CloudFront", versions: ["2013-05-12*", "2013-11-11*", "2014-05-31*", "2014-10-21*", "2014-11-06*", "2015-04-17*", "2015-07-27*", "2015-09-17*", "2016-01-13*", "2016-01-28*", "2016-08-01*", "2016-08-20*", "2016-09-07*", "2016-09-29*", "2016-11-25*", "2017-03-25*", "2017-10-30*", "2018-06-18*", "2018-11-05*", "2019-03-26*"], cors: true }, cloudhsm: { name: "CloudHSM", cors: true }, cloudsearch: { name: "CloudSearch" }, cloudsearchdomain: { name: "CloudSearchDomain" }, cloudtrail: { name: "CloudTrail", cors: true }, cloudwatch: { prefix: "monitoring", name: "CloudWatch", cors: true }, cloudwatchevents: { prefix: "events", name: "CloudWatchEvents", versions: ["2014-02-03*"], cors: true }, cloudwatchlogs: { prefix: "logs", name: "CloudWatchLogs", cors: true }, codebuild: { name: "CodeBuild", cors: true }, codecommit: { name: "CodeCommit", cors: true }, codedeploy: { name: "CodeDeploy", cors: true }, codepipeline: { name: "CodePipeline", cors: true }, cognitoidentity: { prefix: "cognito-identity", name: "CognitoIdentity", cors: true }, cognitoidentityserviceprovider: { prefix: "cognito-idp", name: "CognitoIdentityServiceProvider", cors: true }, cognitosync: { prefix: "cognito-sync", name: "CognitoSync", cors: true }, configservice: { prefix: "config", name: "ConfigService", cors: true }, cur: { name: "CUR", cors: true }, datapipeline: { name: "DataPipeline" }, devicefarm: { name: "DeviceFarm", cors: true }, directconnect: { name: "DirectConnect", cors: true }, directoryservice: { prefix: "ds", name: "DirectoryService" }, discovery: { name: "Discovery" }, dms: { name: "DMS" }, dynamodb: { name: "DynamoDB", cors: true }, dynamodbstreams: { prefix: "streams.dynamodb", name: "DynamoDBStreams", cors: true }, ec2: { name: "EC2", versions: ["2013-06-15*", "2013-10-15*", "2014-02-01*", "2014-05-01*", "2014-06-15*", "2014-09-01*", "2014-10-01*", "2015-03-01*", "2015-04-15*", "2015-10-01*", "2016-04-01*", "2016-09-15*"], cors: true }, ecr: { name: "ECR", cors: true }, ecs: { name: "ECS", cors: true }, efs: { prefix: "elasticfilesystem", name: "EFS", cors: true }, elasticache: { name: "ElastiCache", versions: ["2012-11-15*", "2014-03-24*", "2014-07-15*", "2014-09-30*"], cors: true }, elasticbeanstalk: { name: "ElasticBeanstalk", cors: true }, elb: { prefix: "elasticloadbalancing", name: "ELB", cors: true }, elbv2: { prefix: "elasticloadbalancingv2", name: "ELBv2", cors: true }, emr: { prefix: "elasticmapreduce", name: "EMR", cors: true }, es: { name: "ES" }, elastictranscoder: { name: "ElasticTranscoder", cors: true }, firehose: { name: "Firehose", cors: true }, gamelift: { name: "GameLift", cors: true }, glacier: { name: "Glacier" }, health: { name: "Health" }, iam: { name: "IAM", cors: true }, importexport: { name: "ImportExport" }, inspector: { name: "Inspector", versions: ["2015-08-18*"], cors: true }, iot: { name: "Iot", cors: true }, iotdata: { prefix: "iot-data", name: "IotData", cors: true }, kinesis: { name: "Kinesis", cors: true }, kinesisanalytics: { name: "KinesisAnalytics" }, kms: { name: "KMS", cors: true }, lambda: { name: "Lambda", cors: true }, lexruntime: { prefix: "runtime.lex", name: "LexRuntime", cors: true }, lightsail: { name: "Lightsail" }, machinelearning: { name: "MachineLearning", cors: true }, marketplacecommerceanalytics: { name: "MarketplaceCommerceAnalytics", cors: true }, marketplacemetering: { prefix: "meteringmarketplace", name: "MarketplaceMetering" }, mturk: { prefix: "mturk-requester", name: "MTurk", cors: true }, mobileanalytics: { name: "MobileAnalytics", cors: true }, opsworks: { name: "OpsWorks", cors: true }, opsworkscm: { name: "OpsWorksCM" }, organizations: { name: "Organizations" }, pinpoint: { name: "Pinpoint" }, polly: { name: "Polly", cors: true }, rds: { name: "RDS", versions: ["2014-09-01*"], cors: true }, redshift: { name: "Redshift", cors: true }, rekognition: { name: "Rekognition", cors: true }, resourcegroupstaggingapi: { name: "ResourceGroupsTaggingAPI" }, route53: { name: "Route53", cors: true }, route53domains: { name: "Route53Domains", cors: true }, s3: { name: "S3", dualstackAvailable: true, cors: true }, s3control: { name: "S3Control", dualstackAvailable: true, xmlNoDefaultLists: true }, servicecatalog: { name: "ServiceCatalog", cors: true }, ses: { prefix: "email", name: "SES", cors: true }, shield: { name: "Shield" }, simpledb: { prefix: "sdb", name: "SimpleDB" }, sms: { name: "SMS" }, snowball: { name: "Snowball" }, sns: { name: "SNS", cors: true }, sqs: { name: "SQS", cors: true }, ssm: { name: "SSM", cors: true }, storagegateway: { name: "StorageGateway", cors: true }, stepfunctions: { prefix: "states", name: "StepFunctions" }, sts: { name: "STS", cors: true }, support: { name: "Support" }, swf: { name: "SWF" }, xray: { name: "XRay", cors: true }, waf: { name: "WAF", cors: true }, wafregional: { prefix: "waf-regional", name: "WAFRegional" }, workdocs: { name: "WorkDocs", cors: true }, workspaces: { name: "WorkSpaces" }, codestar: { name: "CodeStar" }, lexmodelbuildingservice: { prefix: "lex-models", name: "LexModelBuildingService", cors: true }, marketplaceentitlementservice: { prefix: "entitlement.marketplace", name: "MarketplaceEntitlementService" }, athena: { name: "Athena" }, greengrass: { name: "Greengrass" }, dax: { name: "DAX" }, migrationhub: { prefix: "AWSMigrationHub", name: "MigrationHub" }, cloudhsmv2: { name: "CloudHSMV2" }, glue: { name: "Glue" }, mobile: { name: "Mobile" }, pricing: { name: "Pricing", cors: true }, costexplorer: { prefix: "ce", name: "CostExplorer", cors: true }, mediaconvert: { name: "MediaConvert" }, medialive: { name: "MediaLive" }, mediapackage: { name: "MediaPackage" }, mediastore: { name: "MediaStore" }, mediastoredata: { prefix: "mediastore-data", name: "MediaStoreData", cors: true }, appsync: { name: "AppSync" }, guardduty: { name: "GuardDuty" }, mq: { name: "MQ" }, comprehend: { name: "Comprehend", cors: true }, iotjobsdataplane: { prefix: "iot-jobs-data", name: "IoTJobsDataPlane" }, kinesisvideoarchivedmedia: { prefix: "kinesis-video-archived-media", name: "KinesisVideoArchivedMedia", cors: true }, kinesisvideomedia: { prefix: "kinesis-video-media", name: "KinesisVideoMedia", cors: true }, kinesisvideo: { name: "KinesisVideo", cors: true }, sagemakerruntime: { prefix: "runtime.sagemaker", name: "SageMakerRuntime" }, sagemaker: { name: "SageMaker" }, translate: { name: "Translate", cors: true }, resourcegroups: { prefix: "resource-groups", name: "ResourceGroups", cors: true }, alexaforbusiness: { name: "AlexaForBusiness" }, cloud9: { name: "Cloud9" }, serverlessapplicationrepository: { prefix: "serverlessrepo", name: "ServerlessApplicationRepository" }, servicediscovery: { name: "ServiceDiscovery" }, workmail: { name: "WorkMail" }, autoscalingplans: { prefix: "autoscaling-plans", name: "AutoScalingPlans" }, transcribeservice: { prefix: "transcribe", name: "TranscribeService" }, connect: { name: "Connect", cors: true }, acmpca: { prefix: "acm-pca", name: "ACMPCA" }, fms: { name: "FMS" }, secretsmanager: { name: "SecretsManager", cors: true }, iotanalytics: { name: "IoTAnalytics", cors: true }, iot1clickdevicesservice: { prefix: "iot1click-devices", name: "IoT1ClickDevicesService" }, iot1clickprojects: { prefix: "iot1click-projects", name: "IoT1ClickProjects" }, pi: { name: "PI" }, neptune: { name: "Neptune" }, mediatailor: { name: "MediaTailor" }, eks: { name: "EKS" }, macie: { name: "Macie" }, dlm: { name: "DLM" }, signer: { name: "Signer" }, chime: { name: "Chime" }, pinpointemail: { prefix: "pinpoint-email", name: "PinpointEmail" }, ram: { name: "RAM" }, route53resolver: { name: "Route53Resolver" }, pinpointsmsvoice: { prefix: "sms-voice", name: "PinpointSMSVoice" }, quicksight: { name: "QuickSight" }, rdsdataservice: { prefix: "rds-data", name: "RDSDataService" }, amplify: { name: "Amplify" }, datasync: { name: "DataSync" }, robomaker: { name: "RoboMaker" }, transfer: { name: "Transfer" }, globalaccelerator: { name: "GlobalAccelerator" }, comprehendmedical: { name: "ComprehendMedical", cors: true }, kinesisanalyticsv2: { name: "KinesisAnalyticsV2" }, mediaconnect: { name: "MediaConnect" }, fsx: { name: "FSx" }, securityhub: { name: "SecurityHub" }, appmesh: { name: "AppMesh", versions: ["2018-10-01*"] }, licensemanager: { prefix: "license-manager", name: "LicenseManager" }, kafka: { name: "Kafka" }, apigatewaymanagementapi: { name: "ApiGatewayManagementApi" }, apigatewayv2: { name: "ApiGatewayV2" }, docdb: { name: "DocDB" }, backup: { name: "Backup" }, worklink: { name: "WorkLink" }, textract: { name: "Textract" }, managedblockchain: { name: "ManagedBlockchain" }, mediapackagevod: { prefix: "mediapackage-vod", name: "MediaPackageVod" }, groundstation: { name: "GroundStation" }, iotthingsgraph: { name: "IoTThingsGraph" }, iotevents: { name: "IoTEvents" }, ioteventsdata: { prefix: "iotevents-data", name: "IoTEventsData" }, personalize: { name: "Personalize", cors: true }, personalizeevents: { prefix: "personalize-events", name: "PersonalizeEvents", cors: true }, personalizeruntime: { prefix: "personalize-runtime", name: "PersonalizeRuntime", cors: true }, applicationinsights: { prefix: "application-insights", name: "ApplicationInsights" }, servicequotas: { prefix: "service-quotas", name: "ServiceQuotas" }, ec2instanceconnect: { prefix: "ec2-instance-connect", name: "EC2InstanceConnect" }, eventbridge: { name: "EventBridge" }, lakeformation: { name: "LakeFormation" }, forecastservice: { prefix: "forecast", name: "ForecastService", cors: true }, forecastqueryservice: { prefix: "forecastquery", name: "ForecastQueryService", cors: true }, qldb: { name: "QLDB" }, qldbsession: { prefix: "qldb-session", name: "QLDBSession" }, workmailmessageflow: { name: "WorkMailMessageFlow" }, codestarnotifications: { prefix: "codestar-notifications", name: "CodeStarNotifications" }, savingsplans: { name: "SavingsPlans" }, sso: { name: "SSO" }, ssooidc: { prefix: "sso-oidc", name: "SSOOIDC" }, marketplacecatalog: { prefix: "marketplace-catalog", name: "MarketplaceCatalog" }, dataexchange: { name: "DataExchange" }, sesv2: { name: "SESV2" }, migrationhubconfig: { prefix: "migrationhub-config", name: "MigrationHubConfig" }, connectparticipant: { name: "ConnectParticipant" }, appconfig: { name: "AppConfig" }, iotsecuretunneling: { name: "IoTSecureTunneling" }, wafv2: { name: "WAFV2" }, elasticinference: { prefix: "elastic-inference", name: "ElasticInference" }, imagebuilder: { name: "Imagebuilder" }, schemas: { name: "Schemas" }, accessanalyzer: { name: "AccessAnalyzer" }, codegurureviewer: { prefix: "codeguru-reviewer", name: "CodeGuruReviewer" }, codeguruprofiler: { name: "CodeGuruProfiler" }, computeoptimizer: { prefix: "compute-optimizer", name: "ComputeOptimizer" }, frauddetector: { name: "FraudDetector" }, kendra: { name: "Kendra" }, networkmanager: { name: "NetworkManager" }, outposts: { name: "Outposts" }, augmentedairuntime: { prefix: "sagemaker-a2i-runtime", name: "AugmentedAIRuntime" }, ebs: { name: "EBS" }, kinesisvideosignalingchannels: { prefix: "kinesis-video-signaling", name: "KinesisVideoSignalingChannels", cors: true }, detective: { name: "Detective" }, codestarconnections: { prefix: "codestar-connections", name: "CodeStarconnections" }, synthetics: { name: "Synthetics" }, iotsitewise: { name: "IoTSiteWise" }, macie2: { name: "Macie2" }, codeartifact: { name: "CodeArtifact" }, honeycode: { name: "Honeycode" }, ivs: { name: "IVS" }, braket: { name: "Braket" }, identitystore: { name: "IdentityStore" }, appflow: { name: "Appflow" }, redshiftdata: { prefix: "redshift-data", name: "RedshiftData" }, ssoadmin: { prefix: "sso-admin", name: "SSOAdmin" }, timestreamquery: { prefix: "timestream-query", name: "TimestreamQuery" }, timestreamwrite: { prefix: "timestream-write", name: "TimestreamWrite" }, s3outposts: { name: "S3Outposts" } };
      }, {}], 6: [function(e3, t3, n3) {
        t3.exports = { version: "2.0", metadata: { apiVersion: "2011-06-15", endpointPrefix: "sts", globalEndpoint: "sts.amazonaws.com", protocol: "query", serviceAbbreviation: "AWS STS", serviceFullName: "AWS Security Token Service", serviceId: "STS", signatureVersion: "v4", uid: "sts-2011-06-15", xmlNamespace: "https://sts.amazonaws.com/doc/2011-06-15/" }, operations: { AssumeRole: { input: { type: "structure", required: ["RoleArn", "RoleSessionName"], members: { RoleArn: {}, RoleSessionName: {}, PolicyArns: { shape: "S4" }, Policy: {}, DurationSeconds: { type: "integer" }, Tags: { shape: "S8" }, TransitiveTagKeys: { type: "list", member: {} }, ExternalId: {}, SerialNumber: {}, TokenCode: {} } }, output: { resultWrapper: "AssumeRoleResult", type: "structure", members: { Credentials: { shape: "Sh" }, AssumedRoleUser: { shape: "Sm" }, PackedPolicySize: { type: "integer" } } } }, AssumeRoleWithSAML: { input: { type: "structure", required: ["RoleArn", "PrincipalArn", "SAMLAssertion"], members: { RoleArn: {}, PrincipalArn: {}, SAMLAssertion: {}, PolicyArns: { shape: "S4" }, Policy: {}, DurationSeconds: { type: "integer" } } }, output: { resultWrapper: "AssumeRoleWithSAMLResult", type: "structure", members: { Credentials: { shape: "Sh" }, AssumedRoleUser: { shape: "Sm" }, PackedPolicySize: { type: "integer" }, Subject: {}, SubjectType: {}, Issuer: {}, Audience: {}, NameQualifier: {} } } }, AssumeRoleWithWebIdentity: { input: { type: "structure", required: ["RoleArn", "RoleSessionName", "WebIdentityToken"], members: { RoleArn: {}, RoleSessionName: {}, WebIdentityToken: {}, ProviderId: {}, PolicyArns: { shape: "S4" }, Policy: {}, DurationSeconds: { type: "integer" } } }, output: { resultWrapper: "AssumeRoleWithWebIdentityResult", type: "structure", members: { Credentials: { shape: "Sh" }, SubjectFromWebIdentityToken: {}, AssumedRoleUser: { shape: "Sm" }, PackedPolicySize: { type: "integer" }, Provider: {}, Audience: {} } } }, DecodeAuthorizationMessage: { input: { type: "structure", required: ["EncodedMessage"], members: { EncodedMessage: {} } }, output: { resultWrapper: "DecodeAuthorizationMessageResult", type: "structure", members: { DecodedMessage: {} } } }, GetAccessKeyInfo: { input: { type: "structure", required: ["AccessKeyId"], members: { AccessKeyId: {} } }, output: { resultWrapper: "GetAccessKeyInfoResult", type: "structure", members: { Account: {} } } }, GetCallerIdentity: { input: { type: "structure", members: {} }, output: { resultWrapper: "GetCallerIdentityResult", type: "structure", members: { UserId: {}, Account: {}, Arn: {} } } }, GetFederationToken: { input: { type: "structure", required: ["Name"], members: { Name: {}, Policy: {}, PolicyArns: { shape: "S4" }, DurationSeconds: { type: "integer" }, Tags: { shape: "S8" } } }, output: { resultWrapper: "GetFederationTokenResult", type: "structure", members: { Credentials: { shape: "Sh" }, FederatedUser: { type: "structure", required: ["FederatedUserId", "Arn"], members: { FederatedUserId: {}, Arn: {} } }, PackedPolicySize: { type: "integer" } } } }, GetSessionToken: { input: { type: "structure", members: { DurationSeconds: { type: "integer" }, SerialNumber: {}, TokenCode: {} } }, output: { resultWrapper: "GetSessionTokenResult", type: "structure", members: { Credentials: { shape: "Sh" } } } } }, shapes: { S4: { type: "list", member: { type: "structure", members: { arn: {} } } }, S8: { type: "list", member: { type: "structure", required: ["Key", "Value"], members: { Key: {}, Value: {} } } }, Sh: { type: "structure", required: ["AccessKeyId", "SecretAccessKey", "SessionToken", "Expiration"], members: { AccessKeyId: {}, SecretAccessKey: {}, SessionToken: {}, Expiration: { type: "timestamp" } } }, Sm: { type: "structure", required: ["AssumedRoleId", "Arn"], members: { AssumedRoleId: {}, Arn: {} } } } };
      }, {}], 7: [function(e3, t3, n3) {
        arguments[4][2][0].apply(n3, arguments);
      }, { dup: 2 }], 8: [function(e3, t3, n3) {
        e3("../lib/node_loader");
        var r2 = e3("../lib/core"), i = r2.Service, o = r2.apiLoader;
        o.services.cognitoidentity = {}, r2.CognitoIdentity = i.defineService("cognitoidentity", ["2014-06-30"]), e3("../lib/services/cognitoidentity"), Object.defineProperty(o.services.cognitoidentity, "2014-06-30", { get: function() {
          var t4 = e3("../apis/cognito-identity-2014-06-30.min.json");
          return t4.paginators = e3("../apis/cognito-identity-2014-06-30.paginators.json").pagination, t4;
        }, enumerable: true, configurable: true }), t3.exports = r2.CognitoIdentity;
      }, { "../apis/cognito-identity-2014-06-30.min.json": 1, "../apis/cognito-identity-2014-06-30.paginators.json": 2, "../lib/core": 20, "../lib/node_loader": 17, "../lib/services/cognitoidentity": 62 }], 9: [function(e3, t3, n3) {
        e3("../lib/node_loader");
        var r2 = e3("../lib/core"), i = r2.Service, o = r2.apiLoader;
        o.services.sts = {}, r2.STS = i.defineService("sts", ["2011-06-15"]), e3("../lib/services/sts"), Object.defineProperty(o.services.sts, "2011-06-15", { get: function() {
          var t4 = e3("../apis/sts-2011-06-15.min.json");
          return t4.paginators = e3("../apis/sts-2011-06-15.paginators.json").pagination, t4;
        }, enumerable: true, configurable: true }), t3.exports = r2.STS;
      }, { "../apis/sts-2011-06-15.min.json": 6, "../apis/sts-2011-06-15.paginators.json": 7, "../lib/core": 20, "../lib/node_loader": 17, "../lib/services/sts": 63 }], 10: [function(e3, t3, n3) {
        function r2(e4, t4) {
          if (!r2.services.hasOwnProperty(e4))
            throw new Error("InvalidService: Failed to load api for " + e4);
          return r2.services[e4][t4];
        }
        r2.services = {}, t3.exports = r2;
      }, {}], 11: [function(e3, t3, n3) {
        var r2 = e3("./browserHmac"), i = e3("./browserMd5"), o = e3("./browserSha1"), s = e3("./browserSha256");
        t3.exports = { createHash: function(e4) {
          if ("md5" === (e4 = e4.toLowerCase()))
            return new i();
          if ("sha256" === e4)
            return new s();
          if ("sha1" === e4)
            return new o();
          throw new Error("Hash algorithm " + e4 + " is not supported in the browser SDK");
        }, createHmac: function(e4, t4) {
          if ("md5" === (e4 = e4.toLowerCase()))
            return new r2(i, t4);
          if ("sha256" === e4)
            return new r2(s, t4);
          if ("sha1" === e4)
            return new r2(o, t4);
          throw new Error("HMAC algorithm " + e4 + " is not supported in the browser SDK");
        }, createSign: function() {
          throw new Error("createSign is not implemented in the browser");
        } };
      }, { "./browserHmac": 13, "./browserMd5": 14, "./browserSha1": 15, "./browserSha256": 16 }], 12: [function(e3, t3, n3) {
        var r2 = e3("buffer/").Buffer;
        "undefined" != typeof ArrayBuffer && void 0 === ArrayBuffer.isView && (ArrayBuffer.isView = function(e4) {
          return i.indexOf(Object.prototype.toString.call(e4)) > -1;
        });
        var i = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]", "[object DataView]"];
        t3.exports = { isEmptyData: function(e4) {
          return "string" == typeof e4 ? 0 === e4.length : 0 === e4.byteLength;
        }, convertToBuffer: function(e4) {
          return "string" == typeof e4 && (e4 = new r2(e4, "utf8")), ArrayBuffer.isView(e4) ? new Uint8Array(e4.buffer, e4.byteOffset, e4.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e4);
        } };
      }, { "buffer/": 82 }], 13: [function(e3, t3, n3) {
        function r2(e4, t4) {
          this.hash = new e4(), this.outer = new e4();
          var n4 = i(e4, t4), r3 = new Uint8Array(e4.BLOCK_SIZE);
          r3.set(n4);
          for (var o2 = 0; o2 < e4.BLOCK_SIZE; o2++)
            n4[o2] ^= 54, r3[o2] ^= 92;
          for (this.hash.update(n4), this.outer.update(r3), o2 = 0; o2 < n4.byteLength; o2++)
            n4[o2] = 0;
        }
        function i(e4, t4) {
          var n4 = o.convertToBuffer(t4);
          if (n4.byteLength > e4.BLOCK_SIZE) {
            var r3 = new e4();
            r3.update(n4), n4 = r3.digest();
          }
          var i2 = new Uint8Array(e4.BLOCK_SIZE);
          return i2.set(n4), i2;
        }
        var o = e3("./browserHashUtils");
        t3.exports = r2, r2.prototype.update = function(e4) {
          if (o.isEmptyData(e4) || this.error)
            return this;
          try {
            this.hash.update(o.convertToBuffer(e4));
          } catch (e5) {
            this.error = e5;
          }
          return this;
        }, r2.prototype.digest = function(e4) {
          return this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest(e4);
        };
      }, { "./browserHashUtils": 12 }], 14: [function(e3, t3, n3) {
        function r2() {
          this.state = [1732584193, 4023233417, 2562383102, 271733878], this.buffer = new DataView(new ArrayBuffer(p)), this.bufferLength = 0, this.bytesHashed = 0, this.finished = false;
        }
        function i(e4, t4, n4, r3, i2, o2) {
          return ((t4 = (t4 + e4 & 4294967295) + (r3 + o2 & 4294967295) & 4294967295) << i2 | t4 >>> 32 - i2) + n4 & 4294967295;
        }
        function o(e4, t4, n4, r3, o2, s2, a2) {
          return i(t4 & n4 | ~t4 & r3, e4, t4, o2, s2, a2);
        }
        function s(e4, t4, n4, r3, o2, s2, a2) {
          return i(t4 & r3 | n4 & ~r3, e4, t4, o2, s2, a2);
        }
        function a(e4, t4, n4, r3, o2, s2, a2) {
          return i(t4 ^ n4 ^ r3, e4, t4, o2, s2, a2);
        }
        function c(e4, t4, n4, r3, o2, s2, a2) {
          return i(n4 ^ (t4 | ~r3), e4, t4, o2, s2, a2);
        }
        var u = e3("./browserHashUtils"), l = e3("buffer/").Buffer, p = 64;
        t3.exports = r2, r2.BLOCK_SIZE = p, r2.prototype.update = function(e4) {
          if (u.isEmptyData(e4))
            return this;
          if (this.finished)
            throw new Error("Attempted to update an already finished hash.");
          var t4 = u.convertToBuffer(e4), n4 = 0, r3 = t4.byteLength;
          for (this.bytesHashed += r3; r3 > 0; )
            this.buffer.setUint8(this.bufferLength++, t4[n4++]), r3--, this.bufferLength === p && (this.hashBuffer(), this.bufferLength = 0);
          return this;
        }, r2.prototype.digest = function(e4) {
          if (!this.finished) {
            var t4 = this, n4 = t4.buffer, r3 = t4.bufferLength, i2 = 8 * t4.bytesHashed;
            if (n4.setUint8(this.bufferLength++, 128), r3 % p >= p - 8) {
              for (var o2 = this.bufferLength; o2 < p; o2++)
                n4.setUint8(o2, 0);
              this.hashBuffer(), this.bufferLength = 0;
            }
            for (o2 = this.bufferLength; o2 < p - 8; o2++)
              n4.setUint8(o2, 0);
            n4.setUint32(p - 8, i2 >>> 0, true), n4.setUint32(p - 4, Math.floor(i2 / 4294967296), true), this.hashBuffer(), this.finished = true;
          }
          var s2 = new DataView(new ArrayBuffer(16));
          for (o2 = 0; o2 < 4; o2++)
            s2.setUint32(4 * o2, this.state[o2], true);
          var a2 = new l(s2.buffer, s2.byteOffset, s2.byteLength);
          return e4 ? a2.toString(e4) : a2;
        }, r2.prototype.hashBuffer = function() {
          var e4 = this.buffer, t4 = this.state, n4 = t4[0], r3 = t4[1], i2 = t4[2], u2 = t4[3];
          n4 = o(n4, r3, i2, u2, e4.getUint32(0, true), 7, 3614090360), u2 = o(u2, n4, r3, i2, e4.getUint32(4, true), 12, 3905402710), i2 = o(i2, u2, n4, r3, e4.getUint32(8, true), 17, 606105819), r3 = o(r3, i2, u2, n4, e4.getUint32(12, true), 22, 3250441966), n4 = o(n4, r3, i2, u2, e4.getUint32(16, true), 7, 4118548399), u2 = o(u2, n4, r3, i2, e4.getUint32(20, true), 12, 1200080426), i2 = o(i2, u2, n4, r3, e4.getUint32(24, true), 17, 2821735955), r3 = o(r3, i2, u2, n4, e4.getUint32(28, true), 22, 4249261313), n4 = o(n4, r3, i2, u2, e4.getUint32(32, true), 7, 1770035416), u2 = o(u2, n4, r3, i2, e4.getUint32(36, true), 12, 2336552879), i2 = o(i2, u2, n4, r3, e4.getUint32(40, true), 17, 4294925233), r3 = o(r3, i2, u2, n4, e4.getUint32(44, true), 22, 2304563134), n4 = o(n4, r3, i2, u2, e4.getUint32(48, true), 7, 1804603682), u2 = o(u2, n4, r3, i2, e4.getUint32(52, true), 12, 4254626195), i2 = o(i2, u2, n4, r3, e4.getUint32(56, true), 17, 2792965006), n4 = s(n4, r3 = o(r3, i2, u2, n4, e4.getUint32(60, true), 22, 1236535329), i2, u2, e4.getUint32(4, true), 5, 4129170786), u2 = s(u2, n4, r3, i2, e4.getUint32(24, true), 9, 3225465664), i2 = s(i2, u2, n4, r3, e4.getUint32(44, true), 14, 643717713), r3 = s(r3, i2, u2, n4, e4.getUint32(0, true), 20, 3921069994), n4 = s(n4, r3, i2, u2, e4.getUint32(20, true), 5, 3593408605), u2 = s(u2, n4, r3, i2, e4.getUint32(40, true), 9, 38016083), i2 = s(i2, u2, n4, r3, e4.getUint32(60, true), 14, 3634488961), r3 = s(r3, i2, u2, n4, e4.getUint32(16, true), 20, 3889429448), n4 = s(n4, r3, i2, u2, e4.getUint32(36, true), 5, 568446438), u2 = s(u2, n4, r3, i2, e4.getUint32(56, true), 9, 3275163606), i2 = s(i2, u2, n4, r3, e4.getUint32(12, true), 14, 4107603335), r3 = s(r3, i2, u2, n4, e4.getUint32(32, true), 20, 1163531501), n4 = s(n4, r3, i2, u2, e4.getUint32(52, true), 5, 2850285829), u2 = s(u2, n4, r3, i2, e4.getUint32(8, true), 9, 4243563512), i2 = s(i2, u2, n4, r3, e4.getUint32(28, true), 14, 1735328473), n4 = a(n4, r3 = s(r3, i2, u2, n4, e4.getUint32(48, true), 20, 2368359562), i2, u2, e4.getUint32(20, true), 4, 4294588738), u2 = a(u2, n4, r3, i2, e4.getUint32(32, true), 11, 2272392833), i2 = a(i2, u2, n4, r3, e4.getUint32(44, true), 16, 1839030562), r3 = a(r3, i2, u2, n4, e4.getUint32(56, true), 23, 4259657740), n4 = a(n4, r3, i2, u2, e4.getUint32(4, true), 4, 2763975236), u2 = a(u2, n4, r3, i2, e4.getUint32(16, true), 11, 1272893353), i2 = a(i2, u2, n4, r3, e4.getUint32(28, true), 16, 4139469664), r3 = a(r3, i2, u2, n4, e4.getUint32(40, true), 23, 3200236656), n4 = a(n4, r3, i2, u2, e4.getUint32(52, true), 4, 681279174), u2 = a(u2, n4, r3, i2, e4.getUint32(0, true), 11, 3936430074), i2 = a(i2, u2, n4, r3, e4.getUint32(12, true), 16, 3572445317), r3 = a(r3, i2, u2, n4, e4.getUint32(24, true), 23, 76029189), n4 = a(n4, r3, i2, u2, e4.getUint32(36, true), 4, 3654602809), u2 = a(u2, n4, r3, i2, e4.getUint32(48, true), 11, 3873151461), i2 = a(i2, u2, n4, r3, e4.getUint32(60, true), 16, 530742520), n4 = c(n4, r3 = a(r3, i2, u2, n4, e4.getUint32(8, true), 23, 3299628645), i2, u2, e4.getUint32(0, true), 6, 4096336452), u2 = c(u2, n4, r3, i2, e4.getUint32(28, true), 10, 1126891415), i2 = c(i2, u2, n4, r3, e4.getUint32(56, true), 15, 2878612391), r3 = c(r3, i2, u2, n4, e4.getUint32(20, true), 21, 4237533241), n4 = c(n4, r3, i2, u2, e4.getUint32(48, true), 6, 1700485571), u2 = c(u2, n4, r3, i2, e4.getUint32(12, true), 10, 2399980690), i2 = c(i2, u2, n4, r3, e4.getUint32(40, true), 15, 4293915773), r3 = c(r3, i2, u2, n4, e4.getUint32(4, true), 21, 2240044497), n4 = c(n4, r3, i2, u2, e4.getUint32(32, true), 6, 1873313359), u2 = c(u2, n4, r3, i2, e4.getUint32(60, true), 10, 4264355552), i2 = c(i2, u2, n4, r3, e4.getUint32(24, true), 15, 2734768916), r3 = c(r3, i2, u2, n4, e4.getUint32(52, true), 21, 1309151649), n4 = c(n4, r3, i2, u2, e4.getUint32(16, true), 6, 4149444226), u2 = c(u2, n4, r3, i2, e4.getUint32(44, true), 10, 3174756917), i2 = c(i2, u2, n4, r3, e4.getUint32(8, true), 15, 718787259), r3 = c(r3, i2, u2, n4, e4.getUint32(36, true), 21, 3951481745), t4[0] = n4 + t4[0] & 4294967295, t4[1] = r3 + t4[1] & 4294967295, t4[2] = i2 + t4[2] & 4294967295, t4[3] = u2 + t4[3] & 4294967295;
        };
      }, { "./browserHashUtils": 12, "buffer/": 82 }], 15: [function(e3, t3, n3) {
        function r2() {
          this.h0 = 1732584193, this.h1 = 4023233417, this.h2 = 2562383102, this.h3 = 271733878, this.h4 = 3285377520, this.block = new Uint32Array(80), this.offset = 0, this.shift = 24, this.totalLength = 0;
        }
        var i = e3("buffer/").Buffer, o = e3("./browserHashUtils");
        t3.exports = r2, r2.BLOCK_SIZE = 64, r2.prototype.update = function(e4) {
          if (this.finished)
            throw new Error("Attempted to update an already finished hash.");
          if (o.isEmptyData(e4))
            return this;
          var t4 = (e4 = o.convertToBuffer(e4)).length;
          this.totalLength += 8 * t4;
          for (var n4 = 0; n4 < t4; n4++)
            this.write(e4[n4]);
          return this;
        }, r2.prototype.write = function(e4) {
          this.block[this.offset] |= (255 & e4) << this.shift, this.shift ? this.shift -= 8 : (this.offset++, this.shift = 24), 16 === this.offset && this.processBlock();
        }, r2.prototype.digest = function(e4) {
          this.write(128), (this.offset > 14 || 14 === this.offset && this.shift < 24) && this.processBlock(), this.offset = 14, this.shift = 24, this.write(0), this.write(0), this.write(this.totalLength > 1099511627775 ? this.totalLength / 1099511627776 : 0), this.write(this.totalLength > 4294967295 ? this.totalLength / 4294967296 : 0);
          for (var t4 = 24; t4 >= 0; t4 -= 8)
            this.write(this.totalLength >> t4);
          var n4 = new i(20), r3 = new DataView(n4.buffer);
          return r3.setUint32(0, this.h0, false), r3.setUint32(4, this.h1, false), r3.setUint32(8, this.h2, false), r3.setUint32(12, this.h3, false), r3.setUint32(16, this.h4, false), e4 ? n4.toString(e4) : n4;
        }, r2.prototype.processBlock = function() {
          for (var e4 = 16; e4 < 80; e4++) {
            var t4 = this.block[e4 - 3] ^ this.block[e4 - 8] ^ this.block[e4 - 14] ^ this.block[e4 - 16];
            this.block[e4] = t4 << 1 | t4 >>> 31;
          }
          var n4, r3, i2 = this.h0, o2 = this.h1, s = this.h2, a = this.h3, c = this.h4;
          for (e4 = 0; e4 < 80; e4++) {
            e4 < 20 ? (n4 = a ^ o2 & (s ^ a), r3 = 1518500249) : e4 < 40 ? (n4 = o2 ^ s ^ a, r3 = 1859775393) : e4 < 60 ? (n4 = o2 & s | a & (o2 | s), r3 = 2400959708) : (n4 = o2 ^ s ^ a, r3 = 3395469782);
            var u = (i2 << 5 | i2 >>> 27) + n4 + c + r3 + (0 | this.block[e4]);
            c = a, a = s, s = o2 << 30 | o2 >>> 2, o2 = i2, i2 = u;
          }
          for (this.h0 = this.h0 + i2 | 0, this.h1 = this.h1 + o2 | 0, this.h2 = this.h2 + s | 0, this.h3 = this.h3 + a | 0, this.h4 = this.h4 + c | 0, this.offset = 0, e4 = 0; e4 < 16; e4++)
            this.block[e4] = 0;
        };
      }, { "./browserHashUtils": 12, "buffer/": 82 }], 16: [function(e3, t3, n3) {
        function r2() {
          this.state = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = false;
        }
        var i = e3("buffer/").Buffer, o = e3("./browserHashUtils"), s = new Uint32Array([1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]), a = Math.pow(2, 53) - 1;
        t3.exports = r2, r2.BLOCK_SIZE = 64, r2.prototype.update = function(e4) {
          if (this.finished)
            throw new Error("Attempted to update an already finished hash.");
          if (o.isEmptyData(e4))
            return this;
          var t4 = 0, n4 = (e4 = o.convertToBuffer(e4)).byteLength;
          if (this.bytesHashed += n4, 8 * this.bytesHashed > a)
            throw new Error("Cannot hash more than 2^53 - 1 bits");
          for (; n4 > 0; )
            this.buffer[this.bufferLength++] = e4[t4++], n4--, 64 === this.bufferLength && (this.hashBuffer(), this.bufferLength = 0);
          return this;
        }, r2.prototype.digest = function(e4) {
          if (!this.finished) {
            var t4 = 8 * this.bytesHashed, n4 = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), r3 = this.bufferLength;
            if (n4.setUint8(this.bufferLength++, 128), r3 % 64 >= 56) {
              for (var o2 = this.bufferLength; o2 < 64; o2++)
                n4.setUint8(o2, 0);
              this.hashBuffer(), this.bufferLength = 0;
            }
            for (o2 = this.bufferLength; o2 < 56; o2++)
              n4.setUint8(o2, 0);
            n4.setUint32(56, Math.floor(t4 / 4294967296), true), n4.setUint32(60, t4), this.hashBuffer(), this.finished = true;
          }
          var s2 = new i(32);
          for (o2 = 0; o2 < 8; o2++)
            s2[4 * o2] = this.state[o2] >>> 24 & 255, s2[4 * o2 + 1] = this.state[o2] >>> 16 & 255, s2[4 * o2 + 2] = this.state[o2] >>> 8 & 255, s2[4 * o2 + 3] = this.state[o2] >>> 0 & 255;
          return e4 ? s2.toString(e4) : s2;
        }, r2.prototype.hashBuffer = function() {
          for (var e4 = this.buffer, t4 = this.state, n4 = t4[0], r3 = t4[1], i2 = t4[2], o2 = t4[3], a2 = t4[4], c = t4[5], u = t4[6], l = t4[7], p = 0; p < 64; p++) {
            if (p < 16)
              this.temp[p] = (255 & e4[4 * p]) << 24 | (255 & e4[4 * p + 1]) << 16 | (255 & e4[4 * p + 2]) << 8 | 255 & e4[4 * p + 3];
            else {
              var d = this.temp[p - 2], h = (d >>> 17 | d << 15) ^ (d >>> 19 | d << 13) ^ d >>> 10, f = ((d = this.temp[p - 15]) >>> 7 | d << 25) ^ (d >>> 18 | d << 14) ^ d >>> 3;
              this.temp[p] = (h + this.temp[p - 7] | 0) + (f + this.temp[p - 16] | 0);
            }
            var m = (((a2 >>> 6 | a2 << 26) ^ (a2 >>> 11 | a2 << 21) ^ (a2 >>> 25 | a2 << 7)) + (a2 & c ^ ~a2 & u) | 0) + (l + (s[p] + this.temp[p] | 0) | 0) | 0, g = ((n4 >>> 2 | n4 << 30) ^ (n4 >>> 13 | n4 << 19) ^ (n4 >>> 22 | n4 << 10)) + (n4 & r3 ^ n4 & i2 ^ r3 & i2) | 0;
            l = u, u = c, c = a2, a2 = o2 + m | 0, o2 = i2, i2 = r3, r3 = n4, n4 = m + g | 0;
          }
          t4[0] += n4, t4[1] += r3, t4[2] += i2, t4[3] += o2, t4[4] += a2, t4[5] += c, t4[6] += u, t4[7] += l;
        };
      }, { "./browserHashUtils": 12, "buffer/": 82 }], 17: [function(e3, t3, n3) {
        (function(n4) {
          (function() {
            var n5 = e3("./util");
            n5.crypto.lib = e3("./browserCryptoLib"), n5.Buffer = e3("buffer/").Buffer, n5.url = e3("url/"), n5.querystring = e3("querystring/"), n5.realClock = e3("./realclock/browserClock"), n5.environment = "js", n5.createEventStream = e3("./event-stream/buffered-create-event-stream").createEventStream, n5.isBrowser = function() {
              return true;
            }, n5.isNode = function() {
              return false;
            };
            var r2 = e3("./core");
            if (t3.exports = r2, e3("./credentials"), e3("./credentials/credential_provider_chain"), e3("./credentials/temporary_credentials"), e3("./credentials/chainable_temporary_credentials"), e3("./credentials/web_identity_credentials"), e3("./credentials/cognito_identity_credentials"), e3("./credentials/saml_credentials"), r2.XML.Parser = e3("./xml/browser_parser"), e3("./http/xhr"), void 0 === i)
              var i = { browser: true };
          }).call(this);
        }).call(this, e3("_process"));
      }, { "./browserCryptoLib": 11, "./core": 20, "./credentials": 21, "./credentials/chainable_temporary_credentials": 22, "./credentials/cognito_identity_credentials": 23, "./credentials/credential_provider_chain": 24, "./credentials/saml_credentials": 25, "./credentials/temporary_credentials": 26, "./credentials/web_identity_credentials": 27, "./event-stream/buffered-create-event-stream": 29, "./http/xhr": 37, "./realclock/browserClock": 54, "./util": 73, "./xml/browser_parser": 74, _process: 87, "buffer/": 82, "querystring/": 94, "url/": 96 }], 18: [function(e3, t3, n3) {
        var r2, i = e3("./core");
        e3("./credentials"), e3("./credentials/credential_provider_chain"), i.Config = i.util.inherit({ constructor: function(e4) {
          void 0 === e4 && (e4 = {}), e4 = this.extractCredentials(e4), i.util.each.call(this, this.keys, function(t4, n4) {
            this.set(t4, e4[t4], n4);
          });
        }, getCredentials: function(e4) {
          function t4(t5) {
            e4(t5, t5 ? null : r3.credentials);
          }
          function n4(e5, t5) {
            return new i.util.error(t5 || new Error(), { code: "CredentialsError", message: e5, name: "CredentialsError" });
          }
          var r3 = this;
          r3.credentials ? "function" == typeof r3.credentials.get ? r3.credentials.get(function(e5) {
            e5 && (e5 = n4("Could not load credentials from " + r3.credentials.constructor.name, e5)), t4(e5);
          }) : function() {
            var e5 = null;
            r3.credentials.accessKeyId && r3.credentials.secretAccessKey || (e5 = n4("Missing credentials")), t4(e5);
          }() : r3.credentialProvider ? r3.credentialProvider.resolve(function(e5, i2) {
            e5 && (e5 = n4("Could not load credentials from any providers", e5)), r3.credentials = i2, t4(e5);
          }) : t4(n4("No credentials to load"));
        }, update: function(e4, t4) {
          t4 = t4 || false, e4 = this.extractCredentials(e4), i.util.each.call(this, e4, function(e5, n4) {
            (t4 || Object.prototype.hasOwnProperty.call(this.keys, e5) || i.Service.hasService(e5)) && this.set(e5, n4);
          });
        }, loadFromPath: function(e4) {
          this.clear();
          var t4 = JSON.parse(i.util.readFileSync(e4)), n4 = new i.FileSystemCredentials(e4), r3 = new i.CredentialProviderChain();
          return r3.providers.unshift(n4), r3.resolve(function(e5, n5) {
            if (e5)
              throw e5;
            t4.credentials = n5;
          }), this.constructor(t4), this;
        }, clear: function() {
          i.util.each.call(this, this.keys, function(e4) {
            delete this[e4];
          }), this.set("credentials", void 0), this.set("credentialProvider", void 0);
        }, set: function(e4, t4, n4) {
          void 0 === t4 ? (void 0 === n4 && (n4 = this.keys[e4]), this[e4] = "function" == typeof n4 ? n4.call(this) : n4) : "httpOptions" === e4 && this[e4] ? this[e4] = i.util.merge(this[e4], t4) : this[e4] = t4;
        }, keys: { credentials: null, credentialProvider: null, region: null, logger: null, apiVersions: {}, apiVersion: null, endpoint: void 0, httpOptions: { timeout: 12e4 }, maxRetries: void 0, maxRedirects: 10, paramValidation: true, sslEnabled: true, s3ForcePathStyle: false, s3BucketEndpoint: false, s3DisableBodySigning: true, s3UsEast1RegionalEndpoint: "legacy", s3UseArnRegion: void 0, computeChecksums: true, convertResponseTypes: true, correctClockSkew: false, customUserAgent: null, dynamoDbCrc32: true, systemClockOffset: 0, signatureVersion: null, signatureCache: true, retryDelayOptions: {}, useAccelerateEndpoint: false, clientSideMonitoring: false, endpointDiscoveryEnabled: void 0, endpointCacheSize: 1e3, hostPrefixEnabled: true, stsRegionalEndpoints: "legacy" }, extractCredentials: function(e4) {
          return e4.accessKeyId && e4.secretAccessKey && ((e4 = i.util.copy(e4)).credentials = new i.Credentials(e4)), e4;
        }, setPromisesDependency: function(e4) {
          r2 = e4, null === e4 && "function" == typeof Promise && (r2 = Promise);
          var t4 = [i.Request, i.Credentials, i.CredentialProviderChain];
          i.S3 && (t4.push(i.S3), i.S3.ManagedUpload && t4.push(i.S3.ManagedUpload)), i.util.addPromises(t4, r2);
        }, getPromisesDependency: function() {
          return r2;
        } }), i.config = new i.Config();
      }, { "./core": 20, "./credentials": 21, "./credentials/credential_provider_chain": 24 }], 19: [function(e3, t3, n3) {
        (function(n4) {
          (function() {
            function r2(e4, t4) {
              if ("string" == typeof e4) {
                if (["legacy", "regional"].indexOf(e4.toLowerCase()) >= 0)
                  return e4.toLowerCase();
                throw i.util.error(new Error(), t4);
              }
            }
            var i = e3("./core");
            t3.exports = function(e4, t4) {
              var o;
              if ((e4 = e4 || {})[t4.clientConfig] && (o = r2(e4[t4.clientConfig], { code: "InvalidConfiguration", message: 'invalid "' + t4.clientConfig + '" configuration. Expect "legacy"  or "regional". Got "' + e4[t4.clientConfig] + '".' })))
                return o;
              if (!i.util.isNode())
                return o;
              if (Object.prototype.hasOwnProperty.call(n4.env, t4.env) && (o = r2(n4.env[t4.env], { code: "InvalidEnvironmentalVariable", message: "invalid " + t4.env + ' environmental variable. Expect "legacy"  or "regional". Got "' + n4.env[t4.env] + '".' })))
                return o;
              var s = {};
              try {
                s = i.util.getProfilesFromSharedConfig(i.util.iniLoader)[n4.env.AWS_PROFILE || i.util.defaultProfile];
              } catch (e5) {
              }
              return s && Object.prototype.hasOwnProperty.call(s, t4.sharedConfig) && (o = r2(s[t4.sharedConfig], { code: "InvalidConfiguration", message: "invalid " + t4.sharedConfig + ' profile config. Expect "legacy"  or "regional". Got "' + s[t4.sharedConfig] + '".' })), o;
            };
          }).call(this);
        }).call(this, e3("_process"));
      }, { "./core": 20, _process: 87 }], 20: [function(e3, t3, n3) {
        var r2 = { util: e3("./util") };
        t3.exports = r2, r2.util.update(r2, { VERSION: "2.772.0", Signers: {}, Protocol: { Json: e3("./protocol/json"), Query: e3("./protocol/query"), Rest: e3("./protocol/rest"), RestJson: e3("./protocol/rest_json"), RestXml: e3("./protocol/rest_xml") }, XML: { Builder: e3("./xml/builder"), Parser: null }, JSON: { Builder: e3("./json/builder"), Parser: e3("./json/parser") }, Model: { Api: e3("./model/api"), Operation: e3("./model/operation"), Shape: e3("./model/shape"), Paginator: e3("./model/paginator"), ResourceWaiter: e3("./model/resource_waiter") }, apiLoader: e3("./api_loader"), EndpointCache: e3("../vendor/endpoint-cache").EndpointCache }), e3("./sequential_executor"), e3("./service"), e3("./config"), e3("./http"), e3("./event_listeners"), e3("./request"), e3("./response"), e3("./resource_waiter"), e3("./signers/request_signer"), e3("./param_validator"), r2.events = new r2.SequentialExecutor(), r2.util.memoizedProperty(r2, "endpointCache", function() {
          return new r2.EndpointCache(r2.config.endpointCacheSize);
        }, true);
      }, { "../vendor/endpoint-cache": 105, "./api_loader": 10, "./config": 18, "./event_listeners": 35, "./http": 36, "./json/builder": 38, "./json/parser": 39, "./model/api": 40, "./model/operation": 42, "./model/paginator": 43, "./model/resource_waiter": 44, "./model/shape": 45, "./param_validator": 46, "./protocol/json": 48, "./protocol/query": 49, "./protocol/rest": 50, "./protocol/rest_json": 51, "./protocol/rest_xml": 52, "./request": 57, "./resource_waiter": 58, "./response": 59, "./sequential_executor": 60, "./service": 61, "./signers/request_signer": 65, "./util": 73, "./xml/builder": 75 }], 21: [function(e3, t3, n3) {
        var r2 = e3("./core");
        r2.Credentials = r2.util.inherit({ constructor: function() {
          if (r2.util.hideProperties(this, ["secretAccessKey"]), this.expired = false, this.expireTime = null, this.refreshCallbacks = [], 1 === arguments.length && "object" == typeof arguments[0]) {
            var e4 = arguments[0].credentials || arguments[0];
            this.accessKeyId = e4.accessKeyId, this.secretAccessKey = e4.secretAccessKey, this.sessionToken = e4.sessionToken;
          } else
            this.accessKeyId = arguments[0], this.secretAccessKey = arguments[1], this.sessionToken = arguments[2];
        }, expiryWindow: 15, needsRefresh: function() {
          var e4 = r2.util.date.getDate().getTime(), t4 = new Date(e4 + 1e3 * this.expiryWindow);
          return !!(this.expireTime && t4 > this.expireTime) || this.expired || !this.accessKeyId || !this.secretAccessKey;
        }, get: function(e4) {
          var t4 = this;
          this.needsRefresh() ? this.refresh(function(n4) {
            n4 || (t4.expired = false), e4 && e4(n4);
          }) : e4 && e4();
        }, refresh: function(e4) {
          this.expired = false, e4();
        }, coalesceRefresh: function(e4, t4) {
          var n4 = this;
          1 === n4.refreshCallbacks.push(e4) && n4.load(function(e5) {
            r2.util.arrayEach(n4.refreshCallbacks, function(n5) {
              t4 ? n5(e5) : r2.util.defer(function() {
                n5(e5);
              });
            }), n4.refreshCallbacks.length = 0;
          });
        }, load: function(e4) {
          e4();
        } }), r2.Credentials.addPromisesToClass = function(e4) {
          this.prototype.getPromise = r2.util.promisifyMethod("get", e4), this.prototype.refreshPromise = r2.util.promisifyMethod("refresh", e4);
        }, r2.Credentials.deletePromisesFromClass = function() {
          delete this.prototype.getPromise, delete this.prototype.refreshPromise;
        }, r2.util.addPromises(r2.Credentials);
      }, { "./core": 20 }], 22: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../../clients/sts");
        r2.ChainableTemporaryCredentials = r2.util.inherit(r2.Credentials, { constructor: function(e4) {
          r2.Credentials.call(this), e4 = e4 || {}, this.errorCode = "ChainableTemporaryCredentialsProviderFailure", this.expired = true, this.tokenCodeFn = null;
          var t4 = r2.util.copy(e4.params) || {};
          if (t4.RoleArn && (t4.RoleSessionName = t4.RoleSessionName || "temporary-credentials"), t4.SerialNumber) {
            if (!e4.tokenCodeFn || "function" != typeof e4.tokenCodeFn)
              throw new r2.util.error(new Error("tokenCodeFn must be a function when params.SerialNumber is given"), { code: this.errorCode });
            this.tokenCodeFn = e4.tokenCodeFn;
          }
          var n4 = r2.util.merge({ params: t4, credentials: e4.masterCredentials || r2.config.credentials }, e4.stsConfig || {});
          this.service = new i(n4);
        }, refresh: function(e4) {
          this.coalesceRefresh(e4 || r2.util.fn.callback);
        }, load: function(e4) {
          var t4 = this, n4 = t4.service.config.params.RoleArn ? "assumeRole" : "getSessionToken";
          this.getTokenCode(function(r3, i2) {
            var o = {};
            r3 ? e4(r3) : (i2 && (o.TokenCode = i2), t4.service[n4](o, function(n5, r4) {
              n5 || t4.service.credentialsFrom(r4, t4), e4(n5);
            }));
          });
        }, getTokenCode: function(e4) {
          var t4 = this;
          this.tokenCodeFn ? this.tokenCodeFn(this.service.config.params.SerialNumber, function(n4, i2) {
            if (n4) {
              var o = n4;
              return n4 instanceof Error && (o = n4.message), void e4(r2.util.error(new Error("Error fetching MFA token: " + o), { code: t4.errorCode }));
            }
            e4(null, i2);
          }) : e4(null);
        } });
      }, { "../../clients/sts": 9, "../core": 20 }], 23: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../../clients/cognitoidentity"), o = e3("../../clients/sts");
        r2.CognitoIdentityCredentials = r2.util.inherit(r2.Credentials, { localStorageKey: { id: "aws.cognito.identity-id.", providers: "aws.cognito.identity-providers." }, constructor: function(e4, t4) {
          r2.Credentials.call(this), this.expired = true, this.params = e4, this.data = null, this._identityId = null, this._clientConfig = r2.util.copy(t4 || {}), this.loadCachedId();
          var n4 = this;
          Object.defineProperty(this, "identityId", { get: function() {
            return n4.loadCachedId(), n4._identityId || n4.params.IdentityId;
          }, set: function(e5) {
            n4._identityId = e5;
          } });
        }, refresh: function(e4) {
          this.coalesceRefresh(e4 || r2.util.fn.callback);
        }, load: function(e4) {
          var t4 = this;
          t4.createClients(), t4.data = null, t4._identityId = null, t4.getId(function(n4) {
            n4 ? (t4.clearIdOnNotAuthorized(n4), e4(n4)) : t4.params.RoleArn ? t4.getCredentialsFromSTS(e4) : t4.getCredentialsForIdentity(e4);
          });
        }, clearCachedId: function() {
          this._identityId = null, delete this.params.IdentityId;
          var e4 = this.params.IdentityPoolId, t4 = this.params.LoginId || "";
          delete this.storage[this.localStorageKey.id + e4 + t4], delete this.storage[this.localStorageKey.providers + e4 + t4];
        }, clearIdOnNotAuthorized: function(e4) {
          "NotAuthorizedException" == e4.code && this.clearCachedId();
        }, getId: function(e4) {
          var t4 = this;
          if ("string" == typeof t4.params.IdentityId)
            return e4(null, t4.params.IdentityId);
          t4.cognito.getId(function(n4, r3) {
            !n4 && r3.IdentityId ? (t4.params.IdentityId = r3.IdentityId, e4(null, r3.IdentityId)) : e4(n4);
          });
        }, loadCredentials: function(e4, t4) {
          e4 && t4 && (t4.expired = false, t4.accessKeyId = e4.Credentials.AccessKeyId, t4.secretAccessKey = e4.Credentials.SecretKey, t4.sessionToken = e4.Credentials.SessionToken, t4.expireTime = e4.Credentials.Expiration);
        }, getCredentialsForIdentity: function(e4) {
          var t4 = this;
          t4.cognito.getCredentialsForIdentity(function(n4, r3) {
            n4 ? t4.clearIdOnNotAuthorized(n4) : (t4.cacheId(r3), t4.data = r3, t4.loadCredentials(t4.data, t4)), e4(n4);
          });
        }, getCredentialsFromSTS: function(e4) {
          var t4 = this;
          t4.cognito.getOpenIdToken(function(n4, r3) {
            n4 ? (t4.clearIdOnNotAuthorized(n4), e4(n4)) : (t4.cacheId(r3), t4.params.WebIdentityToken = r3.Token, t4.webIdentityCredentials.refresh(function(n5) {
              n5 || (t4.data = t4.webIdentityCredentials.data, t4.sts.credentialsFrom(t4.data, t4)), e4(n5);
            }));
          });
        }, loadCachedId: function() {
          var e4 = this;
          if (r2.util.isBrowser() && !e4.params.IdentityId) {
            var t4 = e4.getStorage("id");
            if (t4 && e4.params.Logins) {
              var n4 = Object.keys(e4.params.Logins);
              0 !== (e4.getStorage("providers") || "").split(",").filter(function(e5) {
                return -1 !== n4.indexOf(e5);
              }).length && (e4.params.IdentityId = t4);
            } else
              t4 && (e4.params.IdentityId = t4);
          }
        }, createClients: function() {
          var e4 = this._clientConfig;
          if (this.webIdentityCredentials = this.webIdentityCredentials || new r2.WebIdentityCredentials(this.params, e4), !this.cognito) {
            var t4 = r2.util.merge({}, e4);
            t4.params = this.params, this.cognito = new i(t4);
          }
          this.sts = this.sts || new o(e4);
        }, cacheId: function(e4) {
          this._identityId = e4.IdentityId, this.params.IdentityId = this._identityId, r2.util.isBrowser() && (this.setStorage("id", e4.IdentityId), this.params.Logins && this.setStorage("providers", Object.keys(this.params.Logins).join(",")));
        }, getStorage: function(e4) {
          return this.storage[this.localStorageKey[e4] + this.params.IdentityPoolId + (this.params.LoginId || "")];
        }, setStorage: function(e4, t4) {
          try {
            this.storage[this.localStorageKey[e4] + this.params.IdentityPoolId + (this.params.LoginId || "")] = t4;
          } catch (e5) {
          }
        }, storage: function() {
          try {
            var e4 = r2.util.isBrowser() && null !== window.localStorage && "object" == typeof window.localStorage ? window.localStorage : {};
            return e4["aws.test-storage"] = "foobar", delete e4["aws.test-storage"], e4;
          } catch (e5) {
            return {};
          }
        }() });
      }, { "../../clients/cognitoidentity": 8, "../../clients/sts": 9, "../core": 20 }], 24: [function(e3, t3, n3) {
        var r2 = e3("../core");
        r2.CredentialProviderChain = r2.util.inherit(r2.Credentials, { constructor: function(e4) {
          this.providers = e4 || r2.CredentialProviderChain.defaultProviders.slice(0), this.resolveCallbacks = [];
        }, resolve: function(e4) {
          var t4 = this;
          if (0 === t4.providers.length)
            return e4(new Error("No providers")), t4;
          if (1 === t4.resolveCallbacks.push(e4)) {
            var n4 = 0, i = t4.providers.slice(0);
            !function e5(o, s) {
              if (!o && s || n4 === i.length)
                return r2.util.arrayEach(t4.resolveCallbacks, function(e6) {
                  e6(o, s);
                }), void (t4.resolveCallbacks.length = 0);
              var a = i[n4++];
              (s = "function" == typeof a ? a.call() : a).get ? s.get(function(t5) {
                e5(t5, t5 ? null : s);
              }) : e5(null, s);
            }();
          }
          return t4;
        } }), r2.CredentialProviderChain.defaultProviders = [], r2.CredentialProviderChain.addPromisesToClass = function(e4) {
          this.prototype.resolvePromise = r2.util.promisifyMethod("resolve", e4);
        }, r2.CredentialProviderChain.deletePromisesFromClass = function() {
          delete this.prototype.resolvePromise;
        }, r2.util.addPromises(r2.CredentialProviderChain);
      }, { "../core": 20 }], 25: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../../clients/sts");
        r2.SAMLCredentials = r2.util.inherit(r2.Credentials, { constructor: function(e4) {
          r2.Credentials.call(this), this.expired = true, this.params = e4;
        }, refresh: function(e4) {
          this.coalesceRefresh(e4 || r2.util.fn.callback);
        }, load: function(e4) {
          var t4 = this;
          t4.createClients(), t4.service.assumeRoleWithSAML(function(n4, r3) {
            n4 || t4.service.credentialsFrom(r3, t4), e4(n4);
          });
        }, createClients: function() {
          this.service = this.service || new i({ params: this.params });
        } });
      }, { "../../clients/sts": 9, "../core": 20 }], 26: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../../clients/sts");
        r2.TemporaryCredentials = r2.util.inherit(r2.Credentials, { constructor: function(e4, t4) {
          r2.Credentials.call(this), this.loadMasterCredentials(t4), this.expired = true, this.params = e4 || {}, this.params.RoleArn && (this.params.RoleSessionName = this.params.RoleSessionName || "temporary-credentials");
        }, refresh: function(e4) {
          this.coalesceRefresh(e4 || r2.util.fn.callback);
        }, load: function(e4) {
          var t4 = this;
          t4.createClients(), t4.masterCredentials.get(function() {
            t4.service.config.credentials = t4.masterCredentials, (t4.params.RoleArn ? t4.service.assumeRole : t4.service.getSessionToken).call(t4.service, function(n4, r3) {
              n4 || t4.service.credentialsFrom(r3, t4), e4(n4);
            });
          });
        }, loadMasterCredentials: function(e4) {
          for (this.masterCredentials = e4 || r2.config.credentials; this.masterCredentials.masterCredentials; )
            this.masterCredentials = this.masterCredentials.masterCredentials;
          "function" != typeof this.masterCredentials.get && (this.masterCredentials = new r2.Credentials(this.masterCredentials));
        }, createClients: function() {
          this.service = this.service || new i({ params: this.params });
        } });
      }, { "../../clients/sts": 9, "../core": 20 }], 27: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../../clients/sts");
        r2.WebIdentityCredentials = r2.util.inherit(r2.Credentials, { constructor: function(e4, t4) {
          r2.Credentials.call(this), this.expired = true, this.params = e4, this.params.RoleSessionName = this.params.RoleSessionName || "web-identity", this.data = null, this._clientConfig = r2.util.copy(t4 || {});
        }, refresh: function(e4) {
          this.coalesceRefresh(e4 || r2.util.fn.callback);
        }, load: function(e4) {
          var t4 = this;
          t4.createClients(), t4.service.assumeRoleWithWebIdentity(function(n4, r3) {
            t4.data = null, n4 || (t4.data = r3, t4.service.credentialsFrom(r3, t4)), e4(n4);
          });
        }, createClients: function() {
          if (!this.service) {
            var e4 = r2.util.merge({}, this._clientConfig);
            e4.params = this.params, this.service = new i(e4);
          }
        } });
      }, { "../../clients/sts": 9, "../core": 20 }], 28: [function(e3, t3, n3) {
        (function(n4) {
          (function() {
            function r2(e4) {
              var t4 = e4.service, n5 = t4.api || {}, r3 = {};
              return t4.config.region && (r3.region = t4.config.region), n5.serviceId && (r3.serviceId = n5.serviceId), t4.config.credentials.accessKeyId && (r3.accessKeyId = t4.config.credentials.accessKeyId), r3;
            }
            function i(e4, t4, n5) {
              n5 && null != t4 && "structure" === n5.type && n5.required && n5.required.length > 0 && h.arrayEach(n5.required, function(r3) {
                var o2 = n5.members[r3];
                if (true === o2.endpointDiscoveryId) {
                  var s2 = o2.isLocationName ? o2.name : r3;
                  e4[s2] = String(t4[r3]);
                } else
                  i(e4, t4[r3], o2);
              });
            }
            function o(e4, t4) {
              var n5 = {};
              return i(n5, e4.params, t4), n5;
            }
            function s(e4) {
              var t4 = e4.service, n5 = t4.api, i2 = n5.operations ? n5.operations[e4.operation] : void 0, s2 = o(e4, i2 ? i2.input : void 0), a2 = r2(e4);
              Object.keys(s2).length > 0 && (a2 = h.update(a2, s2), i2 && (a2.operation = i2.name));
              var u2 = d.endpointCache.get(a2);
              if (!u2 || 1 !== u2.length || "" !== u2[0].Address)
                if (u2 && u2.length > 0)
                  e4.httpRequest.updateEndpoint(u2[0].Address);
                else {
                  var l2 = t4.makeRequest(n5.endpointOperation, { Operation: i2.name, Identifiers: s2 });
                  c(l2), l2.removeListener("validate", d.EventListeners.Core.VALIDATE_PARAMETERS), l2.removeListener("retry", d.EventListeners.Core.RETRY_CHECK), d.endpointCache.put(a2, [{ Address: "", CachePeriodInMinutes: 1 }]), l2.send(function(e5, t5) {
                    t5 && t5.Endpoints ? d.endpointCache.put(a2, t5.Endpoints) : e5 && d.endpointCache.put(a2, [{ Address: "", CachePeriodInMinutes: 1 }]);
                  });
                }
            }
            function a(e4, t4) {
              var n5 = e4.service, i2 = n5.api, s2 = i2.operations ? i2.operations[e4.operation] : void 0, a2 = s2 ? s2.input : void 0, u2 = o(e4, a2), l2 = r2(e4);
              Object.keys(u2).length > 0 && (l2 = h.update(l2, u2), s2 && (l2.operation = s2.name));
              var p2 = d.EndpointCache.getKeyString(l2), f2 = d.endpointCache.get(p2);
              if (f2 && 1 === f2.length && "" === f2[0].Address)
                return m[p2] || (m[p2] = []), void m[p2].push({ request: e4, callback: t4 });
              if (f2 && f2.length > 0)
                e4.httpRequest.updateEndpoint(f2[0].Address), t4();
              else {
                var g = n5.makeRequest(i2.endpointOperation, { Operation: s2.name, Identifiers: u2 });
                g.removeListener("validate", d.EventListeners.Core.VALIDATE_PARAMETERS), c(g), d.endpointCache.put(p2, [{ Address: "", CachePeriodInMinutes: 60 }]), g.send(function(n6, r3) {
                  if (n6) {
                    if (e4.response.error = h.error(n6, { retryable: false }), d.endpointCache.remove(l2), m[p2]) {
                      var i3 = m[p2];
                      h.arrayEach(i3, function(e5) {
                        e5.request.response.error = h.error(n6, { retryable: false }), e5.callback();
                      }), delete m[p2];
                    }
                  } else
                    r3 && (d.endpointCache.put(p2, r3.Endpoints), e4.httpRequest.updateEndpoint(r3.Endpoints[0].Address), m[p2]) && (i3 = m[p2], h.arrayEach(i3, function(e5) {
                      e5.request.httpRequest.updateEndpoint(r3.Endpoints[0].Address), e5.callback();
                    }), delete m[p2]);
                  t4();
                });
              }
            }
            function c(e4) {
              var t4 = e4.service.api.apiVersion;
              t4 && !e4.httpRequest.headers["x-amz-api-version"] && (e4.httpRequest.headers["x-amz-api-version"] = t4);
            }
            function u(e4) {
              var t4 = e4.error, n5 = e4.httpResponse;
              if (t4 && ("InvalidEndpointException" === t4.code || 421 === n5.statusCode)) {
                var i2 = e4.request, s2 = i2.service.api.operations || {}, a2 = o(i2, s2[i2.operation] ? s2[i2.operation].input : void 0), c2 = r2(i2);
                Object.keys(a2).length > 0 && (c2 = h.update(c2, a2), s2[i2.operation] && (c2.operation = s2[i2.operation].name)), d.endpointCache.remove(c2);
              }
            }
            function l(e4) {
              return ["false", "0"].indexOf(e4) >= 0;
            }
            function p(e4) {
              var t4 = e4.service || {};
              if (void 0 !== t4.config.endpointDiscoveryEnabled)
                return t4.config.endpointDiscoveryEnabled;
              if (!h.isBrowser()) {
                for (var r3 = 0; r3 < f.length; r3++) {
                  var i2 = f[r3];
                  if (Object.prototype.hasOwnProperty.call(n4.env, i2)) {
                    if ("" === n4.env[i2] || void 0 === n4.env[i2])
                      throw h.error(new Error(), { code: "ConfigurationException", message: "environmental variable " + i2 + " cannot be set to nothing" });
                    return !l(n4.env[i2]);
                  }
                }
                var o2 = {};
                try {
                  o2 = d.util.iniLoader ? d.util.iniLoader.loadFrom({ isConfig: true, filename: n4.env[d.util.sharedConfigFileEnv] }) : {};
                } catch (e5) {
                }
                var s2 = o2[n4.env.AWS_PROFILE || d.util.defaultProfile] || {};
                if (Object.prototype.hasOwnProperty.call(s2, "endpoint_discovery_enabled")) {
                  if (void 0 === s2.endpoint_discovery_enabled)
                    throw h.error(new Error(), { code: "ConfigurationException", message: "config file entry 'endpoint_discovery_enabled' cannot be set to nothing" });
                  return !l(s2.endpoint_discovery_enabled);
                }
              }
            }
            var d = e3("./core"), h = e3("./util"), f = ["AWS_ENABLE_ENDPOINT_DISCOVERY", "AWS_ENDPOINT_DISCOVERY_ENABLED"], m = {};
            t3.exports = { discoverEndpoint: function(e4, t4) {
              var n5 = e4.service || {};
              if (function(e5) {
                if (e5._originalConfig && e5._originalConfig.endpoint && true === e5._originalConfig.endpointDiscoveryEnabled)
                  throw h.error(new Error(), { code: "ConfigurationException", message: "Custom endpoint is supplied; endpointDiscoveryEnabled must not be true." });
                var t5 = d.config[e5.serviceIdentifier] || {};
                return Boolean(d.config.endpoint || t5.endpoint || e5._originalConfig && e5._originalConfig.endpoint);
              }(n5) || e4.isPresigned())
                return t4();
              var r3 = (n5.api.operations || {})[e4.operation], i2 = r3 ? r3.endpointDiscoveryRequired : "NULL", o2 = p(e4), c2 = n5.api.hasRequiredEndpointDiscovery;
              switch ((o2 || c2) && e4.httpRequest.appendToUserAgent("endpoint-discovery"), i2) {
                case "OPTIONAL":
                  (o2 || c2) && (s(e4), e4.addNamedListener("INVALIDATE_CACHED_ENDPOINTS", "extractError", u)), t4();
                  break;
                case "REQUIRED":
                  if (false === o2) {
                    e4.response.error = h.error(new Error(), { code: "ConfigurationException", message: "Endpoint Discovery is disabled but " + n5.api.className + "." + e4.operation + "() requires it. Please check your configurations." }), t4();
                    break;
                  }
                  e4.addNamedListener("INVALIDATE_CACHED_ENDPOINTS", "extractError", u), a(e4, t4);
                  break;
                default:
                  t4();
              }
            }, requiredDiscoverEndpoint: a, optionalDiscoverEndpoint: s, marshallCustomIdentifiers: o, getCacheKey: r2, invalidateCachedEndpoint: u };
          }).call(this);
        }).call(this, e3("_process"));
      }, { "./core": 20, "./util": 73, _process: 87 }], 29: [function(e3, t3, n3) {
        var r2 = e3("../event-stream/event-message-chunker").eventMessageChunker, i = e3("./parse-event").parseEvent;
        t3.exports = { createEventStream: function(e4, t4, n4) {
          for (var o = r2(e4), s = [], a = 0; a < o.length; a++)
            s.push(i(t4, o[a], n4));
          return s;
        } };
      }, { "../event-stream/event-message-chunker": 30, "./parse-event": 32 }], 30: [function(e3, t3, n3) {
        t3.exports = { eventMessageChunker: function(e4) {
          for (var t4 = [], n4 = 0; n4 < e4.length; ) {
            var r2 = e4.readInt32BE(n4), i = e4.slice(n4, r2 + n4);
            n4 += r2, t4.push(i);
          }
          return t4;
        } };
      }, {}], 31: [function(e3, t3, n3) {
        function r2(e4) {
          if (8 !== e4.length)
            throw new Error("Int64 buffers must be exactly 8 bytes");
          o.Buffer.isBuffer(e4) || (e4 = s(e4)), this.bytes = e4;
        }
        function i(e4) {
          for (var t4 = 0; t4 < 8; t4++)
            e4[t4] ^= 255;
          for (t4 = 7; t4 > -1 && 0 == ++e4[t4]; t4--)
            ;
        }
        var o = e3("../core").util, s = o.buffer.toBuffer;
        r2.fromNumber = function(e4) {
          if (e4 > 9223372036854776e3 || e4 < -9223372036854776e3)
            throw new Error(e4 + " is too large (or, if negative, too small) to represent as an Int64");
          for (var t4 = new Uint8Array(8), n4 = 7, o2 = Math.abs(Math.round(e4)); n4 > -1 && o2 > 0; n4--, o2 /= 256)
            t4[n4] = o2;
          return e4 < 0 && i(t4), new r2(t4);
        }, r2.prototype.valueOf = function() {
          var e4 = this.bytes.slice(0), t4 = 128 & e4[0];
          return t4 && i(e4), parseInt(e4.toString("hex"), 16) * (t4 ? -1 : 1);
        }, r2.prototype.toString = function() {
          return String(this.valueOf());
        }, t3.exports = { Int64: r2 };
      }, { "../core": 20 }], 32: [function(e3, t3, n3) {
        var r2 = e3("./parse-message").parseMessage;
        t3.exports = { parseEvent: function(e4, t4, n4) {
          var i = r2(t4), o = i.headers[":message-type"];
          if (o) {
            if ("error" === o.value)
              throw function(e5) {
                var t5 = e5.headers[":error-code"], n5 = e5.headers[":error-message"], r3 = new Error(n5.value || n5);
                return r3.code = r3.name = t5.value || t5, r3;
              }(i);
            if ("event" !== o.value)
              return;
          }
          var s = i.headers[":event-type"], a = n4.members[s.value];
          if (a) {
            var c = {}, u = a.eventPayloadMemberName;
            if (u) {
              var l = a.members[u];
              "binary" === l.type ? c[u] = i.body : c[u] = e4.parse(i.body.toString(), l);
            }
            for (var p = a.eventHeaderMemberNames, d = 0; d < p.length; d++) {
              var h = p[d];
              i.headers[h] && (c[h] = a.members[h].toType(i.headers[h].value));
            }
            var f = {};
            return f[s.value] = c, f;
          }
        } };
      }, { "./parse-message": 33 }], 33: [function(e3, t3, n3) {
        function r2(e4) {
          for (var t4 = {}, n4 = 0; n4 < e4.length; ) {
            var r3 = e4.readUInt8(n4++), o2 = e4.slice(n4, n4 + r3).toString();
            switch (n4 += r3, e4.readUInt8(n4++)) {
              case 0:
                t4[o2] = { type: s, value: true };
                break;
              case 1:
                t4[o2] = { type: s, value: false };
                break;
              case 2:
                t4[o2] = { type: a, value: e4.readInt8(n4++) };
                break;
              case 3:
                t4[o2] = { type: c, value: e4.readInt16BE(n4) }, n4 += 2;
                break;
              case 4:
                t4[o2] = { type: u, value: e4.readInt32BE(n4) }, n4 += 4;
                break;
              case 5:
                t4[o2] = { type: l, value: new i(e4.slice(n4, n4 + 8)) }, n4 += 8;
                break;
              case 6:
                var m = e4.readUInt16BE(n4);
                n4 += 2, t4[o2] = { type: p, value: e4.slice(n4, n4 + m) }, n4 += m;
                break;
              case 7:
                var g = e4.readUInt16BE(n4);
                n4 += 2, t4[o2] = { type: d, value: e4.slice(n4, n4 + g).toString() }, n4 += g;
                break;
              case 8:
                t4[o2] = { type: h, value: new Date(new i(e4.slice(n4, n4 + 8)).valueOf()) }, n4 += 8;
                break;
              case 9:
                var v = e4.slice(n4, n4 + 16).toString("hex");
                n4 += 16, t4[o2] = { type: f, value: v.substr(0, 8) + "-" + v.substr(8, 4) + "-" + v.substr(12, 4) + "-" + v.substr(16, 4) + "-" + v.substr(20) };
                break;
              default:
                throw new Error("Unrecognized header type tag");
            }
          }
          return t4;
        }
        var i = e3("./int64").Int64, o = e3("./split-message").splitMessage, s = "boolean", a = "byte", c = "short", u = "integer", l = "long", p = "binary", d = "string", h = "timestamp", f = "uuid";
        t3.exports = { parseMessage: function(e4) {
          var t4 = o(e4);
          return { headers: r2(t4.headers), body: t4.body };
        } };
      }, { "./int64": 31, "./split-message": 34 }], 34: [function(e3, t3, n3) {
        var r2 = e3("../core").util, i = r2.buffer.toBuffer;
        t3.exports = { splitMessage: function(e4) {
          if (r2.Buffer.isBuffer(e4) || (e4 = i(e4)), e4.length < 16)
            throw new Error("Provided message too short to accommodate event stream message overhead");
          if (e4.length !== e4.readUInt32BE(0))
            throw new Error("Reported message length does not match received message length");
          var t4 = e4.readUInt32BE(8);
          if (t4 !== r2.crypto.crc32(e4.slice(0, 8)))
            throw new Error("The prelude checksum specified in the message (" + t4 + ") does not match the calculated CRC32 checksum.");
          var n4 = e4.readUInt32BE(e4.length - 4);
          if (n4 !== r2.crypto.crc32(e4.slice(0, e4.length - 4)))
            throw new Error("The message checksum did not match the expected value of " + n4);
          var o = 12 + e4.readUInt32BE(4);
          return { headers: e4.slice(12, o), body: e4.slice(o, e4.length - 4) };
        } };
      }, { "../core": 20 }], 35: [function(e3, t3, n3) {
        var r2 = e3("./core"), i = e3("./sequential_executor"), o = e3("./discover_endpoint").discoverEndpoint;
        r2.EventListeners = { Core: {} }, r2.EventListeners = { Core: new i().addNamedListeners(function(e4, t4) {
          t4("VALIDATE_CREDENTIALS", "validate", function(e5, t5) {
            if (!e5.service.api.signatureVersion && !e5.service.config.signatureVersion)
              return t5();
            e5.service.config.getCredentials(function(n4) {
              n4 && (e5.response.error = r2.util.error(n4, { code: "CredentialsError", message: "Missing credentials in config, if using AWS_CONFIG_FILE, set AWS_SDK_LOAD_CONFIG=1" })), t5();
            });
          }), e4("VALIDATE_REGION", "validate", function(e5) {
            if (!e5.service.isGlobalEndpoint) {
              var t5 = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
              e5.service.config.region ? t5.test(e5.service.config.region) || (e5.response.error = r2.util.error(new Error(), { code: "ConfigError", message: "Invalid region in config" })) : e5.response.error = r2.util.error(new Error(), { code: "ConfigError", message: "Missing region in config" });
            }
          }), e4("BUILD_IDEMPOTENCY_TOKENS", "validate", function(e5) {
            if (e5.service.api.operations) {
              var t5 = e5.service.api.operations[e5.operation];
              if (t5) {
                var n4 = t5.idempotentMembers;
                if (n4.length) {
                  for (var i2 = r2.util.copy(e5.params), o2 = 0, s = n4.length; o2 < s; o2++)
                    i2[n4[o2]] || (i2[n4[o2]] = r2.util.uuid.v4());
                  e5.params = i2;
                }
              }
            }
          }), e4("VALIDATE_PARAMETERS", "validate", function(e5) {
            if (e5.service.api.operations) {
              var t5 = e5.service.api.operations[e5.operation].input, n4 = e5.service.config.paramValidation;
              new r2.ParamValidator(n4).validate(t5, e5.params);
            }
          }), t4("COMPUTE_SHA256", "afterBuild", function(e5, t5) {
            if (e5.haltHandlersOnError(), e5.service.api.operations) {
              var n4 = e5.service.api.operations[e5.operation], i2 = n4 ? n4.authtype : "";
              if (!e5.service.api.signatureVersion && !i2 && !e5.service.config.signatureVersion)
                return t5();
              if (e5.service.getSignerClass(e5) === r2.Signers.V4) {
                var o2 = e5.httpRequest.body || "";
                if (i2.indexOf("unsigned-body") >= 0)
                  return e5.httpRequest.headers["X-Amz-Content-Sha256"] = "UNSIGNED-PAYLOAD", t5();
                r2.util.computeSha256(o2, function(n5, r3) {
                  n5 ? t5(n5) : (e5.httpRequest.headers["X-Amz-Content-Sha256"] = r3, t5());
                });
              } else
                t5();
            }
          }), e4("SET_CONTENT_LENGTH", "afterBuild", function(e5) {
            var t5 = function(e6) {
              if (!e6.service.api.operations)
                return "";
              var t6 = e6.service.api.operations[e6.operation];
              return t6 ? t6.authtype : "";
            }(e5), n4 = r2.util.getRequestPayloadShape(e5);
            if (void 0 === e5.httpRequest.headers["Content-Length"])
              try {
                var i2 = r2.util.string.byteLength(e5.httpRequest.body);
                e5.httpRequest.headers["Content-Length"] = i2;
              } catch (r3) {
                if (n4 && n4.isStreaming) {
                  if (n4.requiresLength)
                    throw r3;
                  if (t5.indexOf("unsigned-body") >= 0)
                    return void (e5.httpRequest.headers["Transfer-Encoding"] = "chunked");
                  throw r3;
                }
                throw r3;
              }
          }), e4("SET_HTTP_HOST", "afterBuild", function(e5) {
            e5.httpRequest.headers.Host = e5.httpRequest.endpoint.host;
          }), e4("RESTART", "restart", function() {
            var e5 = this.response.error;
            e5 && e5.retryable && (this.httpRequest = new r2.HttpRequest(this.service.endpoint, this.service.region), this.response.retryCount < this.service.config.maxRetries ? this.response.retryCount++ : this.response.error = null);
          }), t4("DISCOVER_ENDPOINT", "sign", o, true), t4("SIGN", "sign", function(e5, t5) {
            var n4 = e5.service, r3 = (e5.service.api.operations || {})[e5.operation], i2 = r3 ? r3.authtype : "";
            if (!n4.api.signatureVersion && !i2 && !n4.config.signatureVersion)
              return t5();
            n4.config.getCredentials(function(i3, o2) {
              if (i3)
                return e5.response.error = i3, t5();
              try {
                var s = n4.getSkewCorrectedDate(), a = new (n4.getSignerClass(e5))(e5.httpRequest, n4.getSigningName(), { signatureCache: n4.config.signatureCache, operation: r3, signatureVersion: n4.api.signatureVersion });
                a.setServiceClientId(n4._clientId), delete e5.httpRequest.headers.Authorization, delete e5.httpRequest.headers.Date, delete e5.httpRequest.headers["X-Amz-Date"], a.addAuthorization(o2, s), e5.signedAt = s;
              } catch (t6) {
                e5.response.error = t6;
              }
              t5();
            });
          }), e4("VALIDATE_RESPONSE", "validateResponse", function(e5) {
            this.service.successfulResponse(e5, this) ? (e5.data = {}, e5.error = null) : (e5.data = null, e5.error = r2.util.error(new Error(), { code: "UnknownError", message: "An unknown error occurred." }));
          }), t4("SEND", "send", function(e5, t5) {
            function n4(n5) {
              e5.httpResponse.stream = n5;
              var i3 = e5.request.httpRequest.stream, o3 = e5.request.service, s = o3.api, a = e5.request.operation, c = s.operations[a] || {};
              n5.on("headers", function(i4, s2, a2) {
                if (e5.request.emit("httpHeaders", [i4, s2, e5, a2]), !e5.httpResponse.streaming)
                  if (2 === r2.HttpClient.streamsApiVersion) {
                    if (c.hasEventOutput && o3.successfulResponse(e5))
                      return e5.request.emit("httpDone"), void t5();
                    n5.on("readable", function() {
                      var t6 = n5.read();
                      null !== t6 && e5.request.emit("httpData", [t6, e5]);
                    });
                  } else
                    n5.on("data", function(t6) {
                      e5.request.emit("httpData", [t6, e5]);
                    });
              }), n5.on("end", function() {
                if (!i3 || !i3.didCallback) {
                  if (2 === r2.HttpClient.streamsApiVersion && c.hasEventOutput && o3.successfulResponse(e5))
                    return;
                  e5.request.emit("httpDone"), t5();
                }
              });
            }
            function i2(n5) {
              if ("RequestAbortedError" !== n5.code) {
                var i3 = "TimeoutError" === n5.code ? n5.code : "NetworkingError";
                n5 = r2.util.error(n5, { code: i3, region: e5.request.httpRequest.region, hostname: e5.request.httpRequest.endpoint.hostname, retryable: true });
              }
              e5.error = n5, e5.request.emit("httpError", [e5.error, e5], function() {
                t5();
              });
            }
            function o2() {
              var t6 = r2.HttpClient.getInstance(), o3 = e5.request.service.config.httpOptions || {};
              try {
                !function(t7) {
                  t7.on("sendProgress", function(t8) {
                    e5.request.emit("httpUploadProgress", [t8, e5]);
                  }), t7.on("receiveProgress", function(t8) {
                    e5.request.emit("httpDownloadProgress", [t8, e5]);
                  });
                }(t6.handleRequest(e5.request.httpRequest, o3, n4, i2));
              } catch (e6) {
                i2(e6);
              }
            }
            e5.httpResponse._abortCallback = t5, e5.error = null, e5.data = null, (e5.request.service.getSkewCorrectedDate() - this.signedAt) / 1e3 >= 600 ? this.emit("sign", [this], function(e6) {
              e6 ? t5(e6) : o2();
            }) : o2();
          }), e4("HTTP_HEADERS", "httpHeaders", function(e5, t5, n4, i2) {
            n4.httpResponse.statusCode = e5, n4.httpResponse.statusMessage = i2, n4.httpResponse.headers = t5, n4.httpResponse.body = r2.util.buffer.toBuffer(""), n4.httpResponse.buffers = [], n4.httpResponse.numBytes = 0;
            var o2 = t5.date || t5.Date, s = n4.request.service;
            if (o2) {
              var a = Date.parse(o2);
              s.config.correctClockSkew && s.isClockSkewed(a) && s.applyClockOffset(a);
            }
          }), e4("HTTP_DATA", "httpData", function(e5, t5) {
            if (e5) {
              if (r2.util.isNode()) {
                t5.httpResponse.numBytes += e5.length;
                var n4 = t5.httpResponse.headers["content-length"], i2 = { loaded: t5.httpResponse.numBytes, total: n4 };
                t5.request.emit("httpDownloadProgress", [i2, t5]);
              }
              t5.httpResponse.buffers.push(r2.util.buffer.toBuffer(e5));
            }
          }), e4("HTTP_DONE", "httpDone", function(e5) {
            if (e5.httpResponse.buffers && e5.httpResponse.buffers.length > 0) {
              var t5 = r2.util.buffer.concat(e5.httpResponse.buffers);
              e5.httpResponse.body = t5;
            }
            delete e5.httpResponse.numBytes, delete e5.httpResponse.buffers;
          }), e4("FINALIZE_ERROR", "retry", function(e5) {
            e5.httpResponse.statusCode && (e5.error.statusCode = e5.httpResponse.statusCode, void 0 === e5.error.retryable && (e5.error.retryable = this.service.retryableError(e5.error, this)));
          }), e4("INVALIDATE_CREDENTIALS", "retry", function(e5) {
            if (e5.error)
              switch (e5.error.code) {
                case "RequestExpired":
                case "ExpiredTokenException":
                case "ExpiredToken":
                  e5.error.retryable = true, e5.request.service.config.credentials.expired = true;
              }
          }), e4("EXPIRED_SIGNATURE", "retry", function(e5) {
            var t5 = e5.error;
            t5 && "string" == typeof t5.code && "string" == typeof t5.message && t5.code.match(/Signature/) && t5.message.match(/expired/) && (e5.error.retryable = true);
          }), e4("CLOCK_SKEWED", "retry", function(e5) {
            e5.error && this.service.clockSkewError(e5.error) && this.service.config.correctClockSkew && (e5.error.retryable = true);
          }), e4("REDIRECT", "retry", function(e5) {
            e5.error && e5.error.statusCode >= 300 && e5.error.statusCode < 400 && e5.httpResponse.headers.location && (this.httpRequest.endpoint = new r2.Endpoint(e5.httpResponse.headers.location), this.httpRequest.headers.Host = this.httpRequest.endpoint.host, e5.error.redirect = true, e5.error.retryable = true);
          }), e4("RETRY_CHECK", "retry", function(e5) {
            e5.error && (e5.error.redirect && e5.redirectCount < e5.maxRedirects ? e5.error.retryDelay = 0 : e5.retryCount < e5.maxRetries && (e5.error.retryDelay = this.service.retryDelays(e5.retryCount, e5.error) || 0));
          }), t4("RESET_RETRY_STATE", "afterRetry", function(e5, t5) {
            var n4, r3 = false;
            e5.error && (n4 = e5.error.retryDelay || 0, e5.error.retryable && e5.retryCount < e5.maxRetries ? (e5.retryCount++, r3 = true) : e5.error.redirect && e5.redirectCount < e5.maxRedirects && (e5.redirectCount++, r3 = true)), r3 && n4 >= 0 ? (e5.error = null, setTimeout(t5, n4)) : t5();
          });
        }), CorePost: new i().addNamedListeners(function(e4) {
          e4("EXTRACT_REQUEST_ID", "extractData", r2.util.extractRequestId), e4("EXTRACT_REQUEST_ID", "extractError", r2.util.extractRequestId), e4("ENOTFOUND_ERROR", "httpError", function(e5) {
            if ("NetworkingError" === e5.code && function(e6) {
              return "ENOTFOUND" === e6.errno || "number" == typeof e6.errno && "function" == typeof r2.util.getSystemErrorName && ["EAI_NONAME", "EAI_NODATA"].indexOf(r2.util.getSystemErrorName(e6.errno) >= 0);
            }(e5)) {
              var t4 = "Inaccessible host: `" + e5.hostname + "'. This service may not be available in the `" + e5.region + "' region.";
              this.response.error = r2.util.error(new Error(t4), { code: "UnknownEndpoint", region: e5.region, hostname: e5.hostname, retryable: true, originalError: e5 });
            }
          });
        }), Logger: new i().addNamedListeners(function(t4) {
          t4("LOG_REQUEST", "complete", function(t5) {
            function n4(e4, t6) {
              if (!t6)
                return t6;
              if (e4.isSensitive)
                return "***SensitiveInformation***";
              switch (e4.type) {
                case "structure":
                  var i3 = {};
                  return r2.util.each(t6, function(t7, r3) {
                    Object.prototype.hasOwnProperty.call(e4.members, t7) ? i3[t7] = n4(e4.members[t7], r3) : i3[t7] = r3;
                  }), i3;
                case "list":
                  var o3 = [];
                  return r2.util.arrayEach(t6, function(t7, r3) {
                    o3.push(n4(e4.member, t7));
                  }), o3;
                case "map":
                  var s2 = {};
                  return r2.util.each(t6, function(t7, r3) {
                    s2[t7] = n4(e4.value, r3);
                  }), s2;
                default:
                  return t6;
              }
            }
            var i2 = t5.request, o2 = i2.service.config.logger;
            if (o2) {
              var s = function() {
                var s2 = (t5.request.service.getSkewCorrectedDate().getTime() - i2.startTime.getTime()) / 1e3, a = !!o2.isTTY, c = t5.httpResponse.statusCode, u = i2.params;
                i2.service.api.operations && i2.service.api.operations[i2.operation] && i2.service.api.operations[i2.operation].input && (u = n4(i2.service.api.operations[i2.operation].input, i2.params));
                var l = e3("util").inspect(u, true, null), p = "";
                return a && (p += "\x1B[33m"), p += "[AWS " + i2.service.serviceIdentifier + " " + c, p += " " + s2.toString() + "s " + t5.retryCount + " retries]", a && (p += "\x1B[0;1m"), p += " " + r2.util.string.lowerFirst(i2.operation), p += "(" + l + ")", a && (p += "\x1B[0m"), p;
              }();
              "function" == typeof o2.log ? o2.log(s) : "function" == typeof o2.write && o2.write(s + "\n");
            }
          });
        }), Json: new i().addNamedListeners(function(t4) {
          var n4 = e3("./protocol/json");
          t4("BUILD", "build", n4.buildRequest), t4("EXTRACT_DATA", "extractData", n4.extractData), t4("EXTRACT_ERROR", "extractError", n4.extractError);
        }), Rest: new i().addNamedListeners(function(t4) {
          var n4 = e3("./protocol/rest");
          t4("BUILD", "build", n4.buildRequest), t4("EXTRACT_DATA", "extractData", n4.extractData), t4("EXTRACT_ERROR", "extractError", n4.extractError);
        }), RestJson: new i().addNamedListeners(function(t4) {
          var n4 = e3("./protocol/rest_json");
          t4("BUILD", "build", n4.buildRequest), t4("EXTRACT_DATA", "extractData", n4.extractData), t4("EXTRACT_ERROR", "extractError", n4.extractError);
        }), RestXml: new i().addNamedListeners(function(t4) {
          var n4 = e3("./protocol/rest_xml");
          t4("BUILD", "build", n4.buildRequest), t4("EXTRACT_DATA", "extractData", n4.extractData), t4("EXTRACT_ERROR", "extractError", n4.extractError);
        }), Query: new i().addNamedListeners(function(t4) {
          var n4 = e3("./protocol/query");
          t4("BUILD", "build", n4.buildRequest), t4("EXTRACT_DATA", "extractData", n4.extractData), t4("EXTRACT_ERROR", "extractError", n4.extractError);
        }) };
      }, { "./core": 20, "./discover_endpoint": 28, "./protocol/json": 48, "./protocol/query": 49, "./protocol/rest": 50, "./protocol/rest_json": 51, "./protocol/rest_xml": 52, "./sequential_executor": 60, util: 99 }], 36: [function(e3, t3, n3) {
        var r2 = e3("./core"), i = r2.util.inherit;
        r2.Endpoint = i({ constructor: function(e4, t4) {
          if (r2.util.hideProperties(this, ["slashes", "auth", "hash", "search", "query"]), null == e4)
            throw new Error("Invalid endpoint: " + e4);
          if ("string" != typeof e4)
            return r2.util.copy(e4);
          e4.match(/^http/) || (e4 = ((t4 && void 0 !== t4.sslEnabled ? t4.sslEnabled : r2.config.sslEnabled) ? "https" : "http") + "://" + e4), r2.util.update(this, r2.util.urlParse(e4)), this.port ? this.port = parseInt(this.port, 10) : this.port = "https:" === this.protocol ? 443 : 80;
        } }), r2.HttpRequest = i({ constructor: function(e4, t4) {
          e4 = new r2.Endpoint(e4), this.method = "POST", this.path = e4.path || "/", this.headers = {}, this.body = "", this.endpoint = e4, this.region = t4, this._userAgent = "", this.setUserAgent();
        }, setUserAgent: function() {
          this._userAgent = this.headers[this.getUserAgentHeaderName()] = r2.util.userAgent();
        }, getUserAgentHeaderName: function() {
          return (r2.util.isBrowser() ? "X-Amz-" : "") + "User-Agent";
        }, appendToUserAgent: function(e4) {
          "string" == typeof e4 && e4 && (this._userAgent += " " + e4), this.headers[this.getUserAgentHeaderName()] = this._userAgent;
        }, getUserAgent: function() {
          return this._userAgent;
        }, pathname: function() {
          return this.path.split("?", 1)[0];
        }, search: function() {
          var e4 = this.path.split("?", 2)[1];
          return e4 ? (e4 = r2.util.queryStringParse(e4), r2.util.queryParamsToString(e4)) : "";
        }, updateEndpoint: function(e4) {
          var t4 = new r2.Endpoint(e4);
          this.endpoint = t4, this.path = t4.path || "/", this.headers.Host && (this.headers.Host = t4.host);
        } }), r2.HttpResponse = i({ constructor: function() {
          this.statusCode = void 0, this.headers = {}, this.body = void 0, this.streaming = false, this.stream = null;
        }, createUnbufferedStream: function() {
          return this.streaming = true, this.stream;
        } }), r2.HttpClient = i({}), r2.HttpClient.getInstance = function() {
          return void 0 === this.singleton && (this.singleton = new this()), this.singleton;
        };
      }, { "./core": 20 }], 37: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("events").EventEmitter;
        e3("../http"), r2.XHRClient = r2.util.inherit({ handleRequest: function(e4, t4, n4, o) {
          var s = this, a = e4.endpoint, c = new i(), u = a.protocol + "//" + a.hostname;
          80 !== a.port && 443 !== a.port && (u += ":" + a.port), u += e4.path;
          var l = new XMLHttpRequest(), p = false;
          e4.stream = l, l.addEventListener("readystatechange", function() {
            try {
              if (0 === l.status)
                return;
            } catch (e5) {
              return;
            }
            this.readyState >= this.HEADERS_RECEIVED && !p && (c.statusCode = l.status, c.headers = s.parseHeaders(l.getAllResponseHeaders()), c.emit("headers", c.statusCode, c.headers, l.statusText), p = true), this.readyState === this.DONE && s.finishRequest(l, c);
          }, false), l.upload.addEventListener("progress", function(e5) {
            c.emit("sendProgress", e5);
          }), l.addEventListener("progress", function(e5) {
            c.emit("receiveProgress", e5);
          }, false), l.addEventListener("timeout", function() {
            o(r2.util.error(new Error("Timeout"), { code: "TimeoutError" }));
          }, false), l.addEventListener("error", function() {
            o(r2.util.error(new Error("Network Failure"), { code: "NetworkingError" }));
          }, false), l.addEventListener("abort", function() {
            o(r2.util.error(new Error("Request aborted"), { code: "RequestAbortedError" }));
          }, false), n4(c), l.open(e4.method, u, false !== t4.xhrAsync), r2.util.each(e4.headers, function(e5, t5) {
            "Content-Length" !== e5 && "User-Agent" !== e5 && "Host" !== e5 && l.setRequestHeader(e5, t5);
          }), t4.timeout && false !== t4.xhrAsync && (l.timeout = t4.timeout), t4.xhrWithCredentials && (l.withCredentials = true);
          try {
            l.responseType = "arraybuffer";
          } catch (e5) {
          }
          try {
            e4.body ? l.send(e4.body) : l.send();
          } catch (t5) {
            if (!e4.body || "object" != typeof e4.body.buffer)
              throw t5;
            l.send(e4.body.buffer);
          }
          return c;
        }, parseHeaders: function(e4) {
          var t4 = {};
          return r2.util.arrayEach(e4.split(/\r?\n/), function(e5) {
            var n4 = e5.split(":", 1)[0], r3 = e5.substring(n4.length + 2);
            n4.length > 0 && (t4[n4.toLowerCase()] = r3);
          }), t4;
        }, finishRequest: function(e4, t4) {
          var n4;
          if ("arraybuffer" === e4.responseType && e4.response) {
            var i2 = e4.response;
            n4 = new r2.util.Buffer(i2.byteLength);
            for (var o = new Uint8Array(i2), s = 0; s < n4.length; ++s)
              n4[s] = o[s];
          }
          try {
            n4 || "string" != typeof e4.responseText || (n4 = new r2.util.Buffer(e4.responseText));
          } catch (e5) {
          }
          n4 && t4.emit("data", n4), t4.emit("end");
        } }), r2.HttpClient.prototype = r2.XHRClient.prototype, r2.HttpClient.streamsApiVersion = 1;
      }, { "../core": 20, "../http": 36, events: 83 }], 38: [function(e3, t3, n3) {
        function r2() {
        }
        function i(e4, t4) {
          if (t4 && null != e4)
            switch (t4.type) {
              case "structure":
                return function(e5, t5) {
                  var n4 = {};
                  return o.each(e5, function(e6, r3) {
                    var o2 = t5.members[e6];
                    if (o2) {
                      if ("body" !== o2.location)
                        return;
                      var s = o2.isLocationName ? o2.name : e6, a = i(r3, o2);
                      void 0 !== a && (n4[s] = a);
                    }
                  }), n4;
                }(e4, t4);
              case "map":
                return function(e5, t5) {
                  var n4 = {};
                  return o.each(e5, function(e6, r3) {
                    var o2 = i(r3, t5.value);
                    void 0 !== o2 && (n4[e6] = o2);
                  }), n4;
                }(e4, t4);
              case "list":
                return function(e5, t5) {
                  var n4 = [];
                  return o.arrayEach(e5, function(e6) {
                    var r3 = i(e6, t5.member);
                    void 0 !== r3 && n4.push(r3);
                  }), n4;
                }(e4, t4);
              default:
                return function(e5, t5) {
                  return t5.toWireFormat(e5);
                }(e4, t4);
            }
        }
        var o = e3("../util");
        r2.prototype.build = function(e4, t4) {
          return JSON.stringify(i(e4, t4));
        }, t3.exports = r2;
      }, { "../util": 73 }], 39: [function(e3, t3, n3) {
        function r2() {
        }
        function i(e4, t4) {
          if (t4 && void 0 !== e4)
            switch (t4.type) {
              case "structure":
                return function(e5, t5) {
                  if (null != e5) {
                    var n4 = {}, r3 = t5.members;
                    return o.each(r3, function(t6, r4) {
                      var o2 = r4.isLocationName ? r4.name : t6;
                      if (Object.prototype.hasOwnProperty.call(e5, o2)) {
                        var s = i(e5[o2], r4);
                        void 0 !== s && (n4[t6] = s);
                      }
                    }), n4;
                  }
                }(e4, t4);
              case "map":
                return function(e5, t5) {
                  if (null != e5) {
                    var n4 = {};
                    return o.each(e5, function(e6, r3) {
                      var o2 = i(r3, t5.value);
                      n4[e6] = void 0 === o2 ? null : o2;
                    }), n4;
                  }
                }(e4, t4);
              case "list":
                return function(e5, t5) {
                  if (null != e5) {
                    var n4 = [];
                    return o.arrayEach(e5, function(e6) {
                      var r3 = i(e6, t5.member);
                      void 0 === r3 ? n4.push(null) : n4.push(r3);
                    }), n4;
                  }
                }(e4, t4);
              default:
                return function(e5, t5) {
                  return t5.toType(e5);
                }(e4, t4);
            }
        }
        var o = e3("../util");
        r2.prototype.parse = function(e4, t4) {
          return i(JSON.parse(e4), t4);
        }, t3.exports = r2;
      }, { "../util": 73 }], 40: [function(e3, t3, n3) {
        var r2 = e3("./collection"), i = e3("./operation"), o = e3("./shape"), s = e3("./paginator"), a = e3("./resource_waiter"), c = e3("../../apis/metadata.json"), u = e3("../util"), l = u.property, p = u.memoizedProperty;
        t3.exports = function(e4, t4) {
          var n4 = this;
          e4 = e4 || {}, (t4 = t4 || {}).api = this, e4.metadata = e4.metadata || {};
          var d = t4.serviceIdentifier;
          delete t4.serviceIdentifier, l(this, "isApi", true, false), l(this, "apiVersion", e4.metadata.apiVersion), l(this, "endpointPrefix", e4.metadata.endpointPrefix), l(this, "signingName", e4.metadata.signingName), l(this, "globalEndpoint", e4.metadata.globalEndpoint), l(this, "signatureVersion", e4.metadata.signatureVersion), l(this, "jsonVersion", e4.metadata.jsonVersion), l(this, "targetPrefix", e4.metadata.targetPrefix), l(this, "protocol", e4.metadata.protocol), l(this, "timestampFormat", e4.metadata.timestampFormat), l(this, "xmlNamespaceUri", e4.metadata.xmlNamespace), l(this, "abbreviation", e4.metadata.serviceAbbreviation), l(this, "fullName", e4.metadata.serviceFullName), l(this, "serviceId", e4.metadata.serviceId), d && c[d] && l(this, "xmlNoDefaultLists", c[d].xmlNoDefaultLists, false), p(this, "className", function() {
            var t5 = e4.metadata.serviceAbbreviation || e4.metadata.serviceFullName;
            return t5 ? ("ElasticLoadBalancing" === (t5 = t5.replace(/^Amazon|AWS\s*|\(.*|\s+|\W+/g, "")) && (t5 = "ELB"), t5) : null;
          }), l(this, "operations", new r2(e4.operations, t4, function(e5, n5) {
            return new i(e5, n5, t4);
          }, u.string.lowerFirst, function(e5, t5) {
            true === t5.endpointoperation && l(n4, "endpointOperation", u.string.lowerFirst(e5)), t5.endpointdiscovery && !n4.hasRequiredEndpointDiscovery && l(n4, "hasRequiredEndpointDiscovery", true === t5.endpointdiscovery.required);
          })), l(this, "shapes", new r2(e4.shapes, t4, function(e5, n5) {
            return o.create(n5, t4);
          })), l(this, "paginators", new r2(e4.paginators, t4, function(e5, n5) {
            return new s(e5, n5, t4);
          })), l(this, "waiters", new r2(e4.waiters, t4, function(e5, n5) {
            return new a(e5, n5, t4);
          }, u.string.lowerFirst)), t4.documentation && (l(this, "documentation", e4.documentation), l(this, "documentationUrl", e4.documentationUrl));
        };
      }, { "../../apis/metadata.json": 5, "../util": 73, "./collection": 41, "./operation": 42, "./paginator": 43, "./resource_waiter": 44, "./shape": 45 }], 41: [function(e3, t3, n3) {
        function r2(e4, t4, n4, r3) {
          i(this, r3(e4), function() {
            return n4(e4, t4);
          });
        }
        var i = e3("../util").memoizedProperty;
        t3.exports = function(e4, t4, n4, i2, o) {
          for (var s in i2 = i2 || String, e4)
            Object.prototype.hasOwnProperty.call(e4, s) && (r2.call(this, s, e4[s], n4, i2), o && o(s, e4[s]));
        };
      }, { "../util": 73 }], 42: [function(e3, t3, n3) {
        var r2 = e3("./shape"), i = e3("../util"), o = i.property, s = i.memoizedProperty;
        t3.exports = function(e4, t4, n4) {
          var i2 = this;
          n4 = n4 || {}, o(this, "name", t4.name || e4), o(this, "api", n4.api, false), t4.http = t4.http || {}, o(this, "endpoint", t4.endpoint), o(this, "httpMethod", t4.http.method || "POST"), o(this, "httpPath", t4.http.requestUri || "/"), o(this, "authtype", t4.authtype || ""), o(this, "endpointDiscoveryRequired", t4.endpointdiscovery ? t4.endpointdiscovery.required ? "REQUIRED" : "OPTIONAL" : "NULL"), s(this, "input", function() {
            return t4.input ? r2.create(t4.input, n4) : new r2.create({ type: "structure" }, n4);
          }), s(this, "output", function() {
            return t4.output ? r2.create(t4.output, n4) : new r2.create({ type: "structure" }, n4);
          }), s(this, "errors", function() {
            var e5 = [];
            if (!t4.errors)
              return null;
            for (var i3 = 0; i3 < t4.errors.length; i3++)
              e5.push(r2.create(t4.errors[i3], n4));
            return e5;
          }), s(this, "paginator", function() {
            return n4.api.paginators[e4];
          }), n4.documentation && (o(this, "documentation", t4.documentation), o(this, "documentationUrl", t4.documentationUrl)), s(this, "idempotentMembers", function() {
            var e5 = [], t5 = i2.input, n5 = t5.members;
            if (!t5.members)
              return e5;
            for (var r3 in n5)
              n5.hasOwnProperty(r3) && true === n5[r3].isIdempotent && e5.push(r3);
            return e5;
          }), s(this, "hasEventOutput", function() {
            return function(e5) {
              var t5 = e5.members, n5 = e5.payload;
              if (!e5.members)
                return false;
              if (n5)
                return t5[n5].isEventStream;
              for (var r3 in t5)
                if (!t5.hasOwnProperty(r3) && true === t5[r3].isEventStream)
                  return true;
              return false;
            }(i2.output);
          });
        };
      }, { "../util": 73, "./shape": 45 }], 43: [function(e3, t3, n3) {
        var r2 = e3("../util").property;
        t3.exports = function(e4, t4) {
          r2(this, "inputToken", t4.input_token), r2(this, "limitKey", t4.limit_key), r2(this, "moreResults", t4.more_results), r2(this, "outputToken", t4.output_token), r2(this, "resultKey", t4.result_key);
        };
      }, { "../util": 73 }], 44: [function(e3, t3, n3) {
        var r2 = e3("../util"), i = r2.property;
        t3.exports = function(e4, t4, n4) {
          n4 = n4 || {}, i(this, "name", e4), i(this, "api", n4.api, false), t4.operation && i(this, "operation", r2.string.lowerFirst(t4.operation));
          var o = this;
          ["type", "description", "delay", "maxAttempts", "acceptors"].forEach(function(e5) {
            var n5 = t4[e5];
            n5 && i(o, e5, n5);
          });
        };
      }, { "../util": 73 }], 45: [function(e3, t3, n3) {
        function r2(e4, t4, n4) {
          null != n4 && m.property.apply(this, arguments);
        }
        function i(e4, t4) {
          e4.constructor.prototype[t4] || m.memoizedProperty.apply(this, arguments);
        }
        function o(e4, t4, n4) {
          t4 = t4 || {}, r2(this, "shape", e4.shape), r2(this, "api", t4.api, false), r2(this, "type", e4.type), r2(this, "enum", e4.enum), r2(this, "min", e4.min), r2(this, "max", e4.max), r2(this, "pattern", e4.pattern), r2(this, "location", e4.location || this.location || "body"), r2(this, "name", this.name || e4.xmlName || e4.queryName || e4.locationName || n4), r2(this, "isStreaming", e4.streaming || this.isStreaming || false), r2(this, "requiresLength", e4.requiresLength, false), r2(this, "isComposite", e4.isComposite || false), r2(this, "isShape", true, false), r2(this, "isQueryName", Boolean(e4.queryName), false), r2(this, "isLocationName", Boolean(e4.locationName), false), r2(this, "isIdempotent", true === e4.idempotencyToken), r2(this, "isJsonValue", true === e4.jsonvalue), r2(this, "isSensitive", true === e4.sensitive || e4.prototype && true === e4.prototype.sensitive), r2(this, "isEventStream", Boolean(e4.eventstream), false), r2(this, "isEvent", Boolean(e4.event), false), r2(this, "isEventPayload", Boolean(e4.eventpayload), false), r2(this, "isEventHeader", Boolean(e4.eventheader), false), r2(this, "isTimestampFormatSet", Boolean(e4.timestampFormat) || e4.prototype && true === e4.prototype.isTimestampFormatSet, false), r2(this, "endpointDiscoveryId", Boolean(e4.endpointdiscoveryid), false), r2(this, "hostLabel", Boolean(e4.hostLabel), false), t4.documentation && (r2(this, "documentation", e4.documentation), r2(this, "documentationUrl", e4.documentationUrl)), e4.xmlAttribute && r2(this, "isXmlAttribute", e4.xmlAttribute || false), r2(this, "defaultValue", null), this.toWireFormat = function(e5) {
            return null == e5 ? "" : e5;
          }, this.toType = function(e5) {
            return e5;
          };
        }
        function s(e4) {
          o.apply(this, arguments), r2(this, "isComposite", true), e4.flattened && r2(this, "flattened", e4.flattened || false);
        }
        function a(e4, t4) {
          var n4 = this, a2 = null, c2 = !this.isShape;
          s.apply(this, arguments), c2 && (r2(this, "defaultValue", function() {
            return {};
          }), r2(this, "members", {}), r2(this, "memberNames", []), r2(this, "required", []), r2(this, "isRequired", function() {
            return false;
          })), e4.members && (r2(this, "members", new f(e4.members, t4, function(e5, n5) {
            return o.create(n5, t4, e5);
          })), i(this, "memberNames", function() {
            return e4.xmlOrder || Object.keys(e4.members);
          }), e4.event && (i(this, "eventPayloadMemberName", function() {
            for (var e5 = n4.members, t5 = n4.memberNames, r3 = 0, i2 = t5.length; r3 < i2; r3++)
              if (e5[t5[r3]].isEventPayload)
                return t5[r3];
          }), i(this, "eventHeaderMemberNames", function() {
            for (var e5 = n4.members, t5 = n4.memberNames, r3 = [], i2 = 0, o2 = t5.length; i2 < o2; i2++)
              e5[t5[i2]].isEventHeader && r3.push(t5[i2]);
            return r3;
          }))), e4.required && (r2(this, "required", e4.required), r2(this, "isRequired", function(t5) {
            if (!a2) {
              a2 = {};
              for (var n5 = 0; n5 < e4.required.length; n5++)
                a2[e4.required[n5]] = true;
            }
            return a2[t5];
          }, false, true)), r2(this, "resultWrapper", e4.resultWrapper || null), e4.payload && r2(this, "payload", e4.payload), "string" == typeof e4.xmlNamespace ? r2(this, "xmlNamespaceUri", e4.xmlNamespace) : "object" == typeof e4.xmlNamespace && (r2(this, "xmlNamespacePrefix", e4.xmlNamespace.prefix), r2(this, "xmlNamespaceUri", e4.xmlNamespace.uri));
        }
        function c(e4, t4) {
          var n4 = this, a2 = !this.isShape;
          if (s.apply(this, arguments), a2 && r2(this, "defaultValue", function() {
            return [];
          }), e4.member && i(this, "member", function() {
            return o.create(e4.member, t4);
          }), this.flattened) {
            var c2 = this.name;
            i(this, "name", function() {
              return n4.member.name || c2;
            });
          }
        }
        function u(e4, t4) {
          var n4 = !this.isShape;
          s.apply(this, arguments), n4 && (r2(this, "defaultValue", function() {
            return {};
          }), r2(this, "key", o.create({ type: "string" }, t4)), r2(this, "value", o.create({ type: "string" }, t4))), e4.key && i(this, "key", function() {
            return o.create(e4.key, t4);
          }), e4.value && i(this, "value", function() {
            return o.create(e4.value, t4);
          });
        }
        function l() {
          o.apply(this, arguments);
          var e4 = ["rest-xml", "query", "ec2"];
          this.toType = function(t4) {
            return t4 = this.api && e4.indexOf(this.api.protocol) > -1 ? t4 || "" : t4, this.isJsonValue ? JSON.parse(t4) : t4 && "function" == typeof t4.toString ? t4.toString() : t4;
          }, this.toWireFormat = function(e5) {
            return this.isJsonValue ? JSON.stringify(e5) : e5;
          };
        }
        function p() {
          o.apply(this, arguments), this.toType = function(e4) {
            var t4 = m.base64.decode(e4);
            if (this.isSensitive && m.isNode() && "function" == typeof m.Buffer.alloc) {
              var n4 = m.Buffer.alloc(t4.length, t4);
              t4.fill(0), t4 = n4;
            }
            return t4;
          }, this.toWireFormat = m.base64.encode;
        }
        function d() {
          p.apply(this, arguments);
        }
        function h() {
          o.apply(this, arguments), this.toType = function(e4) {
            return "boolean" == typeof e4 ? e4 : null == e4 ? null : "true" === e4;
          };
        }
        var f = e3("./collection"), m = e3("../util");
        o.normalizedTypes = { character: "string", double: "float", long: "integer", short: "integer", biginteger: "integer", bigdecimal: "float", blob: "binary" }, o.types = { structure: a, list: c, map: u, boolean: h, timestamp: function(e4) {
          var t4 = this;
          if (o.apply(this, arguments), e4.timestampFormat)
            r2(this, "timestampFormat", e4.timestampFormat);
          else if (t4.isTimestampFormatSet && this.timestampFormat)
            r2(this, "timestampFormat", this.timestampFormat);
          else if ("header" === this.location)
            r2(this, "timestampFormat", "rfc822");
          else if ("querystring" === this.location)
            r2(this, "timestampFormat", "iso8601");
          else if (this.api)
            switch (this.api.protocol) {
              case "json":
              case "rest-json":
                r2(this, "timestampFormat", "unixTimestamp");
                break;
              case "rest-xml":
              case "query":
              case "ec2":
                r2(this, "timestampFormat", "iso8601");
            }
          this.toType = function(e5) {
            return null == e5 ? null : "function" == typeof e5.toUTCString ? e5 : "string" == typeof e5 || "number" == typeof e5 ? m.date.parseTimestamp(e5) : null;
          }, this.toWireFormat = function(e5) {
            return m.date.format(e5, t4.timestampFormat);
          };
        }, float: function() {
          o.apply(this, arguments), this.toType = function(e4) {
            return null == e4 ? null : parseFloat(e4);
          }, this.toWireFormat = this.toType;
        }, integer: function() {
          o.apply(this, arguments), this.toType = function(e4) {
            return null == e4 ? null : parseInt(e4, 10);
          }, this.toWireFormat = this.toType;
        }, string: l, base64: d, binary: p }, o.resolve = function(e4, t4) {
          if (e4.shape) {
            var n4 = t4.api.shapes[e4.shape];
            if (!n4)
              throw new Error("Cannot find shape reference: " + e4.shape);
            return n4;
          }
          return null;
        }, o.create = function(e4, t4, n4) {
          if (e4.isShape)
            return e4;
          var r3 = o.resolve(e4, t4);
          if (r3) {
            var i2 = Object.keys(e4);
            t4.documentation || (i2 = i2.filter(function(e5) {
              return !e5.match(/documentation/);
            }));
            var s2 = function() {
              r3.constructor.call(this, e4, t4, n4);
            };
            return s2.prototype = r3, new s2();
          }
          e4.type || (e4.members ? e4.type = "structure" : e4.member ? e4.type = "list" : e4.key ? e4.type = "map" : e4.type = "string");
          var a2 = e4.type;
          if (o.normalizedTypes[e4.type] && (e4.type = o.normalizedTypes[e4.type]), o.types[e4.type])
            return new o.types[e4.type](e4, t4, n4);
          throw new Error("Unrecognized shape type: " + a2);
        }, o.shapes = { StructureShape: a, ListShape: c, MapShape: u, StringShape: l, BooleanShape: h, Base64Shape: d }, t3.exports = o;
      }, { "../util": 73, "./collection": 41 }], 46: [function(e3, t3, n3) {
        var r2 = e3("./core");
        r2.ParamValidator = r2.util.inherit({ constructor: function(e4) {
          true !== e4 && void 0 !== e4 || (e4 = { min: true }), this.validation = e4;
        }, validate: function(e4, t4, n4) {
          if (this.errors = [], this.validateMember(e4, t4 || {}, n4 || "params"), this.errors.length > 1) {
            var i = this.errors.join("\n* ");
            throw i = "There were " + this.errors.length + " validation errors:\n* " + i, r2.util.error(new Error(i), { code: "MultipleValidationErrors", errors: this.errors });
          }
          if (1 === this.errors.length)
            throw this.errors[0];
          return true;
        }, fail: function(e4, t4) {
          this.errors.push(r2.util.error(new Error(t4), { code: e4 }));
        }, validateStructure: function(e4, t4, n4) {
          this.validateType(t4, n4, ["object"], "structure");
          for (var r3, i = 0; e4.required && i < e4.required.length; i++) {
            null != t4[r3 = e4.required[i]] || this.fail("MissingRequiredParameter", "Missing required key '" + r3 + "' in " + n4);
          }
          for (r3 in t4)
            if (Object.prototype.hasOwnProperty.call(t4, r3)) {
              var o = t4[r3], s = e4.members[r3];
              if (void 0 !== s) {
                var a = [n4, r3].join(".");
                this.validateMember(s, o, a);
              } else
                this.fail("UnexpectedParameter", "Unexpected key '" + r3 + "' found in " + n4);
            }
          return true;
        }, validateMember: function(e4, t4, n4) {
          switch (e4.type) {
            case "structure":
              return this.validateStructure(e4, t4, n4);
            case "list":
              return this.validateList(e4, t4, n4);
            case "map":
              return this.validateMap(e4, t4, n4);
            default:
              return this.validateScalar(e4, t4, n4);
          }
        }, validateList: function(e4, t4, n4) {
          if (this.validateType(t4, n4, [Array])) {
            this.validateRange(e4, t4.length, n4, "list member count");
            for (var r3 = 0; r3 < t4.length; r3++)
              this.validateMember(e4.member, t4[r3], n4 + "[" + r3 + "]");
          }
        }, validateMap: function(e4, t4, n4) {
          if (this.validateType(t4, n4, ["object"], "map")) {
            var r3 = 0;
            for (var i in t4)
              Object.prototype.hasOwnProperty.call(t4, i) && (this.validateMember(e4.key, i, n4 + "[key='" + i + "']"), this.validateMember(e4.value, t4[i], n4 + "['" + i + "']"), r3++);
            this.validateRange(e4, r3, n4, "map member count");
          }
        }, validateScalar: function(e4, t4, n4) {
          switch (e4.type) {
            case null:
            case void 0:
            case "string":
              return this.validateString(e4, t4, n4);
            case "base64":
            case "binary":
              return this.validatePayload(t4, n4);
            case "integer":
            case "float":
              return this.validateNumber(e4, t4, n4);
            case "boolean":
              return this.validateType(t4, n4, ["boolean"]);
            case "timestamp":
              return this.validateType(t4, n4, [Date, /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/, "number"], "Date object, ISO-8601 string, or a UNIX timestamp");
            default:
              return this.fail("UnkownType", "Unhandled type " + e4.type + " for " + n4);
          }
        }, validateString: function(e4, t4, n4) {
          var r3 = ["string"];
          e4.isJsonValue && (r3 = r3.concat(["number", "object", "boolean"])), null !== t4 && this.validateType(t4, n4, r3) && (this.validateEnum(e4, t4, n4), this.validateRange(e4, t4.length, n4, "string length"), this.validatePattern(e4, t4, n4), this.validateUri(e4, t4, n4));
        }, validateUri: function(e4, t4, n4) {
          "uri" === e4.location && 0 === t4.length && this.fail("UriParameterError", 'Expected uri parameter to have length >= 1, but found "' + t4 + '" for ' + n4);
        }, validatePattern: function(e4, t4, n4) {
          this.validation.pattern && void 0 !== e4.pattern && (new RegExp(e4.pattern).test(t4) || this.fail("PatternMatchError", 'Provided value "' + t4 + '" does not match regex pattern /' + e4.pattern + "/ for " + n4));
        }, validateRange: function(e4, t4, n4, r3) {
          this.validation.min && void 0 !== e4.min && t4 < e4.min && this.fail("MinRangeError", "Expected " + r3 + " >= " + e4.min + ", but found " + t4 + " for " + n4), this.validation.max && void 0 !== e4.max && t4 > e4.max && this.fail("MaxRangeError", "Expected " + r3 + " <= " + e4.max + ", but found " + t4 + " for " + n4);
        }, validateEnum: function(e4, t4, n4) {
          this.validation.enum && void 0 !== e4.enum && -1 === e4.enum.indexOf(t4) && this.fail("EnumError", "Found string value of " + t4 + ", but expected " + e4.enum.join("|") + " for " + n4);
        }, validateType: function(e4, t4, n4, i) {
          if (null == e4)
            return false;
          for (var o = false, s = 0; s < n4.length; s++) {
            if ("string" == typeof n4[s]) {
              if (typeof e4 === n4[s])
                return true;
            } else if (n4[s] instanceof RegExp) {
              if ((e4 || "").toString().match(n4[s]))
                return true;
            } else {
              if (e4 instanceof n4[s])
                return true;
              if (r2.util.isType(e4, n4[s]))
                return true;
              i || o || (n4 = n4.slice()), n4[s] = r2.util.typeName(n4[s]);
            }
            o = true;
          }
          var a = i;
          a || (a = n4.join(", ").replace(/,([^,]+)$/, ", or$1"));
          var c = a.match(/^[aeiou]/i) ? "n" : "";
          return this.fail("InvalidParameterType", "Expected " + t4 + " to be a" + c + " " + a), false;
        }, validateNumber: function(e4, t4, n4) {
          if (null != t4) {
            if ("string" == typeof t4) {
              var r3 = parseFloat(t4);
              r3.toString() === t4 && (t4 = r3);
            }
            this.validateType(t4, n4, ["number"]) && this.validateRange(e4, t4, n4, "numeric value");
          }
        }, validatePayload: function(e4, t4) {
          if (null != e4 && "string" != typeof e4 && (!e4 || "number" != typeof e4.byteLength)) {
            if (r2.util.isNode()) {
              var n4 = r2.util.stream.Stream;
              if (r2.util.Buffer.isBuffer(e4) || e4 instanceof n4)
                return;
            } else if (void 0 !== typeof Blob && e4 instanceof Blob)
              return;
            var i = ["Buffer", "Stream", "File", "Blob", "ArrayBuffer", "DataView"];
            if (e4)
              for (var o = 0; o < i.length; o++) {
                if (r2.util.isType(e4, i[o]))
                  return;
                if (r2.util.typeName(e4.constructor) === i[o])
                  return;
              }
            this.fail("InvalidParameterType", "Expected " + t4 + " to be a string, Buffer, Stream, Blob, or typed array object");
          }
        } });
      }, { "./core": 20 }], 47: [function(e3, t3, n3) {
        var r2 = e3("../util"), i = e3("../core");
        t3.exports = { populateHostPrefix: function(e4) {
          if (!e4.service.config.hostPrefixEnabled)
            return e4;
          var t4 = e4.service.api.operations[e4.operation];
          if (function(e5) {
            var t5 = e5.service.api, n5 = t5.operations[e5.operation], i2 = t5.endpointOperation && t5.endpointOperation === r2.string.lowerFirst(n5.name);
            return "NULL" !== n5.endpointDiscoveryRequired || true === i2;
          }(e4))
            return e4;
          if (t4.endpoint && t4.endpoint.hostPrefix) {
            var n4 = function(e5, t5, n5) {
              return r2.each(n5.members, function(n6, i2) {
                if (true === i2.hostLabel) {
                  if ("string" != typeof t5[n6] || "" === t5[n6])
                    throw r2.error(new Error(), { message: "Parameter " + n6 + " should be a non-empty string.", code: "InvalidParameter" });
                  var o = new RegExp("\\{" + n6 + "\\}", "g");
                  e5 = e5.replace(o, t5[n6]);
                }
              }), e5;
            }(t4.endpoint.hostPrefix, e4.params, t4.input);
            (function(e5, t5) {
              e5.host && (e5.host = t5 + e5.host), e5.hostname && (e5.hostname = t5 + e5.hostname);
            })(e4.httpRequest.endpoint, n4), function(e5) {
              var t5 = e5.split("."), n5 = /^[a-zA-Z0-9]{1}$|^[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9]$/;
              r2.arrayEach(t5, function(e6) {
                if (!e6.length || e6.length < 1 || e6.length > 63)
                  throw r2.error(new Error(), { code: "ValidationError", message: "Hostname label length should be between 1 to 63 characters, inclusive." });
                if (!n5.test(e6))
                  throw i.util.error(new Error(), { code: "ValidationError", message: e6 + " is not hostname compatible." });
              });
            }(e4.httpRequest.endpoint.hostname);
          }
          return e4;
        } };
      }, { "../core": 20, "../util": 73 }], 48: [function(e3, t3, n3) {
        var r2 = e3("../util"), i = e3("../json/builder"), o = e3("../json/parser"), s = e3("./helpers").populateHostPrefix;
        t3.exports = { buildRequest: function(e4) {
          var t4 = e4.httpRequest, n4 = e4.service.api, r3 = n4.targetPrefix + "." + n4.operations[e4.operation].name, o2 = n4.jsonVersion || "1.0", a = n4.operations[e4.operation].input, c = new i();
          1 === o2 && (o2 = "1.0"), t4.body = c.build(e4.params || {}, a), t4.headers["Content-Type"] = "application/x-amz-json-" + o2, t4.headers["X-Amz-Target"] = r3, s(e4);
        }, extractError: function(e4) {
          var t4 = {}, n4 = e4.httpResponse;
          if (t4.code = n4.headers["x-amzn-errortype"] || "UnknownError", "string" == typeof t4.code && (t4.code = t4.code.split(":")[0]), n4.body.length > 0)
            try {
              var i2 = JSON.parse(n4.body.toString()), o2 = i2.__type || i2.code || i2.Code;
              o2 && (t4.code = o2.split("#").pop()), "RequestEntityTooLarge" === t4.code ? t4.message = "Request body must be less than 1 MB" : t4.message = i2.message || i2.Message || null;
            } catch (i3) {
              t4.statusCode = n4.statusCode, t4.message = n4.statusMessage;
            }
          else
            t4.statusCode = n4.statusCode, t4.message = n4.statusCode.toString();
          e4.error = r2.error(new Error(), t4);
        }, extractData: function(e4) {
          var t4 = e4.httpResponse.body.toString() || "{}";
          if (false === e4.request.service.config.convertResponseTypes)
            e4.data = JSON.parse(t4);
          else {
            var n4 = e4.request.service.api.operations[e4.request.operation].output || {}, r3 = new o();
            e4.data = r3.parse(t4, n4);
          }
        } };
      }, { "../json/builder": 38, "../json/parser": 39, "../util": 73, "./helpers": 47 }], 49: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../util"), o = e3("../query/query_param_serializer"), s = e3("../model/shape"), a = e3("./helpers").populateHostPrefix;
        t3.exports = { buildRequest: function(e4) {
          var t4 = e4.service.api.operations[e4.operation], n4 = e4.httpRequest;
          n4.headers["Content-Type"] = "application/x-www-form-urlencoded; charset=utf-8", n4.params = { Version: e4.service.api.apiVersion, Action: t4.name }, new o().serialize(e4.params, t4.input, function(e5, t5) {
            n4.params[e5] = t5;
          }), n4.body = i.queryParamsToString(n4.params), a(e4);
        }, extractError: function(e4) {
          var t4, n4 = e4.httpResponse.body.toString();
          if (n4.match("<UnknownOperationException"))
            t4 = { Code: "UnknownOperation", Message: "Unknown operation " + e4.request.operation };
          else
            try {
              t4 = new r2.XML.Parser().parse(n4);
            } catch (n5) {
              t4 = { Code: e4.httpResponse.statusCode, Message: e4.httpResponse.statusMessage };
            }
          t4.requestId && !e4.requestId && (e4.requestId = t4.requestId), t4.Errors && (t4 = t4.Errors), t4.Error && (t4 = t4.Error), t4.Code ? e4.error = i.error(new Error(), { code: t4.Code, message: t4.Message }) : e4.error = i.error(new Error(), { code: e4.httpResponse.statusCode, message: null });
        }, extractData: function(e4) {
          var t4 = e4.request, n4 = t4.service.api.operations[t4.operation].output || {}, o2 = n4;
          if (o2.resultWrapper) {
            var a2 = s.create({ type: "structure" });
            a2.members[o2.resultWrapper] = n4, a2.memberNames = [o2.resultWrapper], i.property(n4, "name", n4.resultWrapper), n4 = a2;
          }
          var c = new r2.XML.Parser();
          if (n4 && n4.members && !n4.members._XAMZRequestId) {
            var u = s.create({ type: "string" }, { api: { protocol: "query" } }, "requestId");
            n4.members._XAMZRequestId = u;
          }
          var l = c.parse(e4.httpResponse.body.toString(), n4);
          e4.requestId = l._XAMZRequestId || l.requestId, l._XAMZRequestId && delete l._XAMZRequestId, o2.resultWrapper && l[o2.resultWrapper] && (i.update(l, l[o2.resultWrapper]), delete l[o2.resultWrapper]), e4.data = l;
        } };
      }, { "../core": 20, "../model/shape": 45, "../query/query_param_serializer": 53, "../util": 73, "./helpers": 47 }], 50: [function(e3, t3, n3) {
        function r2(e4, t4, n4, r3) {
          var o2 = [e4, t4].join("/");
          o2 = o2.replace(/\/+/g, "/");
          var s = {}, a = false;
          if (i.each(n4.members, function(e5, t5) {
            var n5 = r3[e5];
            if (null != n5)
              if ("uri" === t5.location) {
                var c2 = new RegExp("\\{" + t5.name + "(\\+)?\\}");
                o2 = o2.replace(c2, function(e6, t6) {
                  return (t6 ? i.uriEscapePath : i.uriEscape)(String(n5));
                });
              } else
                "querystring" === t5.location && (a = true, "list" === t5.type ? s[t5.name] = n5.map(function(e6) {
                  return i.uriEscape(t5.member.toWireFormat(e6).toString());
                }) : "map" === t5.type ? i.each(n5, function(e6, t6) {
                  Array.isArray(t6) ? s[e6] = t6.map(function(e7) {
                    return i.uriEscape(String(e7));
                  }) : s[e6] = i.uriEscape(String(t6));
                }) : s[t5.name] = i.uriEscape(t5.toWireFormat(n5).toString()));
          }), a) {
            o2 += o2.indexOf("?") >= 0 ? "&" : "?";
            var c = [];
            i.arrayEach(Object.keys(s).sort(), function(e5) {
              Array.isArray(s[e5]) || (s[e5] = [s[e5]]);
              for (var t5 = 0; t5 < s[e5].length; t5++)
                c.push(i.uriEscape(String(e5)) + "=" + s[e5][t5]);
            }), o2 += c.join("&");
          }
          return o2;
        }
        var i = e3("../util"), o = e3("./helpers").populateHostPrefix;
        t3.exports = { buildRequest: function(e4) {
          (function(e5) {
            e5.httpRequest.method = e5.service.api.operations[e5.operation].httpMethod;
          })(e4), function(e5) {
            var t4 = e5.service.api.operations[e5.operation], n4 = t4.input, i2 = r2(e5.httpRequest.endpoint.path, t4.httpPath, n4, e5.params);
            e5.httpRequest.path = i2;
          }(e4), function(e5) {
            var t4 = e5.service.api.operations[e5.operation];
            i.each(t4.input.members, function(t5, n4) {
              var r3 = e5.params[t5];
              null != r3 && ("headers" === n4.location && "map" === n4.type ? i.each(r3, function(t6, r4) {
                e5.httpRequest.headers[n4.name + t6] = r4;
              }) : "header" === n4.location && (r3 = n4.toWireFormat(r3).toString(), n4.isJsonValue && (r3 = i.base64.encode(r3)), e5.httpRequest.headers[n4.name] = r3));
            });
          }(e4), o(e4);
        }, extractError: function() {
        }, extractData: function(e4) {
          var t4 = e4.request, n4 = {}, r3 = e4.httpResponse, o2 = t4.service.api.operations[t4.operation].output, s = {};
          i.each(r3.headers, function(e5, t5) {
            s[e5.toLowerCase()] = t5;
          }), i.each(o2.members, function(e5, t5) {
            var o3 = (t5.name || e5).toLowerCase();
            if ("headers" === t5.location && "map" === t5.type) {
              n4[e5] = {};
              var a = t5.isLocationName ? t5.name : "", c = new RegExp("^" + a + "(.+)", "i");
              i.each(r3.headers, function(t6, r4) {
                var i2 = t6.match(c);
                null !== i2 && (n4[e5][i2[1]] = r4);
              });
            } else if ("header" === t5.location) {
              if (void 0 !== s[o3]) {
                var u = t5.isJsonValue ? i.base64.decode(s[o3]) : s[o3];
                n4[e5] = t5.toType(u);
              }
            } else
              "statusCode" === t5.location && (n4[e5] = parseInt(r3.statusCode, 10));
          }), e4.data = n4;
        }, generateURI: r2 };
      }, { "../util": 73, "./helpers": 47 }], 51: [function(e3, t3, n3) {
        function r2(e4, t4) {
          if (e4.service.api.operations[e4.operation].input, !e4.httpRequest.headers["Content-Type"]) {
            var n4 = t4 ? "binary/octet-stream" : "application/json";
            e4.httpRequest.headers["Content-Type"] = n4;
          }
        }
        var i = e3("../util"), o = e3("./rest"), s = e3("./json"), a = e3("../json/builder"), c = e3("../json/parser");
        t3.exports = { buildRequest: function(e4) {
          o.buildRequest(e4), ["HEAD", "DELETE"].indexOf(e4.httpRequest.method) < 0 && function(e5) {
            var t4 = new a(), n4 = e5.service.api.operations[e5.operation].input;
            if (n4.payload) {
              var i2, o2 = n4.members[n4.payload];
              if (void 0 === (i2 = e5.params[n4.payload]))
                return;
              "structure" === o2.type ? (e5.httpRequest.body = t4.build(i2, o2), r2(e5)) : (e5.httpRequest.body = i2, ("binary" === o2.type || o2.isStreaming) && r2(e5, true));
            } else {
              var s2 = t4.build(e5.params, n4);
              "{}" === s2 && "GET" === e5.httpRequest.method || (e5.httpRequest.body = s2), r2(e5);
            }
          }(e4);
        }, extractError: function(e4) {
          s.extractError(e4);
        }, extractData: function(e4) {
          o.extractData(e4);
          var t4 = e4.request, n4 = t4.service.api.operations[t4.operation], r3 = t4.service.api.operations[t4.operation].output || {};
          if (n4.hasEventOutput, r3.payload) {
            var a2 = r3.members[r3.payload], u = e4.httpResponse.body;
            if (a2.isEventStream)
              l = new c(), e4.data[payload] = i.createEventStream(2 === AWS.HttpClient.streamsApiVersion ? e4.httpResponse.stream : u, l, a2);
            else if ("structure" === a2.type || "list" === a2.type) {
              var l = new c();
              e4.data[r3.payload] = l.parse(u, a2);
            } else
              "binary" === a2.type || a2.isStreaming ? e4.data[r3.payload] = u : e4.data[r3.payload] = a2.toType(u);
          } else {
            var p = e4.data;
            s.extractData(e4), e4.data = i.merge(p, e4.data);
          }
        } };
      }, { "../json/builder": 38, "../json/parser": 39, "../util": 73, "./json": 48, "./rest": 50 }], 52: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../util"), o = e3("./rest");
        t3.exports = { buildRequest: function(e4) {
          o.buildRequest(e4), ["GET", "HEAD"].indexOf(e4.httpRequest.method) < 0 && function(e5) {
            var t4 = e5.service.api.operations[e5.operation].input, n4 = new r2.XML.Builder(), o2 = e5.params, s = t4.payload;
            if (s) {
              var a = t4.members[s];
              if (void 0 === (o2 = o2[s]))
                return;
              if ("structure" === a.type) {
                var c = a.name;
                e5.httpRequest.body = n4.toXML(o2, a, c, true);
              } else
                e5.httpRequest.body = o2;
            } else
              e5.httpRequest.body = n4.toXML(o2, t4, t4.name || t4.shape || i.string.upperFirst(e5.operation) + "Request");
          }(e4);
        }, extractError: function(e4) {
          var t4;
          o.extractError(e4);
          try {
            t4 = new r2.XML.Parser().parse(e4.httpResponse.body.toString());
          } catch (n4) {
            t4 = { Code: e4.httpResponse.statusCode, Message: e4.httpResponse.statusMessage };
          }
          t4.Errors && (t4 = t4.Errors), t4.Error && (t4 = t4.Error), t4.Code ? e4.error = i.error(new Error(), { code: t4.Code, message: t4.Message }) : e4.error = i.error(new Error(), { code: e4.httpResponse.statusCode, message: null });
        }, extractData: function(e4) {
          o.extractData(e4);
          var t4, n4 = e4.request, s = e4.httpResponse.body, a = n4.service.api.operations[n4.operation], c = a.output, u = (a.hasEventOutput, c.payload);
          if (u) {
            var l = c.members[u];
            l.isEventStream ? (t4 = new r2.XML.Parser(), e4.data[u] = i.createEventStream(2 === r2.HttpClient.streamsApiVersion ? e4.httpResponse.stream : e4.httpResponse.body, t4, l)) : "structure" === l.type ? (t4 = new r2.XML.Parser(), e4.data[u] = t4.parse(s.toString(), l)) : "binary" === l.type || l.isStreaming ? e4.data[u] = s : e4.data[u] = l.toType(s);
          } else if (s.length > 0) {
            var p = (t4 = new r2.XML.Parser()).parse(s.toString(), c);
            i.update(e4.data, p);
          }
        } };
      }, { "../core": 20, "../util": 73, "./rest": 50 }], 53: [function(e3, t3, n3) {
        function r2() {
        }
        function i(e4) {
          return e4.isQueryName || "ec2" !== e4.api.protocol ? e4.name : e4.name[0].toUpperCase() + e4.name.substr(1);
        }
        function o(e4, t4, n4, r3) {
          a.each(n4.members, function(n5, o2) {
            var a2 = t4[n5];
            if (null != a2) {
              var c = i(o2);
              s(c = e4 ? e4 + "." + c : c, a2, o2, r3);
            }
          });
        }
        function s(e4, t4, n4, r3) {
          null != t4 && ("structure" === n4.type ? o(e4, t4, n4, r3) : "list" === n4.type ? function(e5, t5, n5, r4) {
            var o2 = n5.member || {};
            0 !== t5.length ? a.arrayEach(t5, function(t6, a2) {
              var c = "." + (a2 + 1);
              if ("ec2" === n5.api.protocol)
                c += "";
              else if (n5.flattened) {
                if (o2.name) {
                  var u = e5.split(".");
                  u.pop(), u.push(i(o2)), e5 = u.join(".");
                }
              } else
                c = "." + (o2.name ? o2.name : "member") + c;
              s(e5 + c, t6, o2, r4);
            }) : r4.call(this, e5, null);
          }(e4, t4, n4, r3) : "map" === n4.type ? function(e5, t5, n5, r4) {
            var i2 = 1;
            a.each(t5, function(t6, o2) {
              var a2 = (n5.flattened ? "." : ".entry.") + i2++ + ".", c = a2 + (n5.key.name || "key"), u = a2 + (n5.value.name || "value");
              s(e5 + c, t6, n5.key, r4), s(e5 + u, o2, n5.value, r4);
            });
          }(e4, t4, n4, r3) : r3(e4, n4.toWireFormat(t4).toString()));
        }
        var a = e3("../util");
        r2.prototype.serialize = function(e4, t4, n4) {
          o("", e4, t4, n4);
        }, t3.exports = r2;
      }, { "../util": 73 }], 54: [function(e3, t3, n3) {
        t3.exports = { now: function() {
          return "undefined" != typeof performance && "function" == typeof performance.now ? performance.now() : Date.now();
        } };
      }, {}], 55: [function(e3, t3, n3) {
        function r2(e4, t4) {
          i.each(t4, function(t5, n4) {
            "globalEndpoint" !== t5 && (void 0 !== e4.config[t5] && null !== e4.config[t5] || (e4.config[t5] = n4));
          });
        }
        var i = e3("./util"), o = e3("./region_config_data.json");
        t3.exports = { configureEndpoint: function(e4) {
          for (var t4 = function(e5) {
            var t5 = e5.config.region, n5 = function(e6) {
              if (!e6)
                return null;
              var t6 = e6.split("-");
              return t6.length < 3 ? null : t6.slice(0, t6.length - 2).join("-") + "-*";
            }(t5), r3 = e5.api.endpointPrefix;
            return [[t5, r3], [n5, r3], [t5, "*"], [n5, "*"], ["*", r3], ["*", "*"]].map(function(e6) {
              return e6[0] && e6[1] ? e6.join("/") : null;
            });
          }(e4), n4 = 0; n4 < t4.length; n4++) {
            var s = t4[n4];
            if (s && Object.prototype.hasOwnProperty.call(o.rules, s)) {
              var a = o.rules[s];
              return "string" == typeof a && (a = o.patterns[a]), e4.config.useDualstack && i.isDualstackAvailable(e4) && ((a = i.copy(a)).endpoint = a.endpoint.replace(/{service}\.({region}\.)?/, "{service}.dualstack.{region}.")), e4.isGlobalEndpoint = !!a.globalEndpoint, a.signingRegion && (e4.signingRegion = a.signingRegion), a.signatureVersion || (a.signatureVersion = "v4"), void r2(e4, a);
            }
          }
        }, getEndpointSuffix: function(e4) {
          for (var t4 = { "^(us|eu|ap|sa|ca|me)\\-\\w+\\-\\d+$": "amazonaws.com", "^cn\\-\\w+\\-\\d+$": "amazonaws.com.cn", "^us\\-gov\\-\\w+\\-\\d+$": "amazonaws.com", "^us\\-iso\\-\\w+\\-\\d+$": "c2s.ic.gov", "^us\\-isob\\-\\w+\\-\\d+$": "sc2s.sgov.gov" }, n4 = Object.keys(t4), r3 = 0; r3 < n4.length; r3++) {
            var i2 = RegExp(n4[r3]), o2 = t4[n4[r3]];
            if (i2.test(e4))
              return o2;
          }
          return "amazonaws.com";
        } };
      }, { "./region_config_data.json": 56, "./util": 73 }], 56: [function(e3, t3, n3) {
        t3.exports = { rules: { "*/*": { endpoint: "{service}.{region}.amazonaws.com" }, "cn-*/*": { endpoint: "{service}.{region}.amazonaws.com.cn" }, "us-iso-*/*": { endpoint: "{service}.{region}.c2s.ic.gov" }, "us-isob-*/*": { endpoint: "{service}.{region}.sc2s.sgov.gov" }, "*/budgets": "globalSSL", "*/cloudfront": "globalSSL", "*/sts": "globalSSL", "*/importexport": { endpoint: "{service}.amazonaws.com", signatureVersion: "v2", globalEndpoint: true }, "*/route53": "globalSSL", "cn-*/route53": { endpoint: "{service}.amazonaws.com.cn", globalEndpoint: true, signingRegion: "cn-northwest-1" }, "us-gov-*/route53": "globalGovCloud", "*/waf": "globalSSL", "*/iam": "globalSSL", "cn-*/iam": { endpoint: "{service}.cn-north-1.amazonaws.com.cn", globalEndpoint: true, signingRegion: "cn-north-1" }, "us-gov-*/iam": "globalGovCloud", "us-gov-*/sts": { endpoint: "{service}.{region}.amazonaws.com" }, "us-gov-west-1/s3": "s3signature", "us-west-1/s3": "s3signature", "us-west-2/s3": "s3signature", "eu-west-1/s3": "s3signature", "ap-southeast-1/s3": "s3signature", "ap-southeast-2/s3": "s3signature", "ap-northeast-1/s3": "s3signature", "sa-east-1/s3": "s3signature", "us-east-1/s3": { endpoint: "{service}.amazonaws.com", signatureVersion: "s3" }, "us-east-1/sdb": { endpoint: "{service}.amazonaws.com", signatureVersion: "v2" }, "*/sdb": { endpoint: "{service}.{region}.amazonaws.com", signatureVersion: "v2" } }, patterns: { globalSSL: { endpoint: "https://{service}.amazonaws.com", globalEndpoint: true, signingRegion: "us-east-1" }, globalGovCloud: { endpoint: "{service}.us-gov.amazonaws.com", globalEndpoint: true, signingRegion: "us-gov-west-1" }, s3signature: { endpoint: "{service}.{region}.amazonaws.com", signatureVersion: "s3" } } };
      }, {}], 57: [function(e3, t3, n3) {
        (function(t4) {
          (function() {
            var n4 = e3("./core"), r2 = e3("./state_machine"), i = n4.util.inherit, o = n4.util.domain, s = e3("jmespath"), a = { success: 1, error: 1, complete: 1 }, c = new r2();
            c.setupStates = function() {
              var e4 = function(e5, t5) {
                var n5 = this;
                n5._haltHandlersOnError = false, n5.emit(n5._asm.currentState, function(e6) {
                  if (e6)
                    if (function(e7) {
                      return Object.prototype.hasOwnProperty.call(a, e7._asm.currentState);
                    }(n5)) {
                      if (!(o && n5.domain instanceof o.Domain))
                        throw e6;
                      e6.domainEmitter = n5, e6.domain = n5.domain, e6.domainThrown = false, n5.domain.emit("error", e6);
                    } else
                      n5.response.error = e6, t5(e6);
                  else
                    t5(n5.response.error);
                });
              };
              this.addState("validate", "build", "error", e4), this.addState("build", "afterBuild", "restart", e4), this.addState("afterBuild", "sign", "restart", e4), this.addState("sign", "send", "retry", e4), this.addState("retry", "afterRetry", "afterRetry", e4), this.addState("afterRetry", "sign", "error", e4), this.addState("send", "validateResponse", "retry", e4), this.addState("validateResponse", "extractData", "extractError", e4), this.addState("extractError", "extractData", "retry", e4), this.addState("extractData", "success", "retry", e4), this.addState("restart", "build", "error", e4), this.addState("success", "complete", "complete", e4), this.addState("error", "complete", "complete", e4), this.addState("complete", null, null, e4);
            }, c.setupStates(), n4.Request = i({ constructor: function(e4, t5, i2) {
              var s2 = e4.endpoint, a2 = e4.config.region, u = e4.config.customUserAgent;
              e4.isGlobalEndpoint && (a2 = e4.signingRegion ? e4.signingRegion : "us-east-1"), this.domain = o && o.active, this.service = e4, this.operation = t5, this.params = i2 || {}, this.httpRequest = new n4.HttpRequest(s2, a2), this.httpRequest.appendToUserAgent(u), this.startTime = e4.getSkewCorrectedDate(), this.response = new n4.Response(this), this._asm = new r2(c.states, "validate"), this._haltHandlersOnError = false, n4.SequentialExecutor.call(this), this.emit = this.emitEvent;
            }, send: function(e4) {
              return e4 && (this.httpRequest.appendToUserAgent("callback"), this.on("complete", function(t5) {
                e4.call(t5, t5.error, t5.data);
              })), this.runTo(), this.response;
            }, build: function(e4) {
              return this.runTo("send", e4);
            }, runTo: function(e4, t5) {
              return this._asm.runTo(e4, t5, this), this;
            }, abort: function() {
              return this.removeAllListeners("validateResponse"), this.removeAllListeners("extractError"), this.on("validateResponse", function(e4) {
                e4.error = n4.util.error(new Error("Request aborted by user"), { code: "RequestAbortedError", retryable: false });
              }), this.httpRequest.stream && !this.httpRequest.stream.didCallback && (this.httpRequest.stream.abort(), this.httpRequest._abortCallback ? this.httpRequest._abortCallback() : this.removeAllListeners("send")), this;
            }, eachPage: function(e4) {
              e4 = n4.util.fn.makeAsync(e4, 3), this.on("complete", function t5(r3) {
                e4.call(r3, r3.error, r3.data, function(i2) {
                  false !== i2 && (r3.hasNextPage() ? r3.nextPage().on("complete", t5).send() : e4.call(r3, null, null, n4.util.fn.noop));
                });
              }).send();
            }, eachItem: function(e4) {
              var t5 = this;
              this.eachPage(function(r3, i2) {
                if (r3)
                  return e4(r3, null);
                if (null === i2)
                  return e4(null, null);
                var o2 = t5.service.paginationConfig(t5.operation).resultKey;
                Array.isArray(o2) && (o2 = o2[0]);
                var a2 = s.search(i2, o2), c2 = true;
                return n4.util.arrayEach(a2, function(t6) {
                  if (false === (c2 = e4(null, t6)))
                    return n4.util.abort;
                }), c2;
              });
            }, isPageable: function() {
              return !!this.service.paginationConfig(this.operation);
            }, createReadStream: function() {
              var e4 = n4.util.stream, r3 = this, i2 = null;
              return 2 === n4.HttpClient.streamsApiVersion ? (i2 = new e4.PassThrough(), t4.nextTick(function() {
                r3.send();
              })) : ((i2 = new e4.Stream()).readable = true, i2.sent = false, i2.on("newListener", function(e5) {
                i2.sent || "data" !== e5 || (i2.sent = true, t4.nextTick(function() {
                  r3.send();
                }));
              })), this.on("error", function(e5) {
                i2.emit("error", e5);
              }), this.on("httpHeaders", function(t5, o2, s2) {
                if (t5 < 300) {
                  r3.removeListener("httpData", n4.EventListeners.Core.HTTP_DATA), r3.removeListener("httpError", n4.EventListeners.Core.HTTP_ERROR), r3.on("httpError", function(e5) {
                    s2.error = e5, s2.error.retryable = false;
                  });
                  var a2, c2 = false;
                  if ("HEAD" !== r3.httpRequest.method && (a2 = parseInt(o2["content-length"], 10)), void 0 !== a2 && !isNaN(a2) && a2 >= 0) {
                    c2 = true;
                    var u = 0;
                  }
                  var l = function() {
                    c2 && u !== a2 ? i2.emit("error", n4.util.error(new Error("Stream content length mismatch. Received " + u + " of " + a2 + " bytes."), { code: "StreamContentLengthMismatch" })) : 2 === n4.HttpClient.streamsApiVersion ? i2.end() : i2.emit("end");
                  }, p = s2.httpResponse.createUnbufferedStream();
                  if (2 === n4.HttpClient.streamsApiVersion)
                    if (c2) {
                      var d = new e4.PassThrough();
                      d._write = function(t6) {
                        return t6 && t6.length && (u += t6.length), e4.PassThrough.prototype._write.apply(this, arguments);
                      }, d.on("end", l), i2.on("error", function(e5) {
                        c2 = false, p.unpipe(d), d.emit("end"), d.end();
                      }), p.pipe(d).pipe(i2, { end: false });
                    } else
                      p.pipe(i2);
                  else
                    c2 && p.on("data", function(e5) {
                      e5 && e5.length && (u += e5.length);
                    }), p.on("data", function(e5) {
                      i2.emit("data", e5);
                    }), p.on("end", l);
                  p.on("error", function(e5) {
                    c2 = false, i2.emit("error", e5);
                  });
                }
              }), i2;
            }, emitEvent: function(e4, t5, r3) {
              "function" == typeof t5 && (r3 = t5, t5 = null), r3 || (r3 = function() {
              }), t5 || (t5 = this.eventParameters(e4, this.response)), n4.SequentialExecutor.prototype.emit.call(this, e4, t5, function(e5) {
                e5 && (this.response.error = e5), r3.call(this, e5);
              });
            }, eventParameters: function(e4) {
              switch (e4) {
                case "restart":
                case "validate":
                case "sign":
                case "build":
                case "afterValidate":
                case "afterBuild":
                  return [this];
                case "error":
                  return [this.response.error, this.response];
                default:
                  return [this.response];
              }
            }, presign: function(e4, t5) {
              return t5 || "function" != typeof e4 || (t5 = e4, e4 = null), new n4.Signers.Presign().sign(this.toGet(), e4, t5);
            }, isPresigned: function() {
              return Object.prototype.hasOwnProperty.call(this.httpRequest.headers, "presigned-expires");
            }, toUnauthenticated: function() {
              return this._unAuthenticated = true, this.removeListener("validate", n4.EventListeners.Core.VALIDATE_CREDENTIALS), this.removeListener("sign", n4.EventListeners.Core.SIGN), this;
            }, toGet: function() {
              return "query" !== this.service.api.protocol && "ec2" !== this.service.api.protocol || (this.removeListener("build", this.buildAsGet), this.addListener("build", this.buildAsGet)), this;
            }, buildAsGet: function(e4) {
              e4.httpRequest.method = "GET", e4.httpRequest.path = e4.service.endpoint.path + "?" + e4.httpRequest.body, e4.httpRequest.body = "", delete e4.httpRequest.headers["Content-Length"], delete e4.httpRequest.headers["Content-Type"];
            }, haltHandlersOnError: function() {
              this._haltHandlersOnError = true;
            } }), n4.Request.addPromisesToClass = function(e4) {
              this.prototype.promise = function() {
                var t5 = this;
                return this.httpRequest.appendToUserAgent("promise"), new e4(function(e5, n5) {
                  t5.on("complete", function(t6) {
                    t6.error ? n5(t6.error) : e5(Object.defineProperty(t6.data || {}, "$response", { value: t6 }));
                  }), t5.runTo();
                });
              };
            }, n4.Request.deletePromisesFromClass = function() {
              delete this.prototype.promise;
            }, n4.util.addPromises(n4.Request), n4.util.mixin(n4.Request, n4.SequentialExecutor);
          }).call(this);
        }).call(this, e3("_process"));
      }, { "./core": 20, "./state_machine": 72, _process: 87, jmespath: 86 }], 58: [function(e3, t3, n3) {
        function r2(e4) {
          var t4 = e4.request._waiter, n4 = t4.config.acceptors, r3 = false, i2 = "retry";
          n4.forEach(function(n5) {
            if (!r3) {
              var o2 = t4.matchers[n5.matcher];
              o2 && o2(e4, n5.expected, n5.argument) && (r3 = true, i2 = n5.state);
            }
          }), !r3 && e4.error && (i2 = "failure"), "success" === i2 ? t4.setSuccess(e4) : t4.setError(e4, "retry" === i2);
        }
        var i = e3("./core"), o = i.util.inherit, s = e3("jmespath");
        i.ResourceWaiter = o({ constructor: function(e4, t4) {
          this.service = e4, this.state = t4, this.loadWaiterConfig(this.state);
        }, service: null, state: null, config: null, matchers: { path: function(e4, t4, n4) {
          try {
            var r3 = s.search(e4.data, n4);
          } catch (e5) {
            return false;
          }
          return s.strictDeepEqual(r3, t4);
        }, pathAll: function(e4, t4, n4) {
          try {
            var r3 = s.search(e4.data, n4);
          } catch (e5) {
            return false;
          }
          Array.isArray(r3) || (r3 = [r3]);
          var i2 = r3.length;
          if (!i2)
            return false;
          for (var o2 = 0; o2 < i2; o2++)
            if (!s.strictDeepEqual(r3[o2], t4))
              return false;
          return true;
        }, pathAny: function(e4, t4, n4) {
          try {
            var r3 = s.search(e4.data, n4);
          } catch (e5) {
            return false;
          }
          Array.isArray(r3) || (r3 = [r3]);
          for (var i2 = r3.length, o2 = 0; o2 < i2; o2++)
            if (s.strictDeepEqual(r3[o2], t4))
              return true;
          return false;
        }, status: function(e4, t4) {
          var n4 = e4.httpResponse.statusCode;
          return "number" == typeof n4 && n4 === t4;
        }, error: function(e4, t4) {
          return "string" == typeof t4 && e4.error ? t4 === e4.error.code : t4 === !!e4.error;
        } }, listeners: new i.SequentialExecutor().addNamedListeners(function(e4) {
          e4("RETRY_CHECK", "retry", function(e5) {
            var t4 = e5.request._waiter;
            e5.error && "ResourceNotReady" === e5.error.code && (e5.error.retryDelay = 1e3 * (t4.config.delay || 0));
          }), e4("CHECK_OUTPUT", "extractData", r2), e4("CHECK_ERROR", "extractError", r2);
        }), wait: function(e4, t4) {
          "function" == typeof e4 && (t4 = e4, e4 = void 0), e4 && e4.$waiter && ("number" == typeof (e4 = i.util.copy(e4)).$waiter.delay && (this.config.delay = e4.$waiter.delay), "number" == typeof e4.$waiter.maxAttempts && (this.config.maxAttempts = e4.$waiter.maxAttempts), delete e4.$waiter);
          var n4 = this.service.makeRequest(this.config.operation, e4);
          return n4._waiter = this, n4.response.maxRetries = this.config.maxAttempts, n4.addListeners(this.listeners), t4 && n4.send(t4), n4;
        }, setSuccess: function(e4) {
          e4.error = null, e4.data = e4.data || {}, e4.request.removeAllListeners("extractData");
        }, setError: function(e4, t4) {
          e4.data = null, e4.error = i.util.error(e4.error || new Error(), { code: "ResourceNotReady", message: "Resource is not in the state " + this.state, retryable: t4 });
        }, loadWaiterConfig: function(e4) {
          if (!this.service.api.waiters[e4])
            throw new i.util.error(new Error(), { code: "StateNotFoundError", message: "State " + e4 + " not found." });
          this.config = i.util.copy(this.service.api.waiters[e4]);
        } });
      }, { "./core": 20, jmespath: 86 }], 59: [function(e3, t3, n3) {
        var r2 = e3("./core"), i = r2.util.inherit, o = e3("jmespath");
        r2.Response = i({ constructor: function(e4) {
          this.request = e4, this.data = null, this.error = null, this.retryCount = 0, this.redirectCount = 0, this.httpResponse = new r2.HttpResponse(), e4 && (this.maxRetries = e4.service.numRetries(), this.maxRedirects = e4.service.config.maxRedirects);
        }, nextPage: function(e4) {
          var t4, n4 = this.request.service, i2 = this.request.operation;
          try {
            t4 = n4.paginationConfig(i2, true);
          } catch (e5) {
            this.error = e5;
          }
          if (!this.hasNextPage()) {
            if (e4)
              e4(this.error, null);
            else if (this.error)
              throw this.error;
            return null;
          }
          var o2 = r2.util.copy(this.request.params);
          if (this.nextPageTokens) {
            var s = t4.inputToken;
            "string" == typeof s && (s = [s]);
            for (var a = 0; a < s.length; a++)
              o2[s[a]] = this.nextPageTokens[a];
            return n4.makeRequest(this.request.operation, o2, e4);
          }
          return e4 ? e4(null, null) : null;
        }, hasNextPage: function() {
          return this.cacheNextPageTokens(), !!this.nextPageTokens || void 0 === this.nextPageTokens && void 0;
        }, cacheNextPageTokens: function() {
          if (Object.prototype.hasOwnProperty.call(this, "nextPageTokens"))
            return this.nextPageTokens;
          this.nextPageTokens = void 0;
          var e4 = this.request.service.paginationConfig(this.request.operation);
          if (!e4)
            return this.nextPageTokens;
          if (this.nextPageTokens = null, e4.moreResults && !o.search(this.data, e4.moreResults))
            return this.nextPageTokens;
          var t4 = e4.outputToken;
          return "string" == typeof t4 && (t4 = [t4]), r2.util.arrayEach.call(this, t4, function(e5) {
            var t5 = o.search(this.data, e5);
            t5 && (this.nextPageTokens = this.nextPageTokens || [], this.nextPageTokens.push(t5));
          }), this.nextPageTokens;
        } });
      }, { "./core": 20, jmespath: 86 }], 60: [function(e3, t3, n3) {
        var r2 = e3("./core");
        r2.SequentialExecutor = r2.util.inherit({ constructor: function() {
          this._events = {};
        }, listeners: function(e4) {
          return this._events[e4] ? this._events[e4].slice(0) : [];
        }, on: function(e4, t4, n4) {
          return this._events[e4] ? n4 ? this._events[e4].unshift(t4) : this._events[e4].push(t4) : this._events[e4] = [t4], this;
        }, onAsync: function(e4, t4, n4) {
          return t4._isAsync = true, this.on(e4, t4, n4);
        }, removeListener: function(e4, t4) {
          var n4 = this._events[e4];
          if (n4) {
            for (var r3 = n4.length, i = -1, o = 0; o < r3; ++o)
              n4[o] === t4 && (i = o);
            i > -1 && n4.splice(i, 1);
          }
          return this;
        }, removeAllListeners: function(e4) {
          return e4 ? delete this._events[e4] : this._events = {}, this;
        }, emit: function(e4, t4, n4) {
          n4 || (n4 = function() {
          });
          var r3 = this.listeners(e4), i = r3.length;
          return this.callListeners(r3, t4, n4), i > 0;
        }, callListeners: function(e4, t4, n4, i) {
          function o(i2) {
            if (i2 && (a = r2.util.error(a || new Error(), i2), s._haltHandlersOnError))
              return n4.call(s, a);
            s.callListeners(e4, t4, n4, a);
          }
          for (var s = this, a = i || null; e4.length > 0; ) {
            var c = e4.shift();
            if (c._isAsync)
              return void c.apply(s, t4.concat([o]));
            try {
              c.apply(s, t4);
            } catch (e5) {
              a = r2.util.error(a || new Error(), e5);
            }
            if (a && s._haltHandlersOnError)
              return void n4.call(s, a);
          }
          n4.call(s, a);
        }, addListeners: function(e4) {
          var t4 = this;
          return e4._events && (e4 = e4._events), r2.util.each(e4, function(e5, n4) {
            "function" == typeof n4 && (n4 = [n4]), r2.util.arrayEach(n4, function(n5) {
              t4.on(e5, n5);
            });
          }), t4;
        }, addNamedListener: function(e4, t4, n4, r3) {
          return this[e4] = n4, this.addListener(t4, n4, r3), this;
        }, addNamedAsyncListener: function(e4, t4, n4, r3) {
          return n4._isAsync = true, this.addNamedListener(e4, t4, n4, r3);
        }, addNamedListeners: function(e4) {
          var t4 = this;
          return e4(function() {
            t4.addNamedListener.apply(t4, arguments);
          }, function() {
            t4.addNamedAsyncListener.apply(t4, arguments);
          }), this;
        } }), r2.SequentialExecutor.prototype.addListener = r2.SequentialExecutor.prototype.on, t3.exports = r2.SequentialExecutor;
      }, { "./core": 20 }], 61: [function(e3, t3, n3) {
        (function(n4) {
          (function() {
            var r2 = e3("./core"), i = e3("./model/api"), o = e3("./region_config"), s = r2.util.inherit, a = 0;
            r2.Service = s({ constructor: function(e4) {
              if (!this.loadServiceClass)
                throw r2.util.error(new Error(), "Service must be constructed with `new' operator");
              var t4 = this.loadServiceClass(e4 || {});
              if (t4) {
                var n5 = r2.util.copy(e4), i2 = new t4(e4);
                return Object.defineProperty(i2, "_originalConfig", { get: function() {
                  return n5;
                }, enumerable: false, configurable: true }), i2._clientId = ++a, i2;
              }
              this.initialize(e4);
            }, initialize: function(e4) {
              var t4 = r2.config[this.serviceIdentifier];
              if (this.config = new r2.Config(r2.config), t4 && this.config.update(t4, true), e4 && this.config.update(e4, true), this.validateService(), this.config.endpoint || o.configureEndpoint(this), this.config.endpoint = this.endpointFromTemplate(this.config.endpoint), this.setEndpoint(this.config.endpoint), r2.SequentialExecutor.call(this), r2.Service.addDefaultMonitoringListeners(this), (this.config.clientSideMonitoring || r2.Service._clientSideMonitoring) && this.publisher) {
                var i2 = this.publisher;
                this.addNamedListener("PUBLISH_API_CALL", "apiCall", function(e5) {
                  n4.nextTick(function() {
                    i2.eventHandler(e5);
                  });
                }), this.addNamedListener("PUBLISH_API_ATTEMPT", "apiCallAttempt", function(e5) {
                  n4.nextTick(function() {
                    i2.eventHandler(e5);
                  });
                });
              }
            }, validateService: function() {
            }, loadServiceClass: function(e4) {
              var t4 = e4;
              if (r2.util.isEmpty(this.api)) {
                if (t4.apiConfig)
                  return r2.Service.defineServiceApi(this.constructor, t4.apiConfig);
                if (this.constructor.services) {
                  (t4 = new r2.Config(r2.config)).update(e4, true);
                  var n5 = t4.apiVersions[this.constructor.serviceIdentifier];
                  return n5 = n5 || t4.apiVersion, this.getLatestServiceClass(n5);
                }
                return null;
              }
              return null;
            }, getLatestServiceClass: function(e4) {
              return e4 = this.getLatestServiceVersion(e4), null === this.constructor.services[e4] && r2.Service.defineServiceApi(this.constructor, e4), this.constructor.services[e4];
            }, getLatestServiceVersion: function(e4) {
              if (!this.constructor.services || 0 === this.constructor.services.length)
                throw new Error("No services defined on " + this.constructor.serviceIdentifier);
              if (e4 ? r2.util.isType(e4, Date) && (e4 = r2.util.date.iso8601(e4).split("T")[0]) : e4 = "latest", Object.hasOwnProperty(this.constructor.services, e4))
                return e4;
              for (var t4 = Object.keys(this.constructor.services).sort(), n5 = null, i2 = t4.length - 1; i2 >= 0; i2--)
                if ("*" !== t4[i2][t4[i2].length - 1] && (n5 = t4[i2]), t4[i2].substr(0, 10) <= e4)
                  return n5;
              throw new Error("Could not find " + this.constructor.serviceIdentifier + " API to satisfy version constraint `" + e4 + "'");
            }, api: {}, defaultRetryCount: 3, customizeRequests: function(e4) {
              if (e4) {
                if ("function" != typeof e4)
                  throw new Error("Invalid callback type '" + typeof e4 + "' provided in customizeRequests");
                this.customRequestHandler = e4;
              } else
                this.customRequestHandler = null;
            }, makeRequest: function(e4, t4, n5) {
              if ("function" == typeof t4 && (n5 = t4, t4 = null), t4 = t4 || {}, this.config.params) {
                var i2 = this.api.operations[e4];
                i2 && (t4 = r2.util.copy(t4), r2.util.each(this.config.params, function(e5, n6) {
                  i2.input.members[e5] && (void 0 !== t4[e5] && null !== t4[e5] || (t4[e5] = n6));
                }));
              }
              var o2 = new r2.Request(this, e4, t4);
              return this.addAllRequestListeners(o2), this.attachMonitoringEmitter(o2), n5 && o2.send(n5), o2;
            }, makeUnauthenticatedRequest: function(e4, t4, n5) {
              "function" == typeof t4 && (n5 = t4, t4 = {});
              var r3 = this.makeRequest(e4, t4).toUnauthenticated();
              return n5 ? r3.send(n5) : r3;
            }, waitFor: function(e4, t4, n5) {
              return new r2.ResourceWaiter(this, e4).wait(t4, n5);
            }, addAllRequestListeners: function(e4) {
              for (var t4 = [r2.events, r2.EventListeners.Core, this.serviceInterface(), r2.EventListeners.CorePost], n5 = 0; n5 < t4.length; n5++)
                t4[n5] && e4.addListeners(t4[n5]);
              this.config.paramValidation || e4.removeListener("validate", r2.EventListeners.Core.VALIDATE_PARAMETERS), this.config.logger && e4.addListeners(r2.EventListeners.Logger), this.setupRequestListeners(e4), "function" == typeof this.constructor.prototype.customRequestHandler && this.constructor.prototype.customRequestHandler(e4), Object.prototype.hasOwnProperty.call(this, "customRequestHandler") && "function" == typeof this.customRequestHandler && this.customRequestHandler(e4);
            }, apiCallEvent: function(e4) {
              var t4 = e4.service.api.operations[e4.operation], n5 = { Type: "ApiCall", Api: t4 ? t4.name : e4.operation, Version: 1, Service: e4.service.api.serviceId || e4.service.api.endpointPrefix, Region: e4.httpRequest.region, MaxRetriesExceeded: 0, UserAgent: e4.httpRequest.getUserAgent() }, r3 = e4.response;
              if (r3.httpResponse.statusCode && (n5.FinalHttpStatusCode = r3.httpResponse.statusCode), r3.error) {
                var i2 = r3.error;
                r3.httpResponse.statusCode > 299 ? (i2.code && (n5.FinalAwsException = i2.code), i2.message && (n5.FinalAwsExceptionMessage = i2.message)) : ((i2.code || i2.name) && (n5.FinalSdkException = i2.code || i2.name), i2.message && (n5.FinalSdkExceptionMessage = i2.message));
              }
              return n5;
            }, apiAttemptEvent: function(e4) {
              var t4 = e4.service.api.operations[e4.operation], n5 = { Type: "ApiCallAttempt", Api: t4 ? t4.name : e4.operation, Version: 1, Service: e4.service.api.serviceId || e4.service.api.endpointPrefix, Fqdn: e4.httpRequest.endpoint.hostname, UserAgent: e4.httpRequest.getUserAgent() }, r3 = e4.response;
              return r3.httpResponse.statusCode && (n5.HttpStatusCode = r3.httpResponse.statusCode), !e4._unAuthenticated && e4.service.config.credentials && e4.service.config.credentials.accessKeyId && (n5.AccessKey = e4.service.config.credentials.accessKeyId), r3.httpResponse.headers ? (e4.httpRequest.headers["x-amz-security-token"] && (n5.SessionToken = e4.httpRequest.headers["x-amz-security-token"]), r3.httpResponse.headers["x-amzn-requestid"] && (n5.XAmznRequestId = r3.httpResponse.headers["x-amzn-requestid"]), r3.httpResponse.headers["x-amz-request-id"] && (n5.XAmzRequestId = r3.httpResponse.headers["x-amz-request-id"]), r3.httpResponse.headers["x-amz-id-2"] && (n5.XAmzId2 = r3.httpResponse.headers["x-amz-id-2"]), n5) : n5;
            }, attemptFailEvent: function(e4) {
              var t4 = this.apiAttemptEvent(e4), n5 = e4.response, r3 = n5.error;
              return n5.httpResponse.statusCode > 299 ? (r3.code && (t4.AwsException = r3.code), r3.message && (t4.AwsExceptionMessage = r3.message)) : ((r3.code || r3.name) && (t4.SdkException = r3.code || r3.name), r3.message && (t4.SdkExceptionMessage = r3.message)), t4;
            }, attachMonitoringEmitter: function(e4) {
              var t4, n5, i2, o2, s2, a2, c = 0, u = this;
              e4.on("validate", function() {
                o2 = r2.util.realClock.now(), a2 = Date.now();
              }, true), e4.on("sign", function() {
                n5 = r2.util.realClock.now(), t4 = Date.now(), s2 = e4.httpRequest.region, c++;
              }, true), e4.on("validateResponse", function() {
                i2 = Math.round(r2.util.realClock.now() - n5);
              }), e4.addNamedListener("API_CALL_ATTEMPT", "success", function() {
                var n6 = u.apiAttemptEvent(e4);
                n6.Timestamp = t4, n6.AttemptLatency = i2 >= 0 ? i2 : 0, n6.Region = s2, u.emit("apiCallAttempt", [n6]);
              }), e4.addNamedListener("API_CALL_ATTEMPT_RETRY", "retry", function() {
                var o3 = u.attemptFailEvent(e4);
                o3.Timestamp = t4, i2 = i2 || Math.round(r2.util.realClock.now() - n5), o3.AttemptLatency = i2 >= 0 ? i2 : 0, o3.Region = s2, u.emit("apiCallAttempt", [o3]);
              }), e4.addNamedListener("API_CALL", "complete", function() {
                var t5 = u.apiCallEvent(e4);
                if (t5.AttemptCount = c, !(t5.AttemptCount <= 0)) {
                  t5.Timestamp = a2;
                  var n6 = Math.round(r2.util.realClock.now() - o2);
                  t5.Latency = n6 >= 0 ? n6 : 0;
                  var i3 = e4.response;
                  i3.error && i3.error.retryable && "number" == typeof i3.retryCount && "number" == typeof i3.maxRetries && i3.retryCount >= i3.maxRetries && (t5.MaxRetriesExceeded = 1), u.emit("apiCall", [t5]);
                }
              });
            }, setupRequestListeners: function(e4) {
            }, getSigningName: function() {
              return this.api.signingName || this.api.endpointPrefix;
            }, getSignerClass: function(e4) {
              var t4, n5 = null, i2 = "";
              return e4 && (i2 = (n5 = (e4.service.api.operations || {})[e4.operation] || null) ? n5.authtype : ""), t4 = this.config.signatureVersion ? this.config.signatureVersion : "v4" === i2 || "v4-unsigned-body" === i2 ? "v4" : this.api.signatureVersion, r2.Signers.RequestSigner.getVersion(t4);
            }, serviceInterface: function() {
              switch (this.api.protocol) {
                case "ec2":
                case "query":
                  return r2.EventListeners.Query;
                case "json":
                  return r2.EventListeners.Json;
                case "rest-json":
                  return r2.EventListeners.RestJson;
                case "rest-xml":
                  return r2.EventListeners.RestXml;
              }
              if (this.api.protocol)
                throw new Error("Invalid service `protocol' " + this.api.protocol + " in API config");
            }, successfulResponse: function(e4) {
              return e4.httpResponse.statusCode < 300;
            }, numRetries: function() {
              return void 0 !== this.config.maxRetries ? this.config.maxRetries : this.defaultRetryCount;
            }, retryDelays: function(e4, t4) {
              return r2.util.calculateRetryDelay(e4, this.config.retryDelayOptions, t4);
            }, retryableError: function(e4) {
              return !!this.timeoutError(e4) || !!this.networkingError(e4) || !!this.expiredCredentialsError(e4) || !!this.throttledError(e4) || e4.statusCode >= 500;
            }, networkingError: function(e4) {
              return "NetworkingError" === e4.code;
            }, timeoutError: function(e4) {
              return "TimeoutError" === e4.code;
            }, expiredCredentialsError: function(e4) {
              return "ExpiredTokenException" === e4.code;
            }, clockSkewError: function(e4) {
              switch (e4.code) {
                case "RequestTimeTooSkewed":
                case "RequestExpired":
                case "InvalidSignatureException":
                case "SignatureDoesNotMatch":
                case "AuthFailure":
                case "RequestInTheFuture":
                  return true;
                default:
                  return false;
              }
            }, getSkewCorrectedDate: function() {
              return new Date(Date.now() + this.config.systemClockOffset);
            }, applyClockOffset: function(e4) {
              e4 && (this.config.systemClockOffset = e4 - Date.now());
            }, isClockSkewed: function(e4) {
              if (e4)
                return Math.abs(this.getSkewCorrectedDate().getTime() - e4) >= 3e5;
            }, throttledError: function(e4) {
              if (429 === e4.statusCode)
                return true;
              switch (e4.code) {
                case "ProvisionedThroughputExceededException":
                case "Throttling":
                case "ThrottlingException":
                case "RequestLimitExceeded":
                case "RequestThrottled":
                case "RequestThrottledException":
                case "TooManyRequestsException":
                case "TransactionInProgressException":
                case "EC2ThrottledException":
                  return true;
                default:
                  return false;
              }
            }, endpointFromTemplate: function(e4) {
              if ("string" != typeof e4)
                return e4;
              return e4.replace(/\{service\}/g, this.api.endpointPrefix).replace(/\{region\}/g, this.config.region).replace(/\{scheme\}/g, this.config.sslEnabled ? "https" : "http");
            }, setEndpoint: function(e4) {
              this.endpoint = new r2.Endpoint(e4, this.config);
            }, paginationConfig: function(e4, t4) {
              var n5 = this.api.operations[e4].paginator;
              if (!n5) {
                if (t4) {
                  var i2 = new Error();
                  throw r2.util.error(i2, "No pagination configuration for " + e4);
                }
                return null;
              }
              return n5;
            } }), r2.util.update(r2.Service, { defineMethods: function(e4) {
              r2.util.each(e4.prototype.api.operations, function(t4) {
                e4.prototype[t4] || ("none" === e4.prototype.api.operations[t4].authtype ? e4.prototype[t4] = function(e5, n5) {
                  return this.makeUnauthenticatedRequest(t4, e5, n5);
                } : e4.prototype[t4] = function(e5, n5) {
                  return this.makeRequest(t4, e5, n5);
                });
              });
            }, defineService: function(e4, t4, n5) {
              r2.Service._serviceMap[e4] = true, Array.isArray(t4) || (n5 = t4, t4 = []);
              var i2 = s(r2.Service, n5 || {});
              if ("string" == typeof e4) {
                r2.Service.addVersions(i2, t4);
                var o2 = i2.serviceIdentifier || e4;
                i2.serviceIdentifier = o2;
              } else
                i2.prototype.api = e4, r2.Service.defineMethods(i2);
              if (r2.SequentialExecutor.call(this.prototype), !this.prototype.publisher && r2.util.clientSideMonitoring) {
                var a2 = r2.util.clientSideMonitoring.Publisher, c = (0, r2.util.clientSideMonitoring.configProvider)();
                this.prototype.publisher = new a2(c), c.enabled && (r2.Service._clientSideMonitoring = true);
              }
              return r2.SequentialExecutor.call(i2.prototype), r2.Service.addDefaultMonitoringListeners(i2.prototype), i2;
            }, addVersions: function(e4, t4) {
              Array.isArray(t4) || (t4 = [t4]), e4.services = e4.services || {};
              for (var n5 = 0; n5 < t4.length; n5++)
                void 0 === e4.services[t4[n5]] && (e4.services[t4[n5]] = null);
              e4.apiVersions = Object.keys(e4.services).sort();
            }, defineServiceApi: function(e4, t4, n5) {
              function o2(t5) {
                t5.isApi ? a2.prototype.api = t5 : a2.prototype.api = new i(t5, { serviceIdentifier: e4.serviceIdentifier });
              }
              var a2 = s(e4, { serviceIdentifier: e4.serviceIdentifier });
              if ("string" == typeof t4) {
                if (n5)
                  o2(n5);
                else
                  try {
                    o2(r2.apiLoader(e4.serviceIdentifier, t4));
                  } catch (n6) {
                    throw r2.util.error(n6, { message: "Could not find API configuration " + e4.serviceIdentifier + "-" + t4 });
                  }
                Object.prototype.hasOwnProperty.call(e4.services, t4) || (e4.apiVersions = e4.apiVersions.concat(t4).sort()), e4.services[t4] = a2;
              } else
                o2(t4);
              return r2.Service.defineMethods(a2), a2;
            }, hasService: function(e4) {
              return Object.prototype.hasOwnProperty.call(r2.Service._serviceMap, e4);
            }, addDefaultMonitoringListeners: function(e4) {
              e4.addNamedListener("MONITOR_EVENTS_BUBBLE", "apiCallAttempt", function(t4) {
                var n5 = Object.getPrototypeOf(e4);
                n5._events && n5.emit("apiCallAttempt", [t4]);
              }), e4.addNamedListener("CALL_EVENTS_BUBBLE", "apiCall", function(t4) {
                var n5 = Object.getPrototypeOf(e4);
                n5._events && n5.emit("apiCall", [t4]);
              });
            }, _serviceMap: {} }), r2.util.mixin(r2.Service, r2.SequentialExecutor), t3.exports = r2.Service;
          }).call(this);
        }).call(this, e3("_process"));
      }, { "./core": 20, "./model/api": 40, "./region_config": 55, _process: 87 }], 62: [function(e3, t3, n3) {
        var r2 = e3("../core");
        r2.util.update(r2.CognitoIdentity.prototype, { getOpenIdToken: function(e4, t4) {
          return this.makeUnauthenticatedRequest("getOpenIdToken", e4, t4);
        }, getId: function(e4, t4) {
          return this.makeUnauthenticatedRequest("getId", e4, t4);
        }, getCredentialsForIdentity: function(e4, t4) {
          return this.makeUnauthenticatedRequest("getCredentialsForIdentity", e4, t4);
        } });
      }, { "../core": 20 }], 63: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("../config_regional_endpoint");
        r2.util.update(r2.STS.prototype, { credentialsFrom: function(e4, t4) {
          return e4 ? (t4 || (t4 = new r2.TemporaryCredentials()), t4.expired = false, t4.accessKeyId = e4.Credentials.AccessKeyId, t4.secretAccessKey = e4.Credentials.SecretAccessKey, t4.sessionToken = e4.Credentials.SessionToken, t4.expireTime = e4.Credentials.Expiration, t4) : null;
        }, assumeRoleWithWebIdentity: function(e4, t4) {
          return this.makeUnauthenticatedRequest("assumeRoleWithWebIdentity", e4, t4);
        }, assumeRoleWithSAML: function(e4, t4) {
          return this.makeUnauthenticatedRequest("assumeRoleWithSAML", e4, t4);
        }, setupRequestListeners: function(e4) {
          e4.addListener("validate", this.optInRegionalEndpoint, true);
        }, optInRegionalEndpoint: function(e4) {
          var t4 = e4.service, n4 = t4.config;
          if (n4.stsRegionalEndpoints = i(t4._originalConfig, { env: "AWS_STS_REGIONAL_ENDPOINTS", sharedConfig: "sts_regional_endpoints", clientConfig: "stsRegionalEndpoints" }), "regional" === n4.stsRegionalEndpoints && t4.isGlobalEndpoint) {
            if (!n4.region)
              throw r2.util.error(new Error(), { code: "ConfigError", message: "Missing region in config" });
            var o = n4.endpoint.indexOf(".amazonaws.com"), s = n4.endpoint.substring(0, o) + "." + n4.region + n4.endpoint.substring(o);
            e4.httpRequest.updateEndpoint(s), e4.httpRequest.region = n4.region;
          }
        } });
      }, { "../config_regional_endpoint": 19, "../core": 20 }], 64: [function(e3, t3, n3) {
        function r2(e4) {
          var t4 = e4.httpRequest.headers[a], n4 = e4.service.getSignerClass(e4);
          if (delete e4.httpRequest.headers["User-Agent"], delete e4.httpRequest.headers["X-Amz-User-Agent"], n4 === o.Signers.V4) {
            if (t4 > 604800)
              throw o.util.error(new Error(), { code: "InvalidExpiryTime", message: "Presigning does not support expiry time greater than a week with SigV4 signing.", retryable: false });
            e4.httpRequest.headers[a] = t4;
          } else {
            if (n4 !== o.Signers.S3)
              throw o.util.error(new Error(), { message: "Presigning only supports S3 or SigV4 signing.", code: "UnsupportedSigner", retryable: false });
            var r3 = e4.service ? e4.service.getSkewCorrectedDate() : o.util.date.getDate();
            e4.httpRequest.headers[a] = parseInt(o.util.date.unixTimestamp(r3) + t4, 10).toString();
          }
        }
        function i(e4) {
          var t4 = e4.httpRequest.endpoint, n4 = o.util.urlParse(e4.httpRequest.path), r3 = {};
          n4.search && (r3 = o.util.queryStringParse(n4.search.substr(1)));
          var i2 = e4.httpRequest.headers.Authorization.split(" ");
          if ("AWS" === i2[0])
            i2 = i2[1].split(":"), r3.Signature = i2.pop(), r3.AWSAccessKeyId = i2.join(":"), o.util.each(e4.httpRequest.headers, function(e5, t5) {
              e5 === a && (e5 = "Expires"), 0 === e5.indexOf("x-amz-meta-") && (delete r3[e5], e5 = e5.toLowerCase()), r3[e5] = t5;
            }), delete e4.httpRequest.headers[a], delete r3.Authorization, delete r3.Host;
          else if ("AWS4-HMAC-SHA256" === i2[0]) {
            i2.shift();
            var s2 = i2.join(" ").match(/Signature=(.*?)(?:,|\s|\r?\n|$)/)[1];
            r3["X-Amz-Signature"] = s2, delete r3.Expires;
          }
          t4.pathname = n4.pathname, t4.search = o.util.queryParamsToString(r3);
        }
        var o = e3("../core"), s = o.util.inherit, a = "presigned-expires";
        o.Signers.Presign = s({ sign: function(e4, t4, n4) {
          if (e4.httpRequest.headers[a] = t4 || 3600, e4.on("build", r2), e4.on("sign", i), e4.removeListener("afterBuild", o.EventListeners.Core.SET_CONTENT_LENGTH), e4.removeListener("afterBuild", o.EventListeners.Core.COMPUTE_SHA256), e4.emit("beforePresign", [e4]), !n4) {
            if (e4.build(), e4.response.error)
              throw e4.response.error;
            return o.util.urlFormat(e4.httpRequest.endpoint);
          }
          e4.build(function() {
            this.response.error ? n4(this.response.error) : n4(null, o.util.urlFormat(e4.httpRequest.endpoint));
          });
        } }), t3.exports = o.Signers.Presign;
      }, { "../core": 20 }], 65: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = r2.util.inherit;
        r2.Signers.RequestSigner = i({ constructor: function(e4) {
          this.request = e4;
        }, setServiceClientId: function(e4) {
          this.serviceClientId = e4;
        }, getServiceClientId: function() {
          return this.serviceClientId;
        } }), r2.Signers.RequestSigner.getVersion = function(e4) {
          switch (e4) {
            case "v2":
              return r2.Signers.V2;
            case "v3":
              return r2.Signers.V3;
            case "s3v4":
            case "v4":
              return r2.Signers.V4;
            case "s3":
              return r2.Signers.S3;
            case "v3https":
              return r2.Signers.V3Https;
          }
          throw new Error("Unknown signing version " + e4);
        }, e3("./v2"), e3("./v3"), e3("./v3https"), e3("./v4"), e3("./s3"), e3("./presign");
      }, { "../core": 20, "./presign": 64, "./s3": 66, "./v2": 67, "./v3": 68, "./v3https": 69, "./v4": 70 }], 66: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = r2.util.inherit;
        r2.Signers.S3 = i(r2.Signers.RequestSigner, { subResources: { acl: 1, accelerate: 1, analytics: 1, cors: 1, lifecycle: 1, delete: 1, inventory: 1, location: 1, logging: 1, metrics: 1, notification: 1, partNumber: 1, policy: 1, requestPayment: 1, replication: 1, restore: 1, tagging: 1, torrent: 1, uploadId: 1, uploads: 1, versionId: 1, versioning: 1, versions: 1, website: 1 }, responseHeaders: { "response-content-type": 1, "response-content-language": 1, "response-expires": 1, "response-cache-control": 1, "response-content-disposition": 1, "response-content-encoding": 1 }, addAuthorization: function(e4, t4) {
          this.request.headers["presigned-expires"] || (this.request.headers["X-Amz-Date"] = r2.util.date.rfc822(t4)), e4.sessionToken && (this.request.headers["x-amz-security-token"] = e4.sessionToken);
          var n4 = this.sign(e4.secretAccessKey, this.stringToSign()), i2 = "AWS " + e4.accessKeyId + ":" + n4;
          this.request.headers.Authorization = i2;
        }, stringToSign: function() {
          var e4 = this.request, t4 = [];
          t4.push(e4.method), t4.push(e4.headers["Content-MD5"] || ""), t4.push(e4.headers["Content-Type"] || ""), t4.push(e4.headers["presigned-expires"] || "");
          var n4 = this.canonicalizedAmzHeaders();
          return n4 && t4.push(n4), t4.push(this.canonicalizedResource()), t4.join("\n");
        }, canonicalizedAmzHeaders: function() {
          var e4 = [];
          r2.util.each(this.request.headers, function(t5) {
            t5.match(/^x-amz-/i) && e4.push(t5);
          }), e4.sort(function(e5, t5) {
            return e5.toLowerCase() < t5.toLowerCase() ? -1 : 1;
          });
          var t4 = [];
          return r2.util.arrayEach.call(this, e4, function(e5) {
            t4.push(e5.toLowerCase() + ":" + String(this.request.headers[e5]));
          }), t4.join("\n");
        }, canonicalizedResource: function() {
          var e4 = this.request, t4 = e4.path.split("?"), n4 = t4[0], i2 = t4[1], o = "";
          if (e4.virtualHostedBucket && (o += "/" + e4.virtualHostedBucket), o += n4, i2) {
            var s = [];
            r2.util.arrayEach.call(this, i2.split("&"), function(e5) {
              var t5 = e5.split("=")[0], n5 = e5.split("=")[1];
              if (this.subResources[t5] || this.responseHeaders[t5]) {
                var r3 = { name: t5 };
                void 0 !== n5 && (this.subResources[t5] ? r3.value = n5 : r3.value = decodeURIComponent(n5)), s.push(r3);
              }
            }), s.sort(function(e5, t5) {
              return e5.name < t5.name ? -1 : 1;
            }), s.length && (i2 = [], r2.util.arrayEach(s, function(e5) {
              void 0 === e5.value ? i2.push(e5.name) : i2.push(e5.name + "=" + e5.value);
            }), o += "?" + i2.join("&"));
          }
          return o;
        }, sign: function(e4, t4) {
          return r2.util.crypto.hmac(e4, t4, "base64", "sha1");
        } }), t3.exports = r2.Signers.S3;
      }, { "../core": 20 }], 67: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = r2.util.inherit;
        r2.Signers.V2 = i(r2.Signers.RequestSigner, { addAuthorization: function(e4, t4) {
          t4 || (t4 = r2.util.date.getDate());
          var n4 = this.request;
          n4.params.Timestamp = r2.util.date.iso8601(t4), n4.params.SignatureVersion = "2", n4.params.SignatureMethod = "HmacSHA256", n4.params.AWSAccessKeyId = e4.accessKeyId, e4.sessionToken && (n4.params.SecurityToken = e4.sessionToken), delete n4.params.Signature, n4.params.Signature = this.signature(e4), n4.body = r2.util.queryParamsToString(n4.params), n4.headers["Content-Length"] = n4.body.length;
        }, signature: function(e4) {
          return r2.util.crypto.hmac(e4.secretAccessKey, this.stringToSign(), "base64");
        }, stringToSign: function() {
          var e4 = [];
          return e4.push(this.request.method), e4.push(this.request.endpoint.host.toLowerCase()), e4.push(this.request.pathname()), e4.push(r2.util.queryParamsToString(this.request.params)), e4.join("\n");
        } }), t3.exports = r2.Signers.V2;
      }, { "../core": 20 }], 68: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = r2.util.inherit;
        r2.Signers.V3 = i(r2.Signers.RequestSigner, { addAuthorization: function(e4, t4) {
          var n4 = r2.util.date.rfc822(t4);
          this.request.headers["X-Amz-Date"] = n4, e4.sessionToken && (this.request.headers["x-amz-security-token"] = e4.sessionToken), this.request.headers["X-Amzn-Authorization"] = this.authorization(e4, n4);
        }, authorization: function(e4) {
          return "AWS3 AWSAccessKeyId=" + e4.accessKeyId + ",Algorithm=HmacSHA256,SignedHeaders=" + this.signedHeaders() + ",Signature=" + this.signature(e4);
        }, signedHeaders: function() {
          var e4 = [];
          return r2.util.arrayEach(this.headersToSign(), function(t4) {
            e4.push(t4.toLowerCase());
          }), e4.sort().join(";");
        }, canonicalHeaders: function() {
          var e4 = this.request.headers, t4 = [];
          return r2.util.arrayEach(this.headersToSign(), function(n4) {
            t4.push(n4.toLowerCase().trim() + ":" + String(e4[n4]).trim());
          }), t4.sort().join("\n") + "\n";
        }, headersToSign: function() {
          var e4 = [];
          return r2.util.each(this.request.headers, function(t4) {
            ("Host" === t4 || "Content-Encoding" === t4 || t4.match(/^X-Amz/i)) && e4.push(t4);
          }), e4;
        }, signature: function(e4) {
          return r2.util.crypto.hmac(e4.secretAccessKey, this.stringToSign(), "base64");
        }, stringToSign: function() {
          var e4 = [];
          return e4.push(this.request.method), e4.push("/"), e4.push(""), e4.push(this.canonicalHeaders()), e4.push(this.request.body), r2.util.crypto.sha256(e4.join("\n"));
        } }), t3.exports = r2.Signers.V3;
      }, { "../core": 20 }], 69: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = r2.util.inherit;
        e3("./v3"), r2.Signers.V3Https = i(r2.Signers.V3, { authorization: function(e4) {
          return "AWS3-HTTPS AWSAccessKeyId=" + e4.accessKeyId + ",Algorithm=HmacSHA256,Signature=" + this.signature(e4);
        }, stringToSign: function() {
          return this.request.headers["X-Amz-Date"];
        } }), t3.exports = r2.Signers.V3Https;
      }, { "../core": 20, "./v3": 68 }], 70: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = e3("./v4_credentials"), o = r2.util.inherit;
        r2.Signers.V4 = o(r2.Signers.RequestSigner, { constructor: function(e4, t4, n4) {
          r2.Signers.RequestSigner.call(this, e4), this.serviceName = t4, n4 = n4 || {}, this.signatureCache = "boolean" != typeof n4.signatureCache || n4.signatureCache, this.operation = n4.operation, this.signatureVersion = n4.signatureVersion;
        }, algorithm: "AWS4-HMAC-SHA256", addAuthorization: function(e4, t4) {
          var n4 = r2.util.date.iso8601(t4).replace(/[:\-]|\.\d{3}/g, "");
          this.isPresigned() ? this.updateForPresigned(e4, n4) : this.addHeaders(e4, n4), this.request.headers.Authorization = this.authorization(e4, n4);
        }, addHeaders: function(e4, t4) {
          this.request.headers["X-Amz-Date"] = t4, e4.sessionToken && (this.request.headers["x-amz-security-token"] = e4.sessionToken);
        }, updateForPresigned: function(e4, t4) {
          var n4 = this.credentialString(t4), i2 = { "X-Amz-Date": t4, "X-Amz-Algorithm": this.algorithm, "X-Amz-Credential": e4.accessKeyId + "/" + n4, "X-Amz-Expires": this.request.headers["presigned-expires"], "X-Amz-SignedHeaders": this.signedHeaders() };
          e4.sessionToken && (i2["X-Amz-Security-Token"] = e4.sessionToken), this.request.headers["Content-Type"] && (i2["Content-Type"] = this.request.headers["Content-Type"]), this.request.headers["Content-MD5"] && (i2["Content-MD5"] = this.request.headers["Content-MD5"]), this.request.headers["Cache-Control"] && (i2["Cache-Control"] = this.request.headers["Cache-Control"]), r2.util.each.call(this, this.request.headers, function(e5, t5) {
            if ("presigned-expires" !== e5 && this.isSignableHeader(e5)) {
              var n5 = e5.toLowerCase();
              0 === n5.indexOf("x-amz-meta-") ? i2[n5] = t5 : 0 === n5.indexOf("x-amz-") && (i2[e5] = t5);
            }
          });
          var o2 = this.request.path.indexOf("?") >= 0 ? "&" : "?";
          this.request.path += o2 + r2.util.queryParamsToString(i2);
        }, authorization: function(e4, t4) {
          var n4 = [], r3 = this.credentialString(t4);
          return n4.push(this.algorithm + " Credential=" + e4.accessKeyId + "/" + r3), n4.push("SignedHeaders=" + this.signedHeaders()), n4.push("Signature=" + this.signature(e4, t4)), n4.join(", ");
        }, signature: function(e4, t4) {
          var n4 = i.getSigningKey(e4, t4.substr(0, 8), this.request.region, this.serviceName, this.signatureCache);
          return r2.util.crypto.hmac(n4, this.stringToSign(t4), "hex");
        }, stringToSign: function(e4) {
          var t4 = [];
          return t4.push("AWS4-HMAC-SHA256"), t4.push(e4), t4.push(this.credentialString(e4)), t4.push(this.hexEncodedHash(this.canonicalString())), t4.join("\n");
        }, canonicalString: function() {
          var e4 = [], t4 = this.request.pathname();
          return "s3" !== this.serviceName && "s3v4" !== this.signatureVersion && (t4 = r2.util.uriEscapePath(t4)), e4.push(this.request.method), e4.push(t4), e4.push(this.request.search()), e4.push(this.canonicalHeaders() + "\n"), e4.push(this.signedHeaders()), e4.push(this.hexEncodedBodyHash()), e4.join("\n");
        }, canonicalHeaders: function() {
          var e4 = [];
          r2.util.each.call(this, this.request.headers, function(t5, n4) {
            e4.push([t5, n4]);
          }), e4.sort(function(e5, t5) {
            return e5[0].toLowerCase() < t5[0].toLowerCase() ? -1 : 1;
          });
          var t4 = [];
          return r2.util.arrayEach.call(this, e4, function(e5) {
            var n4 = e5[0].toLowerCase();
            if (this.isSignableHeader(n4)) {
              var i2 = e5[1];
              if (null == i2 || "function" != typeof i2.toString)
                throw r2.util.error(new Error("Header " + n4 + " contains invalid value"), { code: "InvalidHeader" });
              t4.push(n4 + ":" + this.canonicalHeaderValues(i2.toString()));
            }
          }), t4.join("\n");
        }, canonicalHeaderValues: function(e4) {
          return e4.replace(/\s+/g, " ").replace(/^\s+|\s+$/g, "");
        }, signedHeaders: function() {
          var e4 = [];
          return r2.util.each.call(this, this.request.headers, function(t4) {
            t4 = t4.toLowerCase(), this.isSignableHeader(t4) && e4.push(t4);
          }), e4.sort().join(";");
        }, credentialString: function(e4) {
          return i.createScope(e4.substr(0, 8), this.request.region, this.serviceName);
        }, hexEncodedHash: function(e4) {
          return r2.util.crypto.sha256(e4, "hex");
        }, hexEncodedBodyHash: function() {
          var e4 = this.request;
          return this.isPresigned() && "s3" === this.serviceName && !e4.body ? "UNSIGNED-PAYLOAD" : e4.headers["X-Amz-Content-Sha256"] ? e4.headers["X-Amz-Content-Sha256"] : this.hexEncodedHash(this.request.body || "");
        }, unsignableHeaders: ["authorization", "content-type", "content-length", "user-agent", "presigned-expires", "expect", "x-amzn-trace-id"], isSignableHeader: function(e4) {
          return 0 === e4.toLowerCase().indexOf("x-amz-") || this.unsignableHeaders.indexOf(e4) < 0;
        }, isPresigned: function() {
          return !!this.request.headers["presigned-expires"];
        } }), t3.exports = r2.Signers.V4;
      }, { "../core": 20, "./v4_credentials": 71 }], 71: [function(e3, t3, n3) {
        var r2 = e3("../core"), i = {}, o = [];
        t3.exports = { createScope: function(e4, t4, n4) {
          return [e4.substr(0, 8), t4, n4, "aws4_request"].join("/");
        }, getSigningKey: function(e4, t4, n4, s, a) {
          var c = [r2.util.crypto.hmac(e4.secretAccessKey, e4.accessKeyId, "base64"), t4, n4, s].join("_");
          if ((a = false !== a) && c in i)
            return i[c];
          var u = r2.util.crypto.hmac("AWS4" + e4.secretAccessKey, t4, "buffer"), l = r2.util.crypto.hmac(u, n4, "buffer"), p = r2.util.crypto.hmac(l, s, "buffer"), d = r2.util.crypto.hmac(p, "aws4_request", "buffer");
          return a && (i[c] = d, o.push(c), o.length > 50 && delete i[o.shift()]), d;
        }, emptyCache: function() {
          i = {}, o = [];
        } };
      }, { "../core": 20 }], 72: [function(e3, t3, n3) {
        function r2(e4, t4) {
          this.currentState = t4 || null, this.states = e4 || {};
        }
        r2.prototype.runTo = function(e4, t4, n4, r3) {
          "function" == typeof e4 && (r3 = n4, n4 = t4, t4 = e4, e4 = null);
          var i = this, o = i.states[i.currentState];
          o.fn.call(n4 || i, r3, function(r4) {
            if (r4) {
              if (!o.fail)
                return t4 ? t4.call(n4, r4) : null;
              i.currentState = o.fail;
            } else {
              if (!o.accept)
                return t4 ? t4.call(n4) : null;
              i.currentState = o.accept;
            }
            if (i.currentState === e4)
              return t4 ? t4.call(n4, r4) : null;
            i.runTo(e4, t4, n4, r4);
          });
        }, r2.prototype.addState = function(e4, t4, n4, r3) {
          return "function" == typeof t4 ? (r3 = t4, t4 = null, n4 = null) : "function" == typeof n4 && (r3 = n4, n4 = null), this.currentState || (this.currentState = e4), this.states[e4] = { accept: t4, fail: n4, fn: r3 }, this;
        }, t3.exports = r2;
      }, {}], 73: [function(e3, t3, n3) {
        (function(n4, r2) {
          (function() {
            var i, o = { environment: "nodejs", engine: function() {
              if (o.isBrowser() && "undefined" != typeof navigator)
                return navigator.userAgent;
              var e4 = n4.platform + "/" + n4.version;
              return n4.env.AWS_EXECUTION_ENV && (e4 += " exec-env/" + n4.env.AWS_EXECUTION_ENV), e4;
            }, userAgent: function() {
              var t4 = o.environment, n5 = "aws-sdk-" + t4 + "/" + e3("./core").VERSION;
              return "nodejs" === t4 && (n5 += " " + o.engine()), n5;
            }, uriEscape: function(e4) {
              var t4 = encodeURIComponent(e4);
              return (t4 = t4.replace(/[^A-Za-z0-9_.~\-%]+/g, escape)).replace(/[*]/g, function(e5) {
                return "%" + e5.charCodeAt(0).toString(16).toUpperCase();
              });
            }, uriEscapePath: function(e4) {
              var t4 = [];
              return o.arrayEach(e4.split("/"), function(e5) {
                t4.push(o.uriEscape(e5));
              }), t4.join("/");
            }, urlParse: function(e4) {
              return o.url.parse(e4);
            }, urlFormat: function(e4) {
              return o.url.format(e4);
            }, queryStringParse: function(e4) {
              return o.querystring.parse(e4);
            }, queryParamsToString: function(e4) {
              var t4 = [], n5 = o.uriEscape, r3 = Object.keys(e4).sort();
              return o.arrayEach(r3, function(r4) {
                var i2 = e4[r4], s = n5(r4), a = s + "=";
                if (Array.isArray(i2)) {
                  var c = [];
                  o.arrayEach(i2, function(e5) {
                    c.push(n5(e5));
                  }), a = s + "=" + c.sort().join("&" + s + "=");
                } else
                  null != i2 && (a = s + "=" + n5(i2));
                t4.push(a);
              }), t4.join("&");
            }, readFileSync: function(t4) {
              return o.isBrowser() ? null : e3("fs").readFileSync(t4, "utf-8");
            }, base64: { encode: function(e4) {
              if ("number" == typeof e4)
                throw o.error(new Error("Cannot base64 encode number " + e4));
              return null == e4 ? e4 : o.buffer.toBuffer(e4).toString("base64");
            }, decode: function(e4) {
              if ("number" == typeof e4)
                throw o.error(new Error("Cannot base64 decode number " + e4));
              return null == e4 ? e4 : o.buffer.toBuffer(e4, "base64");
            } }, buffer: { toBuffer: function(e4, t4) {
              return "function" == typeof o.Buffer.from && o.Buffer.from !== Uint8Array.from ? o.Buffer.from(e4, t4) : new o.Buffer(e4, t4);
            }, alloc: function(e4, t4, n5) {
              if ("number" != typeof e4)
                throw new Error("size passed to alloc must be a number.");
              if ("function" == typeof o.Buffer.alloc)
                return o.Buffer.alloc(e4, t4, n5);
              var r3 = new o.Buffer(e4);
              return void 0 !== t4 && "function" == typeof r3.fill && r3.fill(t4, void 0, void 0, n5), r3;
            }, toStream: function(e4) {
              o.Buffer.isBuffer(e4) || (e4 = o.buffer.toBuffer(e4));
              var t4 = new o.stream.Readable(), n5 = 0;
              return t4._read = function(r3) {
                if (n5 >= e4.length)
                  return t4.push(null);
                var i2 = n5 + r3;
                i2 > e4.length && (i2 = e4.length), t4.push(e4.slice(n5, i2)), n5 = i2;
              }, t4;
            }, concat: function(e4) {
              var t4, n5, r3 = 0, i2 = 0;
              for (t4 = 0; t4 < e4.length; t4++)
                r3 += e4[t4].length;
              for (n5 = o.buffer.alloc(r3), t4 = 0; t4 < e4.length; t4++)
                e4[t4].copy(n5, i2), i2 += e4[t4].length;
              return n5;
            } }, string: { byteLength: function(t4) {
              if (null == t4)
                return 0;
              if ("string" == typeof t4 && (t4 = o.buffer.toBuffer(t4)), "number" == typeof t4.byteLength)
                return t4.byteLength;
              if ("number" == typeof t4.length)
                return t4.length;
              if ("number" == typeof t4.size)
                return t4.size;
              if ("string" == typeof t4.path)
                return e3("fs").lstatSync(t4.path).size;
              throw o.error(new Error("Cannot determine length of " + t4), { object: t4 });
            }, upperFirst: function(e4) {
              return e4[0].toUpperCase() + e4.substr(1);
            }, lowerFirst: function(e4) {
              return e4[0].toLowerCase() + e4.substr(1);
            } }, ini: { parse: function(e4) {
              var t4, n5 = {};
              return o.arrayEach(e4.split(/\r?\n/), function(e5) {
                var r3 = (e5 = e5.split(/(^|\s)[;#]/)[0]).match(/^\s*\[([^\[\]]+)\]\s*$/);
                if (r3)
                  t4 = r3[1];
                else if (t4) {
                  var i2 = e5.match(/^\s*(.+?)\s*=\s*(.+?)\s*$/);
                  i2 && (n5[t4] = n5[t4] || {}, n5[t4][i2[1]] = i2[2]);
                }
              }), n5;
            } }, fn: { noop: function() {
            }, callback: function(e4) {
              if (e4)
                throw e4;
            }, makeAsync: function(e4, t4) {
              return t4 && t4 <= e4.length ? e4 : function() {
                var t5 = Array.prototype.slice.call(arguments, 0);
                t5.pop()(e4.apply(null, t5));
              };
            } }, date: { getDate: function() {
              return i || (i = e3("./core")), i.config.systemClockOffset ? new Date((/* @__PURE__ */ new Date()).getTime() + i.config.systemClockOffset) : /* @__PURE__ */ new Date();
            }, iso8601: function(e4) {
              return void 0 === e4 && (e4 = o.date.getDate()), e4.toISOString().replace(/\.\d{3}Z$/, "Z");
            }, rfc822: function(e4) {
              return void 0 === e4 && (e4 = o.date.getDate()), e4.toUTCString();
            }, unixTimestamp: function(e4) {
              return void 0 === e4 && (e4 = o.date.getDate()), e4.getTime() / 1e3;
            }, from: function(e4) {
              return "number" == typeof e4 ? new Date(1e3 * e4) : new Date(e4);
            }, format: function(e4, t4) {
              return t4 || (t4 = "iso8601"), o.date[t4](o.date.from(e4));
            }, parseTimestamp: function(e4) {
              if ("number" == typeof e4)
                return new Date(1e3 * e4);
              if (e4.match(/^\d+$/))
                return new Date(1e3 * e4);
              if (e4.match(/^\d{4}/))
                return new Date(e4);
              if (e4.match(/^\w{3},/))
                return new Date(e4);
              throw o.error(new Error("unhandled timestamp format: " + e4), { code: "TimestampParserError" });
            } }, crypto: { crc32Table: [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], crc32: function(e4) {
              var t4 = o.crypto.crc32Table, n5 = -1;
              "string" == typeof e4 && (e4 = o.buffer.toBuffer(e4));
              for (var r3 = 0; r3 < e4.length; r3++)
                n5 = n5 >>> 8 ^ t4[255 & (n5 ^ e4.readUInt8(r3))];
              return (-1 ^ n5) >>> 0;
            }, hmac: function(e4, t4, n5, r3) {
              return n5 || (n5 = "binary"), "buffer" === n5 && (n5 = void 0), r3 || (r3 = "sha256"), "string" == typeof t4 && (t4 = o.buffer.toBuffer(t4)), o.crypto.lib.createHmac(r3, e4).update(t4).digest(n5);
            }, md5: function(e4, t4, n5) {
              return o.crypto.hash("md5", e4, t4, n5);
            }, sha256: function(e4, t4, n5) {
              return o.crypto.hash("sha256", e4, t4, n5);
            }, hash: function(e4, t4, n5, r3) {
              var i2 = o.crypto.createHash(e4);
              n5 || (n5 = "binary"), "buffer" === n5 && (n5 = void 0), "string" == typeof t4 && (t4 = o.buffer.toBuffer(t4));
              var s = o.arraySliceFn(t4), a = o.Buffer.isBuffer(t4);
              if (o.isBrowser() && "undefined" != typeof ArrayBuffer && t4 && t4.buffer instanceof ArrayBuffer && (a = true), r3 && "object" == typeof t4 && "function" == typeof t4.on && !a)
                t4.on("data", function(e5) {
                  i2.update(e5);
                }), t4.on("error", function(e5) {
                  r3(e5);
                }), t4.on("end", function() {
                  r3(null, i2.digest(n5));
                });
              else {
                if (!r3 || !s || a || "undefined" == typeof FileReader) {
                  o.isBrowser() && "object" == typeof t4 && !a && (t4 = new o.Buffer(new Uint8Array(t4)));
                  var c = i2.update(t4).digest(n5);
                  return r3 && r3(null, c), c;
                }
                var u = 0, l = new FileReader();
                l.onerror = function() {
                  r3(new Error("Failed to read data."));
                }, l.onload = function() {
                  var e5 = new o.Buffer(new Uint8Array(l.result));
                  i2.update(e5), u += e5.length, l._continueReading();
                }, l._continueReading = function() {
                  if (u >= t4.size)
                    r3(null, i2.digest(n5));
                  else {
                    var e5 = u + 524288;
                    e5 > t4.size && (e5 = t4.size), l.readAsArrayBuffer(s.call(t4, u, e5));
                  }
                }, l._continueReading();
              }
            }, toHex: function(e4) {
              for (var t4 = [], n5 = 0; n5 < e4.length; n5++)
                t4.push(("0" + e4.charCodeAt(n5).toString(16)).substr(-2, 2));
              return t4.join("");
            }, createHash: function(e4) {
              return o.crypto.lib.createHash(e4);
            } }, abort: {}, each: function(e4, t4) {
              for (var n5 in e4)
                if (Object.prototype.hasOwnProperty.call(e4, n5) && t4.call(this, n5, e4[n5]) === o.abort)
                  break;
            }, arrayEach: function(e4, t4) {
              for (var n5 in e4)
                if (Object.prototype.hasOwnProperty.call(e4, n5) && t4.call(this, e4[n5], parseInt(n5, 10)) === o.abort)
                  break;
            }, update: function(e4, t4) {
              return o.each(t4, function(t5, n5) {
                e4[t5] = n5;
              }), e4;
            }, merge: function(e4, t4) {
              return o.update(o.copy(e4), t4);
            }, copy: function(e4) {
              if (null == e4)
                return e4;
              var t4 = {};
              for (var n5 in e4)
                t4[n5] = e4[n5];
              return t4;
            }, isEmpty: function(e4) {
              for (var t4 in e4)
                if (Object.prototype.hasOwnProperty.call(e4, t4))
                  return false;
              return true;
            }, arraySliceFn: function(e4) {
              var t4 = e4.slice || e4.webkitSlice || e4.mozSlice;
              return "function" == typeof t4 ? t4 : null;
            }, isType: function(e4, t4) {
              return "function" == typeof t4 && (t4 = o.typeName(t4)), Object.prototype.toString.call(e4) === "[object " + t4 + "]";
            }, typeName: function(e4) {
              if (Object.prototype.hasOwnProperty.call(e4, "name"))
                return e4.name;
              var t4 = e4.toString(), n5 = t4.match(/^\s*function (.+)\(/);
              return n5 ? n5[1] : t4;
            }, error: function(e4, t4) {
              var n5 = null;
              return "string" == typeof e4.message && "" !== e4.message && ("string" == typeof t4 || t4 && t4.message) && ((n5 = o.copy(e4)).message = e4.message), e4.message = e4.message || null, "string" == typeof t4 ? e4.message = t4 : "object" == typeof t4 && null !== t4 && (o.update(e4, t4), t4.message && (e4.message = t4.message), (t4.code || t4.name) && (e4.code = t4.code || t4.name), t4.stack && (e4.stack = t4.stack)), "function" == typeof Object.defineProperty && (Object.defineProperty(e4, "name", { writable: true, enumerable: false }), Object.defineProperty(e4, "message", { enumerable: true })), e4.name = String(t4 && t4.name || e4.name || e4.code || "Error"), e4.time = /* @__PURE__ */ new Date(), n5 && (e4.originalError = n5), e4;
            }, inherit: function(e4, t4) {
              var n5 = null;
              if (void 0 === t4)
                t4 = e4, e4 = Object, n5 = {};
              else {
                var r3 = function() {
                };
                r3.prototype = e4.prototype, n5 = new r3();
              }
              return t4.constructor === Object && (t4.constructor = function() {
                if (e4 !== Object)
                  return e4.apply(this, arguments);
              }), t4.constructor.prototype = n5, o.update(t4.constructor.prototype, t4), t4.constructor.__super__ = e4, t4.constructor;
            }, mixin: function() {
              for (var e4 = arguments[0], t4 = 1; t4 < arguments.length; t4++)
                for (var n5 in arguments[t4].prototype) {
                  var r3 = arguments[t4].prototype[n5];
                  "constructor" !== n5 && (e4.prototype[n5] = r3);
                }
              return e4;
            }, hideProperties: function(e4, t4) {
              "function" == typeof Object.defineProperty && o.arrayEach(t4, function(t5) {
                Object.defineProperty(e4, t5, { enumerable: false, writable: true, configurable: true });
              });
            }, property: function(e4, t4, n5, r3, i2) {
              var o2 = { configurable: true, enumerable: void 0 === r3 || r3 };
              "function" != typeof n5 || i2 ? (o2.value = n5, o2.writable = true) : o2.get = n5, Object.defineProperty(e4, t4, o2);
            }, memoizedProperty: function(e4, t4, n5, r3) {
              var i2 = null;
              o.property(e4, t4, function() {
                return null === i2 && (i2 = n5()), i2;
              }, r3);
            }, hoistPayloadMember: function(e4) {
              var t4 = e4.request, n5 = t4.operation, r3 = t4.service.api.operations[n5], i2 = r3.output;
              if (i2.payload && !r3.hasEventOutput) {
                var s = i2.members[i2.payload], a = e4.data[i2.payload];
                "structure" === s.type && o.each(a, function(t5, n6) {
                  o.property(e4.data, t5, n6, false);
                });
              }
            }, computeSha256: function(t4, n5) {
              if (o.isNode()) {
                var r3 = o.stream.Stream, i2 = e3("fs");
                if ("function" == typeof r3 && t4 instanceof r3) {
                  if ("string" != typeof t4.path)
                    return n5(new Error("Non-file stream objects are not supported with SigV4"));
                  var s = {};
                  "number" == typeof t4.start && (s.start = t4.start), "number" == typeof t4.end && (s.end = t4.end), t4 = i2.createReadStream(t4.path, s);
                }
              }
              o.crypto.sha256(t4, "hex", function(e4, t5) {
                e4 ? n5(e4) : n5(null, t5);
              });
            }, isClockSkewed: function(e4) {
              if (e4)
                return o.property(i.config, "isClockSkewed", Math.abs((/* @__PURE__ */ new Date()).getTime() - e4) >= 3e5, false), i.config.isClockSkewed;
            }, applyClockOffset: function(e4) {
              e4 && (i.config.systemClockOffset = e4 - (/* @__PURE__ */ new Date()).getTime());
            }, extractRequestId: function(e4) {
              var t4 = e4.httpResponse.headers["x-amz-request-id"] || e4.httpResponse.headers["x-amzn-requestid"];
              !t4 && e4.data && e4.data.ResponseMetadata && (t4 = e4.data.ResponseMetadata.RequestId), t4 && (e4.requestId = t4), e4.error && (e4.error.requestId = t4);
            }, addPromises: function(e4, t4) {
              var n5 = false;
              void 0 === t4 && i && i.config && (t4 = i.config.getPromisesDependency()), void 0 === t4 && "undefined" != typeof Promise && (t4 = Promise), "function" != typeof t4 && (n5 = true), Array.isArray(e4) || (e4 = [e4]);
              for (var r3 = 0; r3 < e4.length; r3++) {
                var o2 = e4[r3];
                n5 ? o2.deletePromisesFromClass && o2.deletePromisesFromClass() : o2.addPromisesToClass && o2.addPromisesToClass(t4);
              }
            }, promisifyMethod: function(e4, t4) {
              return function() {
                var n5 = this, r3 = Array.prototype.slice.call(arguments);
                return new t4(function(t5, i2) {
                  r3.push(function(e5, n6) {
                    e5 ? i2(e5) : t5(n6);
                  }), n5[e4].apply(n5, r3);
                });
              };
            }, isDualstackAvailable: function(t4) {
              if (!t4)
                return false;
              var n5 = e3("../apis/metadata.json");
              return "string" != typeof t4 && (t4 = t4.serviceIdentifier), !("string" != typeof t4 || !n5.hasOwnProperty(t4) || !n5[t4].dualstackAvailable);
            }, calculateRetryDelay: function(e4, t4, n5) {
              t4 || (t4 = {});
              var r3 = t4.customBackoff || null;
              if ("function" == typeof r3)
                return r3(e4, n5);
              var i2 = "number" == typeof t4.base ? t4.base : 100;
              return Math.random() * (Math.pow(2, e4) * i2);
            }, handleRequestWithRetries: function(e4, t4, n5) {
              t4 || (t4 = {});
              var r3 = i.HttpClient.getInstance(), s = t4.httpOptions || {}, a = 0, c = function(e5) {
                var r4 = t4.maxRetries || 0;
                if (e5 && "TimeoutError" === e5.code && (e5.retryable = true), e5 && e5.retryable && a < r4) {
                  var i2 = o.calculateRetryDelay(a, t4.retryDelayOptions, e5);
                  if (i2 >= 0)
                    return a++, void setTimeout(u, i2 + (e5.retryAfter || 0));
                }
                n5(e5);
              }, u = function() {
                var t5 = "";
                r3.handleRequest(e4, s, function(e5) {
                  e5.on("data", function(e6) {
                    t5 += e6.toString();
                  }), e5.on("end", function() {
                    var r4 = e5.statusCode;
                    if (r4 < 300)
                      n5(null, t5);
                    else {
                      var i2 = 1e3 * parseInt(e5.headers["retry-after"], 10) || 0, s2 = o.error(new Error(), { statusCode: r4, retryable: r4 >= 500 || 429 === r4 });
                      i2 && s2.retryable && (s2.retryAfter = i2), c(s2);
                    }
                  });
                }, c);
              };
              i.util.defer(u);
            }, uuid: { v4: function() {
              return e3("uuid").v4();
            } }, convertPayloadToString: function(e4) {
              var t4 = e4.request, n5 = t4.operation, r3 = t4.service.api.operations[n5].output || {};
              r3.payload && e4.data[r3.payload] && (e4.data[r3.payload] = e4.data[r3.payload].toString());
            }, defer: function(e4) {
              "object" == typeof n4 && "function" == typeof n4.nextTick ? n4.nextTick(e4) : "function" == typeof r2 ? r2(e4) : setTimeout(e4, 0);
            }, getRequestPayloadShape: function(e4) {
              var t4 = e4.service.api.operations;
              if (t4) {
                var n5 = (t4 || {})[e4.operation];
                if (n5 && n5.input && n5.input.payload)
                  return n5.input.members[n5.input.payload];
              }
            }, getProfilesFromSharedConfig: function(e4, t4) {
              function r3(e5, t5) {
                for (var n5 = 0, r4 = Object.keys(t5); n5 < r4.length; n5++)
                  e5[r4[n5]] = t5[r4[n5]];
                return e5;
              }
              var i2 = {}, s = {};
              n4.env[o.configOptInEnv] && (s = e4.loadFrom({ isConfig: true, filename: n4.env[o.sharedConfigFileEnv] }));
              for (var a = e4.loadFrom({ filename: t4 || n4.env[o.configOptInEnv] && n4.env[o.sharedCredentialsFileEnv] }), c = 0, u = Object.keys(s); c < u.length; c++)
                i2[u[c]] = r3(i2[u[c]] || {}, s[u[c]]);
              for (c = 0, u = Object.keys(a); c < u.length; c++)
                i2[u[c]] = r3(i2[u[c]] || {}, a[u[c]]);
              return i2;
            }, ARN: { validate: function(e4) {
              return e4 && 0 === e4.indexOf("arn:") && e4.split(":").length >= 6;
            }, parse: function(e4) {
              var t4 = e4.split(":");
              return { partition: t4[1], service: t4[2], region: t4[3], accountId: t4[4], resource: t4.slice(5).join(":") };
            }, build: function(e4) {
              if (void 0 === e4.service || void 0 === e4.region || void 0 === e4.accountId || void 0 === e4.resource)
                throw o.error(new Error("Input ARN object is invalid"));
              return "arn:" + (e4.partition || "aws") + ":" + e4.service + ":" + e4.region + ":" + e4.accountId + ":" + e4.resource;
            } }, defaultProfile: "default", configOptInEnv: "AWS_SDK_LOAD_CONFIG", sharedCredentialsFileEnv: "AWS_SHARED_CREDENTIALS_FILE", sharedConfigFileEnv: "AWS_CONFIG_FILE", imdsDisabledEnv: "AWS_EC2_METADATA_DISABLED" };
            t3.exports = o;
          }).call(this);
        }).call(this, e3("_process"), e3("timers").setImmediate);
      }, { "../apis/metadata.json": 5, "./core": 20, _process: 87, fs: 81, timers: 95, uuid: 100 }], 74: [function(e3, t3, n3) {
        function r2() {
        }
        function i(e4, t4) {
          for (var n4 = e4.getElementsByTagName(t4), r3 = 0, i2 = n4.length; r3 < i2; r3++)
            if (n4[r3].parentNode === e4)
              return n4[r3];
        }
        function o(e4, t4) {
          switch (t4 || (t4 = {}), t4.type) {
            case "structure":
              return s(e4, t4);
            case "map":
              return function(e5, t5) {
                for (var n4 = {}, r3 = t5.key.name || "key", s2 = t5.value.name || "value", a2 = t5.flattened ? t5.name : "entry", c2 = e5.firstElementChild; c2; ) {
                  if (c2.nodeName === a2) {
                    var u = i(c2, r3).textContent, l = i(c2, s2);
                    n4[u] = o(l, t5.value);
                  }
                  c2 = c2.nextElementSibling;
                }
                return n4;
              }(e4, t4);
            case "list":
              return function(e5, t5) {
                for (var n4 = [], r3 = t5.flattened ? t5.name : t5.member.name || "member", i2 = e5.firstElementChild; i2; )
                  i2.nodeName === r3 && n4.push(o(i2, t5.member)), i2 = i2.nextElementSibling;
                return n4;
              }(e4, t4);
            case void 0:
            case null:
              return function(e5) {
                if (null == e5)
                  return "";
                if (!e5.firstElementChild)
                  return null === e5.parentNode.parentNode ? {} : 0 === e5.childNodes.length ? "" : e5.textContent;
                for (var t5 = { type: "structure", members: {} }, n4 = e5.firstElementChild; n4; ) {
                  var r3 = n4.nodeName;
                  Object.prototype.hasOwnProperty.call(t5.members, r3) ? t5.members[r3].type = "list" : t5.members[r3] = { name: r3 }, n4 = n4.nextElementSibling;
                }
                return s(e5, t5);
              }(e4);
            default:
              return function(e5, t5) {
                if (e5.getAttribute) {
                  var n4 = e5.getAttribute("encoding");
                  "base64" === n4 && (t5 = new c.create({ type: n4 }));
                }
                var r3 = e5.textContent;
                return "" === r3 && (r3 = null), "function" == typeof t5.toType ? t5.toType(r3) : r3;
              }(e4, t4);
          }
        }
        function s(e4, t4) {
          var n4 = {};
          return null === e4 || a.each(t4.members, function(r3, s2) {
            if (s2.isXmlAttribute) {
              if (Object.prototype.hasOwnProperty.call(e4.attributes, s2.name)) {
                var a2 = e4.attributes[s2.name].value;
                n4[r3] = o({ textContent: a2 }, s2);
              }
            } else {
              var c2 = s2.flattened ? e4 : i(e4, s2.name);
              c2 ? n4[r3] = o(c2, s2) : s2.flattened || "list" !== s2.type || t4.api.xmlNoDefaultLists || (n4[r3] = s2.defaultValue);
            }
          }), n4;
        }
        var a = e3("../util"), c = e3("../model/shape");
        r2.prototype.parse = function(e4, t4) {
          if ("" === e4.replace(/^\s+/, ""))
            return {};
          var n4, r3;
          try {
            if (window.DOMParser) {
              try {
                n4 = new DOMParser().parseFromString(e4, "text/xml");
              } catch (e5) {
                throw a.error(new Error("Parse error in document"), { originalError: e5, code: "XMLParserError", retryable: true });
              }
              if (null === n4.documentElement)
                throw a.error(new Error("Cannot parse empty document."), { code: "XMLParserError", retryable: true });
              var s2 = n4.getElementsByTagName("parsererror")[0];
              if (s2 && (s2.parentNode === n4 || "body" === s2.parentNode.nodeName || s2.parentNode.parentNode === n4 || "body" === s2.parentNode.parentNode.nodeName)) {
                var c2 = s2.getElementsByTagName("div")[0] || s2;
                throw a.error(new Error(c2.textContent || "Parser error in document"), { code: "XMLParserError", retryable: true });
              }
            } else {
              if (!window.ActiveXObject)
                throw new Error("Cannot load XML parser");
              if ((n4 = new window.ActiveXObject("Microsoft.XMLDOM")).async = false, !n4.loadXML(e4))
                throw a.error(new Error("Parse error in document"), { code: "XMLParserError", retryable: true });
            }
          } catch (e5) {
            r3 = e5;
          }
          if (n4 && n4.documentElement && !r3) {
            var u = o(n4.documentElement, t4), l = i(n4.documentElement, "ResponseMetadata");
            return l && (u.ResponseMetadata = o(l, {})), u;
          }
          if (r3)
            throw a.error(r3 || new Error(), { code: "XMLParserError", retryable: true });
          return {};
        }, t3.exports = r2;
      }, { "../model/shape": 45, "../util": 73 }], 75: [function(e3, t3, n3) {
        function r2() {
        }
        function i(e4, t4, n4) {
          switch (n4.type) {
            case "structure":
              return function(e5, t5, n5) {
                s.arrayEach(n5.memberNames, function(r3) {
                  var s2 = n5.members[r3];
                  if ("body" === s2.location) {
                    var c2 = t5[r3], u = s2.name;
                    if (null != c2)
                      if (s2.isXmlAttribute)
                        e5.addAttribute(u, c2);
                      else if (s2.flattened)
                        i(e5, c2, s2);
                      else {
                        var l = new a(u);
                        e5.addChildNode(l), o(l, s2), i(l, c2, s2);
                      }
                  }
                });
              }(e4, t4, n4);
            case "map":
              return function(e5, t5, n5) {
                var r3 = n5.key.name || "key", o2 = n5.value.name || "value";
                s.each(t5, function(t6, s2) {
                  var c2 = new a(n5.flattened ? n5.name : "entry");
                  e5.addChildNode(c2);
                  var u = new a(r3), l = new a(o2);
                  c2.addChildNode(u), c2.addChildNode(l), i(u, t6, n5.key), i(l, s2, n5.value);
                });
              }(e4, t4, n4);
            case "list":
              return function(e5, t5, n5) {
                n5.flattened ? s.arrayEach(t5, function(t6) {
                  var r3 = n5.member.name || n5.name, o2 = new a(r3);
                  e5.addChildNode(o2), i(o2, t6, n5.member);
                }) : s.arrayEach(t5, function(t6) {
                  var r3 = n5.member.name || "member", o2 = new a(r3);
                  e5.addChildNode(o2), i(o2, t6, n5.member);
                });
              }(e4, t4, n4);
            default:
              return function(e5, t5, n5) {
                e5.addChildNode(new c(n5.toWireFormat(t5)));
              }(e4, t4, n4);
          }
        }
        function o(e4, t4, n4) {
          var r3, i2 = "xmlns";
          t4.xmlNamespaceUri ? (r3 = t4.xmlNamespaceUri, t4.xmlNamespacePrefix && (i2 += ":" + t4.xmlNamespacePrefix)) : n4 && t4.api.xmlNamespaceUri && (r3 = t4.api.xmlNamespaceUri), r3 && e4.addAttribute(i2, r3);
        }
        var s = e3("../util"), a = e3("./xml-node").XmlNode, c = e3("./xml-text").XmlText;
        r2.prototype.toXML = function(e4, t4, n4, r3) {
          var s2 = new a(n4);
          return o(s2, t4, true), i(s2, e4, t4), s2.children.length > 0 || r3 ? s2.toString() : "";
        }, t3.exports = r2;
      }, { "../util": 73, "./xml-node": 78, "./xml-text": 79 }], 76: [function(e3, t3, n3) {
        t3.exports = { escapeAttribute: function(e4) {
          return e4.replace(/&/g, "&amp;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        } };
      }, {}], 77: [function(e3, t3, n3) {
        t3.exports = { escapeElement: function(e4) {
          return e4.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        } };
      }, {}], 78: [function(e3, t3, n3) {
        function r2(e4, t4) {
          void 0 === t4 && (t4 = []), this.name = e4, this.children = t4, this.attributes = {};
        }
        var i = e3("./escape-attribute").escapeAttribute;
        r2.prototype.addAttribute = function(e4, t4) {
          return this.attributes[e4] = t4, this;
        }, r2.prototype.addChildNode = function(e4) {
          return this.children.push(e4), this;
        }, r2.prototype.removeAttribute = function(e4) {
          return delete this.attributes[e4], this;
        }, r2.prototype.toString = function() {
          for (var e4 = Boolean(this.children.length), t4 = "<" + this.name, n4 = this.attributes, r3 = 0, o = Object.keys(n4); r3 < o.length; r3++) {
            var s = o[r3], a = n4[s];
            null != a && (t4 += " " + s + '="' + i("" + a) + '"');
          }
          return t4 + (e4 ? ">" + this.children.map(function(e5) {
            return e5.toString();
          }).join("") + "</" + this.name + ">" : "/>");
        }, t3.exports = { XmlNode: r2 };
      }, { "./escape-attribute": 76 }], 79: [function(e3, t3, n3) {
        function r2(e4) {
          this.value = e4;
        }
        var i = e3("./escape-element").escapeElement;
        r2.prototype.toString = function() {
          return i("" + this.value);
        }, t3.exports = { XmlText: r2 };
      }, { "./escape-element": 77 }], 80: [function(e3, t3, n3) {
        function r2(e4) {
          var t4 = e4.length;
          if (t4 % 4 > 0)
            throw new Error("Invalid string. Length must be a multiple of 4");
          var n4 = e4.indexOf("=");
          return -1 === n4 && (n4 = t4), [n4, n4 === t4 ? 0 : 4 - n4 % 4];
        }
        function i(e4) {
          return s[e4 >> 18 & 63] + s[e4 >> 12 & 63] + s[e4 >> 6 & 63] + s[63 & e4];
        }
        function o(e4, t4, n4) {
          for (var r3, o2 = [], s2 = t4; s2 < n4; s2 += 3)
            r3 = (e4[s2] << 16 & 16711680) + (e4[s2 + 1] << 8 & 65280) + (255 & e4[s2 + 2]), o2.push(i(r3));
          return o2.join("");
        }
        n3.byteLength = function(e4) {
          var t4 = r2(e4), n4 = t4[0], i2 = t4[1];
          return 3 * (n4 + i2) / 4 - i2;
        }, n3.toByteArray = function(e4) {
          var t4, n4, i2 = r2(e4), o2 = i2[0], s2 = i2[1], u2 = new c(function(e5, t5, n5) {
            return 3 * (t5 + n5) / 4 - n5;
          }(0, o2, s2)), l2 = 0, p2 = s2 > 0 ? o2 - 4 : o2;
          for (n4 = 0; n4 < p2; n4 += 4)
            t4 = a[e4.charCodeAt(n4)] << 18 | a[e4.charCodeAt(n4 + 1)] << 12 | a[e4.charCodeAt(n4 + 2)] << 6 | a[e4.charCodeAt(n4 + 3)], u2[l2++] = t4 >> 16 & 255, u2[l2++] = t4 >> 8 & 255, u2[l2++] = 255 & t4;
          return 2 === s2 && (t4 = a[e4.charCodeAt(n4)] << 2 | a[e4.charCodeAt(n4 + 1)] >> 4, u2[l2++] = 255 & t4), 1 === s2 && (t4 = a[e4.charCodeAt(n4)] << 10 | a[e4.charCodeAt(n4 + 1)] << 4 | a[e4.charCodeAt(n4 + 2)] >> 2, u2[l2++] = t4 >> 8 & 255, u2[l2++] = 255 & t4), u2;
        }, n3.fromByteArray = function(e4) {
          for (var t4, n4 = e4.length, r3 = n4 % 3, i2 = [], a2 = 0, c2 = n4 - r3; a2 < c2; a2 += 16383)
            i2.push(o(e4, a2, a2 + 16383 > c2 ? c2 : a2 + 16383));
          return 1 === r3 ? (t4 = e4[n4 - 1], i2.push(s[t4 >> 2] + s[t4 << 4 & 63] + "==")) : 2 === r3 && (t4 = (e4[n4 - 2] << 8) + e4[n4 - 1], i2.push(s[t4 >> 10] + s[t4 >> 4 & 63] + s[t4 << 2 & 63] + "=")), i2.join("");
        };
        for (var s = [], a = [], c = "undefined" != typeof Uint8Array ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", l = 0, p = u.length; l < p; ++l)
          s[l] = u[l], a[u.charCodeAt(l)] = l;
        a["-".charCodeAt(0)] = 62, a["_".charCodeAt(0)] = 63;
      }, {}], 81: [function(e3, t3, n3) {
      }, {}], 82: [function(e3, t3, n3) {
        (function(t4, r2) {
          (function() {
            function r3() {
              return o.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
            }
            function i(e4, t5) {
              if (r3() < t5)
                throw new RangeError("Invalid typed array length");
              return o.TYPED_ARRAY_SUPPORT ? (e4 = new Uint8Array(t5)).__proto__ = o.prototype : (null === e4 && (e4 = new o(t5)), e4.length = t5), e4;
            }
            function o(e4, t5, n4) {
              if (!(o.TYPED_ARRAY_SUPPORT || this instanceof o))
                return new o(e4, t5, n4);
              if ("number" == typeof e4) {
                if ("string" == typeof t5)
                  throw new Error("If encoding is specified then the first argument must be a string");
                return c(this, e4);
              }
              return s(this, e4, t5, n4);
            }
            function s(e4, t5, n4, r4) {
              if ("number" == typeof t5)
                throw new TypeError('"value" argument must not be a number');
              return "undefined" != typeof ArrayBuffer && t5 instanceof ArrayBuffer ? function(e5, t6, n5, r5) {
                if (t6.byteLength, n5 < 0 || t6.byteLength < n5)
                  throw new RangeError("'offset' is out of bounds");
                if (t6.byteLength < n5 + (r5 || 0))
                  throw new RangeError("'length' is out of bounds");
                return t6 = void 0 === n5 && void 0 === r5 ? new Uint8Array(t6) : void 0 === r5 ? new Uint8Array(t6, n5) : new Uint8Array(t6, n5, r5), o.TYPED_ARRAY_SUPPORT ? (e5 = t6).__proto__ = o.prototype : e5 = u(e5, t6), e5;
              }(e4, t5, n4, r4) : "string" == typeof t5 ? function(e5, t6, n5) {
                if ("string" == typeof n5 && "" !== n5 || (n5 = "utf8"), !o.isEncoding(n5))
                  throw new TypeError('"encoding" must be a valid string encoding');
                var r5 = 0 | p(t6, n5), s2 = (e5 = i(e5, r5)).write(t6, n5);
                return s2 !== r5 && (e5 = e5.slice(0, s2)), e5;
              }(e4, t5, n4) : function(e5, t6) {
                if (o.isBuffer(t6)) {
                  var n5 = 0 | l(t6.length);
                  return 0 === (e5 = i(e5, n5)).length || t6.copy(e5, 0, 0, n5), e5;
                }
                if (t6) {
                  if ("undefined" != typeof ArrayBuffer && t6.buffer instanceof ArrayBuffer || "length" in t6)
                    return "number" != typeof t6.length || function(e6) {
                      return e6 != e6;
                    }(t6.length) ? i(e5, 0) : u(e5, t6);
                  if ("Buffer" === t6.type && W(t6.data))
                    return u(e5, t6.data);
                }
                throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
              }(e4, t5);
            }
            function a(e4) {
              if ("number" != typeof e4)
                throw new TypeError('"size" argument must be a number');
              if (e4 < 0)
                throw new RangeError('"size" argument must not be negative');
            }
            function c(e4, t5) {
              if (a(t5), e4 = i(e4, t5 < 0 ? 0 : 0 | l(t5)), !o.TYPED_ARRAY_SUPPORT)
                for (var n4 = 0; n4 < t5; ++n4)
                  e4[n4] = 0;
              return e4;
            }
            function u(e4, t5) {
              var n4 = t5.length < 0 ? 0 : 0 | l(t5.length);
              e4 = i(e4, n4);
              for (var r4 = 0; r4 < n4; r4 += 1)
                e4[r4] = 255 & t5[r4];
              return e4;
            }
            function l(e4) {
              if (e4 >= r3())
                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + r3().toString(16) + " bytes");
              return 0 | e4;
            }
            function p(e4, t5) {
              if (o.isBuffer(e4))
                return e4.length;
              if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(e4) || e4 instanceof ArrayBuffer))
                return e4.byteLength;
              "string" != typeof e4 && (e4 = "" + e4);
              var n4 = e4.length;
              if (0 === n4)
                return 0;
              for (var r4 = false; ; )
                switch (t5) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return n4;
                  case "utf8":
                  case "utf-8":
                  case void 0:
                    return D(e4).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return 2 * n4;
                  case "hex":
                    return n4 >>> 1;
                  case "base64":
                    return U(e4).length;
                  default:
                    if (r4)
                      return D(e4).length;
                    t5 = ("" + t5).toLowerCase(), r4 = true;
                }
            }
            function d(e4, t5, n4) {
              var r4 = false;
              if ((void 0 === t5 || t5 < 0) && (t5 = 0), t5 > this.length)
                return "";
              if ((void 0 === n4 || n4 > this.length) && (n4 = this.length), n4 <= 0)
                return "";
              if ((n4 >>>= 0) <= (t5 >>>= 0))
                return "";
              for (e4 || (e4 = "utf8"); ; )
                switch (e4) {
                  case "hex":
                    return k(this, t5, n4);
                  case "utf8":
                  case "utf-8":
                    return C(this, t5, n4);
                  case "ascii":
                    return T(this, t5, n4);
                  case "latin1":
                  case "binary":
                    return I(this, t5, n4);
                  case "base64":
                    return S(this, t5, n4);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return _(this, t5, n4);
                  default:
                    if (r4)
                      throw new TypeError("Unknown encoding: " + e4);
                    e4 = (e4 + "").toLowerCase(), r4 = true;
                }
            }
            function h(e4, t5, n4) {
              var r4 = e4[t5];
              e4[t5] = e4[n4], e4[n4] = r4;
            }
            function f(e4, t5, n4, r4, i2) {
              if (0 === e4.length)
                return -1;
              if ("string" == typeof n4 ? (r4 = n4, n4 = 0) : n4 > 2147483647 ? n4 = 2147483647 : n4 < -2147483648 && (n4 = -2147483648), n4 = +n4, isNaN(n4) && (n4 = i2 ? 0 : e4.length - 1), n4 < 0 && (n4 = e4.length + n4), n4 >= e4.length) {
                if (i2)
                  return -1;
                n4 = e4.length - 1;
              } else if (n4 < 0) {
                if (!i2)
                  return -1;
                n4 = 0;
              }
              if ("string" == typeof t5 && (t5 = o.from(t5, r4)), o.isBuffer(t5))
                return 0 === t5.length ? -1 : m(e4, t5, n4, r4, i2);
              if ("number" == typeof t5)
                return t5 &= 255, o.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i2 ? Uint8Array.prototype.indexOf.call(e4, t5, n4) : Uint8Array.prototype.lastIndexOf.call(e4, t5, n4) : m(e4, [t5], n4, r4, i2);
              throw new TypeError("val must be string, number or Buffer");
            }
            function m(e4, t5, n4, r4, i2) {
              function o2(e5, t6) {
                return 1 === a2 ? e5[t6] : e5.readUInt16BE(t6 * a2);
              }
              var s2, a2 = 1, c2 = e4.length, u2 = t5.length;
              if (void 0 !== r4 && ("ucs2" === (r4 = String(r4).toLowerCase()) || "ucs-2" === r4 || "utf16le" === r4 || "utf-16le" === r4)) {
                if (e4.length < 2 || t5.length < 2)
                  return -1;
                a2 = 2, c2 /= 2, u2 /= 2, n4 /= 2;
              }
              if (i2) {
                var l2 = -1;
                for (s2 = n4; s2 < c2; s2++)
                  if (o2(e4, s2) === o2(t5, -1 === l2 ? 0 : s2 - l2)) {
                    if (-1 === l2 && (l2 = s2), s2 - l2 + 1 === u2)
                      return l2 * a2;
                  } else
                    -1 !== l2 && (s2 -= s2 - l2), l2 = -1;
              } else
                for (n4 + u2 > c2 && (n4 = c2 - u2), s2 = n4; s2 >= 0; s2--) {
                  for (var p2 = true, d2 = 0; d2 < u2; d2++)
                    if (o2(e4, s2 + d2) !== o2(t5, d2)) {
                      p2 = false;
                      break;
                    }
                  if (p2)
                    return s2;
                }
              return -1;
            }
            function g(e4, t5, n4, r4) {
              n4 = Number(n4) || 0;
              var i2 = e4.length - n4;
              r4 ? (r4 = Number(r4)) > i2 && (r4 = i2) : r4 = i2;
              var o2 = t5.length;
              if (o2 % 2 != 0)
                throw new TypeError("Invalid hex string");
              r4 > o2 / 2 && (r4 = o2 / 2);
              for (var s2 = 0; s2 < r4; ++s2) {
                var a2 = parseInt(t5.substr(2 * s2, 2), 16);
                if (isNaN(a2))
                  return s2;
                e4[n4 + s2] = a2;
              }
              return s2;
            }
            function v(e4, t5, n4, r4) {
              return q(D(t5, e4.length - n4), e4, n4, r4);
            }
            function y(e4, t5, n4, r4) {
              return q(function(e5) {
                for (var t6 = [], n5 = 0; n5 < e5.length; ++n5)
                  t6.push(255 & e5.charCodeAt(n5));
                return t6;
              }(t5), e4, n4, r4);
            }
            function b(e4, t5, n4, r4) {
              return y(e4, t5, n4, r4);
            }
            function w(e4, t5, n4, r4) {
              return q(U(t5), e4, n4, r4);
            }
            function E(e4, t5, n4, r4) {
              return q(function(e5, t6) {
                for (var n5, r5, i2, o2 = [], s2 = 0; s2 < e5.length && !((t6 -= 2) < 0); ++s2)
                  r5 = (n5 = e5.charCodeAt(s2)) >> 8, i2 = n5 % 256, o2.push(i2), o2.push(r5);
                return o2;
              }(t5, e4.length - n4), e4, n4, r4);
            }
            function S(e4, t5, n4) {
              return 0 === t5 && n4 === e4.length ? j.fromByteArray(e4) : j.fromByteArray(e4.slice(t5, n4));
            }
            function C(e4, t5, n4) {
              n4 = Math.min(e4.length, n4);
              for (var r4 = [], i2 = t5; i2 < n4; ) {
                var o2, s2, a2, c2, u2 = e4[i2], l2 = null, p2 = u2 > 239 ? 4 : u2 > 223 ? 3 : u2 > 191 ? 2 : 1;
                if (i2 + p2 <= n4)
                  switch (p2) {
                    case 1:
                      u2 < 128 && (l2 = u2);
                      break;
                    case 2:
                      128 == (192 & (o2 = e4[i2 + 1])) && (c2 = (31 & u2) << 6 | 63 & o2) > 127 && (l2 = c2);
                      break;
                    case 3:
                      o2 = e4[i2 + 1], s2 = e4[i2 + 2], 128 == (192 & o2) && 128 == (192 & s2) && (c2 = (15 & u2) << 12 | (63 & o2) << 6 | 63 & s2) > 2047 && (c2 < 55296 || c2 > 57343) && (l2 = c2);
                      break;
                    case 4:
                      o2 = e4[i2 + 1], s2 = e4[i2 + 2], a2 = e4[i2 + 3], 128 == (192 & o2) && 128 == (192 & s2) && 128 == (192 & a2) && (c2 = (15 & u2) << 18 | (63 & o2) << 12 | (63 & s2) << 6 | 63 & a2) > 65535 && c2 < 1114112 && (l2 = c2);
                  }
                null === l2 ? (l2 = 65533, p2 = 1) : l2 > 65535 && (l2 -= 65536, r4.push(l2 >>> 10 & 1023 | 55296), l2 = 56320 | 1023 & l2), r4.push(l2), i2 += p2;
              }
              return function(e5) {
                var t6 = e5.length;
                if (t6 <= B)
                  return String.fromCharCode.apply(String, e5);
                for (var n5 = "", r5 = 0; r5 < t6; )
                  n5 += String.fromCharCode.apply(String, e5.slice(r5, r5 += B));
                return n5;
              }(r4);
            }
            function T(e4, t5, n4) {
              var r4 = "";
              n4 = Math.min(e4.length, n4);
              for (var i2 = t5; i2 < n4; ++i2)
                r4 += String.fromCharCode(127 & e4[i2]);
              return r4;
            }
            function I(e4, t5, n4) {
              var r4 = "";
              n4 = Math.min(e4.length, n4);
              for (var i2 = t5; i2 < n4; ++i2)
                r4 += String.fromCharCode(e4[i2]);
              return r4;
            }
            function k(e4, t5, n4) {
              var r4 = e4.length;
              (!t5 || t5 < 0) && (t5 = 0), (!n4 || n4 < 0 || n4 > r4) && (n4 = r4);
              for (var i2 = "", o2 = t5; o2 < n4; ++o2)
                i2 += P(e4[o2]);
              return i2;
            }
            function _(e4, t5, n4) {
              for (var r4 = e4.slice(t5, n4), i2 = "", o2 = 0; o2 < r4.length; o2 += 2)
                i2 += String.fromCharCode(r4[o2] + 256 * r4[o2 + 1]);
              return i2;
            }
            function x(e4, t5, n4) {
              if (e4 % 1 != 0 || e4 < 0)
                throw new RangeError("offset is not uint");
              if (e4 + t5 > n4)
                throw new RangeError("Trying to access beyond buffer length");
            }
            function A(e4, t5, n4, r4, i2, s2) {
              if (!o.isBuffer(e4))
                throw new TypeError('"buffer" argument must be a Buffer instance');
              if (t5 > i2 || t5 < s2)
                throw new RangeError('"value" argument is out of bounds');
              if (n4 + r4 > e4.length)
                throw new RangeError("Index out of range");
            }
            function R(e4, t5, n4, r4) {
              t5 < 0 && (t5 = 65535 + t5 + 1);
              for (var i2 = 0, o2 = Math.min(e4.length - n4, 2); i2 < o2; ++i2)
                e4[n4 + i2] = (t5 & 255 << 8 * (r4 ? i2 : 1 - i2)) >>> 8 * (r4 ? i2 : 1 - i2);
            }
            function O(e4, t5, n4, r4) {
              t5 < 0 && (t5 = 4294967295 + t5 + 1);
              for (var i2 = 0, o2 = Math.min(e4.length - n4, 4); i2 < o2; ++i2)
                e4[n4 + i2] = t5 >>> 8 * (r4 ? i2 : 3 - i2) & 255;
            }
            function N(e4, t5, n4, r4, i2, o2) {
              if (n4 + r4 > e4.length)
                throw new RangeError("Index out of range");
              if (n4 < 0)
                throw new RangeError("Index out of range");
            }
            function L(e4, t5, n4, r4, i2) {
              return i2 || N(e4, 0, n4, 4), F.write(e4, t5, n4, r4, 23, 4), n4 + 4;
            }
            function M(e4, t5, n4, r4, i2) {
              return i2 || N(e4, 0, n4, 8), F.write(e4, t5, n4, r4, 52, 8), n4 + 8;
            }
            function P(e4) {
              return e4 < 16 ? "0" + e4.toString(16) : e4.toString(16);
            }
            function D(e4, t5) {
              t5 = t5 || 1 / 0;
              for (var n4, r4 = e4.length, i2 = null, o2 = [], s2 = 0; s2 < r4; ++s2) {
                if ((n4 = e4.charCodeAt(s2)) > 55295 && n4 < 57344) {
                  if (!i2) {
                    if (n4 > 56319) {
                      (t5 -= 3) > -1 && o2.push(239, 191, 189);
                      continue;
                    }
                    if (s2 + 1 === r4) {
                      (t5 -= 3) > -1 && o2.push(239, 191, 189);
                      continue;
                    }
                    i2 = n4;
                    continue;
                  }
                  if (n4 < 56320) {
                    (t5 -= 3) > -1 && o2.push(239, 191, 189), i2 = n4;
                    continue;
                  }
                  n4 = 65536 + (i2 - 55296 << 10 | n4 - 56320);
                } else
                  i2 && (t5 -= 3) > -1 && o2.push(239, 191, 189);
                if (i2 = null, n4 < 128) {
                  if ((t5 -= 1) < 0)
                    break;
                  o2.push(n4);
                } else if (n4 < 2048) {
                  if ((t5 -= 2) < 0)
                    break;
                  o2.push(n4 >> 6 | 192, 63 & n4 | 128);
                } else if (n4 < 65536) {
                  if ((t5 -= 3) < 0)
                    break;
                  o2.push(n4 >> 12 | 224, n4 >> 6 & 63 | 128, 63 & n4 | 128);
                } else {
                  if (!(n4 < 1114112))
                    throw new Error("Invalid code point");
                  if ((t5 -= 4) < 0)
                    break;
                  o2.push(n4 >> 18 | 240, n4 >> 12 & 63 | 128, n4 >> 6 & 63 | 128, 63 & n4 | 128);
                }
              }
              return o2;
            }
            function U(e4) {
              return j.toByteArray(function(e5) {
                if ((e5 = function(e6) {
                  return e6.trim ? e6.trim() : e6.replace(/^\s+|\s+$/g, "");
                }(e5).replace(z, "")).length < 2)
                  return "";
                for (; e5.length % 4 != 0; )
                  e5 += "=";
                return e5;
              }(e4));
            }
            function q(e4, t5, n4, r4) {
              for (var i2 = 0; i2 < r4 && !(i2 + n4 >= t5.length || i2 >= e4.length); ++i2)
                t5[i2 + n4] = e4[i2];
              return i2;
            }
            var j = e3("base64-js"), F = e3("ieee754"), W = e3("isarray");
            n3.Buffer = o, n3.SlowBuffer = function(e4) {
              return +e4 != e4 && (e4 = 0), o.alloc(+e4);
            }, n3.INSPECT_MAX_BYTES = 50, o.TYPED_ARRAY_SUPPORT = void 0 !== t4.TYPED_ARRAY_SUPPORT ? t4.TYPED_ARRAY_SUPPORT : function() {
              try {
                var e4 = new Uint8Array(1);
                return e4.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                  return 42;
                } }, 42 === e4.foo() && "function" == typeof e4.subarray && 0 === e4.subarray(1, 1).byteLength;
              } catch (e5) {
                return false;
              }
            }(), n3.kMaxLength = r3(), o.poolSize = 8192, o._augment = function(e4) {
              return e4.__proto__ = o.prototype, e4;
            }, o.from = function(e4, t5, n4) {
              return s(null, e4, t5, n4);
            }, o.TYPED_ARRAY_SUPPORT && (o.prototype.__proto__ = Uint8Array.prototype, o.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && o[Symbol.species] === o && Object.defineProperty(o, Symbol.species, { value: null, configurable: true })), o.alloc = function(e4, t5, n4) {
              return function(e5, t6, n5, r4) {
                return a(t6), t6 <= 0 ? i(e5, t6) : void 0 !== n5 ? "string" == typeof r4 ? i(e5, t6).fill(n5, r4) : i(e5, t6).fill(n5) : i(e5, t6);
              }(null, e4, t5, n4);
            }, o.allocUnsafe = function(e4) {
              return c(null, e4);
            }, o.allocUnsafeSlow = function(e4) {
              return c(null, e4);
            }, o.isBuffer = function(e4) {
              return !(null == e4 || !e4._isBuffer);
            }, o.compare = function(e4, t5) {
              if (!o.isBuffer(e4) || !o.isBuffer(t5))
                throw new TypeError("Arguments must be Buffers");
              if (e4 === t5)
                return 0;
              for (var n4 = e4.length, r4 = t5.length, i2 = 0, s2 = Math.min(n4, r4); i2 < s2; ++i2)
                if (e4[i2] !== t5[i2]) {
                  n4 = e4[i2], r4 = t5[i2];
                  break;
                }
              return n4 < r4 ? -1 : r4 < n4 ? 1 : 0;
            }, o.isEncoding = function(e4) {
              switch (String(e4).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return true;
                default:
                  return false;
              }
            }, o.concat = function(e4, t5) {
              if (!W(e4))
                throw new TypeError('"list" argument must be an Array of Buffers');
              if (0 === e4.length)
                return o.alloc(0);
              var n4;
              if (void 0 === t5)
                for (t5 = 0, n4 = 0; n4 < e4.length; ++n4)
                  t5 += e4[n4].length;
              var r4 = o.allocUnsafe(t5), i2 = 0;
              for (n4 = 0; n4 < e4.length; ++n4) {
                var s2 = e4[n4];
                if (!o.isBuffer(s2))
                  throw new TypeError('"list" argument must be an Array of Buffers');
                s2.copy(r4, i2), i2 += s2.length;
              }
              return r4;
            }, o.byteLength = p, o.prototype._isBuffer = true, o.prototype.swap16 = function() {
              var e4 = this.length;
              if (e4 % 2 != 0)
                throw new RangeError("Buffer size must be a multiple of 16-bits");
              for (var t5 = 0; t5 < e4; t5 += 2)
                h(this, t5, t5 + 1);
              return this;
            }, o.prototype.swap32 = function() {
              var e4 = this.length;
              if (e4 % 4 != 0)
                throw new RangeError("Buffer size must be a multiple of 32-bits");
              for (var t5 = 0; t5 < e4; t5 += 4)
                h(this, t5, t5 + 3), h(this, t5 + 1, t5 + 2);
              return this;
            }, o.prototype.swap64 = function() {
              var e4 = this.length;
              if (e4 % 8 != 0)
                throw new RangeError("Buffer size must be a multiple of 64-bits");
              for (var t5 = 0; t5 < e4; t5 += 8)
                h(this, t5, t5 + 7), h(this, t5 + 1, t5 + 6), h(this, t5 + 2, t5 + 5), h(this, t5 + 3, t5 + 4);
              return this;
            }, o.prototype.toString = function() {
              var e4 = 0 | this.length;
              return 0 === e4 ? "" : 0 === arguments.length ? C(this, 0, e4) : d.apply(this, arguments);
            }, o.prototype.equals = function(e4) {
              if (!o.isBuffer(e4))
                throw new TypeError("Argument must be a Buffer");
              return this === e4 || 0 === o.compare(this, e4);
            }, o.prototype.inspect = function() {
              var e4 = "", t5 = n3.INSPECT_MAX_BYTES;
              return this.length > 0 && (e4 = this.toString("hex", 0, t5).match(/.{2}/g).join(" "), this.length > t5 && (e4 += " ... ")), "<Buffer " + e4 + ">";
            }, o.prototype.compare = function(e4, t5, n4, r4, i2) {
              if (!o.isBuffer(e4))
                throw new TypeError("Argument must be a Buffer");
              if (void 0 === t5 && (t5 = 0), void 0 === n4 && (n4 = e4 ? e4.length : 0), void 0 === r4 && (r4 = 0), void 0 === i2 && (i2 = this.length), t5 < 0 || n4 > e4.length || r4 < 0 || i2 > this.length)
                throw new RangeError("out of range index");
              if (r4 >= i2 && t5 >= n4)
                return 0;
              if (r4 >= i2)
                return -1;
              if (t5 >= n4)
                return 1;
              if (this === e4)
                return 0;
              for (var s2 = (i2 >>>= 0) - (r4 >>>= 0), a2 = (n4 >>>= 0) - (t5 >>>= 0), c2 = Math.min(s2, a2), u2 = this.slice(r4, i2), l2 = e4.slice(t5, n4), p2 = 0; p2 < c2; ++p2)
                if (u2[p2] !== l2[p2]) {
                  s2 = u2[p2], a2 = l2[p2];
                  break;
                }
              return s2 < a2 ? -1 : a2 < s2 ? 1 : 0;
            }, o.prototype.includes = function(e4, t5, n4) {
              return -1 !== this.indexOf(e4, t5, n4);
            }, o.prototype.indexOf = function(e4, t5, n4) {
              return f(this, e4, t5, n4, true);
            }, o.prototype.lastIndexOf = function(e4, t5, n4) {
              return f(this, e4, t5, n4, false);
            }, o.prototype.write = function(e4, t5, n4, r4) {
              if (void 0 === t5)
                r4 = "utf8", n4 = this.length, t5 = 0;
              else if (void 0 === n4 && "string" == typeof t5)
                r4 = t5, n4 = this.length, t5 = 0;
              else {
                if (!isFinite(t5))
                  throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                t5 |= 0, isFinite(n4) ? (n4 |= 0, void 0 === r4 && (r4 = "utf8")) : (r4 = n4, n4 = void 0);
              }
              var i2 = this.length - t5;
              if ((void 0 === n4 || n4 > i2) && (n4 = i2), e4.length > 0 && (n4 < 0 || t5 < 0) || t5 > this.length)
                throw new RangeError("Attempt to write outside buffer bounds");
              r4 || (r4 = "utf8");
              for (var o2 = false; ; )
                switch (r4) {
                  case "hex":
                    return g(this, e4, t5, n4);
                  case "utf8":
                  case "utf-8":
                    return v(this, e4, t5, n4);
                  case "ascii":
                    return y(this, e4, t5, n4);
                  case "latin1":
                  case "binary":
                    return b(this, e4, t5, n4);
                  case "base64":
                    return w(this, e4, t5, n4);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return E(this, e4, t5, n4);
                  default:
                    if (o2)
                      throw new TypeError("Unknown encoding: " + r4);
                    r4 = ("" + r4).toLowerCase(), o2 = true;
                }
            }, o.prototype.toJSON = function() {
              return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
            };
            var B = 4096;
            o.prototype.slice = function(e4, t5) {
              var n4, r4 = this.length;
              if ((e4 = ~~e4) < 0 ? (e4 += r4) < 0 && (e4 = 0) : e4 > r4 && (e4 = r4), (t5 = void 0 === t5 ? r4 : ~~t5) < 0 ? (t5 += r4) < 0 && (t5 = 0) : t5 > r4 && (t5 = r4), t5 < e4 && (t5 = e4), o.TYPED_ARRAY_SUPPORT)
                (n4 = this.subarray(e4, t5)).__proto__ = o.prototype;
              else {
                var i2 = t5 - e4;
                n4 = new o(i2, void 0);
                for (var s2 = 0; s2 < i2; ++s2)
                  n4[s2] = this[s2 + e4];
              }
              return n4;
            }, o.prototype.readUIntLE = function(e4, t5, n4) {
              e4 |= 0, t5 |= 0, n4 || x(e4, t5, this.length);
              for (var r4 = this[e4], i2 = 1, o2 = 0; ++o2 < t5 && (i2 *= 256); )
                r4 += this[e4 + o2] * i2;
              return r4;
            }, o.prototype.readUIntBE = function(e4, t5, n4) {
              e4 |= 0, t5 |= 0, n4 || x(e4, t5, this.length);
              for (var r4 = this[e4 + --t5], i2 = 1; t5 > 0 && (i2 *= 256); )
                r4 += this[e4 + --t5] * i2;
              return r4;
            }, o.prototype.readUInt8 = function(e4, t5) {
              return t5 || x(e4, 1, this.length), this[e4];
            }, o.prototype.readUInt16LE = function(e4, t5) {
              return t5 || x(e4, 2, this.length), this[e4] | this[e4 + 1] << 8;
            }, o.prototype.readUInt16BE = function(e4, t5) {
              return t5 || x(e4, 2, this.length), this[e4] << 8 | this[e4 + 1];
            }, o.prototype.readUInt32LE = function(e4, t5) {
              return t5 || x(e4, 4, this.length), (this[e4] | this[e4 + 1] << 8 | this[e4 + 2] << 16) + 16777216 * this[e4 + 3];
            }, o.prototype.readUInt32BE = function(e4, t5) {
              return t5 || x(e4, 4, this.length), 16777216 * this[e4] + (this[e4 + 1] << 16 | this[e4 + 2] << 8 | this[e4 + 3]);
            }, o.prototype.readIntLE = function(e4, t5, n4) {
              e4 |= 0, t5 |= 0, n4 || x(e4, t5, this.length);
              for (var r4 = this[e4], i2 = 1, o2 = 0; ++o2 < t5 && (i2 *= 256); )
                r4 += this[e4 + o2] * i2;
              return r4 >= (i2 *= 128) && (r4 -= Math.pow(2, 8 * t5)), r4;
            }, o.prototype.readIntBE = function(e4, t5, n4) {
              e4 |= 0, t5 |= 0, n4 || x(e4, t5, this.length);
              for (var r4 = t5, i2 = 1, o2 = this[e4 + --r4]; r4 > 0 && (i2 *= 256); )
                o2 += this[e4 + --r4] * i2;
              return o2 >= (i2 *= 128) && (o2 -= Math.pow(2, 8 * t5)), o2;
            }, o.prototype.readInt8 = function(e4, t5) {
              return t5 || x(e4, 1, this.length), 128 & this[e4] ? -1 * (255 - this[e4] + 1) : this[e4];
            }, o.prototype.readInt16LE = function(e4, t5) {
              t5 || x(e4, 2, this.length);
              var n4 = this[e4] | this[e4 + 1] << 8;
              return 32768 & n4 ? 4294901760 | n4 : n4;
            }, o.prototype.readInt16BE = function(e4, t5) {
              t5 || x(e4, 2, this.length);
              var n4 = this[e4 + 1] | this[e4] << 8;
              return 32768 & n4 ? 4294901760 | n4 : n4;
            }, o.prototype.readInt32LE = function(e4, t5) {
              return t5 || x(e4, 4, this.length), this[e4] | this[e4 + 1] << 8 | this[e4 + 2] << 16 | this[e4 + 3] << 24;
            }, o.prototype.readInt32BE = function(e4, t5) {
              return t5 || x(e4, 4, this.length), this[e4] << 24 | this[e4 + 1] << 16 | this[e4 + 2] << 8 | this[e4 + 3];
            }, o.prototype.readFloatLE = function(e4, t5) {
              return t5 || x(e4, 4, this.length), F.read(this, e4, true, 23, 4);
            }, o.prototype.readFloatBE = function(e4, t5) {
              return t5 || x(e4, 4, this.length), F.read(this, e4, false, 23, 4);
            }, o.prototype.readDoubleLE = function(e4, t5) {
              return t5 || x(e4, 8, this.length), F.read(this, e4, true, 52, 8);
            }, o.prototype.readDoubleBE = function(e4, t5) {
              return t5 || x(e4, 8, this.length), F.read(this, e4, false, 52, 8);
            }, o.prototype.writeUIntLE = function(e4, t5, n4, r4) {
              e4 = +e4, t5 |= 0, n4 |= 0, r4 || A(this, e4, t5, n4, Math.pow(2, 8 * n4) - 1, 0);
              var i2 = 1, o2 = 0;
              for (this[t5] = 255 & e4; ++o2 < n4 && (i2 *= 256); )
                this[t5 + o2] = e4 / i2 & 255;
              return t5 + n4;
            }, o.prototype.writeUIntBE = function(e4, t5, n4, r4) {
              e4 = +e4, t5 |= 0, n4 |= 0, r4 || A(this, e4, t5, n4, Math.pow(2, 8 * n4) - 1, 0);
              var i2 = n4 - 1, o2 = 1;
              for (this[t5 + i2] = 255 & e4; --i2 >= 0 && (o2 *= 256); )
                this[t5 + i2] = e4 / o2 & 255;
              return t5 + n4;
            }, o.prototype.writeUInt8 = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 1, 255, 0), o.TYPED_ARRAY_SUPPORT || (e4 = Math.floor(e4)), this[t5] = 255 & e4, t5 + 1;
            }, o.prototype.writeUInt16LE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 2, 65535, 0), o.TYPED_ARRAY_SUPPORT ? (this[t5] = 255 & e4, this[t5 + 1] = e4 >>> 8) : R(this, e4, t5, true), t5 + 2;
            }, o.prototype.writeUInt16BE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 2, 65535, 0), o.TYPED_ARRAY_SUPPORT ? (this[t5] = e4 >>> 8, this[t5 + 1] = 255 & e4) : R(this, e4, t5, false), t5 + 2;
            }, o.prototype.writeUInt32LE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 4, 4294967295, 0), o.TYPED_ARRAY_SUPPORT ? (this[t5 + 3] = e4 >>> 24, this[t5 + 2] = e4 >>> 16, this[t5 + 1] = e4 >>> 8, this[t5] = 255 & e4) : O(this, e4, t5, true), t5 + 4;
            }, o.prototype.writeUInt32BE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 4, 4294967295, 0), o.TYPED_ARRAY_SUPPORT ? (this[t5] = e4 >>> 24, this[t5 + 1] = e4 >>> 16, this[t5 + 2] = e4 >>> 8, this[t5 + 3] = 255 & e4) : O(this, e4, t5, false), t5 + 4;
            }, o.prototype.writeIntLE = function(e4, t5, n4, r4) {
              if (e4 = +e4, t5 |= 0, !r4) {
                var i2 = Math.pow(2, 8 * n4 - 1);
                A(this, e4, t5, n4, i2 - 1, -i2);
              }
              var o2 = 0, s2 = 1, a2 = 0;
              for (this[t5] = 255 & e4; ++o2 < n4 && (s2 *= 256); )
                e4 < 0 && 0 === a2 && 0 !== this[t5 + o2 - 1] && (a2 = 1), this[t5 + o2] = (e4 / s2 >> 0) - a2 & 255;
              return t5 + n4;
            }, o.prototype.writeIntBE = function(e4, t5, n4, r4) {
              if (e4 = +e4, t5 |= 0, !r4) {
                var i2 = Math.pow(2, 8 * n4 - 1);
                A(this, e4, t5, n4, i2 - 1, -i2);
              }
              var o2 = n4 - 1, s2 = 1, a2 = 0;
              for (this[t5 + o2] = 255 & e4; --o2 >= 0 && (s2 *= 256); )
                e4 < 0 && 0 === a2 && 0 !== this[t5 + o2 + 1] && (a2 = 1), this[t5 + o2] = (e4 / s2 >> 0) - a2 & 255;
              return t5 + n4;
            }, o.prototype.writeInt8 = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 1, 127, -128), o.TYPED_ARRAY_SUPPORT || (e4 = Math.floor(e4)), e4 < 0 && (e4 = 255 + e4 + 1), this[t5] = 255 & e4, t5 + 1;
            }, o.prototype.writeInt16LE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 2, 32767, -32768), o.TYPED_ARRAY_SUPPORT ? (this[t5] = 255 & e4, this[t5 + 1] = e4 >>> 8) : R(this, e4, t5, true), t5 + 2;
            }, o.prototype.writeInt16BE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 2, 32767, -32768), o.TYPED_ARRAY_SUPPORT ? (this[t5] = e4 >>> 8, this[t5 + 1] = 255 & e4) : R(this, e4, t5, false), t5 + 2;
            }, o.prototype.writeInt32LE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 4, 2147483647, -2147483648), o.TYPED_ARRAY_SUPPORT ? (this[t5] = 255 & e4, this[t5 + 1] = e4 >>> 8, this[t5 + 2] = e4 >>> 16, this[t5 + 3] = e4 >>> 24) : O(this, e4, t5, true), t5 + 4;
            }, o.prototype.writeInt32BE = function(e4, t5, n4) {
              return e4 = +e4, t5 |= 0, n4 || A(this, e4, t5, 4, 2147483647, -2147483648), e4 < 0 && (e4 = 4294967295 + e4 + 1), o.TYPED_ARRAY_SUPPORT ? (this[t5] = e4 >>> 24, this[t5 + 1] = e4 >>> 16, this[t5 + 2] = e4 >>> 8, this[t5 + 3] = 255 & e4) : O(this, e4, t5, false), t5 + 4;
            }, o.prototype.writeFloatLE = function(e4, t5, n4) {
              return L(this, e4, t5, true, n4);
            }, o.prototype.writeFloatBE = function(e4, t5, n4) {
              return L(this, e4, t5, false, n4);
            }, o.prototype.writeDoubleLE = function(e4, t5, n4) {
              return M(this, e4, t5, true, n4);
            }, o.prototype.writeDoubleBE = function(e4, t5, n4) {
              return M(this, e4, t5, false, n4);
            }, o.prototype.copy = function(e4, t5, n4, r4) {
              if (n4 || (n4 = 0), r4 || 0 === r4 || (r4 = this.length), t5 >= e4.length && (t5 = e4.length), t5 || (t5 = 0), r4 > 0 && r4 < n4 && (r4 = n4), r4 === n4)
                return 0;
              if (0 === e4.length || 0 === this.length)
                return 0;
              if (t5 < 0)
                throw new RangeError("targetStart out of bounds");
              if (n4 < 0 || n4 >= this.length)
                throw new RangeError("sourceStart out of bounds");
              if (r4 < 0)
                throw new RangeError("sourceEnd out of bounds");
              r4 > this.length && (r4 = this.length), e4.length - t5 < r4 - n4 && (r4 = e4.length - t5 + n4);
              var i2, s2 = r4 - n4;
              if (this === e4 && n4 < t5 && t5 < r4)
                for (i2 = s2 - 1; i2 >= 0; --i2)
                  e4[i2 + t5] = this[i2 + n4];
              else if (s2 < 1e3 || !o.TYPED_ARRAY_SUPPORT)
                for (i2 = 0; i2 < s2; ++i2)
                  e4[i2 + t5] = this[i2 + n4];
              else
                Uint8Array.prototype.set.call(e4, this.subarray(n4, n4 + s2), t5);
              return s2;
            }, o.prototype.fill = function(e4, t5, n4, r4) {
              if ("string" == typeof e4) {
                if ("string" == typeof t5 ? (r4 = t5, t5 = 0, n4 = this.length) : "string" == typeof n4 && (r4 = n4, n4 = this.length), 1 === e4.length) {
                  var i2 = e4.charCodeAt(0);
                  i2 < 256 && (e4 = i2);
                }
                if (void 0 !== r4 && "string" != typeof r4)
                  throw new TypeError("encoding must be a string");
                if ("string" == typeof r4 && !o.isEncoding(r4))
                  throw new TypeError("Unknown encoding: " + r4);
              } else
                "number" == typeof e4 && (e4 &= 255);
              if (t5 < 0 || this.length < t5 || this.length < n4)
                throw new RangeError("Out of range index");
              if (n4 <= t5)
                return this;
              var s2;
              if (t5 >>>= 0, n4 = void 0 === n4 ? this.length : n4 >>> 0, e4 || (e4 = 0), "number" == typeof e4)
                for (s2 = t5; s2 < n4; ++s2)
                  this[s2] = e4;
              else {
                var a2 = o.isBuffer(e4) ? e4 : D(new o(e4, r4).toString()), c2 = a2.length;
                for (s2 = 0; s2 < n4 - t5; ++s2)
                  this[s2 + t5] = a2[s2 % c2];
              }
              return this;
            };
            var z = /[^+\/0-9A-Za-z-_]/g;
          }).call(this);
        }).call(this, "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {}, e3("buffer").Buffer);
      }, { "base64-js": 80, buffer: 82, ieee754: 84, isarray: 85 }], 83: [function(e3, t3, n3) {
        function r2() {
          this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
        }
        function i(e4) {
          return "function" == typeof e4;
        }
        function o(e4) {
          return "object" == typeof e4 && null !== e4;
        }
        function s(e4) {
          return void 0 === e4;
        }
        t3.exports = r2, r2.EventEmitter = r2, r2.prototype._events = void 0, r2.prototype._maxListeners = void 0, r2.defaultMaxListeners = 10, r2.prototype.setMaxListeners = function(e4) {
          if (!/* @__PURE__ */ function(e5) {
            return "number" == typeof e5;
          }(e4) || e4 < 0 || isNaN(e4))
            throw TypeError("n must be a positive number");
          return this._maxListeners = e4, this;
        }, r2.prototype.emit = function(e4) {
          var t4, n4, r3, a, c, u;
          if (this._events || (this._events = {}), "error" === e4 && (!this._events.error || o(this._events.error) && !this._events.error.length)) {
            if ((t4 = arguments[1]) instanceof Error)
              throw t4;
            var l = new Error('Uncaught, unspecified "error" event. (' + t4 + ")");
            throw l.context = t4, l;
          }
          if (s(n4 = this._events[e4]))
            return false;
          if (i(n4))
            switch (arguments.length) {
              case 1:
                n4.call(this);
                break;
              case 2:
                n4.call(this, arguments[1]);
                break;
              case 3:
                n4.call(this, arguments[1], arguments[2]);
                break;
              default:
                a = Array.prototype.slice.call(arguments, 1), n4.apply(this, a);
            }
          else if (o(n4))
            for (a = Array.prototype.slice.call(arguments, 1), r3 = (u = n4.slice()).length, c = 0; c < r3; c++)
              u[c].apply(this, a);
          return true;
        }, r2.prototype.addListener = function(e4, t4) {
          var n4;
          if (!i(t4))
            throw TypeError("listener must be a function");
          return this._events || (this._events = {}), this._events.newListener && this.emit("newListener", e4, i(t4.listener) ? t4.listener : t4), this._events[e4] ? o(this._events[e4]) ? this._events[e4].push(t4) : this._events[e4] = [this._events[e4], t4] : this._events[e4] = t4, o(this._events[e4]) && !this._events[e4].warned && (n4 = s(this._maxListeners) ? r2.defaultMaxListeners : this._maxListeners) && n4 > 0 && this._events[e4].length > n4 && (this._events[e4].warned = true, console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[e4].length), "function" == typeof console.trace && console.trace()), this;
        }, r2.prototype.on = r2.prototype.addListener, r2.prototype.once = function(e4, t4) {
          function n4() {
            this.removeListener(e4, n4), r3 || (r3 = true, t4.apply(this, arguments));
          }
          if (!i(t4))
            throw TypeError("listener must be a function");
          var r3 = false;
          return n4.listener = t4, this.on(e4, n4), this;
        }, r2.prototype.removeListener = function(e4, t4) {
          var n4, r3, s2, a;
          if (!i(t4))
            throw TypeError("listener must be a function");
          if (!this._events || !this._events[e4])
            return this;
          if (s2 = (n4 = this._events[e4]).length, r3 = -1, n4 === t4 || i(n4.listener) && n4.listener === t4)
            delete this._events[e4], this._events.removeListener && this.emit("removeListener", e4, t4);
          else if (o(n4)) {
            for (a = s2; a-- > 0; )
              if (n4[a] === t4 || n4[a].listener && n4[a].listener === t4) {
                r3 = a;
                break;
              }
            if (r3 < 0)
              return this;
            1 === n4.length ? (n4.length = 0, delete this._events[e4]) : n4.splice(r3, 1), this._events.removeListener && this.emit("removeListener", e4, t4);
          }
          return this;
        }, r2.prototype.removeAllListeners = function(e4) {
          var t4, n4;
          if (!this._events)
            return this;
          if (!this._events.removeListener)
            return 0 === arguments.length ? this._events = {} : this._events[e4] && delete this._events[e4], this;
          if (0 === arguments.length) {
            for (t4 in this._events)
              "removeListener" !== t4 && this.removeAllListeners(t4);
            return this.removeAllListeners("removeListener"), this._events = {}, this;
          }
          if (i(n4 = this._events[e4]))
            this.removeListener(e4, n4);
          else if (n4)
            for (; n4.length; )
              this.removeListener(e4, n4[n4.length - 1]);
          return delete this._events[e4], this;
        }, r2.prototype.listeners = function(e4) {
          return this._events && this._events[e4] ? i(this._events[e4]) ? [this._events[e4]] : this._events[e4].slice() : [];
        }, r2.prototype.listenerCount = function(e4) {
          if (this._events) {
            var t4 = this._events[e4];
            if (i(t4))
              return 1;
            if (t4)
              return t4.length;
          }
          return 0;
        }, r2.listenerCount = function(e4, t4) {
          return e4.listenerCount(t4);
        };
      }, {}], 84: [function(e3, t3, n3) {
        n3.read = function(e4, t4, n4, r2, i) {
          var o, s, a = 8 * i - r2 - 1, c = (1 << a) - 1, u = c >> 1, l = -7, p = n4 ? i - 1 : 0, d = n4 ? -1 : 1, h = e4[t4 + p];
          for (p += d, o = h & (1 << -l) - 1, h >>= -l, l += a; l > 0; o = 256 * o + e4[t4 + p], p += d, l -= 8)
            ;
          for (s = o & (1 << -l) - 1, o >>= -l, l += r2; l > 0; s = 256 * s + e4[t4 + p], p += d, l -= 8)
            ;
          if (0 === o)
            o = 1 - u;
          else {
            if (o === c)
              return s ? NaN : 1 / 0 * (h ? -1 : 1);
            s += Math.pow(2, r2), o -= u;
          }
          return (h ? -1 : 1) * s * Math.pow(2, o - r2);
        }, n3.write = function(e4, t4, n4, r2, i, o) {
          var s, a, c, u = 8 * o - i - 1, l = (1 << u) - 1, p = l >> 1, d = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = r2 ? 0 : o - 1, f = r2 ? 1 : -1, m = t4 < 0 || 0 === t4 && 1 / t4 < 0 ? 1 : 0;
          for (t4 = Math.abs(t4), isNaN(t4) || t4 === 1 / 0 ? (a = isNaN(t4) ? 1 : 0, s = l) : (s = Math.floor(Math.log(t4) / Math.LN2), t4 * (c = Math.pow(2, -s)) < 1 && (s--, c *= 2), (t4 += s + p >= 1 ? d / c : d * Math.pow(2, 1 - p)) * c >= 2 && (s++, c /= 2), s + p >= l ? (a = 0, s = l) : s + p >= 1 ? (a = (t4 * c - 1) * Math.pow(2, i), s += p) : (a = t4 * Math.pow(2, p - 1) * Math.pow(2, i), s = 0)); i >= 8; e4[n4 + h] = 255 & a, h += f, a /= 256, i -= 8)
            ;
          for (s = s << i | a, u += i; u > 0; e4[n4 + h] = 255 & s, h += f, s /= 256, u -= 8)
            ;
          e4[n4 + h - f] |= 128 * m;
        };
      }, {}], 85: [function(e3, t3, n3) {
        var r2 = {}.toString;
        t3.exports = Array.isArray || function(e4) {
          return "[object Array]" == r2.call(e4);
        };
      }, {}], 86: [function(e3, t3, n3) {
        !function(e4) {
          function t4(e5) {
            return null !== e5 && "[object Array]" === Object.prototype.toString.call(e5);
          }
          function n4(e5) {
            return null !== e5 && "[object Object]" === Object.prototype.toString.call(e5);
          }
          function r2(e5, i2) {
            if (e5 === i2)
              return true;
            if (Object.prototype.toString.call(e5) !== Object.prototype.toString.call(i2))
              return false;
            if (true === t4(e5)) {
              if (e5.length !== i2.length)
                return false;
              for (var o2 = 0; o2 < e5.length; o2++)
                if (false === r2(e5[o2], i2[o2]))
                  return false;
              return true;
            }
            if (true === n4(e5)) {
              var s2 = {};
              for (var a2 in e5)
                if (hasOwnProperty.call(e5, a2)) {
                  if (false === r2(e5[a2], i2[a2]))
                    return false;
                  s2[a2] = true;
                }
              for (var c2 in i2)
                if (hasOwnProperty.call(i2, c2) && true !== s2[c2])
                  return false;
              return true;
            }
            return false;
          }
          function i(e5) {
            if ("" === e5 || false === e5 || null === e5)
              return true;
            if (t4(e5) && 0 === e5.length)
              return true;
            if (n4(e5)) {
              for (var r3 in e5)
                if (e5.hasOwnProperty(r3))
                  return false;
              return true;
            }
            return false;
          }
          function o(e5) {
            return e5 >= "a" && e5 <= "z" || e5 >= "A" && e5 <= "Z" || "_" === e5;
          }
          function s(e5) {
            return e5 >= "0" && e5 <= "9" || "-" === e5;
          }
          function a(e5) {
            return e5 >= "a" && e5 <= "z" || e5 >= "A" && e5 <= "Z" || e5 >= "0" && e5 <= "9" || "_" === e5;
          }
          function c() {
          }
          function u() {
          }
          function l(e5) {
            this.runtime = e5;
          }
          function p(e5) {
            this._interpreter = e5, this.functionTable = { abs: { _func: this._functionAbs, _signature: [{ types: [h] }] }, avg: { _func: this._functionAvg, _signature: [{ types: [b] }] }, ceil: { _func: this._functionCeil, _signature: [{ types: [h] }] }, contains: { _func: this._functionContains, _signature: [{ types: [m, g] }, { types: [f] }] }, ends_with: { _func: this._functionEndsWith, _signature: [{ types: [m] }, { types: [m] }] }, floor: { _func: this._functionFloor, _signature: [{ types: [h] }] }, length: { _func: this._functionLength, _signature: [{ types: [m, g, v] }] }, map: { _func: this._functionMap, _signature: [{ types: [y] }, { types: [g] }] }, max: { _func: this._functionMax, _signature: [{ types: [b, w] }] }, merge: { _func: this._functionMerge, _signature: [{ types: [v], variadic: true }] }, max_by: { _func: this._functionMaxBy, _signature: [{ types: [g] }, { types: [y] }] }, sum: { _func: this._functionSum, _signature: [{ types: [b] }] }, starts_with: { _func: this._functionStartsWith, _signature: [{ types: [m] }, { types: [m] }] }, min: { _func: this._functionMin, _signature: [{ types: [b, w] }] }, min_by: { _func: this._functionMinBy, _signature: [{ types: [g] }, { types: [y] }] }, type: { _func: this._functionType, _signature: [{ types: [f] }] }, keys: { _func: this._functionKeys, _signature: [{ types: [v] }] }, values: { _func: this._functionValues, _signature: [{ types: [v] }] }, sort: { _func: this._functionSort, _signature: [{ types: [w, b] }] }, sort_by: { _func: this._functionSortBy, _signature: [{ types: [g] }, { types: [y] }] }, join: { _func: this._functionJoin, _signature: [{ types: [m] }, { types: [w] }] }, reverse: { _func: this._functionReverse, _signature: [{ types: [m, g] }] }, to_array: { _func: this._functionToArray, _signature: [{ types: [f] }] }, to_string: { _func: this._functionToString, _signature: [{ types: [f] }] }, to_number: { _func: this._functionToNumber, _signature: [{ types: [f] }] }, not_null: { _func: this._functionNotNull, _signature: [{ types: [f], variadic: true }] } };
          }
          var d;
          d = "function" == typeof String.prototype.trimLeft ? function(e5) {
            return e5.trimLeft();
          } : function(e5) {
            return e5.match(/^\s*(.*)/)[1];
          };
          var h = 0, f = 1, m = 2, g = 3, v = 4, y = 6, b = 8, w = 9, E = { ".": "Dot", "*": "Star", ",": "Comma", ":": "Colon", "{": "Lbrace", "}": "Rbrace", "]": "Rbracket", "(": "Lparen", ")": "Rparen", "@": "Current" }, S = { "<": true, ">": true, "=": true, "!": true }, C = { " ": true, "	": true, "\n": true };
          c.prototype = { tokenize: function(e5) {
            var t5, n5, r3, i2 = [];
            for (this._current = 0; this._current < e5.length; )
              if (o(e5[this._current]))
                t5 = this._current, n5 = this._consumeUnquotedIdentifier(e5), i2.push({ type: "UnquotedIdentifier", value: n5, start: t5 });
              else if (void 0 !== E[e5[this._current]])
                i2.push({ type: E[e5[this._current]], value: e5[this._current], start: this._current }), this._current++;
              else if (s(e5[this._current]))
                r3 = this._consumeNumber(e5), i2.push(r3);
              else if ("[" === e5[this._current])
                r3 = this._consumeLBracket(e5), i2.push(r3);
              else if ('"' === e5[this._current])
                t5 = this._current, n5 = this._consumeQuotedIdentifier(e5), i2.push({ type: "QuotedIdentifier", value: n5, start: t5 });
              else if ("'" === e5[this._current])
                t5 = this._current, n5 = this._consumeRawStringLiteral(e5), i2.push({ type: "Literal", value: n5, start: t5 });
              else if ("`" === e5[this._current]) {
                t5 = this._current;
                var a2 = this._consumeLiteral(e5);
                i2.push({ type: "Literal", value: a2, start: t5 });
              } else if (void 0 !== S[e5[this._current]])
                i2.push(this._consumeOperator(e5));
              else if (void 0 !== C[e5[this._current]])
                this._current++;
              else if ("&" === e5[this._current])
                t5 = this._current, this._current++, "&" === e5[this._current] ? (this._current++, i2.push({ type: "And", value: "&&", start: t5 })) : i2.push({ type: "Expref", value: "&", start: t5 });
              else {
                if ("|" !== e5[this._current]) {
                  var c2 = new Error("Unknown character:" + e5[this._current]);
                  throw c2.name = "LexerError", c2;
                }
                t5 = this._current, this._current++, "|" === e5[this._current] ? (this._current++, i2.push({ type: "Or", value: "||", start: t5 })) : i2.push({ type: "Pipe", value: "|", start: t5 });
              }
            return i2;
          }, _consumeUnquotedIdentifier: function(e5) {
            var t5 = this._current;
            for (this._current++; this._current < e5.length && a(e5[this._current]); )
              this._current++;
            return e5.slice(t5, this._current);
          }, _consumeQuotedIdentifier: function(e5) {
            var t5 = this._current;
            this._current++;
            for (var n5 = e5.length; '"' !== e5[this._current] && this._current < n5; ) {
              var r3 = this._current;
              "\\" !== e5[r3] || "\\" !== e5[r3 + 1] && '"' !== e5[r3 + 1] ? r3++ : r3 += 2, this._current = r3;
            }
            return this._current++, JSON.parse(e5.slice(t5, this._current));
          }, _consumeRawStringLiteral: function(e5) {
            var t5 = this._current;
            this._current++;
            for (var n5 = e5.length; "'" !== e5[this._current] && this._current < n5; ) {
              var r3 = this._current;
              "\\" !== e5[r3] || "\\" !== e5[r3 + 1] && "'" !== e5[r3 + 1] ? r3++ : r3 += 2, this._current = r3;
            }
            return this._current++, e5.slice(t5 + 1, this._current - 1).replace("\\'", "'");
          }, _consumeNumber: function(e5) {
            var t5 = this._current;
            this._current++;
            for (var n5 = e5.length; s(e5[this._current]) && this._current < n5; )
              this._current++;
            return { type: "Number", value: parseInt(e5.slice(t5, this._current)), start: t5 };
          }, _consumeLBracket: function(e5) {
            var t5 = this._current;
            return this._current++, "?" === e5[this._current] ? (this._current++, { type: "Filter", value: "[?", start: t5 }) : "]" === e5[this._current] ? (this._current++, { type: "Flatten", value: "[]", start: t5 }) : { type: "Lbracket", value: "[", start: t5 };
          }, _consumeOperator: function(e5) {
            var t5 = this._current, n5 = e5[t5];
            return this._current++, "!" === n5 ? "=" === e5[this._current] ? (this._current++, { type: "NE", value: "!=", start: t5 }) : { type: "Not", value: "!", start: t5 } : "<" === n5 ? "=" === e5[this._current] ? (this._current++, { type: "LTE", value: "<=", start: t5 }) : { type: "LT", value: "<", start: t5 } : ">" === n5 ? "=" === e5[this._current] ? (this._current++, { type: "GTE", value: ">=", start: t5 }) : { type: "GT", value: ">", start: t5 } : "=" === n5 && "=" === e5[this._current] ? (this._current++, { type: "EQ", value: "==", start: t5 }) : void 0;
          }, _consumeLiteral: function(e5) {
            this._current++;
            for (var t5, n5 = this._current, r3 = e5.length; "`" !== e5[this._current] && this._current < r3; ) {
              var i2 = this._current;
              "\\" !== e5[i2] || "\\" !== e5[i2 + 1] && "`" !== e5[i2 + 1] ? i2++ : i2 += 2, this._current = i2;
            }
            var o2 = d(e5.slice(n5, this._current));
            return o2 = o2.replace("\\`", "`"), t5 = this._looksLikeJSON(o2) ? JSON.parse(o2) : JSON.parse('"' + o2 + '"'), this._current++, t5;
          }, _looksLikeJSON: function(e5) {
            if ("" === e5)
              return false;
            if ('[{"'.indexOf(e5[0]) >= 0)
              return true;
            if (["true", "false", "null"].indexOf(e5) >= 0)
              return true;
            if (!("-0123456789".indexOf(e5[0]) >= 0))
              return false;
            try {
              return JSON.parse(e5), true;
            } catch (e6) {
              return false;
            }
          } };
          var T = { EOF: 0, UnquotedIdentifier: 0, QuotedIdentifier: 0, Rbracket: 0, Rparen: 0, Comma: 0, Rbrace: 0, Number: 0, Current: 0, Expref: 0, Pipe: 1, Or: 2, And: 3, EQ: 5, GT: 5, LT: 5, GTE: 5, LTE: 5, NE: 5, Flatten: 9, Star: 20, Filter: 21, Dot: 40, Not: 45, Lbrace: 50, Lbracket: 55, Lparen: 60 };
          u.prototype = { parse: function(e5) {
            this._loadTokens(e5), this.index = 0;
            var t5 = this.expression(0);
            if ("EOF" !== this._lookahead(0)) {
              var n5 = this._lookaheadToken(0), r3 = new Error("Unexpected token type: " + n5.type + ", value: " + n5.value);
              throw r3.name = "ParserError", r3;
            }
            return t5;
          }, _loadTokens: function(e5) {
            var t5 = new c().tokenize(e5);
            t5.push({ type: "EOF", value: "", start: e5.length }), this.tokens = t5;
          }, expression: function(e5) {
            var t5 = this._lookaheadToken(0);
            this._advance();
            for (var n5 = this.nud(t5), r3 = this._lookahead(0); e5 < T[r3]; )
              this._advance(), n5 = this.led(r3, n5), r3 = this._lookahead(0);
            return n5;
          }, _lookahead: function(e5) {
            return this.tokens[this.index + e5].type;
          }, _lookaheadToken: function(e5) {
            return this.tokens[this.index + e5];
          }, _advance: function() {
            this.index++;
          }, nud: function(e5) {
            var t5, n5;
            switch (e5.type) {
              case "Literal":
                return { type: "Literal", value: e5.value };
              case "UnquotedIdentifier":
                return { type: "Field", name: e5.value };
              case "QuotedIdentifier":
                var r3 = { type: "Field", name: e5.value };
                if ("Lparen" === this._lookahead(0))
                  throw new Error("Quoted identifier not allowed for function names.");
                return r3;
              case "Not":
                return { type: "NotExpression", children: [t5 = this.expression(T.Not)] };
              case "Star":
                return t5 = null, { type: "ValueProjection", children: [{ type: "Identity" }, t5 = "Rbracket" === this._lookahead(0) ? { type: "Identity" } : this._parseProjectionRHS(T.Star)] };
              case "Filter":
                return this.led(e5.type, { type: "Identity" });
              case "Lbrace":
                return this._parseMultiselectHash();
              case "Flatten":
                return { type: "Projection", children: [{ type: "Flatten", children: [{ type: "Identity" }] }, t5 = this._parseProjectionRHS(T.Flatten)] };
              case "Lbracket":
                return "Number" === this._lookahead(0) || "Colon" === this._lookahead(0) ? (t5 = this._parseIndexExpression(), this._projectIfSlice({ type: "Identity" }, t5)) : "Star" === this._lookahead(0) && "Rbracket" === this._lookahead(1) ? (this._advance(), this._advance(), { type: "Projection", children: [{ type: "Identity" }, t5 = this._parseProjectionRHS(T.Star)] }) : this._parseMultiselectList();
              case "Current":
                return { type: "Current" };
              case "Expref":
                return { type: "ExpressionReference", children: [n5 = this.expression(T.Expref)] };
              case "Lparen":
                for (var i2 = []; "Rparen" !== this._lookahead(0); )
                  "Current" === this._lookahead(0) ? (n5 = { type: "Current" }, this._advance()) : n5 = this.expression(0), i2.push(n5);
                return this._match("Rparen"), i2[0];
              default:
                this._errorToken(e5);
            }
          }, led: function(e5, t5) {
            var n5;
            switch (e5) {
              case "Dot":
                var r3 = T.Dot;
                return "Star" !== this._lookahead(0) ? { type: "Subexpression", children: [t5, n5 = this._parseDotRHS(r3)] } : (this._advance(), { type: "ValueProjection", children: [t5, n5 = this._parseProjectionRHS(r3)] });
              case "Pipe":
                return { type: "Pipe", children: [t5, n5 = this.expression(T.Pipe)] };
              case "Or":
                return { type: "OrExpression", children: [t5, n5 = this.expression(T.Or)] };
              case "And":
                return { type: "AndExpression", children: [t5, n5 = this.expression(T.And)] };
              case "Lparen":
                for (var i2, o2 = t5.name, s2 = []; "Rparen" !== this._lookahead(0); )
                  "Current" === this._lookahead(0) ? (i2 = { type: "Current" }, this._advance()) : i2 = this.expression(0), "Comma" === this._lookahead(0) && this._match("Comma"), s2.push(i2);
                return this._match("Rparen"), { type: "Function", name: o2, children: s2 };
              case "Filter":
                var a2 = this.expression(0);
                return this._match("Rbracket"), { type: "FilterProjection", children: [t5, n5 = "Flatten" === this._lookahead(0) ? { type: "Identity" } : this._parseProjectionRHS(T.Filter), a2] };
              case "Flatten":
                return { type: "Projection", children: [{ type: "Flatten", children: [t5] }, this._parseProjectionRHS(T.Flatten)] };
              case "EQ":
              case "NE":
              case "GT":
              case "GTE":
              case "LT":
              case "LTE":
                return this._parseComparator(t5, e5);
              case "Lbracket":
                var c2 = this._lookaheadToken(0);
                return "Number" === c2.type || "Colon" === c2.type ? (n5 = this._parseIndexExpression(), this._projectIfSlice(t5, n5)) : (this._match("Star"), this._match("Rbracket"), { type: "Projection", children: [t5, n5 = this._parseProjectionRHS(T.Star)] });
              default:
                this._errorToken(this._lookaheadToken(0));
            }
          }, _match: function(e5) {
            if (this._lookahead(0) !== e5) {
              var t5 = this._lookaheadToken(0), n5 = new Error("Expected " + e5 + ", got: " + t5.type);
              throw n5.name = "ParserError", n5;
            }
            this._advance();
          }, _errorToken: function(e5) {
            var t5 = new Error("Invalid token (" + e5.type + '): "' + e5.value + '"');
            throw t5.name = "ParserError", t5;
          }, _parseIndexExpression: function() {
            if ("Colon" === this._lookahead(0) || "Colon" === this._lookahead(1))
              return this._parseSliceExpression();
            var e5 = { type: "Index", value: this._lookaheadToken(0).value };
            return this._advance(), this._match("Rbracket"), e5;
          }, _projectIfSlice: function(e5, t5) {
            var n5 = { type: "IndexExpression", children: [e5, t5] };
            return "Slice" === t5.type ? { type: "Projection", children: [n5, this._parseProjectionRHS(T.Star)] } : n5;
          }, _parseSliceExpression: function() {
            for (var e5 = [null, null, null], t5 = 0, n5 = this._lookahead(0); "Rbracket" !== n5 && t5 < 3; ) {
              if ("Colon" === n5)
                t5++, this._advance();
              else {
                if ("Number" !== n5) {
                  var r3 = this._lookahead(0), i2 = new Error("Syntax error, unexpected token: " + r3.value + "(" + r3.type + ")");
                  throw i2.name = "Parsererror", i2;
                }
                e5[t5] = this._lookaheadToken(0).value, this._advance();
              }
              n5 = this._lookahead(0);
            }
            return this._match("Rbracket"), { type: "Slice", children: e5 };
          }, _parseComparator: function(e5, t5) {
            return { type: "Comparator", name: t5, children: [e5, this.expression(T[t5])] };
          }, _parseDotRHS: function(e5) {
            var t5 = this._lookahead(0);
            return ["UnquotedIdentifier", "QuotedIdentifier", "Star"].indexOf(t5) >= 0 ? this.expression(e5) : "Lbracket" === t5 ? (this._match("Lbracket"), this._parseMultiselectList()) : "Lbrace" === t5 ? (this._match("Lbrace"), this._parseMultiselectHash()) : void 0;
          }, _parseProjectionRHS: function(e5) {
            var t5;
            if (T[this._lookahead(0)] < 10)
              t5 = { type: "Identity" };
            else if ("Lbracket" === this._lookahead(0))
              t5 = this.expression(e5);
            else if ("Filter" === this._lookahead(0))
              t5 = this.expression(e5);
            else {
              if ("Dot" !== this._lookahead(0)) {
                var n5 = this._lookaheadToken(0), r3 = new Error("Sytanx error, unexpected token: " + n5.value + "(" + n5.type + ")");
                throw r3.name = "ParserError", r3;
              }
              this._match("Dot"), t5 = this._parseDotRHS(e5);
            }
            return t5;
          }, _parseMultiselectList: function() {
            for (var e5 = []; "Rbracket" !== this._lookahead(0); ) {
              var t5 = this.expression(0);
              if (e5.push(t5), "Comma" === this._lookahead(0) && (this._match("Comma"), "Rbracket" === this._lookahead(0)))
                throw new Error("Unexpected token Rbracket");
            }
            return this._match("Rbracket"), { type: "MultiSelectList", children: e5 };
          }, _parseMultiselectHash: function() {
            for (var e5, t5, n5, r3 = [], i2 = ["UnquotedIdentifier", "QuotedIdentifier"]; ; ) {
              if (e5 = this._lookaheadToken(0), i2.indexOf(e5.type) < 0)
                throw new Error("Expecting an identifier token, got: " + e5.type);
              if (t5 = e5.value, this._advance(), this._match("Colon"), n5 = { type: "KeyValuePair", name: t5, value: this.expression(0) }, r3.push(n5), "Comma" === this._lookahead(0))
                this._match("Comma");
              else if ("Rbrace" === this._lookahead(0)) {
                this._match("Rbrace");
                break;
              }
            }
            return { type: "MultiSelectHash", children: r3 };
          } }, l.prototype = { search: function(e5, t5) {
            return this.visit(e5, t5);
          }, visit: function(e5, o2) {
            var s2, a2, c2, u2, l2, p2, d2, h2, f2;
            switch (e5.type) {
              case "Field":
                return null === o2 ? null : n4(o2) ? void 0 === (p2 = o2[e5.name]) ? null : p2 : null;
              case "Subexpression":
                for (c2 = this.visit(e5.children[0], o2), f2 = 1; f2 < e5.children.length; f2++)
                  if (null === (c2 = this.visit(e5.children[1], c2)))
                    return null;
                return c2;
              case "IndexExpression":
              case "Pipe":
                return d2 = this.visit(e5.children[0], o2), this.visit(e5.children[1], d2);
              case "Index":
                if (!t4(o2))
                  return null;
                var m2 = e5.value;
                return m2 < 0 && (m2 = o2.length + m2), void 0 === (c2 = o2[m2]) && (c2 = null), c2;
              case "Slice":
                if (!t4(o2))
                  return null;
                var g2 = e5.children.slice(0), v2 = this.computeSliceParams(o2.length, g2), y2 = v2[0], b2 = v2[1], w2 = v2[2];
                if (c2 = [], w2 > 0)
                  for (f2 = y2; f2 < b2; f2 += w2)
                    c2.push(o2[f2]);
                else
                  for (f2 = y2; f2 > b2; f2 += w2)
                    c2.push(o2[f2]);
                return c2;
              case "Projection":
                var E2 = this.visit(e5.children[0], o2);
                if (!t4(E2))
                  return null;
                for (h2 = [], f2 = 0; f2 < E2.length; f2++)
                  null !== (a2 = this.visit(e5.children[1], E2[f2])) && h2.push(a2);
                return h2;
              case "ValueProjection":
                if (!n4(E2 = this.visit(e5.children[0], o2)))
                  return null;
                h2 = [];
                var S2 = function(e6) {
                  for (var t5 = Object.keys(e6), n5 = [], r3 = 0; r3 < t5.length; r3++)
                    n5.push(e6[t5[r3]]);
                  return n5;
                }(E2);
                for (f2 = 0; f2 < S2.length; f2++)
                  null !== (a2 = this.visit(e5.children[1], S2[f2])) && h2.push(a2);
                return h2;
              case "FilterProjection":
                if (!t4(E2 = this.visit(e5.children[0], o2)))
                  return null;
                var C2 = [], T2 = [];
                for (f2 = 0; f2 < E2.length; f2++)
                  i(s2 = this.visit(e5.children[2], E2[f2])) || C2.push(E2[f2]);
                for (var I = 0; I < C2.length; I++)
                  null !== (a2 = this.visit(e5.children[1], C2[I])) && T2.push(a2);
                return T2;
              case "Comparator":
                switch (u2 = this.visit(e5.children[0], o2), l2 = this.visit(e5.children[1], o2), e5.name) {
                  case "EQ":
                    c2 = r2(u2, l2);
                    break;
                  case "NE":
                    c2 = !r2(u2, l2);
                    break;
                  case "GT":
                    c2 = u2 > l2;
                    break;
                  case "GTE":
                    c2 = u2 >= l2;
                    break;
                  case "LT":
                    c2 = u2 < l2;
                    break;
                  case "LTE":
                    c2 = u2 <= l2;
                    break;
                  default:
                    throw new Error("Unknown comparator: " + e5.name);
                }
                return c2;
              case "Flatten":
                var k = this.visit(e5.children[0], o2);
                if (!t4(k))
                  return null;
                var _ = [];
                for (f2 = 0; f2 < k.length; f2++)
                  t4(a2 = k[f2]) ? _.push.apply(_, a2) : _.push(a2);
                return _;
              case "Identity":
              case "Current":
                return o2;
              case "MultiSelectList":
                if (null === o2)
                  return null;
                for (h2 = [], f2 = 0; f2 < e5.children.length; f2++)
                  h2.push(this.visit(e5.children[f2], o2));
                return h2;
              case "MultiSelectHash":
                if (null === o2)
                  return null;
                var x;
                for (h2 = {}, f2 = 0; f2 < e5.children.length; f2++)
                  h2[(x = e5.children[f2]).name] = this.visit(x.value, o2);
                return h2;
              case "OrExpression":
                return i(s2 = this.visit(e5.children[0], o2)) && (s2 = this.visit(e5.children[1], o2)), s2;
              case "AndExpression":
                return true === i(u2 = this.visit(e5.children[0], o2)) ? u2 : this.visit(e5.children[1], o2);
              case "NotExpression":
                return i(u2 = this.visit(e5.children[0], o2));
              case "Literal":
                return e5.value;
              case "Function":
                var A = [];
                for (f2 = 0; f2 < e5.children.length; f2++)
                  A.push(this.visit(e5.children[f2], o2));
                return this.runtime.callFunction(e5.name, A);
              case "ExpressionReference":
                var R = e5.children[0];
                return R.jmespathType = "Expref", R;
              default:
                throw new Error("Unknown node type: " + e5.type);
            }
          }, computeSliceParams: function(e5, t5) {
            var n5 = t5[0], r3 = t5[1], i2 = t5[2], o2 = [null, null, null];
            if (null === i2)
              i2 = 1;
            else if (0 === i2) {
              var s2 = new Error("Invalid slice, step cannot be 0");
              throw s2.name = "RuntimeError", s2;
            }
            var a2 = i2 < 0;
            return n5 = null === n5 ? a2 ? e5 - 1 : 0 : this.capSliceRange(e5, n5, i2), r3 = null === r3 ? a2 ? -1 : e5 : this.capSliceRange(e5, r3, i2), o2[0] = n5, o2[1] = r3, o2[2] = i2, o2;
          }, capSliceRange: function(e5, t5, n5) {
            return t5 < 0 ? (t5 += e5) < 0 && (t5 = n5 < 0 ? -1 : 0) : t5 >= e5 && (t5 = n5 < 0 ? e5 - 1 : e5), t5;
          } }, p.prototype = { callFunction: function(e5, t5) {
            var n5 = this.functionTable[e5];
            if (void 0 === n5)
              throw new Error("Unknown function: " + e5 + "()");
            return this._validateArgs(e5, t5, n5._signature), n5._func.call(this, t5);
          }, _validateArgs: function(e5, t5, n5) {
            var r3;
            if (n5[n5.length - 1].variadic) {
              if (t5.length < n5.length)
                throw r3 = 1 === n5.length ? " argument" : " arguments", new Error("ArgumentError: " + e5 + "() takes at least" + n5.length + r3 + " but received " + t5.length);
            } else if (t5.length !== n5.length)
              throw r3 = 1 === n5.length ? " argument" : " arguments", new Error("ArgumentError: " + e5 + "() takes " + n5.length + r3 + " but received " + t5.length);
            for (var i2, o2, s2, a2 = 0; a2 < n5.length; a2++) {
              s2 = false, i2 = n5[a2].types, o2 = this._getTypeName(t5[a2]);
              for (var c2 = 0; c2 < i2.length; c2++)
                if (this._typeMatches(o2, i2[c2], t5[a2])) {
                  s2 = true;
                  break;
                }
              if (!s2)
                throw new Error("TypeError: " + e5 + "() expected argument " + (a2 + 1) + " to be type " + i2 + " but received type " + o2 + " instead.");
            }
          }, _typeMatches: function(e5, t5, n5) {
            if (t5 === f)
              return true;
            if (t5 !== w && t5 !== b && t5 !== g)
              return e5 === t5;
            if (t5 === g)
              return e5 === g;
            if (e5 === g) {
              var r3;
              t5 === b ? r3 = h : t5 === w && (r3 = m);
              for (var i2 = 0; i2 < n5.length; i2++)
                if (!this._typeMatches(this._getTypeName(n5[i2]), r3, n5[i2]))
                  return false;
              return true;
            }
          }, _getTypeName: function(e5) {
            switch (Object.prototype.toString.call(e5)) {
              case "[object String]":
                return m;
              case "[object Number]":
                return h;
              case "[object Array]":
                return g;
              case "[object Boolean]":
                return 5;
              case "[object Null]":
                return 7;
              case "[object Object]":
                return "Expref" === e5.jmespathType ? y : v;
            }
          }, _functionStartsWith: function(e5) {
            return 0 === e5[0].lastIndexOf(e5[1]);
          }, _functionEndsWith: function(e5) {
            var t5 = e5[0], n5 = e5[1];
            return -1 !== t5.indexOf(n5, t5.length - n5.length);
          }, _functionReverse: function(e5) {
            if (this._getTypeName(e5[0]) === m) {
              for (var t5 = e5[0], n5 = "", r3 = t5.length - 1; r3 >= 0; r3--)
                n5 += t5[r3];
              return n5;
            }
            var i2 = e5[0].slice(0);
            return i2.reverse(), i2;
          }, _functionAbs: function(e5) {
            return Math.abs(e5[0]);
          }, _functionCeil: function(e5) {
            return Math.ceil(e5[0]);
          }, _functionAvg: function(e5) {
            for (var t5 = 0, n5 = e5[0], r3 = 0; r3 < n5.length; r3++)
              t5 += n5[r3];
            return t5 / n5.length;
          }, _functionContains: function(e5) {
            return e5[0].indexOf(e5[1]) >= 0;
          }, _functionFloor: function(e5) {
            return Math.floor(e5[0]);
          }, _functionLength: function(e5) {
            return n4(e5[0]) ? Object.keys(e5[0]).length : e5[0].length;
          }, _functionMap: function(e5) {
            for (var t5 = [], n5 = this._interpreter, r3 = e5[0], i2 = e5[1], o2 = 0; o2 < i2.length; o2++)
              t5.push(n5.visit(r3, i2[o2]));
            return t5;
          }, _functionMerge: function(e5) {
            for (var t5 = {}, n5 = 0; n5 < e5.length; n5++) {
              var r3 = e5[n5];
              for (var i2 in r3)
                t5[i2] = r3[i2];
            }
            return t5;
          }, _functionMax: function(e5) {
            if (e5[0].length > 0) {
              if (this._getTypeName(e5[0][0]) === h)
                return Math.max.apply(Math, e5[0]);
              for (var t5 = e5[0], n5 = t5[0], r3 = 1; r3 < t5.length; r3++)
                n5.localeCompare(t5[r3]) < 0 && (n5 = t5[r3]);
              return n5;
            }
            return null;
          }, _functionMin: function(e5) {
            if (e5[0].length > 0) {
              if (this._getTypeName(e5[0][0]) === h)
                return Math.min.apply(Math, e5[0]);
              for (var t5 = e5[0], n5 = t5[0], r3 = 1; r3 < t5.length; r3++)
                t5[r3].localeCompare(n5) < 0 && (n5 = t5[r3]);
              return n5;
            }
            return null;
          }, _functionSum: function(e5) {
            for (var t5 = 0, n5 = e5[0], r3 = 0; r3 < n5.length; r3++)
              t5 += n5[r3];
            return t5;
          }, _functionType: function(e5) {
            switch (this._getTypeName(e5[0])) {
              case h:
                return "number";
              case m:
                return "string";
              case g:
                return "array";
              case v:
                return "object";
              case 5:
                return "boolean";
              case y:
                return "expref";
              case 7:
                return "null";
            }
          }, _functionKeys: function(e5) {
            return Object.keys(e5[0]);
          }, _functionValues: function(e5) {
            for (var t5 = e5[0], n5 = Object.keys(t5), r3 = [], i2 = 0; i2 < n5.length; i2++)
              r3.push(t5[n5[i2]]);
            return r3;
          }, _functionJoin: function(e5) {
            var t5 = e5[0];
            return e5[1].join(t5);
          }, _functionToArray: function(e5) {
            return this._getTypeName(e5[0]) === g ? e5[0] : [e5[0]];
          }, _functionToString: function(e5) {
            return this._getTypeName(e5[0]) === m ? e5[0] : JSON.stringify(e5[0]);
          }, _functionToNumber: function(e5) {
            var t5, n5 = this._getTypeName(e5[0]);
            return n5 === h ? e5[0] : n5 !== m || (t5 = +e5[0], isNaN(t5)) ? null : t5;
          }, _functionNotNull: function(e5) {
            for (var t5 = 0; t5 < e5.length; t5++)
              if (7 !== this._getTypeName(e5[t5]))
                return e5[t5];
            return null;
          }, _functionSort: function(e5) {
            var t5 = e5[0].slice(0);
            return t5.sort(), t5;
          }, _functionSortBy: function(e5) {
            var t5 = e5[0].slice(0);
            if (0 === t5.length)
              return t5;
            var n5 = this._interpreter, r3 = e5[1], i2 = this._getTypeName(n5.visit(r3, t5[0]));
            if ([h, m].indexOf(i2) < 0)
              throw new Error("TypeError");
            for (var o2 = this, s2 = [], a2 = 0; a2 < t5.length; a2++)
              s2.push([a2, t5[a2]]);
            s2.sort(function(e6, t6) {
              var s3 = n5.visit(r3, e6[1]), a3 = n5.visit(r3, t6[1]);
              if (o2._getTypeName(s3) !== i2)
                throw new Error("TypeError: expected " + i2 + ", received " + o2._getTypeName(s3));
              if (o2._getTypeName(a3) !== i2)
                throw new Error("TypeError: expected " + i2 + ", received " + o2._getTypeName(a3));
              return s3 > a3 ? 1 : s3 < a3 ? -1 : e6[0] - t6[0];
            });
            for (var c2 = 0; c2 < s2.length; c2++)
              t5[c2] = s2[c2][1];
            return t5;
          }, _functionMaxBy: function(e5) {
            for (var t5, n5, r3 = e5[1], i2 = e5[0], o2 = this.createKeyFunction(r3, [h, m]), s2 = -1 / 0, a2 = 0; a2 < i2.length; a2++)
              (n5 = o2(i2[a2])) > s2 && (s2 = n5, t5 = i2[a2]);
            return t5;
          }, _functionMinBy: function(e5) {
            for (var t5, n5, r3 = e5[1], i2 = e5[0], o2 = this.createKeyFunction(r3, [h, m]), s2 = 1 / 0, a2 = 0; a2 < i2.length; a2++)
              (n5 = o2(i2[a2])) < s2 && (s2 = n5, t5 = i2[a2]);
            return t5;
          }, createKeyFunction: function(e5, t5) {
            var n5 = this, r3 = this._interpreter;
            return function(i2) {
              var o2 = r3.visit(e5, i2);
              if (t5.indexOf(n5._getTypeName(o2)) < 0) {
                var s2 = "TypeError: expected one of " + t5 + ", received " + n5._getTypeName(o2);
                throw new Error(s2);
              }
              return o2;
            };
          } }, e4.tokenize = function(e5) {
            return new c().tokenize(e5);
          }, e4.compile = function(e5) {
            return new u().parse(e5);
          }, e4.search = function(e5, t5) {
            var n5 = new u(), r3 = new p(), i2 = new l(r3);
            r3._interpreter = i2;
            var o2 = n5.parse(t5);
            return i2.search(o2, e5);
          }, e4.strictDeepEqual = r2;
        }(void 0 === n3 ? this.jmespath = {} : n3);
      }, {}], 87: [function(e3, t3, n3) {
        function r2() {
          throw new Error("setTimeout has not been defined");
        }
        function i() {
          throw new Error("clearTimeout has not been defined");
        }
        function o(e4) {
          if (l === setTimeout)
            return setTimeout(e4, 0);
          if ((l === r2 || !l) && setTimeout)
            return l = setTimeout, setTimeout(e4, 0);
          try {
            return l(e4, 0);
          } catch (t4) {
            try {
              return l.call(null, e4, 0);
            } catch (t5) {
              return l.call(this, e4, 0);
            }
          }
        }
        function s() {
          m && h && (m = false, h.length ? f = h.concat(f) : g = -1, f.length && a());
        }
        function a() {
          if (!m) {
            var e4 = o(s);
            m = true;
            for (var t4 = f.length; t4; ) {
              for (h = f, f = []; ++g < t4; )
                h && h[g].run();
              g = -1, t4 = f.length;
            }
            h = null, m = false, function(e5) {
              if (p === clearTimeout)
                return clearTimeout(e5);
              if ((p === i || !p) && clearTimeout)
                return p = clearTimeout, clearTimeout(e5);
              try {
                return p(e5);
              } catch (t5) {
                try {
                  return p.call(null, e5);
                } catch (t6) {
                  return p.call(this, e5);
                }
              }
            }(e4);
          }
        }
        function c(e4, t4) {
          this.fun = e4, this.array = t4;
        }
        function u() {
        }
        var l, p, d = t3.exports = {};
        !function() {
          try {
            l = "function" == typeof setTimeout ? setTimeout : r2;
          } catch (e4) {
            l = r2;
          }
          try {
            p = "function" == typeof clearTimeout ? clearTimeout : i;
          } catch (e4) {
            p = i;
          }
        }();
        var h, f = [], m = false, g = -1;
        d.nextTick = function(e4) {
          var t4 = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var n4 = 1; n4 < arguments.length; n4++)
              t4[n4 - 1] = arguments[n4];
          f.push(new c(e4, t4)), 1 !== f.length || m || o(a);
        }, c.prototype.run = function() {
          this.fun.apply(null, this.array);
        }, d.title = "browser", d.browser = true, d.env = {}, d.argv = [], d.version = "", d.versions = {}, d.on = u, d.addListener = u, d.once = u, d.off = u, d.removeListener = u, d.removeAllListeners = u, d.emit = u, d.prependListener = u, d.prependOnceListener = u, d.listeners = function(e4) {
          return [];
        }, d.binding = function(e4) {
          throw new Error("process.binding is not supported");
        }, d.cwd = function() {
          return "/";
        }, d.chdir = function(e4) {
          throw new Error("process.chdir is not supported");
        }, d.umask = function() {
          return 0;
        };
      }, {}], 88: [function(i, o, s) {
        (function(i2) {
          (function() {
            !function(a) {
              function c(e3) {
                throw RangeError(P[e3]);
              }
              function u(e3, t3) {
                for (var n3 = e3.length, r2 = []; n3--; )
                  r2[n3] = t3(e3[n3]);
                return r2;
              }
              function l(e3, t3) {
                var n3 = e3.split("@"), r2 = "";
                return n3.length > 1 && (r2 = n3[0] + "@", e3 = n3[1]), r2 + u((e3 = e3.replace(M, ".")).split("."), t3).join(".");
              }
              function p(e3) {
                for (var t3, n3, r2 = [], i3 = 0, o2 = e3.length; i3 < o2; )
                  (t3 = e3.charCodeAt(i3++)) >= 55296 && t3 <= 56319 && i3 < o2 ? 56320 == (64512 & (n3 = e3.charCodeAt(i3++))) ? r2.push(((1023 & t3) << 10) + (1023 & n3) + 65536) : (r2.push(t3), i3--) : r2.push(t3);
                return r2;
              }
              function d(e3) {
                return u(e3, function(e4) {
                  var t3 = "";
                  return e4 > 65535 && (t3 += q((e4 -= 65536) >>> 10 & 1023 | 55296), e4 = 56320 | 1023 & e4), t3 + q(e4);
                }).join("");
              }
              function h(e3) {
                return e3 - 48 < 10 ? e3 - 22 : e3 - 65 < 26 ? e3 - 65 : e3 - 97 < 26 ? e3 - 97 : T;
              }
              function f(e3, t3) {
                return e3 + 22 + 75 * (e3 < 26) - ((0 != t3) << 5);
              }
              function m(e3, t3, n3) {
                var r2 = 0;
                for (e3 = n3 ? U(e3 / x) : e3 >> 1, e3 += U(e3 / t3); e3 > D * k >> 1; r2 += T)
                  e3 = U(e3 / D);
                return U(r2 + (D + 1) * e3 / (e3 + _));
              }
              function g(e3) {
                var t3, n3, r2, i3, o2, s2, a2, u2, l2, p2, f2 = [], g2 = e3.length, v2 = 0, y2 = R, b2 = A;
                for ((n3 = e3.lastIndexOf(O)) < 0 && (n3 = 0), r2 = 0; r2 < n3; ++r2)
                  e3.charCodeAt(r2) >= 128 && c("not-basic"), f2.push(e3.charCodeAt(r2));
                for (i3 = n3 > 0 ? n3 + 1 : 0; i3 < g2; ) {
                  for (o2 = v2, s2 = 1, a2 = T; i3 >= g2 && c("invalid-input"), ((u2 = h(e3.charCodeAt(i3++))) >= T || u2 > U((C - v2) / s2)) && c("overflow"), v2 += u2 * s2, !(u2 < (l2 = a2 <= b2 ? I : a2 >= b2 + k ? k : a2 - b2)); a2 += T)
                    s2 > U(C / (p2 = T - l2)) && c("overflow"), s2 *= p2;
                  b2 = m(v2 - o2, t3 = f2.length + 1, 0 == o2), U(v2 / t3) > C - y2 && c("overflow"), y2 += U(v2 / t3), v2 %= t3, f2.splice(v2++, 0, y2);
                }
                return d(f2);
              }
              function v(e3) {
                var t3, n3, r2, i3, o2, s2, a2, u2, l2, d2, h2, g2, v2, y2, b2, w2 = [];
                for (g2 = (e3 = p(e3)).length, t3 = R, n3 = 0, o2 = A, s2 = 0; s2 < g2; ++s2)
                  (h2 = e3[s2]) < 128 && w2.push(q(h2));
                for (r2 = i3 = w2.length, i3 && w2.push(O); r2 < g2; ) {
                  for (a2 = C, s2 = 0; s2 < g2; ++s2)
                    (h2 = e3[s2]) >= t3 && h2 < a2 && (a2 = h2);
                  for (a2 - t3 > U((C - n3) / (v2 = r2 + 1)) && c("overflow"), n3 += (a2 - t3) * v2, t3 = a2, s2 = 0; s2 < g2; ++s2)
                    if ((h2 = e3[s2]) < t3 && ++n3 > C && c("overflow"), h2 == t3) {
                      for (u2 = n3, l2 = T; !(u2 < (d2 = l2 <= o2 ? I : l2 >= o2 + k ? k : l2 - o2)); l2 += T)
                        b2 = u2 - d2, y2 = T - d2, w2.push(q(f(d2 + b2 % y2, 0))), u2 = U(b2 / y2);
                      w2.push(q(f(u2, 0))), o2 = m(n3, v2, r2 == i3), n3 = 0, ++r2;
                    }
                  ++n3, ++t3;
                }
                return w2.join("");
              }
              var y = "object" == typeof s && s && !s.nodeType && s, b = "object" == typeof o && o && !o.nodeType && o, w = "object" == typeof i2 && i2;
              w.global !== w && w.window !== w && w.self !== w || (a = w);
              var E, S, C = 2147483647, T = 36, I = 1, k = 26, _ = 38, x = 700, A = 72, R = 128, O = "-", N = /^xn--/, L = /[^\x20-\x7E]/, M = /[\x2E\u3002\uFF0E\uFF61]/g, P = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, D = T - I, U = Math.floor, q = String.fromCharCode;
              if (E = { version: "1.3.2", ucs2: { decode: p, encode: d }, decode: g, encode: v, toASCII: function(e3) {
                return l(e3, function(e4) {
                  return L.test(e4) ? "xn--" + v(e4) : e4;
                });
              }, toUnicode: function(e3) {
                return l(e3, function(e4) {
                  return N.test(e4) ? g(e4.slice(4).toLowerCase()) : e4;
                });
              } }, n2.amdO)
                void 0 === (r = (function() {
                  return E;
                }).call(t2, n2, t2, e2)) || (e2.exports = r);
              else if (y && b)
                if (o.exports == y)
                  b.exports = E;
                else
                  for (S in E)
                    E.hasOwnProperty(S) && (y[S] = E[S]);
              else
                a.punycode = E;
            }(this);
          }).call(this);
        }).call(this, "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, {}], 89: [function(e3, t3, n3) {
        function r2(e4, t4) {
          return Object.prototype.hasOwnProperty.call(e4, t4);
        }
        t3.exports = function(e4, t4, n4, o) {
          t4 = t4 || "&", n4 = n4 || "=";
          var s = {};
          if ("string" != typeof e4 || 0 === e4.length)
            return s;
          var a = /\+/g;
          e4 = e4.split(t4);
          var c = 1e3;
          o && "number" == typeof o.maxKeys && (c = o.maxKeys);
          var u = e4.length;
          c > 0 && u > c && (u = c);
          for (var l = 0; l < u; ++l) {
            var p, d, h, f, m = e4[l].replace(a, "%20"), g = m.indexOf(n4);
            g >= 0 ? (p = m.substr(0, g), d = m.substr(g + 1)) : (p = m, d = ""), h = decodeURIComponent(p), f = decodeURIComponent(d), r2(s, h) ? i(s[h]) ? s[h].push(f) : s[h] = [s[h], f] : s[h] = f;
          }
          return s;
        };
        var i = Array.isArray || function(e4) {
          return "[object Array]" === Object.prototype.toString.call(e4);
        };
      }, {}], 90: [function(e3, t3, n3) {
        function r2(e4, t4) {
          if (e4.map)
            return e4.map(t4);
          for (var n4 = [], r3 = 0; r3 < e4.length; r3++)
            n4.push(t4(e4[r3], r3));
          return n4;
        }
        var i = function(e4) {
          switch (typeof e4) {
            case "string":
              return e4;
            case "boolean":
              return e4 ? "true" : "false";
            case "number":
              return isFinite(e4) ? e4 : "";
            default:
              return "";
          }
        };
        t3.exports = function(e4, t4, n4, a) {
          return t4 = t4 || "&", n4 = n4 || "=", null === e4 && (e4 = void 0), "object" == typeof e4 ? r2(s(e4), function(s2) {
            var a2 = encodeURIComponent(i(s2)) + n4;
            return o(e4[s2]) ? r2(e4[s2], function(e5) {
              return a2 + encodeURIComponent(i(e5));
            }).join(t4) : a2 + encodeURIComponent(i(e4[s2]));
          }).join(t4) : a ? encodeURIComponent(i(a)) + n4 + encodeURIComponent(i(e4)) : "";
        };
        var o = Array.isArray || function(e4) {
          return "[object Array]" === Object.prototype.toString.call(e4);
        }, s = Object.keys || function(e4) {
          var t4 = [];
          for (var n4 in e4)
            Object.prototype.hasOwnProperty.call(e4, n4) && t4.push(n4);
          return t4;
        };
      }, {}], 91: [function(e3, t3, n3) {
        n3.decode = n3.parse = e3("./decode"), n3.encode = n3.stringify = e3("./encode");
      }, { "./decode": 89, "./encode": 90 }], 92: [function(e3, t3, n3) {
        function r2(e4, t4) {
          return Object.prototype.hasOwnProperty.call(e4, t4);
        }
        t3.exports = function(e4, t4, n4, i) {
          t4 = t4 || "&", n4 = n4 || "=";
          var o = {};
          if ("string" != typeof e4 || 0 === e4.length)
            return o;
          var s = /\+/g;
          e4 = e4.split(t4);
          var a = 1e3;
          i && "number" == typeof i.maxKeys && (a = i.maxKeys);
          var c = e4.length;
          a > 0 && c > a && (c = a);
          for (var u = 0; u < c; ++u) {
            var l, p, d, h, f = e4[u].replace(s, "%20"), m = f.indexOf(n4);
            m >= 0 ? (l = f.substr(0, m), p = f.substr(m + 1)) : (l = f, p = ""), d = decodeURIComponent(l), h = decodeURIComponent(p), r2(o, d) ? Array.isArray(o[d]) ? o[d].push(h) : o[d] = [o[d], h] : o[d] = h;
          }
          return o;
        };
      }, {}], 93: [function(e3, t3, n3) {
        var r2 = function(e4) {
          switch (typeof e4) {
            case "string":
              return e4;
            case "boolean":
              return e4 ? "true" : "false";
            case "number":
              return isFinite(e4) ? e4 : "";
            default:
              return "";
          }
        };
        t3.exports = function(e4, t4, n4, i) {
          return t4 = t4 || "&", n4 = n4 || "=", null === e4 && (e4 = void 0), "object" == typeof e4 ? Object.keys(e4).map(function(i2) {
            var o = encodeURIComponent(r2(i2)) + n4;
            return Array.isArray(e4[i2]) ? e4[i2].map(function(e5) {
              return o + encodeURIComponent(r2(e5));
            }).join(t4) : o + encodeURIComponent(r2(e4[i2]));
          }).join(t4) : i ? encodeURIComponent(r2(i)) + n4 + encodeURIComponent(r2(e4)) : "";
        };
      }, {}], 94: [function(e3, t3, n3) {
        arguments[4][91][0].apply(n3, arguments);
      }, { "./decode": 92, "./encode": 93, dup: 91 }], 95: [function(e3, t3, n3) {
        (function(t4, r2) {
          (function() {
            function i(e4, t5) {
              this._id = e4, this._clearFn = t5;
            }
            var o = e3("process/browser.js").nextTick, s = Function.prototype.apply, a = Array.prototype.slice, c = {}, u = 0;
            n3.setTimeout = function() {
              return new i(s.call(setTimeout, window, arguments), clearTimeout);
            }, n3.setInterval = function() {
              return new i(s.call(setInterval, window, arguments), clearInterval);
            }, n3.clearTimeout = n3.clearInterval = function(e4) {
              e4.close();
            }, i.prototype.unref = i.prototype.ref = function() {
            }, i.prototype.close = function() {
              this._clearFn.call(window, this._id);
            }, n3.enroll = function(e4, t5) {
              clearTimeout(e4._idleTimeoutId), e4._idleTimeout = t5;
            }, n3.unenroll = function(e4) {
              clearTimeout(e4._idleTimeoutId), e4._idleTimeout = -1;
            }, n3._unrefActive = n3.active = function(e4) {
              clearTimeout(e4._idleTimeoutId);
              var t5 = e4._idleTimeout;
              t5 >= 0 && (e4._idleTimeoutId = setTimeout(function() {
                e4._onTimeout && e4._onTimeout();
              }, t5));
            }, n3.setImmediate = "function" == typeof t4 ? t4 : function(e4) {
              var t5 = u++, r3 = !(arguments.length < 2) && a.call(arguments, 1);
              return c[t5] = true, o(function() {
                c[t5] && (r3 ? e4.apply(null, r3) : e4.call(null), n3.clearImmediate(t5));
              }), t5;
            }, n3.clearImmediate = "function" == typeof r2 ? r2 : function(e4) {
              delete c[e4];
            };
          }).call(this);
        }).call(this, e3("timers").setImmediate, e3("timers").clearImmediate);
      }, { "process/browser.js": 87, timers: 95 }], 96: [function(e3, t3, n3) {
        function r2() {
          this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
        }
        function i(e4, t4, n4) {
          if (e4 && s(e4) && e4 instanceof r2)
            return e4;
          var i2 = new r2();
          return i2.parse(e4, t4, n4), i2;
        }
        function o(e4) {
          return "string" == typeof e4;
        }
        function s(e4) {
          return "object" == typeof e4 && null !== e4;
        }
        function a(e4) {
          return null === e4;
        }
        var c = e3("punycode");
        n3.parse = i, n3.resolve = function(e4, t4) {
          return i(e4, false, true).resolve(t4);
        }, n3.resolveObject = function(e4, t4) {
          return e4 ? i(e4, false, true).resolveObject(t4) : t4;
        }, n3.format = function(e4) {
          return o(e4) && (e4 = i(e4)), e4 instanceof r2 ? e4.format() : r2.prototype.format.call(e4);
        }, n3.Url = r2;
        var u = /^([a-z0-9.+-]+:)/i, l = /:[0-9]*$/, p = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "	"]), d = ["'"].concat(p), h = ["%", "/", "?", ";", "#"].concat(d), f = ["/", "?", "#"], m = /^[a-z0-9A-Z_-]{0,63}$/, g = /^([a-z0-9A-Z_-]{0,63})(.*)$/, v = { javascript: true, "javascript:": true }, y = { javascript: true, "javascript:": true }, b = { http: true, https: true, ftp: true, gopher: true, file: true, "http:": true, "https:": true, "ftp:": true, "gopher:": true, "file:": true }, w = e3("querystring");
        r2.prototype.parse = function(e4, t4, n4) {
          if (!o(e4))
            throw new TypeError("Parameter 'url' must be a string, not " + typeof e4);
          var r3 = e4;
          r3 = r3.trim();
          var i2 = u.exec(r3);
          if (i2) {
            var s2 = (i2 = i2[0]).toLowerCase();
            this.protocol = s2, r3 = r3.substr(i2.length);
          }
          if (n4 || i2 || r3.match(/^\/\/[^@\/]+@[^@\/]+/)) {
            var a2 = "//" === r3.substr(0, 2);
            !a2 || i2 && y[i2] || (r3 = r3.substr(2), this.slashes = true);
          }
          if (!y[i2] && (a2 || i2 && !b[i2])) {
            for (var l2 = -1, p2 = 0; p2 < f.length; p2++)
              -1 !== (C = r3.indexOf(f[p2])) && (-1 === l2 || C < l2) && (l2 = C);
            var E, S;
            for (-1 !== (S = -1 === l2 ? r3.lastIndexOf("@") : r3.lastIndexOf("@", l2)) && (E = r3.slice(0, S), r3 = r3.slice(S + 1), this.auth = decodeURIComponent(E)), l2 = -1, p2 = 0; p2 < h.length; p2++) {
              var C;
              -1 !== (C = r3.indexOf(h[p2])) && (-1 === l2 || C < l2) && (l2 = C);
            }
            -1 === l2 && (l2 = r3.length), this.host = r3.slice(0, l2), r3 = r3.slice(l2), this.parseHost(), this.hostname = this.hostname || "";
            var T = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
            if (!T)
              for (var I = this.hostname.split(/\./), k = (p2 = 0, I.length); p2 < k; p2++) {
                var _ = I[p2];
                if (_ && !_.match(m)) {
                  for (var x = "", A = 0, R = _.length; A < R; A++)
                    _.charCodeAt(A) > 127 ? x += "x" : x += _[A];
                  if (!x.match(m)) {
                    var O = I.slice(0, p2), N = I.slice(p2 + 1), L = _.match(g);
                    L && (O.push(L[1]), N.unshift(L[2])), N.length && (r3 = "/" + N.join(".") + r3), this.hostname = O.join(".");
                    break;
                  }
                }
              }
            if (this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), !T) {
              var M = this.hostname.split("."), P = [];
              for (p2 = 0; p2 < M.length; ++p2) {
                var D = M[p2];
                P.push(D.match(/[^A-Za-z0-9_-]/) ? "xn--" + c.encode(D) : D);
              }
              this.hostname = P.join(".");
            }
            var U = this.port ? ":" + this.port : "", q = this.hostname || "";
            this.host = q + U, this.href += this.host, T && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== r3[0] && (r3 = "/" + r3));
          }
          if (!v[s2])
            for (p2 = 0, k = d.length; p2 < k; p2++) {
              var j = d[p2], F = encodeURIComponent(j);
              F === j && (F = escape(j)), r3 = r3.split(j).join(F);
            }
          var W = r3.indexOf("#");
          -1 !== W && (this.hash = r3.substr(W), r3 = r3.slice(0, W));
          var B = r3.indexOf("?");
          return -1 !== B ? (this.search = r3.substr(B), this.query = r3.substr(B + 1), t4 && (this.query = w.parse(this.query)), r3 = r3.slice(0, B)) : t4 && (this.search = "", this.query = {}), r3 && (this.pathname = r3), b[s2] && this.hostname && !this.pathname && (this.pathname = "/"), (this.pathname || this.search) && (U = this.pathname || "", D = this.search || "", this.path = U + D), this.href = this.format(), this;
        }, r2.prototype.format = function() {
          var e4 = this.auth || "";
          e4 && (e4 = (e4 = encodeURIComponent(e4)).replace(/%3A/i, ":"), e4 += "@");
          var t4 = this.protocol || "", n4 = this.pathname || "", r3 = this.hash || "", i2 = false, o2 = "";
          this.host ? i2 = e4 + this.host : this.hostname && (i2 = e4 + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (i2 += ":" + this.port)), this.query && s(this.query) && Object.keys(this.query).length && (o2 = w.stringify(this.query));
          var a2 = this.search || o2 && "?" + o2 || "";
          return t4 && ":" !== t4.substr(-1) && (t4 += ":"), this.slashes || (!t4 || b[t4]) && false !== i2 ? (i2 = "//" + (i2 || ""), n4 && "/" !== n4.charAt(0) && (n4 = "/" + n4)) : i2 || (i2 = ""), r3 && "#" !== r3.charAt(0) && (r3 = "#" + r3), a2 && "?" !== a2.charAt(0) && (a2 = "?" + a2), n4 = n4.replace(/[?#]/g, function(e5) {
            return encodeURIComponent(e5);
          }), t4 + i2 + n4 + (a2 = a2.replace("#", "%23")) + r3;
        }, r2.prototype.resolve = function(e4) {
          return this.resolveObject(i(e4, false, true)).format();
        }, r2.prototype.resolveObject = function(e4) {
          if (o(e4)) {
            var t4 = new r2();
            t4.parse(e4, false, true), e4 = t4;
          }
          var n4 = new r2();
          if (Object.keys(this).forEach(function(e5) {
            n4[e5] = this[e5];
          }, this), n4.hash = e4.hash, "" === e4.href)
            return n4.href = n4.format(), n4;
          if (e4.slashes && !e4.protocol)
            return Object.keys(e4).forEach(function(t5) {
              "protocol" !== t5 && (n4[t5] = e4[t5]);
            }), b[n4.protocol] && n4.hostname && !n4.pathname && (n4.path = n4.pathname = "/"), n4.href = n4.format(), n4;
          if (e4.protocol && e4.protocol !== n4.protocol) {
            if (!b[e4.protocol])
              return Object.keys(e4).forEach(function(t5) {
                n4[t5] = e4[t5];
              }), n4.href = n4.format(), n4;
            if (n4.protocol = e4.protocol, e4.host || y[e4.protocol])
              n4.pathname = e4.pathname;
            else {
              for (var i2 = (e4.pathname || "").split("/"); i2.length && !(e4.host = i2.shift()); )
                ;
              e4.host || (e4.host = ""), e4.hostname || (e4.hostname = ""), "" !== i2[0] && i2.unshift(""), i2.length < 2 && i2.unshift(""), n4.pathname = i2.join("/");
            }
            if (n4.search = e4.search, n4.query = e4.query, n4.host = e4.host || "", n4.auth = e4.auth, n4.hostname = e4.hostname || e4.host, n4.port = e4.port, n4.pathname || n4.search) {
              var s2 = n4.pathname || "", c2 = n4.search || "";
              n4.path = s2 + c2;
            }
            return n4.slashes = n4.slashes || e4.slashes, n4.href = n4.format(), n4;
          }
          var u2 = n4.pathname && "/" === n4.pathname.charAt(0), l2 = e4.host || e4.pathname && "/" === e4.pathname.charAt(0), p2 = l2 || u2 || n4.host && e4.pathname, d2 = p2, h2 = n4.pathname && n4.pathname.split("/") || [], f2 = (i2 = e4.pathname && e4.pathname.split("/") || [], n4.protocol && !b[n4.protocol]);
          if (f2 && (n4.hostname = "", n4.port = null, n4.host && ("" === h2[0] ? h2[0] = n4.host : h2.unshift(n4.host)), n4.host = "", e4.protocol && (e4.hostname = null, e4.port = null, e4.host && ("" === i2[0] ? i2[0] = e4.host : i2.unshift(e4.host)), e4.host = null), p2 = p2 && ("" === i2[0] || "" === h2[0])), l2)
            n4.host = e4.host || "" === e4.host ? e4.host : n4.host, n4.hostname = e4.hostname || "" === e4.hostname ? e4.hostname : n4.hostname, n4.search = e4.search, n4.query = e4.query, h2 = i2;
          else if (i2.length)
            h2 || (h2 = []), h2.pop(), h2 = h2.concat(i2), n4.search = e4.search, n4.query = e4.query;
          else if (!function(e5) {
            return null == e5;
          }(e4.search))
            return f2 && (n4.hostname = n4.host = h2.shift(), (E = !!(n4.host && n4.host.indexOf("@") > 0) && n4.host.split("@")) && (n4.auth = E.shift(), n4.host = n4.hostname = E.shift())), n4.search = e4.search, n4.query = e4.query, a(n4.pathname) && a(n4.search) || (n4.path = (n4.pathname ? n4.pathname : "") + (n4.search ? n4.search : "")), n4.href = n4.format(), n4;
          if (!h2.length)
            return n4.pathname = null, n4.search ? n4.path = "/" + n4.search : n4.path = null, n4.href = n4.format(), n4;
          for (var m2 = h2.slice(-1)[0], g2 = (n4.host || e4.host) && ("." === m2 || ".." === m2) || "" === m2, v2 = 0, w2 = h2.length; w2 >= 0; w2--)
            "." == (m2 = h2[w2]) ? h2.splice(w2, 1) : ".." === m2 ? (h2.splice(w2, 1), v2++) : v2 && (h2.splice(w2, 1), v2--);
          if (!p2 && !d2)
            for (; v2--; v2)
              h2.unshift("..");
          !p2 || "" === h2[0] || h2[0] && "/" === h2[0].charAt(0) || h2.unshift(""), g2 && "/" !== h2.join("/").substr(-1) && h2.push("");
          var E, S = "" === h2[0] || h2[0] && "/" === h2[0].charAt(0);
          return f2 && (n4.hostname = n4.host = S ? "" : h2.length ? h2.shift() : "", (E = !!(n4.host && n4.host.indexOf("@") > 0) && n4.host.split("@")) && (n4.auth = E.shift(), n4.host = n4.hostname = E.shift())), (p2 = p2 || n4.host && h2.length) && !S && h2.unshift(""), h2.length ? n4.pathname = h2.join("/") : (n4.pathname = null, n4.path = null), a(n4.pathname) && a(n4.search) || (n4.path = (n4.pathname ? n4.pathname : "") + (n4.search ? n4.search : "")), n4.auth = e4.auth || n4.auth, n4.slashes = n4.slashes || e4.slashes, n4.href = n4.format(), n4;
        }, r2.prototype.parseHost = function() {
          var e4 = this.host, t4 = l.exec(e4);
          t4 && (":" !== (t4 = t4[0]) && (this.port = t4.substr(1)), e4 = e4.substr(0, e4.length - t4.length)), e4 && (this.hostname = e4);
        };
      }, { punycode: 88, querystring: 91 }], 97: [function(e3, t3, n3) {
        "function" == typeof Object.create ? t3.exports = function(e4, t4) {
          e4.super_ = t4, e4.prototype = Object.create(t4.prototype, { constructor: { value: e4, enumerable: false, writable: true, configurable: true } });
        } : t3.exports = function(e4, t4) {
          e4.super_ = t4;
          var n4 = function() {
          };
          n4.prototype = t4.prototype, e4.prototype = new n4(), e4.prototype.constructor = e4;
        };
      }, {}], 98: [function(e3, t3, n3) {
        t3.exports = function(e4) {
          return e4 && "object" == typeof e4 && "function" == typeof e4.copy && "function" == typeof e4.fill && "function" == typeof e4.readUInt8;
        };
      }, {}], 99: [function(e3, t3, n3) {
        (function(t4, r2) {
          (function() {
            function i(e4, t5) {
              var r3 = { seen: [], stylize: s };
              return arguments.length >= 3 && (r3.depth = arguments[2]), arguments.length >= 4 && (r3.colors = arguments[3]), d(t5) ? r3.showHidden = t5 : t5 && n3._extend(r3, t5), g(r3.showHidden) && (r3.showHidden = false), g(r3.depth) && (r3.depth = 2), g(r3.colors) && (r3.colors = false), g(r3.customInspect) && (r3.customInspect = true), r3.colors && (r3.stylize = o), a(r3, e4, r3.depth);
            }
            function o(e4, t5) {
              var n4 = i.styles[t5];
              return n4 ? "\x1B[" + i.colors[n4][0] + "m" + e4 + "\x1B[" + i.colors[n4][1] + "m" : e4;
            }
            function s(e4, t5) {
              return e4;
            }
            function a(e4, t5, r3) {
              if (e4.customInspect && t5 && E(t5.inspect) && t5.inspect !== n3.inspect && (!t5.constructor || t5.constructor.prototype !== t5)) {
                var i2 = t5.inspect(r3, e4);
                return m(i2) || (i2 = a(e4, i2, r3)), i2;
              }
              var o2 = c(e4, t5);
              if (o2)
                return o2;
              var s2 = Object.keys(t5), d2 = function(e5) {
                var t6 = {};
                return e5.forEach(function(e6, n4) {
                  t6[e6] = true;
                }), t6;
              }(s2);
              if (e4.showHidden && (s2 = Object.getOwnPropertyNames(t5)), w(t5) && (s2.indexOf("message") >= 0 || s2.indexOf("description") >= 0))
                return u(t5);
              if (0 === s2.length) {
                if (E(t5)) {
                  var h2 = t5.name ? ": " + t5.name : "";
                  return e4.stylize("[Function" + h2 + "]", "special");
                }
                if (v(t5))
                  return e4.stylize(RegExp.prototype.toString.call(t5), "regexp");
                if (b(t5))
                  return e4.stylize(Date.prototype.toString.call(t5), "date");
                if (w(t5))
                  return u(t5);
              }
              var f2, g2 = "", y2 = false, S2 = ["{", "}"];
              return p(t5) && (y2 = true, S2 = ["[", "]"]), E(t5) && (g2 = " [Function" + (t5.name ? ": " + t5.name : "") + "]"), v(t5) && (g2 = " " + RegExp.prototype.toString.call(t5)), b(t5) && (g2 = " " + Date.prototype.toUTCString.call(t5)), w(t5) && (g2 = " " + u(t5)), 0 !== s2.length || y2 && 0 != t5.length ? r3 < 0 ? v(t5) ? e4.stylize(RegExp.prototype.toString.call(t5), "regexp") : e4.stylize("[Object]", "special") : (e4.seen.push(t5), f2 = y2 ? function(e5, t6, n4, r4, i3) {
                for (var o3 = [], s3 = 0, a2 = t6.length; s3 < a2; ++s3)
                  T(t6, String(s3)) ? o3.push(l(e5, t6, n4, r4, String(s3), true)) : o3.push("");
                return i3.forEach(function(i4) {
                  i4.match(/^\d+$/) || o3.push(l(e5, t6, n4, r4, i4, true));
                }), o3;
              }(e4, t5, r3, d2, s2) : s2.map(function(n4) {
                return l(e4, t5, r3, d2, n4, y2);
              }), e4.seen.pop(), function(e5, t6, n4) {
                return e5.reduce(function(e6, t7) {
                  return t7.indexOf("\n"), e6 + t7.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0) > 60 ? n4[0] + ("" === t6 ? "" : t6 + "\n ") + " " + e5.join(",\n  ") + " " + n4[1] : n4[0] + t6 + " " + e5.join(", ") + " " + n4[1];
              }(f2, g2, S2)) : S2[0] + g2 + S2[1];
            }
            function c(e4, t5) {
              if (g(t5))
                return e4.stylize("undefined", "undefined");
              if (m(t5)) {
                var n4 = "'" + JSON.stringify(t5).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                return e4.stylize(n4, "string");
              }
              return f(t5) ? e4.stylize("" + t5, "number") : d(t5) ? e4.stylize("" + t5, "boolean") : h(t5) ? e4.stylize("null", "null") : void 0;
            }
            function u(e4) {
              return "[" + Error.prototype.toString.call(e4) + "]";
            }
            function l(e4, t5, n4, r3, i2, o2) {
              var s2, c2, u2;
              if ((u2 = Object.getOwnPropertyDescriptor(t5, i2) || { value: t5[i2] }).get ? c2 = u2.set ? e4.stylize("[Getter/Setter]", "special") : e4.stylize("[Getter]", "special") : u2.set && (c2 = e4.stylize("[Setter]", "special")), T(r3, i2) || (s2 = "[" + i2 + "]"), c2 || (e4.seen.indexOf(u2.value) < 0 ? (c2 = h(n4) ? a(e4, u2.value, null) : a(e4, u2.value, n4 - 1)).indexOf("\n") > -1 && (c2 = o2 ? c2.split("\n").map(function(e5) {
                return "  " + e5;
              }).join("\n").substr(2) : "\n" + c2.split("\n").map(function(e5) {
                return "   " + e5;
              }).join("\n")) : c2 = e4.stylize("[Circular]", "special")), g(s2)) {
                if (o2 && i2.match(/^\d+$/))
                  return c2;
                (s2 = JSON.stringify("" + i2)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s2 = s2.substr(1, s2.length - 2), s2 = e4.stylize(s2, "name")) : (s2 = s2.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s2 = e4.stylize(s2, "string"));
              }
              return s2 + ": " + c2;
            }
            function p(e4) {
              return Array.isArray(e4);
            }
            function d(e4) {
              return "boolean" == typeof e4;
            }
            function h(e4) {
              return null === e4;
            }
            function f(e4) {
              return "number" == typeof e4;
            }
            function m(e4) {
              return "string" == typeof e4;
            }
            function g(e4) {
              return void 0 === e4;
            }
            function v(e4) {
              return y(e4) && "[object RegExp]" === S(e4);
            }
            function y(e4) {
              return "object" == typeof e4 && null !== e4;
            }
            function b(e4) {
              return y(e4) && "[object Date]" === S(e4);
            }
            function w(e4) {
              return y(e4) && ("[object Error]" === S(e4) || e4 instanceof Error);
            }
            function E(e4) {
              return "function" == typeof e4;
            }
            function S(e4) {
              return Object.prototype.toString.call(e4);
            }
            function C(e4) {
              return e4 < 10 ? "0" + e4.toString(10) : e4.toString(10);
            }
            function T(e4, t5) {
              return Object.prototype.hasOwnProperty.call(e4, t5);
            }
            var I = /%[sdj%]/g;
            n3.format = function(e4) {
              if (!m(e4)) {
                for (var t5 = [], n4 = 0; n4 < arguments.length; n4++)
                  t5.push(i(arguments[n4]));
                return t5.join(" ");
              }
              n4 = 1;
              for (var r3 = arguments, o2 = r3.length, s2 = String(e4).replace(I, function(e5) {
                if ("%%" === e5)
                  return "%";
                if (n4 >= o2)
                  return e5;
                switch (e5) {
                  case "%s":
                    return String(r3[n4++]);
                  case "%d":
                    return Number(r3[n4++]);
                  case "%j":
                    try {
                      return JSON.stringify(r3[n4++]);
                    } catch (e6) {
                      return "[Circular]";
                    }
                  default:
                    return e5;
                }
              }), a2 = r3[n4]; n4 < o2; a2 = r3[++n4])
                h(a2) || !y(a2) ? s2 += " " + a2 : s2 += " " + i(a2);
              return s2;
            }, n3.deprecate = function(e4, i2) {
              if (g(r2.process))
                return function() {
                  return n3.deprecate(e4, i2).apply(this, arguments);
                };
              if (true === t4.noDeprecation)
                return e4;
              var o2 = false;
              return function() {
                if (!o2) {
                  if (t4.throwDeprecation)
                    throw new Error(i2);
                  t4.traceDeprecation ? console.trace(i2) : console.error(i2), o2 = true;
                }
                return e4.apply(this, arguments);
              };
            };
            var k, _ = {};
            n3.debuglog = function(e4) {
              if (g(k) && (k = t4.env.NODE_DEBUG || ""), e4 = e4.toUpperCase(), !_[e4])
                if (new RegExp("\\b" + e4 + "\\b", "i").test(k)) {
                  var r3 = t4.pid;
                  _[e4] = function() {
                    var t5 = n3.format.apply(n3, arguments);
                    console.error("%s %d: %s", e4, r3, t5);
                  };
                } else
                  _[e4] = function() {
                  };
              return _[e4];
            }, n3.inspect = i, i.colors = { bold: [1, 22], italic: [3, 23], underline: [4, 24], inverse: [7, 27], white: [37, 39], grey: [90, 39], black: [30, 39], blue: [34, 39], cyan: [36, 39], green: [32, 39], magenta: [35, 39], red: [31, 39], yellow: [33, 39] }, i.styles = { special: "cyan", number: "yellow", boolean: "yellow", undefined: "grey", null: "bold", string: "green", date: "magenta", regexp: "red" }, n3.isArray = p, n3.isBoolean = d, n3.isNull = h, n3.isNullOrUndefined = function(e4) {
              return null == e4;
            }, n3.isNumber = f, n3.isString = m, n3.isSymbol = function(e4) {
              return "symbol" == typeof e4;
            }, n3.isUndefined = g, n3.isRegExp = v, n3.isObject = y, n3.isDate = b, n3.isError = w, n3.isFunction = E, n3.isPrimitive = function(e4) {
              return null === e4 || "boolean" == typeof e4 || "number" == typeof e4 || "string" == typeof e4 || "symbol" == typeof e4 || void 0 === e4;
            }, n3.isBuffer = e3("./support/isBuffer");
            var x = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            n3.log = function() {
              console.log("%s - %s", function() {
                var e4 = /* @__PURE__ */ new Date(), t5 = [C(e4.getHours()), C(e4.getMinutes()), C(e4.getSeconds())].join(":");
                return [e4.getDate(), x[e4.getMonth()], t5].join(" ");
              }(), n3.format.apply(n3, arguments));
            }, n3.inherits = e3("inherits"), n3._extend = function(e4, t5) {
              if (!t5 || !y(t5))
                return e4;
              for (var n4 = Object.keys(t5), r3 = n4.length; r3--; )
                e4[n4[r3]] = t5[n4[r3]];
              return e4;
            };
          }).call(this);
        }).call(this, e3("_process"), "undefined" != typeof commonjsGlobal ? commonjsGlobal : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {});
      }, { "./support/isBuffer": 98, _process: 87, inherits: 97 }], 100: [function(e3, t3, n3) {
        var r2 = e3("./v1"), i = e3("./v4"), o = i;
        o.v1 = r2, o.v4 = i, t3.exports = o;
      }, { "./v1": 103, "./v4": 104 }], 101: [function(e3, t3, n3) {
        for (var r2 = [], i = 0; i < 256; ++i)
          r2[i] = (i + 256).toString(16).substr(1);
        t3.exports = function(e4, t4) {
          var n4 = t4 || 0, i2 = r2;
          return [i2[e4[n4++]], i2[e4[n4++]], i2[e4[n4++]], i2[e4[n4++]], "-", i2[e4[n4++]], i2[e4[n4++]], "-", i2[e4[n4++]], i2[e4[n4++]], "-", i2[e4[n4++]], i2[e4[n4++]], "-", i2[e4[n4++]], i2[e4[n4++]], i2[e4[n4++]], i2[e4[n4++]], i2[e4[n4++]], i2[e4[n4++]]].join("");
        };
      }, {}], 102: [function(e3, t3, n3) {
        var r2 = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
        if (r2) {
          var i = new Uint8Array(16);
          t3.exports = function() {
            return r2(i), i;
          };
        } else {
          var o = new Array(16);
          t3.exports = function() {
            for (var e4, t4 = 0; t4 < 16; t4++)
              0 == (3 & t4) && (e4 = 4294967296 * Math.random()), o[t4] = e4 >>> ((3 & t4) << 3) & 255;
            return o;
          };
        }
      }, {}], 103: [function(e3, t3, n3) {
        var r2, i, o = e3("./lib/rng"), s = e3("./lib/bytesToUuid"), a = 0, c = 0;
        t3.exports = function(e4, t4, n4) {
          var u = t4 && n4 || 0, l = t4 || [], p = (e4 = e4 || {}).node || r2, d = void 0 !== e4.clockseq ? e4.clockseq : i;
          if (null == p || null == d) {
            var h = o();
            null == p && (p = r2 = [1 | h[0], h[1], h[2], h[3], h[4], h[5]]), null == d && (d = i = 16383 & (h[6] << 8 | h[7]));
          }
          var f = void 0 !== e4.msecs ? e4.msecs : (/* @__PURE__ */ new Date()).getTime(), m = void 0 !== e4.nsecs ? e4.nsecs : c + 1, g = f - a + (m - c) / 1e4;
          if (g < 0 && void 0 === e4.clockseq && (d = d + 1 & 16383), (g < 0 || f > a) && void 0 === e4.nsecs && (m = 0), m >= 1e4)
            throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          a = f, c = m, i = d;
          var v = (1e4 * (268435455 & (f += 122192928e5)) + m) % 4294967296;
          l[u++] = v >>> 24 & 255, l[u++] = v >>> 16 & 255, l[u++] = v >>> 8 & 255, l[u++] = 255 & v;
          var y = f / 4294967296 * 1e4 & 268435455;
          l[u++] = y >>> 8 & 255, l[u++] = 255 & y, l[u++] = y >>> 24 & 15 | 16, l[u++] = y >>> 16 & 255, l[u++] = d >>> 8 | 128, l[u++] = 255 & d;
          for (var b = 0; b < 6; ++b)
            l[u + b] = p[b];
          return t4 || s(l);
        };
      }, { "./lib/bytesToUuid": 101, "./lib/rng": 102 }], 104: [function(e3, t3, n3) {
        var r2 = e3("./lib/rng"), i = e3("./lib/bytesToUuid");
        t3.exports = function(e4, t4, n4) {
          var o = t4 && n4 || 0;
          "string" == typeof e4 && (t4 = "binary" === e4 ? new Array(16) : null, e4 = null);
          var s = (e4 = e4 || {}).random || (e4.rng || r2)();
          if (s[6] = 15 & s[6] | 64, s[8] = 63 & s[8] | 128, t4)
            for (var a = 0; a < 16; ++a)
              t4[o + a] = s[a];
          return t4 || i(s);
        };
      }, { "./lib/bytesToUuid": 101, "./lib/rng": 102 }], 105: [function(e3, t3, n3) {
        Object.defineProperty(n3, "__esModule", { value: true });
        var r2 = e3("./utils/LRU"), i = function() {
          function e4(e5) {
            void 0 === e5 && (e5 = 1e3), this.maxSize = e5, this.cache = new r2.LRUCache(e5);
          }
          return Object.defineProperty(e4.prototype, "size", { get: function() {
            return this.cache.length;
          }, enumerable: true, configurable: true }), e4.prototype.put = function(t4, n4) {
            var r3 = "string" != typeof t4 ? e4.getKeyString(t4) : t4, i2 = this.populateValue(n4);
            this.cache.put(r3, i2);
          }, e4.prototype.get = function(t4) {
            var n4 = "string" != typeof t4 ? e4.getKeyString(t4) : t4, r3 = Date.now(), i2 = this.cache.get(n4);
            if (i2) {
              for (var o = 0; o < i2.length; o++)
                if (i2[o].Expire < r3)
                  return void this.cache.remove(n4);
            }
            return i2;
          }, e4.getKeyString = function(e5) {
            for (var t4 = [], n4 = Object.keys(e5).sort(), r3 = 0; r3 < n4.length; r3++) {
              var i2 = n4[r3];
              void 0 !== e5[i2] && t4.push(e5[i2]);
            }
            return t4.join(" ");
          }, e4.prototype.populateValue = function(e5) {
            var t4 = Date.now();
            return e5.map(function(e6) {
              return { Address: e6.Address || "", Expire: t4 + 60 * (e6.CachePeriodInMinutes || 1) * 1e3 };
            });
          }, e4.prototype.empty = function() {
            this.cache.empty();
          }, e4.prototype.remove = function(t4) {
            var n4 = "string" != typeof t4 ? e4.getKeyString(t4) : t4;
            this.cache.remove(n4);
          }, e4;
        }();
        n3.EndpointCache = i;
      }, { "./utils/LRU": 106 }], 106: [function(e3, t3, n3) {
        Object.defineProperty(n3, "__esModule", { value: true });
        var r2 = function(e4, t4) {
          this.key = e4, this.value = t4;
        }, i = function() {
          function e4(e5) {
            if (this.nodeMap = {}, this.size = 0, "number" != typeof e5 || e5 < 1)
              throw new Error("Cache size can only be positive number");
            this.sizeLimit = e5;
          }
          return Object.defineProperty(e4.prototype, "length", { get: function() {
            return this.size;
          }, enumerable: true, configurable: true }), e4.prototype.prependToList = function(e5) {
            this.headerNode ? (this.headerNode.prev = e5, e5.next = this.headerNode) : this.tailNode = e5, this.headerNode = e5, this.size++;
          }, e4.prototype.removeFromTail = function() {
            if (this.tailNode) {
              var e5 = this.tailNode, t4 = e5.prev;
              return t4 && (t4.next = void 0), e5.prev = void 0, this.tailNode = t4, this.size--, e5;
            }
          }, e4.prototype.detachFromList = function(e5) {
            this.headerNode === e5 && (this.headerNode = e5.next), this.tailNode === e5 && (this.tailNode = e5.prev), e5.prev && (e5.prev.next = e5.next), e5.next && (e5.next.prev = e5.prev), e5.next = void 0, e5.prev = void 0, this.size--;
          }, e4.prototype.get = function(e5) {
            if (this.nodeMap[e5]) {
              var t4 = this.nodeMap[e5];
              return this.detachFromList(t4), this.prependToList(t4), t4.value;
            }
          }, e4.prototype.remove = function(e5) {
            if (this.nodeMap[e5]) {
              var t4 = this.nodeMap[e5];
              this.detachFromList(t4), delete this.nodeMap[e5];
            }
          }, e4.prototype.put = function(e5, t4) {
            if (this.nodeMap[e5])
              this.remove(e5);
            else if (this.size === this.sizeLimit) {
              var n4 = this.removeFromTail().key;
              delete this.nodeMap[n4];
            }
            var i2 = new r2(e5, t4);
            this.nodeMap[e5] = i2, this.prependToList(i2);
          }, e4.prototype.empty = function() {
            for (var e5 = Object.keys(this.nodeMap), t4 = 0; t4 < e5.length; t4++) {
              var n4 = e5[t4], r3 = this.nodeMap[n4];
              this.detachFromList(r3), delete this.nodeMap[n4];
            }
          }, e4;
        }();
        n3.LRUCache = i;
      }, {}], 107: [function(e3, t3, n3) {
        e3("./browser_loader");
        var r2 = e3("./core");
        "undefined" != typeof window && (window.AWS = r2), void 0 !== t3 && (t3.exports = r2), "undefined" != typeof self && (self.AWS = r2), Object.prototype.hasOwnProperty.call(r2, "ConnectParticipant") || (r2.apiLoader.services.connectparticipant = {}, r2.ConnectParticipant = r2.Service.defineService("connectparticipant", ["2018-09-07"])), r2.apiLoader.services.connectparticipant["2018-09-07"] = e3("../apis/connectparticipant-2018-09-07.min"), r2.apiLoader.services.connectparticipant["2018-09-07"].paginators = e3("../apis/connectparticipant-2018-09-07.paginators").pagination, Object.prototype.hasOwnProperty.call(r2, "STS") || (r2.apiLoader.services.sts = {}, r2.STS = r2.Service.defineService("sts", ["2011-06-15"]), e3("./services/sts"));
      }, { "../apis/connectparticipant-2018-09-07.min": 3, "../apis/connectparticipant-2018-09-07.paginators": 4, "../apis/sts-2011-06-15.min": 6, "./browser_loader": 17, "./core": 20, "./services/sts": 63 }] }, {}, [107]);
    }, 705: (e2, t2, n2) => {
      var r = n2(639).Symbol;
      e2.exports = r;
    }, 239: (e2, t2, n2) => {
      var r = n2(705), i = n2(607), o = n2(333), s = r ? r.toStringTag : void 0;
      e2.exports = function(e3) {
        return null == e3 ? void 0 === e3 ? "[object Undefined]" : "[object Null]" : s && s in Object(e3) ? i(e3) : o(e3);
      };
    }, 561: (e2, t2, n2) => {
      var r = n2(990), i = /^\s+/;
      e2.exports = function(e3) {
        return e3 ? e3.slice(0, r(e3) + 1).replace(i, "") : e3;
      };
    }, 957: (e2) => {
      var t2 = "object" == typeof commonjsGlobal && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
      e2.exports = t2;
    }, 607: (e2, t2, n2) => {
      var r = n2(705), i = Object.prototype, o = i.hasOwnProperty, s = i.toString, a = r ? r.toStringTag : void 0;
      e2.exports = function(e3) {
        var t3 = o.call(e3, a), n3 = e3[a];
        try {
          e3[a] = void 0;
          var r2 = true;
        } catch (e4) {
        }
        var i2 = s.call(e3);
        return r2 && (t3 ? e3[a] = n3 : delete e3[a]), i2;
      };
    }, 333: (e2) => {
      var t2 = Object.prototype.toString;
      e2.exports = function(e3) {
        return t2.call(e3);
      };
    }, 639: (e2, t2, n2) => {
      var r = n2(957), i = "object" == typeof self && self && self.Object === Object && self, o = r || i || Function("return this")();
      e2.exports = o;
    }, 990: (e2) => {
      var t2 = /\s/;
      e2.exports = function(e3) {
        for (var n2 = e3.length; n2-- && t2.test(e3.charAt(n2)); )
          ;
        return n2;
      };
    }, 279: (e2, t2, n2) => {
      var r = n2(218), i = n2(771), o = n2(841), s = Math.max, a = Math.min;
      e2.exports = function(e3, t3, n3) {
        var c, u, l, p, d, h, f = 0, m = false, g = false, v = true;
        if ("function" != typeof e3)
          throw new TypeError("Expected a function");
        function y(t4) {
          var n4 = c, r2 = u;
          return c = u = void 0, f = t4, p = e3.apply(r2, n4);
        }
        function b(e4) {
          var n4 = e4 - h;
          return void 0 === h || n4 >= t3 || n4 < 0 || g && e4 - f >= l;
        }
        function w() {
          var e4 = i();
          if (b(e4))
            return E(e4);
          d = setTimeout(w, function(e5) {
            var n4 = t3 - (e5 - h);
            return g ? a(n4, l - (e5 - f)) : n4;
          }(e4));
        }
        function E(e4) {
          return d = void 0, v && c ? y(e4) : (c = u = void 0, p);
        }
        function S() {
          var e4 = i(), n4 = b(e4);
          if (c = arguments, u = this, h = e4, n4) {
            if (void 0 === d)
              return function(e5) {
                return f = e5, d = setTimeout(w, t3), m ? y(e5) : p;
              }(h);
            if (g)
              return clearTimeout(d), d = setTimeout(w, t3), y(h);
          }
          return void 0 === d && (d = setTimeout(w, t3)), p;
        }
        return t3 = o(t3) || 0, r(n3) && (m = !!n3.leading, l = (g = "maxWait" in n3) ? s(o(n3.maxWait) || 0, t3) : l, v = "trailing" in n3 ? !!n3.trailing : v), S.cancel = function() {
          void 0 !== d && clearTimeout(d), f = 0, c = h = u = d = void 0;
        }, S.flush = function() {
          return void 0 === d ? p : E(i());
        }, S;
      };
    }, 218: (e2) => {
      e2.exports = function(e3) {
        var t2 = typeof e3;
        return null != e3 && ("object" == t2 || "function" == t2);
      };
    }, 5: (e2) => {
      e2.exports = function(e3) {
        return null != e3 && "object" == typeof e3;
      };
    }, 448: (e2, t2, n2) => {
      var r = n2(239), i = n2(5);
      e2.exports = function(e3) {
        return "symbol" == typeof e3 || i(e3) && "[object Symbol]" == r(e3);
      };
    }, 771: (e2, t2, n2) => {
      var r = n2(639);
      e2.exports = function() {
        return r.Date.now();
      };
    }, 493: (e2, t2, n2) => {
      var r = n2(279), i = n2(218);
      e2.exports = function(e3, t3, n3) {
        var o = true, s = true;
        if ("function" != typeof e3)
          throw new TypeError("Expected a function");
        return i(n3) && (o = "leading" in n3 ? !!n3.leading : o, s = "trailing" in n3 ? !!n3.trailing : s), r(e3, t3, { leading: o, maxWait: t3, trailing: s });
      };
    }, 841: (e2, t2, n2) => {
      var r = n2(561), i = n2(218), o = n2(448), s = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt;
      e2.exports = function(e3) {
        if ("number" == typeof e3)
          return e3;
        if (o(e3))
          return NaN;
        if (i(e3)) {
          var t3 = "function" == typeof e3.valueOf ? e3.valueOf() : e3;
          e3 = i(t3) ? t3 + "" : t3;
        }
        if ("string" != typeof e3)
          return 0 === e3 ? e3 : +e3;
        e3 = r(e3);
        var n3 = a.test(e3);
        return n3 || c.test(e3) ? u(e3.slice(2), n3 ? 2 : 8) : s.test(e3) ? NaN : +e3;
      };
    }, 975: (e2, t2, n2) => {
      var r;
      !function() {
        var i = { not_string: /[^s]/, not_bool: /[^t]/, not_type: /[^T]/, not_primitive: /[^v]/, number: /[diefg]/, numeric_arg: /[bcdiefguxX]/, json: /[j]/, not_json: /[^j]/, text: /^[^\x25]+/, modulo: /^\x25{2}/, placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/, key: /^([a-z_][a-z_\d]*)/i, key_access: /^\.([a-z_][a-z_\d]*)/i, index_access: /^\[(\d+)\]/, sign: /^[+-]/ };
        function o(e3) {
          return function(e4, t3) {
            var n3, r2, s2, a2, c, u, l, p, d, h = 1, f = e4.length, m = "";
            for (r2 = 0; r2 < f; r2++)
              if ("string" == typeof e4[r2])
                m += e4[r2];
              else if ("object" == typeof e4[r2]) {
                if ((a2 = e4[r2]).keys)
                  for (n3 = t3[h], s2 = 0; s2 < a2.keys.length; s2++) {
                    if (null == n3)
                      throw new Error(o('[sprintf] Cannot access property "%s" of undefined value "%s"', a2.keys[s2], a2.keys[s2 - 1]));
                    n3 = n3[a2.keys[s2]];
                  }
                else
                  n3 = a2.param_no ? t3[a2.param_no] : t3[h++];
                if (i.not_type.test(a2.type) && i.not_primitive.test(a2.type) && n3 instanceof Function && (n3 = n3()), i.numeric_arg.test(a2.type) && "number" != typeof n3 && isNaN(n3))
                  throw new TypeError(o("[sprintf] expecting number but found %T", n3));
                switch (i.number.test(a2.type) && (p = n3 >= 0), a2.type) {
                  case "b":
                    n3 = parseInt(n3, 10).toString(2);
                    break;
                  case "c":
                    n3 = String.fromCharCode(parseInt(n3, 10));
                    break;
                  case "d":
                  case "i":
                    n3 = parseInt(n3, 10);
                    break;
                  case "j":
                    n3 = JSON.stringify(n3, null, a2.width ? parseInt(a2.width) : 0);
                    break;
                  case "e":
                    n3 = a2.precision ? parseFloat(n3).toExponential(a2.precision) : parseFloat(n3).toExponential();
                    break;
                  case "f":
                    n3 = a2.precision ? parseFloat(n3).toFixed(a2.precision) : parseFloat(n3);
                    break;
                  case "g":
                    n3 = a2.precision ? String(Number(n3.toPrecision(a2.precision))) : parseFloat(n3);
                    break;
                  case "o":
                    n3 = (parseInt(n3, 10) >>> 0).toString(8);
                    break;
                  case "s":
                    n3 = String(n3), n3 = a2.precision ? n3.substring(0, a2.precision) : n3;
                    break;
                  case "t":
                    n3 = String(!!n3), n3 = a2.precision ? n3.substring(0, a2.precision) : n3;
                    break;
                  case "T":
                    n3 = Object.prototype.toString.call(n3).slice(8, -1).toLowerCase(), n3 = a2.precision ? n3.substring(0, a2.precision) : n3;
                    break;
                  case "u":
                    n3 = parseInt(n3, 10) >>> 0;
                    break;
                  case "v":
                    n3 = n3.valueOf(), n3 = a2.precision ? n3.substring(0, a2.precision) : n3;
                    break;
                  case "x":
                    n3 = (parseInt(n3, 10) >>> 0).toString(16);
                    break;
                  case "X":
                    n3 = (parseInt(n3, 10) >>> 0).toString(16).toUpperCase();
                }
                i.json.test(a2.type) ? m += n3 : (!i.number.test(a2.type) || p && !a2.sign ? d = "" : (d = p ? "+" : "-", n3 = n3.toString().replace(i.sign, "")), u = a2.pad_char ? "0" === a2.pad_char ? "0" : a2.pad_char.charAt(1) : " ", l = a2.width - (d + n3).length, c = a2.width && l > 0 ? u.repeat(l) : "", m += a2.align ? d + n3 + c : "0" === u ? d + c + n3 : c + d + n3);
              }
            return m;
          }(function(e4) {
            if (a[e4])
              return a[e4];
            for (var t3, n3 = e4, r2 = [], o2 = 0; n3; ) {
              if (null !== (t3 = i.text.exec(n3)))
                r2.push(t3[0]);
              else if (null !== (t3 = i.modulo.exec(n3)))
                r2.push("%");
              else {
                if (null === (t3 = i.placeholder.exec(n3)))
                  throw new SyntaxError("[sprintf] unexpected placeholder");
                if (t3[2]) {
                  o2 |= 1;
                  var s2 = [], c = t3[2], u = [];
                  if (null === (u = i.key.exec(c)))
                    throw new SyntaxError("[sprintf] failed to parse named argument key");
                  for (s2.push(u[1]); "" !== (c = c.substring(u[0].length)); )
                    if (null !== (u = i.key_access.exec(c)))
                      s2.push(u[1]);
                    else {
                      if (null === (u = i.index_access.exec(c)))
                        throw new SyntaxError("[sprintf] failed to parse named argument key");
                      s2.push(u[1]);
                    }
                  t3[2] = s2;
                } else
                  o2 |= 2;
                if (3 === o2)
                  throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                r2.push({ placeholder: t3[0], param_no: t3[1], keys: t3[2], sign: t3[3], pad_char: t3[4], align: t3[5], width: t3[6], precision: t3[7], type: t3[8] });
              }
              n3 = n3.substring(t3[0].length);
            }
            return a[e4] = r2;
          }(e3), arguments);
        }
        function s(e3, t3) {
          return o.apply(null, [e3].concat(t3 || []));
        }
        var a = /* @__PURE__ */ Object.create(null);
        t2.sprintf = o, t2.vsprintf = s, "undefined" != typeof window && (window.sprintf = o, window.vsprintf = s, void 0 === (r = (function() {
          return { sprintf: o, vsprintf: s };
        }).call(t2, n2, t2, e2)) || (e2.exports = r));
      }();
    } }, t = {};
    function n(r) {
      var i = t[r];
      if (void 0 !== i)
        return i.exports;
      var o = t[r] = { exports: {} };
      return e[r](o, o.exports, n), o.exports;
    }
    n.amdO = {}, n.n = (e2) => {
      var t2 = e2 && e2.__esModule ? () => e2.default : () => e2;
      return n.d(t2, { a: t2 }), t2;
    }, n.d = (e2, t2) => {
      for (var r in t2)
        n.o(t2, r) && !n.o(e2, r) && Object.defineProperty(e2, r, { enumerable: true, get: t2[r] });
    }, n.o = (e2, t2) => Object.prototype.hasOwnProperty.call(e2, t2), (() => {
      class e2 extends Error {
        constructor(e3) {
          super(e3), this.name = "ValueError";
        }
      }
      class t2 extends Error {
        constructor(e3) {
          super(e3), this.name = "UnImplementedMethod";
        }
      }
      class r extends Error {
        constructor(e3, t3) {
          super(e3), this.name = "IllegalArgument", this.argument = t3;
        }
      }
      var s = new class {
        constructor() {
          this.stage = "prod", this.region = "us-west-2", this.reconnect = true;
          var e3 = this;
          this.features = new Proxy([], { set: function(t3, n2, r2) {
            console.log("new features added, initialValue: " + t3[n2] + " , newValue: " + r2, Array.isArray(t3[n2]));
            var i = t3[n2];
            return Array.isArray(r2) && r2.forEach((t4) => {
              Array.isArray(i) && -1 === i.indexOf(t4) && Array.isArray(e3.featureChangeListeners[t4]) && (e3.featureChangeListeners[t4].forEach((e4) => e4()), e3._cleanFeatureChangeListener(t4));
            }), t3[n2] = r2, true;
          } }), this.featureChangeListeners = [];
        }
        update(e3) {
          var t3 = e3 || {};
          this.stage = t3.stage || this.stage, this.region = t3.region || this.region, this.endpointOverride = t3.endpoint || this.endpointOverride, this.reconnect = false !== t3.reconnect && this.reconnect, this.messageReceiptThrottleTime = t3.throttleTime ? t3.throttleTime : 5e3, this.features.values = Array.isArray(t3.features) ? [...t3.features] : new Array();
        }
        updateStageRegion(e3) {
          e3 && (this.stage = e3.stage || this.stage, this.region = e3.region || this.region);
        }
        updateThrottleTime(e3) {
          this.messageReceiptThrottleTime = e3 || this.messageReceiptThrottleTime;
        }
        getMessageReceiptsThrottleTime() {
          return this.messageReceiptThrottleTime;
        }
        getStage() {
          return this.stage;
        }
        getRegion() {
          return this.region;
        }
        getEndpointOverride() {
          return this.endpointOverride;
        }
        setFeatureFlag(e3) {
          if (!this.isFeatureEnabled(e3)) {
            var t3 = Array.isArray(this.features.values) ? this.features.values : [];
            this.features.values = [...t3, e3];
          }
        }
        _registerFeatureChangeListener(e3, t3) {
          this.featureChangeListeners[e3] || (this.featureChangeListeners[e3] = []), this.featureChangeListeners[e3].push(t3);
        }
        _cleanFeatureChangeListener(e3) {
          delete this.featureChangeListeners[e3];
        }
        isFeatureEnabled(e3, t3) {
          return Array.isArray(this.features.values) && -1 !== this.features.values.indexOf(e3) ? "function" != typeof t3 || t3() : ("function" == typeof t3 && this._registerFeatureChangeListener(e3, t3), false);
        }
      }(), a = "MESSAGE_RECEIPTS_ENABLED", c = { AGENT: "AGENT", CUSTOMER: "CUSTOMER" }, u = "API", l = "SendMessage", p = "SendAttachment", d = "DownloadAttachment", h = "SendEvent", f = "GetTranscript", m = "DisconnectParticipant", g = "CreateParticipantConnection", v = "InitWebsocket", y = { INCOMING_MESSAGE: "INCOMING_MESSAGE", INCOMING_TYPING: "INCOMING_TYPING", INCOMING_READ_RECEIPT: "INCOMING_READ_RECEIPT", INCOMING_DELIVERED_RECEIPT: "INCOMING_DELIVERED_RECEIPT", CONNECTION_ESTABLISHED: "CONNECTION_ESTABLISHED", CONNECTION_LOST: "CONNECTION_LOST", CONNECTION_BROKEN: "CONNECTION_BROKEN", CONNECTION_ACK: "CONNECTION_ACK", CHAT_ENDED: "CHAT_ENDED", MESSAGE_METADATA: "MESSAGEMETADATA", PARTICIPANT_IDLE: "PARTICIPANT_IDLE", PARTICIPANT_RETURNED: "PARTICIPANT_RETURNED", AUTODISCONNECTION: "AUTODISCONNECTION" }, b = { textPlain: "text/plain", textMarkdown: "text/markdown", textCsv: "text/csv", applicationDoc: "application/msword", applicationDocx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document", applicationJson: "application/json", applicationPdf: "application/pdf", applicationPpt: "application/vnd.ms-powerpoint", applicationPptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation", applicationXls: "application/vnd.ms-excel", applicationXlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", imageJpg: "image/jpeg", imagePng: "image/png", audioWav: "audio/wav", audioXWav: "audio/x-wav", audioVndWave: "audio/vnd.wave", connectionAcknowledged: "application/vnd.amazonaws.connect.event.connection.acknowledged", typing: "application/vnd.amazonaws.connect.event.typing", participantJoined: "application/vnd.amazonaws.connect.event.participant.joined", participantLeft: "application/vnd.amazonaws.connect.event.participant.left", participantActive: "application/vnd.amazonaws.connect.event.participant.active", participantInactive: "application/vnd.amazonaws.connect.event.participant.inactive", transferSucceeded: "application/vnd.amazonaws.connect.event.transfer.succeeded", transferFailed: "application/vnd.amazonaws.connect.event.transfer.failed", chatEnded: "application/vnd.amazonaws.connect.event.chat.ended", interactiveMessage: "application/vnd.amazonaws.connect.message.interactive", interactiveMessageResponse: "application/vnd.amazonaws.connect.message.interactive.response", readReceipt: "application/vnd.amazonaws.connect.event.message.read", deliveredReceipt: "application/vnd.amazonaws.connect.event.message.delivered", participantIdle: "application/vnd.amazonaws.connect.event.participant.idle", participantReturned: "application/vnd.amazonaws.connect.event.participant.returned", autoDisconnection: "application/vnd.amazonaws.connect.event.participant.autodisconnection" }, w = { [b.typing]: y.INCOMING_TYPING, [b.readReceipt]: y.INCOMING_READ_RECEIPT, [b.deliveredReceipt]: y.INCOMING_DELIVERED_RECEIPT, [b.participantIdle]: y.PARTICIPANT_IDLE, [b.participantReturned]: y.PARTICIPANT_RETURNED, [b.autoDisconnection]: y.AUTODISCONNECTION, default: y.INCOMING_MESSAGE }, E = 3540, S = n(975), C = { assertTrue: function(t3, n2) {
        if (!t3)
          throw new e2(n2);
      }, assertNotNull: function(e3, t3) {
        return C.assertTrue(null != e3, (0, S.sprintf)("%s must be provided", t3 || "A value")), e3;
      }, now: function() {
        return (/* @__PURE__ */ new Date()).getTime();
      }, isString: function(e3) {
        return "string" == typeof e3;
      }, randomId: function() {
        return (0, S.sprintf)("%s-%s", C.now(), Math.random().toString(36).slice(2));
      }, assertIsNonEmptyString: function(e3, t3) {
        if (!e3 || "string" != typeof e3)
          throw new r(t3 + " is not a non-empty string!");
      }, assertIsList: function(e3, t3) {
        if (!Array.isArray(e3))
          throw new r(t3 + " is not an array");
      }, assertIsEnum: function(e3, t3, n2) {
        var i;
        for (i = 0; i < t3.length; i++)
          if (t3[i] === e3)
            return;
        throw new r(n2 + " passed (" + e3 + ") is not valid. Allowed values are: " + t3);
      }, makeEnum: function(e3) {
        var t3 = {};
        return e3.forEach(function(e4) {
          var n2 = e4.replace(/\.?([a-z]+)_?/g, function(e5, t4) {
            return t4.toUpperCase() + "_";
          }).replace(/_$/, "");
          t3[n2] = e4;
        }), t3;
      }, contains: function(e3, t3) {
        return e3 instanceof Array ? null !== C.find(e3, function(e4) {
          return e4 === t3;
        }) : t3 in e3;
      }, find: function(e3, t3) {
        for (var n2 = 0; n2 < e3.length; n2++)
          if (t3(e3[n2]))
            return e3[n2];
        return null;
      }, containsValue: function(e3, t3) {
        return e3 instanceof Array ? null !== C.find(e3, function(e4) {
          return e4 === t3;
        }) : null !== C.find(C.values(e3), function(e4) {
          return e4 === t3;
        });
      }, isFunction: function(e3) {
        return !!(e3 && e3.constructor && e3.call && e3.apply);
      }, values: function(e3) {
        var t3 = [];
        for (var n2 in C.assertNotNull(e3, "map"), e3)
          t3.push(e3[n2]);
        return t3;
      }, isObject: function(e3) {
        return !("object" != typeof e3 || null === e3);
      }, assertIsObject: function(e3, t3) {
        if (!C.isObject(e3))
          throw new r(t3 + " is not an object!");
      }, delay: (e3) => new Promise((t3) => setTimeout(t3, e3)), asyncWhileInterval: function(e3, t3, n2) {
        var r2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null, o = /* @__PURE__ */ new Date();
        return t3(r2) ? e3(r2).catch((i2) => {
          var s2 = Math.max(0, n2 - (/* @__PURE__ */ new Date()).valueOf() + o.valueOf());
          return C.delay(s2).then(() => C.asyncWhileInterval(e3, t3, n2, r2 + 1, i2));
        }) : Promise.reject(i || new Error("async while aborted"));
      }, isAttachmentContentType: function(e3) {
        return e3 === b.applicationPdf || e3 === b.imageJpg || e3 === b.imagePng || e3 === b.applicationDoc || e3 === b.applicationXls || e3 === b.applicationPpt || e3 === b.textCsv || e3 === b.audioWav;
      } };
      const T = C;
      var I = { DEBUG: 10, INFO: 20, WARN: 30, ERROR: 40, ADVANCED_LOG: 50 }, k = new class {
        constructor() {
          this.updateLoggerConfig();
        }
        writeToClientLogger(e3, t3, n2) {
          if (this.hasClientLogger()) {
            var r2 = function(e4) {
              switch (e4) {
                case 10:
                  return "DEBUG";
                case 20:
                  return "INFO";
                case 30:
                  return "WARN";
                case 40:
                  return "ERROR";
                case 50:
                  return "ADVANCED_LOG";
              }
            }(e3);
            switch (e3) {
              case I.DEBUG:
                return this._clientLogger.debug(r2, t3, n2) || t3;
              case I.INFO:
                return this._clientLogger.info(r2, t3, n2) || t3;
              case I.WARN:
                return this._clientLogger.warn(r2, t3, n2) || t3;
              case I.ERROR:
                return this._clientLogger.error(r2, t3, n2) || t3;
              case I.ADVANCED_LOG:
                return this._advancedLogWriter && this._clientLogger[this._advancedLogWriter] && this._clientLogger[this._advancedLogWriter](r2, t3, n2) || t3;
            }
          }
        }
        isLevelEnabled(e3) {
          return e3 >= this._level;
        }
        hasClientLogger() {
          return null !== this._clientLogger;
        }
        getLogger() {
          return new x(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {});
        }
        updateLoggerConfig(e3) {
          var t3 = e3 || {};
          this._level = t3.level || I.INFO, this._advancedLogWriter = "warn", function(e4, t4) {
            var n2 = t4 && Object.keys(t4);
            if (n2 && -1 === n2.indexOf(e4))
              return console.error("customizedLogger: incorrect value for loggerConfig:advancedLogWriter; use valid values from list ".concat(n2, " but used ").concat(e4)), false;
            var r2 = ["warn", "info", "debug", "log"];
            return !e4 || -1 !== r2.indexOf(e4) || (console.error("incorrect value for loggerConfig:advancedLogWriter; use valid values from list ".concat(r2, " but used ").concat(e4)), false);
          }(t3.advancedLogWriter, t3.customizedLogger) && (this._advancedLogWriter = t3.advancedLogWriter), (t3.customizedLogger && "object" == typeof t3.customizedLogger || t3.logger && "object" == typeof t3.logger) && (this.useClientLogger = true), this._clientLogger = this.selectLogger(t3);
        }
        selectLogger(e3) {
          return e3.customizedLogger && "object" == typeof e3.customizedLogger ? e3.customizedLogger : e3.logger && "object" == typeof e3.logger ? e3.logger : e3.useDefaultLogger ? A() : null;
        }
      }();
      class _ {
        debug() {
        }
        info() {
        }
        warn() {
        }
        error() {
        }
      }
      class x extends _ {
        constructor(e3) {
          super(), this.options = e3 || {};
        }
        debug() {
          for (var e3 = arguments.length, t3 = new Array(e3), n2 = 0; n2 < e3; n2++)
            t3[n2] = arguments[n2];
          return this._log(I.DEBUG, t3);
        }
        info() {
          for (var e3 = arguments.length, t3 = new Array(e3), n2 = 0; n2 < e3; n2++)
            t3[n2] = arguments[n2];
          return this._log(I.INFO, t3);
        }
        warn() {
          for (var e3 = arguments.length, t3 = new Array(e3), n2 = 0; n2 < e3; n2++)
            t3[n2] = arguments[n2];
          return this._log(I.WARN, t3);
        }
        error() {
          for (var e3 = arguments.length, t3 = new Array(e3), n2 = 0; n2 < e3; n2++)
            t3[n2] = arguments[n2];
          return this._log(I.ERROR, t3);
        }
        advancedLog() {
          for (var e3 = arguments.length, t3 = new Array(e3), n2 = 0; n2 < e3; n2++)
            t3[n2] = arguments[n2];
          return this._log(I.ADVANCED_LOG, t3);
        }
        _shouldLog(e3) {
          return k.hasClientLogger() && k.isLevelEnabled(e3);
        }
        _writeToClientLogger(e3, t3) {
          return k.writeToClientLogger(e3, t3, this.options.logMetaData);
        }
        _log(e3, t3) {
          if (this._shouldLog(e3)) {
            var n2 = k.useClientLogger ? t3 : this._convertToSingleStatement(t3);
            return this._writeToClientLogger(e3, n2);
          }
        }
        _convertToSingleStatement(e3) {
          var t3 = new Date(Date.now()).toISOString(), n2 = "[".concat(t3, "]");
          this.options && (this.options.prefix ? n2 += " " + this.options.prefix + ":" : n2 += "");
          for (var r2 = 0; r2 < e3.length; r2++) {
            var i = e3[r2];
            n2 += " " + this._convertToString(i);
          }
          return n2;
        }
        _convertToString(e3) {
          try {
            if (!e3)
              return "";
            if (T.isString(e3))
              return e3;
            if (T.isObject(e3) && T.isFunction(e3.toString)) {
              var t3 = e3.toString();
              if ("[object Object]" !== t3)
                return t3;
            }
            return JSON.stringify(e3);
          } catch (t4) {
            return console.error("Error while converting argument to string", e3, t4), "";
          }
        }
      }
      var A = () => {
        var e3 = new _();
        return e3.debug = console.debug.bind(window.console), e3.info = console.info.bind(window.console), e3.warn = console.warn.bind(window.console), e3.error = console.error.bind(window.console), e3;
      }, R = (n(228), n(493)), O = n.n(R);
      function N(e3, t3, n2, r2, i, o, s2) {
        try {
          var a2 = e3[o](s2), c2 = a2.value;
        } catch (e4) {
          return void n2(e4);
        }
        a2.done ? t3(c2) : Promise.resolve(c2).then(r2, i);
      }
      function L(e3, t3) {
        var n2 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var r2 = Object.getOwnPropertySymbols(e3);
          t3 && (r2 = r2.filter(function(t4) {
            return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
          })), n2.push.apply(n2, r2);
        }
        return n2;
      }
      function M(e3) {
        for (var t3 = 1; t3 < arguments.length; t3++) {
          var n2 = null != arguments[t3] ? arguments[t3] : {};
          t3 % 2 ? L(Object(n2), true).forEach(function(t4) {
            P(e3, t4, n2[t4]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(n2)) : L(Object(n2)).forEach(function(t4) {
            Object.defineProperty(e3, t4, Object.getOwnPropertyDescriptor(n2, t4));
          });
        }
        return e3;
      }
      function P(e3, t3, n2) {
        return (t3 = function(e4) {
          var t4 = function(e5, t5) {
            if ("object" != typeof e5 || null === e5)
              return e5;
            var n3 = e5[Symbol.toPrimitive];
            if (void 0 !== n3) {
              var r2 = n3.call(e5, "string");
              if ("object" != typeof r2)
                return r2;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(e5);
          }(e4);
          return "symbol" == typeof t4 ? t4 : String(t4);
        }(t3)) in e3 ? Object.defineProperty(e3, t3, { value: n2, enumerable: true, configurable: true, writable: true }) : e3[t3] = n2, e3;
      }
      class D {
        sendMessage(e3, n2, r2) {
          throw new t2("sendTextMessage in ChatClient");
        }
        sendAttachment(e3, n2, r2) {
          throw new t2("sendAttachment in ChatClient");
        }
        downloadAttachment(e3, n2) {
          throw new t2("downloadAttachment in ChatClient");
        }
        disconnectParticipant(e3) {
          throw new t2("disconnectParticipant in ChatClient");
        }
        sendEvent(e3, n2, r2) {
          throw new t2("sendEvent in ChatClient");
        }
        createParticipantConnection(e3, n2) {
          throw new t2("createParticipantConnection in ChatClient");
        }
      }
      class U extends D {
        constructor(e3) {
          super(), P(this, "throttleEvent", O()((e4, t4, n3) => this._submitEvent(e4, t4, n3), 1e4, { trailing: false, leading: true }));
          var t3 = new AWS.Credentials("", ""), n2 = new AWS.Config({ region: e3.region, endpoint: e3.endpoint, credentials: t3 });
          this.chatClient = new AWS.ConnectParticipant(n2), this.invokeUrl = e3.endpoint, this.logger = k.getLogger({ prefix: "Amazon-Connect-ChatJS-ChatClient", logMetaData: e3.logMetaData });
        }
        createParticipantConnection(e3, t3, n2) {
          var r2 = this, i = { ParticipantToken: e3, Type: t3, ConnectParticipant: n2 }, o = r2.chatClient.createParticipantConnection(i);
          return r2._sendRequest(o).then((e4) => {
            var t4, n3;
            return null === (t4 = r2.logger.info("Successfully create connection request")) || void 0 === t4 || null === (n3 = t4.sendInternalLogToServer) || void 0 === n3 || n3.call(t4), e4;
          }).catch((e4) => {
            var t4, n3;
            return null === (t4 = r2.logger.error("Error when creating connection request ", e4)) || void 0 === t4 || null === (n3 = t4.sendInternalLogToServer) || void 0 === n3 || n3.call(t4), Promise.reject(e4);
          });
        }
        disconnectParticipant(e3) {
          var t3 = this, n2 = { ConnectionToken: e3 }, r2 = t3.chatClient.disconnectParticipant(n2);
          return t3._sendRequest(r2).then((e4) => {
            var n3, r3;
            return null === (n3 = t3.logger.info("Successfully disconnect participant")) || void 0 === n3 || null === (r3 = n3.sendInternalLogToServer) || void 0 === r3 || r3.call(n3), e4;
          }).catch((e4) => {
            var n3, r3;
            return null === (n3 = t3.logger.error("Error when disconnecting participant ", e4)) || void 0 === n3 || null === (r3 = n3.sendInternalLogToServer) || void 0 === r3 || r3.call(n3), Promise.reject(e4);
          });
        }
        getTranscript(e3, t3) {
          var n2 = { MaxResults: t3.maxResults, NextToken: t3.nextToken, ScanDirection: t3.scanDirection, SortOrder: t3.sortOrder, StartPosition: { Id: t3.startPosition.id, AbsoluteTime: t3.startPosition.absoluteTime, MostRecent: t3.startPosition.mostRecent }, ConnectionToken: e3 };
          t3.contactId && (n2.ContactId = t3.contactId);
          var r2 = this.chatClient.getTranscript(n2);
          return this._sendRequest(r2).then((e4) => (this.logger.info("Successfully get transcript"), e4)).catch((e4) => (this.logger.error("Get transcript error", e4), Promise.reject(e4)));
        }
        sendMessage(e3, t3, n2) {
          var r2 = { Content: t3, ContentType: n2, ConnectionToken: e3 }, i = this.chatClient.sendMessage(r2);
          return this._sendRequest(i).then((e4) => {
            var t4, n3 = { id: null === (t4 = e4.data) || void 0 === t4 ? void 0 : t4.Id, contentType: r2.ContentType };
            return this.logger.debug("Successfully send message", n3), e4;
          }).catch((e4) => (this.logger.error("Send message error", e4, { contentType: r2.ContentType }), Promise.reject(e4)));
        }
        sendAttachment(e3, t3, n2) {
          var r2 = this, i = { ContentType: t3.type, AttachmentName: t3.name, AttachmentSizeInBytes: t3.size, ConnectionToken: e3 }, o = r2.chatClient.startAttachmentUpload(i), s2 = { contentType: t3.type, size: t3.size };
          return r2._sendRequest(o).then((n3) => r2._uploadToS3(t3, n3.data.UploadMetadata).then(() => {
            var t4, i2 = { AttachmentIds: [n3.data.AttachmentId], ConnectionToken: e3 };
            this.logger.debug("Successfully upload attachment", M(M({}, s2), {}, { attachmentId: null === (t4 = n3.data) || void 0 === t4 ? void 0 : t4.AttachmentId }));
            var o2 = r2.chatClient.completeAttachmentUpload(i2);
            return r2._sendRequest(o2);
          })).catch((e4) => (this.logger.error("Upload attachment error", e4, s2), Promise.reject(e4)));
        }
        _uploadToS3(e3, t3) {
          return fetch(t3.Url, { method: "PUT", headers: t3.HeadersToInclude, body: e3 });
        }
        downloadAttachment(e3, t3) {
          var n2 = this, r2 = { AttachmentId: t3, ConnectionToken: e3 }, i = { attachmentId: t3 }, o = n2.chatClient.getAttachment(r2);
          return n2._sendRequest(o).then((e4) => (this.logger.debug("Successfully download attachment", i), n2._downloadUrl(e4.data.Url))).catch((e4) => (this.logger.error("Download attachment error", e4, i), Promise.reject(e4)));
        }
        _downloadUrl(e3) {
          return fetch(e3).then((e4) => e4.blob()).catch((e4) => Promise.reject(e4));
        }
        sendEvent(e3, t3, n2) {
          return t3 === b.typing ? this.throttleEvent(e3, t3, n2) : this._submitEvent(e3, t3, n2);
        }
        _submitEvent(e3, t3, n2) {
          var r2, i = this;
          return (r2 = function* () {
            var r3 = i, o = { ConnectionToken: e3, ContentType: t3, Content: n2 }, s2 = r3.chatClient.sendEvent(o), a2 = { contentType: t3 };
            try {
              var c2, u2 = yield r3._sendRequest(s2);
              return i.logger.debug("Successfully send event", M(M({}, a2), {}, { id: null === (c2 = u2.data) || void 0 === c2 ? void 0 : c2.Id })), u2;
            } catch (e4) {
              return yield Promise.reject(e4);
            }
          }, function() {
            var e4 = this, t4 = arguments;
            return new Promise(function(n3, i2) {
              var o = r2.apply(e4, t4);
              function s2(e5) {
                N(o, n3, i2, s2, a2, "next", e5);
              }
              function a2(e5) {
                N(o, n3, i2, s2, a2, "throw", e5);
              }
              s2(void 0);
            });
          })();
        }
        _sendRequest(e3) {
          return new Promise((t3, n2) => {
            e3.on("success", function(e4) {
              t3(e4);
            }).on("error", function(e4) {
              var t4 = { type: e4.code, message: e4.message, stack: e4.stack ? e4.stack.split("\n") : [], statusCode: e4.statusCode };
              n2(t4);
            }).send();
          });
        }
      }
      var q = new class {
        constructor() {
          this.clientCache = {};
        }
        getCachedClient(e3, t3) {
          var n2 = Object.assign({}, e3), r2 = e3.region || s.getRegion() || "us-west-2";
          if (n2.region = r2, t3.region = r2, this.clientCache[r2])
            return this.clientCache[r2];
          var i = this._createAwsClient(n2, t3);
          return this.clientCache[r2] = i, i;
        }
        _createAwsClient(e3, t3) {
          var n2 = e3.region, r2 = s.getEndpointOverride(), i = "https://participant.connect.".concat(n2, ".amazonaws.com");
          return r2 && (i = r2), new U({ endpoint: i, region: n2, logMetaData: t3 });
        }
      }();
      class j {
        validateNewControllerDetails(e3) {
          return true;
        }
        validateSendMessage(e3) {
          if (!T.isString(e3.message))
            throw new r(e3.message + "is not a valid message");
          this.validateContentType(e3.contentType);
        }
        validateContentType(e3) {
          T.assertIsEnum(e3, Object.values(b), "contentType");
        }
        validateConnectChat(e3) {
          return true;
        }
        validateLogger(e3) {
          T.assertIsObject(e3, "logger"), ["debug", "info", "warn", "error"].forEach((t3) => {
            if (!T.isFunction(e3[t3]))
              throw new r(t3 + " should be a valid function on the passed logger object!");
          });
        }
        validateSendEvent(e3) {
          this.validateContentType(e3.contentType);
        }
        validateGetMessages(e3) {
          return true;
        }
      }
      class F extends j {
        validateChatDetails(e3, t3) {
          if (T.assertIsObject(e3, "chatDetails"), t3 === c.AGENT && !T.isFunction(e3.getConnectionToken))
            throw new r("getConnectionToken was not a function", e3.getConnectionToken);
          if (T.assertIsNonEmptyString(e3.contactId, "chatDetails.contactId"), T.assertIsNonEmptyString(e3.participantId, "chatDetails.participantId"), t3 === c.CUSTOMER) {
            if (!e3.participantToken)
              throw new r("participantToken was not provided for a customer session type", e3.participantToken);
            T.assertIsNonEmptyString(e3.participantToken, "chatDetails.participantToken");
          }
        }
        validateInitiateChatResponse() {
          return true;
        }
        normalizeChatDetails(e3) {
          var t3 = {};
          return t3.contactId = e3.ContactId || e3.contactId, t3.participantId = e3.ParticipantId || e3.participantId, t3.initialContactId = e3.InitialContactId || e3.initialContactId || t3.contactId || t3.ContactId, t3.getConnectionToken = e3.getConnectionToken || e3.GetConnectionToken, (e3.participantToken || e3.ParticipantToken) && (t3.participantToken = e3.ParticipantToken || e3.participantToken), this.validateChatDetails(t3), t3;
        }
      }
      var W = "NeverStarted", B = "Starting", z = "Connected", H = "ConnectionLost", V = "Ended", G = "ConnectionLost", K = "ConnectionGained", X = "Ended", J = "IncomingMessage";
      class Y {
        constructor(e3, t3) {
          this.connectionDetailsProvider = e3, this.isStarted = false, this.logger = k.getLogger({ prefix: "ChatJS-BaseConnectionHelper", logMetaData: t3 });
        }
        startConnectionTokenPolling() {
          var e3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 432e5;
          if (!(arguments.length > 0 && void 0 !== arguments[0] && arguments[0]))
            return this.connectionDetailsProvider.fetchConnectionDetails().then((t3) => (this.logger.info("Connection token polling succeeded."), e3 = this.getTimeToConnectionTokenExpiry(), this.timeout = setTimeout(this.startConnectionTokenPolling.bind(this), e3), t3)).catch((t3) => (this.logger.error("An error occurred when attempting to fetch the connection token during Connection Token Polling", t3), this.timeout = setTimeout(this.startConnectionTokenPolling.bind(this), e3), t3));
          this.logger.info("First time polling connection token."), this.timeout = setTimeout(this.startConnectionTokenPolling.bind(this), e3);
        }
        start() {
          return this.isStarted ? this.getConnectionToken() : (this.isStarted = true, this.startConnectionTokenPolling(true, this.getTimeToConnectionTokenExpiry()));
        }
        end() {
          clearTimeout(this.timeout);
        }
        getConnectionToken() {
          return this.connectionDetailsProvider.getFetchedConnectionToken();
        }
        getConnectionTokenExpiry() {
          return this.connectionDetailsProvider.getConnectionTokenExpiry();
        }
        getTimeToConnectionTokenExpiry() {
          return new Date(this.getConnectionTokenExpiry()).getTime() - (/* @__PURE__ */ new Date()).getTime() - 6e4;
        }
      }
      var $ = "<<all>>", Q = function(e3, t3, n2) {
        this.subMap = e3, this.id = T.randomId(), this.eventName = t3, this.f = n2;
      };
      Q.prototype.unsubscribe = function() {
        this.subMap.unsubscribe(this.eventName, this.id);
      };
      var Z = function() {
        this.subIdMap = {}, this.subEventNameMap = {};
      };
      Z.prototype.subscribe = function(e3, t3) {
        var n2 = new Q(this, e3, t3);
        this.subIdMap[n2.id] = n2;
        var r2 = this.subEventNameMap[e3] || [];
        return r2.push(n2), this.subEventNameMap[e3] = r2, () => n2.unsubscribe();
      }, Z.prototype.unsubscribe = function(e3, t3) {
        T.contains(this.subEventNameMap, e3) && (this.subEventNameMap[e3] = this.subEventNameMap[e3].filter(function(e4) {
          return e4.id !== t3;
        }), this.subEventNameMap[e3].length < 1 && delete this.subEventNameMap[e3]), T.contains(this.subIdMap, t3) && delete this.subIdMap[t3];
      }, Z.prototype.getAllSubscriptions = function() {
        return T.values(this.subEventNameMap).reduce(function(e3, t3) {
          return e3.concat(t3);
        }, []);
      }, Z.prototype.getSubscriptions = function(e3) {
        return this.subEventNameMap[e3] || [];
      };
      var ee = function(e3) {
        var t3 = e3 || {};
        this.subMap = new Z(), this.logEvents = t3.logEvents || false;
      };
      ee.prototype.subscribe = function(e3, t3) {
        return T.assertNotNull(e3, "eventName"), T.assertNotNull(t3, "f"), T.assertTrue(T.isFunction(t3), "f must be a function"), this.subMap.subscribe(e3, t3);
      }, ee.prototype.subscribeAll = function(e3) {
        return T.assertNotNull(e3, "f"), T.assertTrue(T.isFunction(e3), "f must be a function"), this.subMap.subscribe($, e3);
      }, ee.prototype.getSubscriptions = function(e3) {
        return this.subMap.getSubscriptions(e3);
      }, ee.prototype.trigger = function(e3, t3) {
        T.assertNotNull(e3, "eventName");
        var n2 = this, r2 = this.subMap.getSubscriptions($), i = this.subMap.getSubscriptions(e3);
        r2.concat(i).forEach(function(r3) {
          try {
            r3.f(t3 || null, e3, n2);
          } catch (e4) {
          }
        });
      }, ee.prototype.triggerAsync = function(e3, t3) {
        setTimeout(() => this.trigger(e3, t3), 0);
      }, ee.prototype.bridge = function() {
        var e3 = this;
        return function(t3, n2) {
          e3.trigger(n2, t3);
        };
      }, ee.prototype.unsubscribeAll = function() {
        this.subMap.getAllSubscriptions().forEach(function(e3) {
          e3.unsubscribe();
        });
      };
      var te = "Category", ne = new class {
        constructor() {
          this.widgetType = "CustomChatWidget", this.logger = k.getLogger({ prefix: "ChatJS-csmService" }), this.csmInitialized = false, this.metricsToBePublished = [], this.agentMetricToBePublished = [], this.MAX_RETRY = 5;
        }
        loadCsmScriptAndExecute() {
          try {
            var e3 = document.createElement("script");
            e3.type = "text/javascript", e3.innerHTML = "(function() {\n  const global = self;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  csm.EVENT_TYPE = {\n    LOG: 'LOG',\n    METRIC: 'METRIC',\n    CONFIG: 'CONFIG',\n    WORKFLOW_EVENT: 'WORKFLOW_EVENT',\n    CUSTOM: 'CUSTOM',\n    CLOSE: 'CLOSE',\n    SET_AUTH: 'SET_AUTH',\n    SET_CONFIG: 'SET_CONFIG',\n  };\n\n  csm.UNIT = {\n    COUNT: 'Count',\n    SECONDS: 'Seconds',\n    MILLISECONDS: 'Milliseconds',\n    MICROSECONDS: 'Microseconds',\n  };\n})();\n\n(function() {\n  const global = self;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  const MAX_METRIC_DIMENSIONS = 10;\n\n  /** ********* Dimension Classes ***********/\n\n  const Dimension = function(name, value) {\n    csm.Util.assertExist(name, 'name');\n    csm.Util.assertExist(value, 'value');\n\n    this.name = name;\n    this.value = value == null ? 'null' : (value === '' ? ' ' : value.toString());\n  };\n\n\n  /** ********* Metric Classes ***********/\n\n  const Metric = function(metricName, unit, value, dedupeOptions) {\n    csm.Util.assertExist(metricName, 'metricName');\n    csm.Util.assertExist(value, 'value');\n    csm.Util.assertExist(unit, 'unit');\n    csm.Util.assertTrue(csm.Util.isValidUnit(unit));\n    if (dedupeOptions) {\n      csm.Util.assertInObject(dedupeOptions, 'dedupeOptions', 'dedupeIntervalMs');\n    }\n\n    this.metricName = metricName;\n    this.unit = unit;\n    this.value = value;\n    this.timestamp = new Date();\n    this.dimensions = csm.globalDimensions ? csm.Util.deepCopy(csm.globalDimensions): [];\n    this.namespace = csm.configuration.namespace;\n    this.dedupeOptions = dedupeOptions; // optional. { dedupeIntervalMs: (int; required), context: (string; optional) }\n\n    // Currently, CloudWatch can't aggregate metrics by a subset of dimensions.\n    // To bypass this limitation, we introduce the optional dimensions concept to CSM.\n    // The CSM metric publisher will publish a default metric without optional dimension\n    // For each optional dimension, the CSM metric publisher publishes an extra metric with that dimension.\n    this.optionalDimensions = csm.globalOptionalDimensions ? csm.Util.deepCopy(csm.globalOptionalDimensions): [];\n  };\n\n  Metric.prototype.addDimension = function(name, value) {\n    this._addDimensionHelper(this.dimensions, name, value);\n  };\n\n  Metric.prototype.addOptionalDimension = function(name, value) {\n    this._addDimensionHelper(this.optionalDimensions, name, value);\n  };\n\n  Metric.prototype._addDimensionHelper = function(targetDimensions, name, value) {\n    // CloudWatch metric allows maximum 10 dimensions\n    // http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/CloudWatch.html#putMetricData-property\n    if ((this.dimensions.length + this.optionalDimensions.length) >= MAX_METRIC_DIMENSIONS) {\n      throw new csm.ExceedDimensionLimitException(name);\n    }\n\n    const existing = targetDimensions.find(function(dimension) {\n      return dimension.name === name;\n    });\n\n    if (existing) {\n      existing.value = value == null ? 'null' : (value === '' ? ' ' : value.toString());\n    } else {\n      targetDimensions.push(new Dimension(name, value));\n    }\n  };\n\n\n  /** ********* Telemetry Classes ***********/\n\n  const WorkflowEvent = function(params) {\n    this.timestamp = params.timestamp || new Date().getTime();\n    this.workflowType = params.workflow.type;\n    this.instanceId = params.workflow.instanceId;\n    this.userId = params.userId;\n    this.organizationId = params.organizationId;\n    this.accountId = params.accountId;\n    this.event = params.event;\n    this.appName = params.appName;\n    this.data = [];\n\n    // Convert 'data' map into the KeyValuePairList structure expected by the Lambda API\n    for (const key in params.data) {\n      if (Object.prototype.hasOwnProperty.call(params.data, key)) {\n        this.data.push({'key': key, 'value': params.data[key]});\n      }\n    }\n  };\n\n  /** ********* Exceptions ***********/\n\n  const NullOrUndefinedException = function(paramName) {\n    this.name = 'NullOrUndefinedException';\n    this.message = paramName + ' is null or undefined. ';\n  };\n  NullOrUndefinedException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n  const AssertTrueException = function() {\n    this.name = 'AssertTrueException';\n    this.message = 'Assertion failed. ';\n  };\n  AssertTrueException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n  const ExceedDimensionLimitException = function(dimensionName) {\n    this.name = 'ExceedDimensionLimitException';\n    this.message = 'Could not add dimension \\'' + dimensionName + '\\'. Metric has maximum 10 dimensions. ';\n  };\n  ExceedDimensionLimitException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n  const InitializationException = function() {\n    this.name = 'InitializationException';\n    this.message = 'Initialization failed. ';\n  };\n  InitializationException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n\n  csm.Dimension = Dimension;\n  csm.Metric = Metric;\n  csm.WorkflowEvent = WorkflowEvent;\n  csm.NullOrUndefinedException = NullOrUndefinedException;\n  csm.AssertTrueException = AssertTrueException;\n  csm.InitializationException = InitializationException;\n  csm.ExceedDimensionLimitException = ExceedDimensionLimitException;\n})();\n\n(function() {\n  const global = self;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  const validTimeUnits = [csm.UNIT.SECONDS, csm.UNIT.MILLISECONDS, csm.UNIT.MICROSECONDS];\n  const validUnits = validTimeUnits.concat(csm.UNIT.COUNT);\n\n  const Util = {\n    assertExist: function(value, paramName) {\n      if (value === null || value === undefined) {\n        throw new csm.NullOrUndefinedException(paramName);\n      }\n    },\n    assertTrue: function(value) {\n      if (!value) {\n        throw new csm.AssertTrueException();\n      }\n    },\n    assertInObject: function(obj, objName, key) {\n      if (obj === null || obj === undefined || typeof obj !== 'object') {\n        throw new csm.NullOrUndefinedException(objName);\n      }\n      if (key === null || key === undefined || !obj[key]) {\n        throw new csm.NullOrUndefinedException(`${objName}[${key}]`);\n      }\n    },\n    isValidUnit: function(unit) {\n      return validUnits.includes(unit);\n    },\n    isValidTimeUnit: function(unit) {\n      return validTimeUnits.includes(unit);\n    },\n    isEmpty: function(value) {\n      if (value !== null && typeof val === 'object') {\n        return Objects.keys(value).length === 0;\n      }\n      return !value;\n    },\n    deepCopy: function(obj) {\n      // NOTE: this will fail if obj has a circular reference\n      return JSON.parse(JSON.stringify(obj));\n    },\n\n    /**\n     * This function is used before setting the page location for default metrics and logs,\n     * and the APIs that set page location\n     * Can be overridden by calling csm.API.setPageLocationTransformer(function(){})\n     * @param {string}        pathname path for page location\n     * @return {string}       pathname provided\n     */\n    pageLocationTransformer: function(pathname) {\n      return pathname;\n    },\n\n    /**\n     * As of now, our service public claims only support for Firefox and Chrome\n     * Reference https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent\n     *\n     * This function will only return firefox, chrome and others\n     *\n     * Best practice as indicated in MDN, \"Avoiding user agent detection\"\n     */\n    getBrowserDetails: function() {\n      const userAgent = window.navigator.userAgent;\n      const details = {};\n      if (userAgent.includes('Firefox') && !userAgent.includes('Seamonkey')) {\n        details.name = 'Firefox';\n        details.version = getBrowserVersion('Firefox');\n      } else if (userAgent.includes('Chrome') && !userAgent.includes('Chromium')) {\n        details.name = 'Chrome';\n        details.version = getBrowserVersion('Chrome');\n      }\n    },\n\n    randomId: function() {\n      return new Date().getTime() + '-' + Math.random().toString(36).slice(2);\n    },\n\n    getOrigin: function() {\n      return document.location.origin;\n    },\n\n    getReferrerUrl: function() {\n      const referrer = document.referrer || '';\n      return this.getURLOrigin(referrer);\n    },\n\n    getWindowParent: function() {\n      let parentLocation = '';\n      try {\n        parentLocation = window.parent.location.href;\n      } catch (e) {\n        parentLocation = '';\n      }\n      return parentLocation;\n    },\n\n    getURLOrigin: function(urlValue) {\n      let origin = '';\n      const originArray = urlValue.split( '/' );\n      if (originArray.length >= 3) {\n        const protocol = originArray[0];\n        const host = originArray[2];\n        origin = protocol + '//' + host;\n      }\n      return origin;\n    },\n\n  };\n\n  const getBrowserVersion = function(browserName) {\n    const userAgent = window.navigator.userAgent;\n    const browserNameIndex = userAgent.indexOf(browserName);\n    const nextSpaceIndex = userAgent.indexOf(' ', browserNameIndex);\n    if (nextSpaceIndex === -1) {\n      return userAgent.substring(browserNameIndex + browserName.length + 1, userAgent.length);\n    } else {\n      return userAgent.substring(browserNameIndex + browserName.length + 1, nextSpaceIndex);\n    }\n  };\n\n  csm.Util = Util;\n})();\n\n(function() {\n  const global = window;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  csm.globalDimensions = []; // These dimensions are added to all captured metrics.\n  csm.globalOptionalDimensions = [];\n  csm.initFailureDimensions = [];\n\n  const API = {\n    getWorkflow: function(workflowType, instanceId, data) {\n      return csm.workflow(workflowType, instanceId, data);\n    },\n\n    addMetric: function(metric) {\n      csm.Util.assertExist(metric, 'metric');\n      csm.putMetric(metric);\n    },\n\n    addMetricWithDedupe: function(metric, dedupeIntervalMs, context) {\n      csm.Util.assertExist(metric, 'metric');\n      csm.Util.assertExist(metric, 'dedupeIntervalMs');\n      // context is optional; if present it will only dedupe on metrics with the same context. ex.) tabId\n      metric.dedupeOptions = {dedupeIntervalMs, context: context || 'global'};\n      csm.putMetric(metric);\n    },\n\n    addCount: function(metricName, count) {\n      csm.Util.assertExist(metricName, 'metricName');\n      csm.Util.assertExist(count, 'count');\n\n      const metric = new csm.Metric(metricName, csm.UNIT.COUNT, count);\n      csm.putMetric(metric);\n    },\n\n    addCountWithPageLocation: function(metricName) {\n      csm.Util.assertExist(metricName, 'metricName');\n\n      const metric = new csm.Metric(metricName, csm.UNIT.COUNT, 1.0);\n      metric.addDimension('WindowLocation', csm.Util.pageLocationTransformer(window.location.pathname));\n      csm.putMetric(metric);\n    },\n\n    addError: function(metricName, count) {\n      csm.Util.assertExist(metricName, 'metricName');\n\n      if (count === undefined || count == null) {\n        count = 1.0;\n      }\n      const metric = new csm.Metric(metricName, csm.UNIT.COUNT, count);\n      metric.addDimension('Metric', 'Error');\n      csm.putMetric(metric);\n    },\n\n    addSuccess: function(metricName) {\n      API.addError(metricName, 0);\n    },\n\n    addTime: function(metricName, time, unit) {\n      csm.Util.assertExist(metricName, 'metricName');\n      csm.Util.assertExist(time, 'time');\n\n      let timeUnit = csm.UNIT.MILLISECONDS;\n      if (unit && csm.Util.isValidTimeUnit(unit)) {\n        timeUnit = unit;\n      }\n      const metric = new csm.Metric(metricName, timeUnit, time);\n      metric.addDimension('Metric', 'Time');\n      csm.putMetric(metric);\n    },\n\n    addTimeWithPageLocation: function(metricName, time, unit) {\n      csm.Util.assertExist(metricName, 'metricName');\n      csm.Util.assertExist(time, 'time');\n\n      let timeUnit = csm.UNIT.MILLISECONDS;\n      if (unit && csm.Util.isValidTimeUnit(unit)) {\n        timeUnit = unit;\n      }\n      const metric = new csm.Metric(metricName, timeUnit, time);\n      metric.addDimension('WindowLocation', csm.Util.pageLocationTransformer(window.location.pathname));\n      csm.putMetric(metric);\n    },\n\n    pageReady: function() {\n      if (window.performance && window.performance.now) {\n        const pageLoadTime = window.performance.now();\n        const metric = new csm.Metric('PageReadyLatency', csm.UNIT.MILLISECONDS, pageLoadTime);\n        metric.addDimension('WindowLocation', csm.Util.pageLocationTransformer(window.location.pathname));\n        csm.putMetric(metric);\n      }\n    },\n\n    setPageLocationTransformer: function(transformFunc) {\n      csm.Util.assertExist(transformFunc, 'transformFunc');\n      csm.Util.assertTrue((typeof transformFunc) === 'function');\n      csm.Util.pageLocationTransformer = transformFunc;\n    },\n\n    setGlobalDimensions: function(dimensions) {\n      csm.Util.assertExist(dimensions, 'dimensions');\n      csm.globalDimensions = dimensions;\n    },\n\n    setGlobalOptionalDimensions: function(dimensions) {\n      csm.Util.assertExist(dimensions, 'dimensions');\n      csm.globalOptionalDimensions = dimensions;\n    },\n\n    setInitFailureDimensions: function(dimensions) {\n      csm.Util.assertExist(dimensions, 'dimensions');\n      csm.initFailureDimensions = dimensions;\n    },\n\n    putCustom: function(endpoint, headers, data) {\n      csm.Util.assertExist(data, 'data');\n      csm.Util.assertExist(endpoint, 'endpoint');\n      csm.Util.assertExist(headers, 'headers');\n      csm.putCustom(endpoint, headers, data);\n    },\n\n    setAuthParams: function(authParams) {\n      csm.setAuthParams(authParams);\n    },\n\n    setConfig: function(key, value) {\n      csm.Util.assertExist(key, 'key');\n      csm.Util.assertExist(value, 'value');\n      if (!csm.configuration[key]) {\n        csm.setConfig(key, value); // set configuration variables such as accountId, instanceId, userId\n      }\n    },\n  };\n\n  csm.API = API;\n})();\n\n(function() {\n  const global = window;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  const WORKFLOW_KEY_PREFIX = 'csm.workflow';\n\n  /**\n   * Calculates the local storage key used to store a workflow of the specified type.\n   * @param {string} type of workflow\n   * @return {string} storage key\n   */\n  const getWorkflowKeyForType = function(type) {\n    return [\n      WORKFLOW_KEY_PREFIX,\n      type,\n    ].join('.');\n  };\n\n  /**\n   * Constructor for new Workflow objects.\n   *\n   * If you need to be able to share a workflow across tabs, it is recommended\n   * to use \"csm.workflow\" to create/hydrate your workflows instead.\n   * @param {string} type of workflow\n   * @param {string} instanceId of workflow\n   * @param {JSON} data blob associated with workflow\n   */\n  const Workflow = function(type, instanceId, data) {\n    this.type = type;\n    this.instanceId = instanceId || csm.Util.randomId();\n    this.instanceSpecified = instanceId || false;\n    this.eventMap = {};\n    this.data = data || {};\n\n    // Merge global dimensions into the data map.\n    const dimensionData = {};\n    csm.globalDimensions.forEach(function(dimension) {\n      dimensionData[dimension.name] = dimension.value;\n    });\n    csm.globalOptionalDimensions.forEach(function(dimension) {\n      dimensionData[dimension.name] = dimension.value;\n    });\n    this.data = this._mergeData(dimensionData);\n  };\n\n  /**\n   * Create a new workflow or rehydrate an existing shared workflow.\n   *\n   * @param {string} type The type of workflow to be created.\n   * @param {string} instanceId The instanceId of the workflow.  If not provided, it will be\n   *      assigned a random ID and will not be automatically saved to local storage.\n   *      If provided, we will attempt to load an existing workflow of the same type\n   *      from local storage and rehydrate it.\n   * @param {JSON} data An optional map of key/value pairs to be added as data to every\n   *      workflow event created with this workflow.\n   * @return {Workflow} workflow event\n   * NOTE: Only one workflow of each type can be stored at the same time, to avoid\n   *       overloading localStorage with unused workflow records.\n   */\n  csm.workflow = function(type, instanceId, data) {\n    let workflow = new Workflow(type, instanceId, data);\n\n    if (instanceId) {\n      const savedWorkflow = csm._loadWorkflow(type);\n      if (savedWorkflow && savedWorkflow.instanceId === instanceId) {\n        workflow = savedWorkflow;\n        workflow.addData(data || {});\n      }\n    }\n\n    return workflow;\n  };\n\n  csm._loadWorkflow = function(type) {\n    let workflow = null;\n    const workflowJson = localStorage.getItem(getWorkflowKeyForType(type));\n    const workflowStruct = workflowJson ? JSON.parse(workflowJson) : null;\n    if (workflowStruct) {\n      workflow = new Workflow(type, workflowStruct.instanceId);\n      workflow.eventMap = workflowStruct.eventMap;\n    }\n    return workflow;\n  };\n\n  /**\n   * Creates a new workflow event and returns it.  Then this workflow event is sent upstream\n   * to the CSMSharedWorker where it is provided to the backend.\n   *\n   * If an instanceId was specified when the workflow was created, this will also save the workflow\n   * and all of its events to localStorage.\n   *\n   * @param {string} event The name of the event that occurred.\n   * @param {JSON} data An optional free-form key attribute pair of metadata items that will be stored\n   *      and reported backstream with the workflow event.\n   * @return {WorkflowEvent} workflowEvent\n   */\n  Workflow.prototype.event = function(event, data) {\n    const mergedData = this._mergeData(data || {});\n    const workflowEvent = new csm.WorkflowEvent({\n      workflow: this,\n      event: event,\n      data: mergedData,\n      userId: csm.configuration.userId || '',\n      organizationId: csm.configuration.organizationId || '',\n      accountId: csm.configuration.accountId || '',\n      appName: csm.configuration.namespace || '',\n    });\n    csm.putWorkflowEvent(workflowEvent);\n    this.eventMap[event] = workflowEvent;\n    if (this.instanceSpecified) {\n      this.save();\n    }\n    return workflowEvent;\n  };\n\n  /**\n   * Creates a new workflow event and returns it, if the same event is not happened in ths past\n   * dedupeIntervalMs milliseconds.\n   * @param {string} event The name of the event that occurred.\n   * @param {JSON} data An optional free-form key attribute pair of metadata items that will be stored\n   * and reported backstream with the workflow event.\n   * @param {int} dedupeIntervalMs defaults to 200 MS\n   * @return {WorkflowEvent} workflowEvent\n   */\n  Workflow.prototype.eventWithDedupe = function(event, data, dedupeIntervalMs) {\n    const pastEvent = this.getPastEvent(event);\n    const now = new Date().getTime();\n    const interval = dedupeIntervalMs || 200;\n\n    // Crafting the expected workflow event data result\n    const mergedData = this._mergeData(data);\n    const expectedData = [];\n    for (const key in mergedData) {\n      if (Object.prototype.hasOwnProperty.call(mergedData, key)) {\n        expectedData.push({'key': key, 'value': mergedData[key]});\n      }\n    }\n\n    // Deduplicate same events that happened within interval\n    if (!pastEvent || (pastEvent && JSON.stringify(pastEvent.data) !== JSON.stringify(expectedData)) ||\n        (pastEvent && (now - pastEvent.timestamp > interval))) {\n      return this.event(event, data);\n    }\n    return null;\n  };\n\n  /**\n   * Get a past event if it exists in this workflow, otherwise returns null.\n   * This can be helpful to emit metrics in real time based on the differences\n   * between workflow event timestamps, especially for workflows shared across tabs.\n   * @param {string} event key to see if workflow exists for this event\n   * @return {WorkflowEvent} workflow event retrieved\n   */\n  Workflow.prototype.getPastEvent = function(event) {\n    return event in this.eventMap ? this.eventMap[event] : null;\n  };\n\n  /**\n   * Save the workflow to local storage. This only happens automatically when an\n   * instanceId is specified on workflow creation, however if this method is called\n   * explicitly by the client, the randomly generated workflow instance id can be\n   * used to retrieve the workflow later and automatic save on events will be enabled.\n   */\n  Workflow.prototype.save = function() {\n    this.instanceSpecified = true;\n    localStorage.setItem(getWorkflowKeyForType(this.type), JSON.stringify(this));\n  };\n\n  /**\n   * Remove this workflow if it is the saved instance for this workflow type in localStorage.\n   */\n  Workflow.prototype.close = function() {\n    const storedWorkflow = csm._loadWorkflow(this.type);\n    if (storedWorkflow && storedWorkflow.instanceId === this.instanceId) {\n      localStorage.removeItem(getWorkflowKeyForType(this.type));\n    }\n  };\n\n  Workflow.prototype.addData = function(data) {\n    for (const key in data) {\n      if (Object.prototype.hasOwnProperty.call(data, key)) {\n        this.data[key] = data[key];\n      }\n    }\n  };\n\n  Workflow.prototype._mergeData = function(data) {\n    const mergedData = {};\n    let key = null;\n    for (key in this.data) {\n      if (Object.prototype.hasOwnProperty.call(this.data, key)) {\n        mergedData[key] = this.data[key] == null ? 'null' : (this.data[key] === '' ? ' ' : this.data[key].toString());\n      }\n    }\n    for (key in data) {\n      if (Object.prototype.hasOwnProperty.call(data, key)) {\n        mergedData[key] = data[key] == null ? 'null' : (data[key] === '' ? ' ' : data[key].toString());\n      }\n    }\n    return mergedData;\n  };\n})();\n\n(function() {\n  const global = window;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  let worker = null;\n  let portId = null;\n\n  const MAX_INIT_MILLISECONDS = 5000;\n  const preInitTaskQueue = [];\n  csm.configuration = {};\n\n  /**\n   * Initialize CSM variables\n   * @param {object} params for CSM\n   * @params.namespace Define your metric namespace used in CloudWatch metrics\n   * @params.sharedWorkerUrl Specify the relative url to the connect-csm-worker.js file in your service\n   * @params.endpoint Specify an LDAS endpoint to use.\n   * @params.dryRunMode When CSM is initialized with dry run mode, it won't actually publish metrics.\n   * @params.defaultMetrics Enable default metrics. Default to false.\n   */\n  csm.initCSM = function(params) {\n    csm.Util.assertExist(params.namespace, 'namespace');\n    csm.Util.assertExist(params.sharedWorkerUrl, 'sharedWorkerUrl');\n    csm.Util.assertExist(params.endpoint, 'endpoint');\n\n    try {\n      console.log('Starting csm shared worker with', params.sharedWorkerUrl);\n      worker = new SharedWorker(params.sharedWorkerUrl, 'CSM_SharedWorker');\n      worker.port.start();\n    } catch (e) {\n      console.log('Failed to initialize csm shared worker with', params.sharedWorkerUrl);\n      console.log(e.message);\n    }\n\n    /**\n     * Configure shared worker\n     */\n    csm.configuration = {\n      namespace: params.namespace,\n      userId: params.userId || '',\n      accountId: params.accountId || '',\n      organizationId: params.organizationId || '',\n      endpointUrl: params.endpoint || null,\n      batchSettings: params.batchSettings || null,\n      addPageVisibilityDimension: params.addPageVisibilityDimension || false,\n      addUrlDataDimensions: params.addUrlDataDimensions || false,\n      dryRunMode: params.dryRunMode || false, // When csm is in dryRunMode it won't actually publish metrics to CSM\n    };\n\n    postEventToWorker(csm.EVENT_TYPE.CONFIG, csm.configuration);\n\n    /**\n     * Receive message from shared worker\n     * @param {MessageEvent} messageEvent from shared worker\n     */\n    worker.port.onmessage = function(messageEvent) {\n      const messageType = messageEvent.data.type;\n      onMessageFromWorker(messageType, messageEvent.data);\n    };\n\n    /**\n     * Inform shared worker window closed\n     */\n    global.onbeforeunload = function() {\n      worker.port.postMessage(\n          {\n            type: csm.EVENT_TYPE.CLOSE,\n            portId: portId,\n          },\n      );\n    };\n\n    /**\n     * Check if initialization success\n     */\n    global.setTimeout(function() {\n      if (!isCSMInitialized()) {\n        console.log('[FATAL] CSM initialization failed! Please make sure the sharedWorkerUrl is reachable.');\n      }\n    }, MAX_INIT_MILLISECONDS);\n\n    // Emit out of the box metrics\n    if (params.defaultMetrics) {\n      emitDefaultMetrics();\n    }\n  };\n  // Final processing before sending to SharedWorker\n  const processMetric = function(metric) {\n    if (csm.configuration.addPageVisibilityDimension && document.visibilityState) {\n      metric.addOptionalDimension('VisibilityState', document.visibilityState);\n    }\n  };\n\n  const processWorkflowEvent = function(event) {\n    if (csm.configuration.addUrlDataDimensions) {\n      event.data.push({'key': 'ReferrerUrl', 'value': csm.Util.getReferrerUrl()});\n      event.data.push({'key': 'Origin', 'value': csm.Util.getOrigin()});\n      event.data.push({'key': 'WindowParent', 'value': csm.Util.getWindowParent()});\n    }\n    if (['initFailure', 'initializationLatencyInfo'].includes(event.event)) {\n      csm.initFailureDimensions.forEach((dimension) => {\n        Object.keys(dimension).forEach((key) => {\n          event.data.push({'key': key, 'value': dimension[key]});\n        });\n      });\n    }\n    return event;\n  };\n\n  csm.putMetric = function(metric) {\n    processMetric(metric);\n    postEventToWorker(csm.EVENT_TYPE.METRIC, metric);\n  };\n\n  csm.putLog = function(log) {\n    postEventToWorker(csm.EVENT_TYPE.LOG, log);\n  };\n\n  csm.putWorkflowEvent = function(event) {\n    const processedEvent = processWorkflowEvent(event);\n    postEventToWorker(csm.EVENT_TYPE.WORKFLOW_EVENT, processedEvent);\n  };\n\n  csm.putCustom = function(endpoint, headers, data) {\n    postEventToWorker(csm.EVENT_TYPE.CUSTOM, data, endpoint, headers);\n  };\n\n  csm.setAuthParams = function(authParams) {\n    postEventToWorker(csm.EVENT_TYPE.SET_AUTH, authParams);\n  };\n\n  csm.setConfig = function(key, value) {\n    csm.configuration[key] = value;\n    postEventToWorker(csm.EVENT_TYPE.SET_CONFIG, {key, value});\n  };\n  /** **********************  PRIVATE METHODS  ************************/\n\n  const onMessageFromWorker = function(messageType, data) {\n    if (messageType === csm.EVENT_TYPE.CONFIG) {\n      portId = data.portId;\n      onCSMInitialized();\n    }\n  };\n\n  const onCSMInitialized = function() {\n    // Purge the preInitTaskQueue\n    preInitTaskQueue.forEach(function(task) {\n      postEventToWorker(task.type, task.message, task.endpoint, task.headers);\n    });\n\n    // TODO:  Capture on errors and publish log to shared worker\n    /**\n            window.onerror = function(message, fileName, lineNumber, columnNumber, errorstack) {\n                var log = new csm.Log(message, fileName, lineNumber, columnNumber, errorstack.stack);\n                csm.putLog(log);\n            };\n        */\n  };\n\n  /**\n   * Emit out of the box metrics automatically\n   *\n   * TODO allow configuration\n   */\n  const emitDefaultMetrics = function() {\n    window.addEventListener('load', function() {\n      // loadEventEnd is avaliable after the onload function finished\n      // https://www.w3.org/TR/navigation-timing-2/#processing-model\n      // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigationTiming\n      global.setTimeout(function() {\n        try {\n          const perfData = window.performance.getEntriesByType('navigation')[0];\n          const pageLoadTime = perfData.loadEventEnd - perfData.startTime;\n          const connectTime = perfData.responseEnd - perfData.requestStart;\n          const domRenderTime = perfData.domComplete - perfData.domInteractive;\n          csm.API.addCountWithPageLocation('PageLoad');\n          csm.API.addTimeWithPageLocation('PageLoadTime', pageLoadTime);\n          csm.API.addTimeWithPageLocation('ConnectTime', connectTime);\n          csm.API.addTimeWithPageLocation('DomRenderTime', domRenderTime);\n        } catch (err) {\n          console.log('Error emitting default metrics', err);\n        }\n      }, 0);\n    });\n  };\n\n  /**\n   * Try posting message to shared worker\n   * If shared worker hasn't been initialized, put the task to queue to be clean up once initialized\n   * @param {csm.EVENT_TYPE} eventType for CSM\n   * @param {object} message event following type of eventType\n   * @param {string} [endpoint] optional parameter for putCustom function (put any data to specified endpoint)\n   * @param {object} [headers] optional parameter for putCustom function\n   */\n  const postEventToWorker = function(eventType, message, endpoint, headers) {\n    if (eventType === csm.EVENT_TYPE.CONFIG || isCSMInitialized()) {\n      worker.port.postMessage(\n          {\n            type: eventType,\n            portId: portId,\n            message: message,\n            endpoint: endpoint,\n            headers: headers,\n          },\n      );\n    } else {\n      preInitTaskQueue.push({\n        type: eventType,\n        message: message,\n        endpoint: endpoint,\n        headers: headers,\n      });\n    }\n  };\n\n  const isCSMInitialized = function() {\n    return portId !== null;\n  };\n})()", document.head.appendChild(e3), this.initializeCSM();
          } catch (e4) {
            this.logger.error("Load csm script error: ", e4);
          }
        }
        initializeCSM() {
          try {
            if (this.csmInitialized)
              return;
            var e3 = s.getRegion(), t3 = "(function() {\n  const global = self;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  csm.EVENT_TYPE = {\n    LOG: 'LOG',\n    METRIC: 'METRIC',\n    CONFIG: 'CONFIG',\n    WORKFLOW_EVENT: 'WORKFLOW_EVENT',\n    CUSTOM: 'CUSTOM',\n    CLOSE: 'CLOSE',\n    SET_AUTH: 'SET_AUTH',\n    SET_CONFIG: 'SET_CONFIG',\n  };\n\n  csm.UNIT = {\n    COUNT: 'Count',\n    SECONDS: 'Seconds',\n    MILLISECONDS: 'Milliseconds',\n    MICROSECONDS: 'Microseconds',\n  };\n})();\n\n(function() {\n  const global = self;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  const MAX_METRIC_DIMENSIONS = 10;\n\n  /** ********* Dimension Classes ***********/\n\n  const Dimension = function(name, value) {\n    csm.Util.assertExist(name, 'name');\n    csm.Util.assertExist(value, 'value');\n\n    this.name = name;\n    this.value = value == null ? 'null' : (value === '' ? ' ' : value.toString());\n  };\n\n\n  /** ********* Metric Classes ***********/\n\n  const Metric = function(metricName, unit, value, dedupeOptions) {\n    csm.Util.assertExist(metricName, 'metricName');\n    csm.Util.assertExist(value, 'value');\n    csm.Util.assertExist(unit, 'unit');\n    csm.Util.assertTrue(csm.Util.isValidUnit(unit));\n    if (dedupeOptions) {\n      csm.Util.assertInObject(dedupeOptions, 'dedupeOptions', 'dedupeIntervalMs');\n    }\n\n    this.metricName = metricName;\n    this.unit = unit;\n    this.value = value;\n    this.timestamp = new Date();\n    this.dimensions = csm.globalDimensions ? csm.Util.deepCopy(csm.globalDimensions): [];\n    this.namespace = csm.configuration.namespace;\n    this.dedupeOptions = dedupeOptions; // optional. { dedupeIntervalMs: (int; required), context: (string; optional) }\n\n    // Currently, CloudWatch can't aggregate metrics by a subset of dimensions.\n    // To bypass this limitation, we introduce the optional dimensions concept to CSM.\n    // The CSM metric publisher will publish a default metric without optional dimension\n    // For each optional dimension, the CSM metric publisher publishes an extra metric with that dimension.\n    this.optionalDimensions = csm.globalOptionalDimensions ? csm.Util.deepCopy(csm.globalOptionalDimensions): [];\n  };\n\n  Metric.prototype.addDimension = function(name, value) {\n    this._addDimensionHelper(this.dimensions, name, value);\n  };\n\n  Metric.prototype.addOptionalDimension = function(name, value) {\n    this._addDimensionHelper(this.optionalDimensions, name, value);\n  };\n\n  Metric.prototype._addDimensionHelper = function(targetDimensions, name, value) {\n    // CloudWatch metric allows maximum 10 dimensions\n    // http://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/CloudWatch.html#putMetricData-property\n    if ((this.dimensions.length + this.optionalDimensions.length) >= MAX_METRIC_DIMENSIONS) {\n      throw new csm.ExceedDimensionLimitException(name);\n    }\n\n    const existing = targetDimensions.find(function(dimension) {\n      return dimension.name === name;\n    });\n\n    if (existing) {\n      existing.value = value == null ? 'null' : (value === '' ? ' ' : value.toString());\n    } else {\n      targetDimensions.push(new Dimension(name, value));\n    }\n  };\n\n\n  /** ********* Telemetry Classes ***********/\n\n  const WorkflowEvent = function(params) {\n    this.timestamp = params.timestamp || new Date().getTime();\n    this.workflowType = params.workflow.type;\n    this.instanceId = params.workflow.instanceId;\n    this.userId = params.userId;\n    this.organizationId = params.organizationId;\n    this.accountId = params.accountId;\n    this.event = params.event;\n    this.appName = params.appName;\n    this.data = [];\n\n    // Convert 'data' map into the KeyValuePairList structure expected by the Lambda API\n    for (const key in params.data) {\n      if (Object.prototype.hasOwnProperty.call(params.data, key)) {\n        this.data.push({'key': key, 'value': params.data[key]});\n      }\n    }\n  };\n\n  /** ********* Exceptions ***********/\n\n  const NullOrUndefinedException = function(paramName) {\n    this.name = 'NullOrUndefinedException';\n    this.message = paramName + ' is null or undefined. ';\n  };\n  NullOrUndefinedException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n  const AssertTrueException = function() {\n    this.name = 'AssertTrueException';\n    this.message = 'Assertion failed. ';\n  };\n  AssertTrueException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n  const ExceedDimensionLimitException = function(dimensionName) {\n    this.name = 'ExceedDimensionLimitException';\n    this.message = 'Could not add dimension ' + dimensionName + ' . Metric has maximum 10 dimensions. ';\n  };\n  ExceedDimensionLimitException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n  const InitializationException = function() {\n    this.name = 'InitializationException';\n    this.message = 'Initialization failed. ';\n  };\n  InitializationException.prototype.toString = function() {\n    return this.name + ': ' + this.message;\n  };\n\n\n  csm.Dimension = Dimension;\n  csm.Metric = Metric;\n  csm.WorkflowEvent = WorkflowEvent;\n  csm.NullOrUndefinedException = NullOrUndefinedException;\n  csm.AssertTrueException = AssertTrueException;\n  csm.InitializationException = InitializationException;\n  csm.ExceedDimensionLimitException = ExceedDimensionLimitException;\n})();\n\n(function() {\n  const global = self;\n  const csm = global.csm || {};\n  global.csm = csm;\n\n  const validTimeUnits = [csm.UNIT.SECONDS, csm.UNIT.MILLISECONDS, csm.UNIT.MICROSECONDS];\n  const validUnits = validTimeUnits.concat(csm.UNIT.COUNT);\n\n  const Util = {\n    assertExist: function(value, paramName) {\n      if (value === null || value === undefined) {\n        throw new csm.NullOrUndefinedException(paramName);\n      }\n    },\n    assertTrue: function(value) {\n      if (!value) {\n        throw new csm.AssertTrueException();\n      }\n    },\n    assertInObject: function(obj, objName, key) {\n      if (obj === null || obj === undefined || typeof obj !== 'object') {\n        throw new csm.NullOrUndefinedException(objName);\n      }\n      if (key === null || key === undefined || !obj[key]) {\n        throw new csm.NullOrUndefinedException(`${objName}[${key}]`);\n      }\n    },\n    isValidUnit: function(unit) {\n      return validUnits.includes(unit);\n    },\n    isValidTimeUnit: function(unit) {\n      return validTimeUnits.includes(unit);\n    },\n    isEmpty: function(value) {\n      if (value !== null && typeof val === 'object') {\n        return Objects.keys(value).length === 0;\n      }\n      return !value;\n    },\n    deepCopy: function(obj) {\n      // NOTE: this will fail if obj has a circular reference\n      return JSON.parse(JSON.stringify(obj));\n    },\n\n    /**\n     * This function is used before setting the page location for default metrics and logs,\n     * and the APIs that set page location\n     * Can be overridden by calling csm.API.setPageLocationTransformer(function(){})\n     * @param {string}        pathname path for page location\n     * @return {string}       pathname provided\n     */\n    pageLocationTransformer: function(pathname) {\n      return pathname;\n    },\n\n    /**\n     * As of now, our service public claims only support for Firefox and Chrome\n     * Reference https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent\n     *\n     * This function will only return firefox, chrome and others\n     *\n     * Best practice as indicated in MDN, \"Avoiding user agent detection\"\n     */\n    getBrowserDetails: function() {\n      const userAgent = window.navigator.userAgent;\n      const details = {};\n      if (userAgent.includes('Firefox') && !userAgent.includes('Seamonkey')) {\n        details.name = 'Firefox';\n        details.version = getBrowserVersion('Firefox');\n      } else if (userAgent.includes('Chrome') && !userAgent.includes('Chromium')) {\n        details.name = 'Chrome';\n        details.version = getBrowserVersion('Chrome');\n      }\n    },\n\n    randomId: function() {\n      return new Date().getTime() + '-' + Math.random().toString(36).slice(2);\n    },\n\n    getOrigin: function() {\n      return document.location.origin;\n    },\n\n    getReferrerUrl: function() {\n      const referrer = document.referrer || '';\n      return this.getURLOrigin(referrer);\n    },\n\n    getWindowParent: function() {\n      let parentLocation = '';\n      try {\n        parentLocation = window.parent.location.href;\n      } catch (e) {\n        parentLocation = '';\n      }\n      return parentLocation;\n    },\n\n    getURLOrigin: function(urlValue) {\n      let origin = '';\n      const originArray = urlValue.split( '/' );\n      if (originArray.length >= 3) {\n        const protocol = originArray[0];\n        const host = originArray[2];\n        origin = protocol + '//' + host;\n      }\n      return origin;\n    },\n\n  };\n\n  const getBrowserVersion = function(browserName) {\n    const userAgent = window.navigator.userAgent;\n    const browserNameIndex = userAgent.indexOf(browserName);\n    const nextSpaceIndex = userAgent.indexOf(' ', browserNameIndex);\n    if (nextSpaceIndex === -1) {\n      return userAgent.substring(browserNameIndex + browserName.length + 1, userAgent.length);\n    } else {\n      return userAgent.substring(browserNameIndex + browserName.length + 1, nextSpaceIndex);\n    }\n  };\n\n  csm.Util = Util;\n})();\n\n(function() {\n  const XHR_DONE_READY_STATE = 4; // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState\n\n  const global = self;\n  const configuration = {};\n  const batchSettings = {\n    maxMetricsSize: 30,\n    maxWorkflowEventsSize: 30,\n    putMetricsIntervalMs: 30000,\n    putWorkflowEventsIntervalMs: 2000,\n  };\n  const metricLists = {}; // metricList per CloudWatch Namespace\n  const metricMap = {};\n  const ports = {};\n  let workflowEvents = {workflowEventList: []};\n\n  // SharedWorker wiki:  https://developer.mozilla.org/en-US/docs/Web/API/SharedWorker\n  onconnect = function(connectEvent) {\n    const port = connectEvent.ports[0];\n\n    port.onmessage = function(event) {\n      const data = event.data;\n      const messageType = data.type;\n      const message = data.message;\n      const endpoint = data.endpoint;\n      const headers = data.headers;\n\n      if (data.portId && !(data.portId in ports)) {\n        // This could happen when a user tries to close a tab which has a pop up alert to confirm closing,\n        // and the user decides to cancel closing\n        // This triggers before unload event while the tab or window is not closed actually\n        ports[data.portId] = port;\n      }\n\n      const {METRIC, WORKFLOW_EVENT, CUSTOM, CONFIG, SET_AUTH, SET_CONFIG, CLOSE} = csm.EVENT_TYPE;\n      switch (messageType) {\n        case METRIC: {\n          csm.Util.assertInObject(message, 'message', 'namespace');\n          const namespace = message.namespace;\n          if (shouldDedupe(message)) break;\n          addMetricEventToMap(message);\n          if (metricLists[namespace]) {\n            metricLists[namespace].push(message);\n          } else {\n            metricLists[namespace] = [message];\n          }\n          if (metricLists[namespace].length >= batchSettings.maxMetricsSize) {\n            putMetricsForNamespace(namespace);\n          }\n          break;\n        }\n        case WORKFLOW_EVENT: {\n          workflowEvents.workflowEventList.push(message);\n          if (workflowEvents.length >= batchSettings.maxWorkflowEventsSize) {\n            putWorkflowEvents();\n          }\n          break;\n        }\n        case CUSTOM: {\n          putCustom(endpoint, headers, message);\n          break;\n        }\n        case CONFIG: {\n          const portId = Object.keys(ports).length + 1; // portId starts from 1\n          ports[portId] = port;\n          for (const setting of Object.keys(message)) {\n            if (!csm.Util.isEmpty(message[setting])) {\n              configuration[setting] = message[setting];\n            }\n          }\n\n          // set optional batch settings\n          if (configuration.batchSettings) {\n            for (const setting of Object.keys(configuration.batchSettings)) {\n              batchSettings[setting] = configuration.batchSettings[setting];\n            }\n          }\n          // send metrics and workflow events at set intervals\n          putMetrics();\n          putWorkflowEvents();\n          global.setInterval(putMetrics, batchSettings.putMetricsIntervalMs);\n          global.setInterval(putWorkflowEvents, batchSettings.putWorkflowEventsIntervalMs);\n\n          port.postMessage(\n              {\n                type: csm.EVENT_TYPE.CONFIG,\n                portId: portId,\n              },\n          );\n          break;\n        }\n        case SET_AUTH: {\n          configuration.authParams = message;\n          authenticate();\n          break;\n        }\n        case SET_CONFIG: {\n          configuration[message.key] = message.value;\n          break;\n        }\n        case CLOSE: {\n          delete ports[data.portId];\n          if (Object.keys(ports).length === 0) {\n            putMetrics();\n            putWorkflowEvents();\n          }\n          break;\n        }\n        default:\n          break;\n      }\n    };\n  };\n\n  const shouldDedupe = function(metric) {\n    try {\n      const pastMetric = getPastMetricEvent(metric);\n      return pastMetric && metric.dedupeOptions &&\n        (metric.timestamp - pastMetric.timestamp < metric.dedupeOptions.dedupeIntervalMs);\n    } catch (err) {\n      console.error('Error in shouldDedupe', err);\n      return false;\n    }\n  };\n\n  const getPastMetricEvent = function(metric) {\n    try {\n      return metricMap[getMetricEventKey(metric)];\n    } catch (err) {\n      // ignore err - no previous metrics found\n      return null;\n    }\n  };\n\n  const addMetricEventToMap = function(metric) {\n    try {\n      metricMap[getMetricEventKey(metric)] = metric;\n    } catch (err) {\n      console.error('Failed to add event to metricMap', err);\n    }\n    csm.metricMap = metricMap;\n  };\n\n  const getMetricEventKey = function(metric) {\n    const {namespace, metricName, unit, dedupeOptions} = metric;\n    let context = 'global';\n    if (dedupeOptions && dedupeOptions.context) {\n      context = dedupeOptions.context;\n    }\n    return `${namespace}-${metricName}-${unit}-${context}`;\n  };\n\n  const authenticate = function() {\n    postRequest(configuration.endpointUrl + '/auth', {authParams: configuration.authParams},\n        {\n          success: function(response) {\n            if (response && response.jwtToken) {\n              configuration.authParams.jwtToken = response.jwtToken;\n            }\n          },\n          failure: function(response) {\n            broadcastMessage('[ERROR] csm auth failed!');\n            broadcastMessage('Response : ' + response);\n          },\n        }, {'x-api-key': 'auth-method-level-key'});\n  };\n\n  /**\n   * Put metrics to service when:\n   * a) metricList size is at maxMetricsSize\n   * b) every putMetricsIntervalMs time if the metricList is not empty\n   * c) worker is closed\n   *\n   * Timer is reset, and metricList emptied after each putMetrics call\n   */\n  const putMetrics = function() {\n    for (const namespace of Object.keys(metricLists)) {\n      putMetricsForNamespace(namespace);\n    }\n  };\n\n  const putMetricsForNamespace = function(namespace) {\n    csm.Util.assertInObject(metricLists, 'metricLists', namespace);\n    const metricList = metricLists[namespace];\n\n    if (metricList.length > 0 && !configuration.dryRunMode && configuration.endpointUrl) {\n      postRequest(configuration.endpointUrl + '/put-metrics', {\n        metricNamespace: namespace,\n        metricList: metricList,\n        authParams: configuration.authParams,\n        accountId: configuration.accountId,\n        organizationId: configuration.organizationId,\n        agentResourceId: configuration.userId,\n      }, {\n        success: function(response) {\n          if (response) {\n            broadcastMessage('PutMetrics response : ' + response);\n            if (response.unsetToken) {\n              delete configuration.authParams.jwtToken;\n              authenticate();\n            }\n          }\n        },\n        failure: function(response) {\n          broadcastMessage('[ERROR] Put metrics to service failed! ');\n        },\n      });\n    }\n    metricLists[namespace] = [];\n  };\n\n  /**\n   * Put metrics to service every two seconds if there are events to be put.\n   */\n  const putWorkflowEvents = function() {\n    if (workflowEvents.workflowEventList.length > 0 && !configuration.dryRunMode && configuration.endpointUrl) {\n      workflowEvents.authParams = configuration.authParams;\n      postRequest(configuration.endpointUrl + '/put-workflow-events', workflowEvents,\n          {\n            success: function(response) {\n              if (response) {\n                if (response.workflowEventList && response.workflowEventList.length > 0) {\n                  broadcastMessage('[WARN] There are ' + response.length + ' workflow events that failed to publish');\n                  broadcastMessage('Response : ' + response);\n                }\n                if (response.unsetToken) {\n                  delete configuration.authParams.jwtToken;\n                  authenticate();\n                }\n              }\n            },\n            failure: function(response) {\n              broadcastMessage('[ERROR] Put workflow events to service failed! ');\n            },\n          });\n    }\n\n    workflowEvents = {workflowEventList: []};\n  };\n\n  /**\n   * Put data to custom endpoint on demand\n   * @param {string} endpoint\n   * @param {object} headers\n   * @param {object} data to send to endpoint\n   */\n  const putCustom = function(endpoint, headers, data) {\n    if (!configuration.dryRunMode && endpoint && data) {\n      postRequest(endpoint, data, {\n        success: function(response) {\n          if (response) {\n            broadcastMessage('Response : ' + response);\n          }\n        },\n        failure: function(response) {\n          broadcastMessage('[ERROR] Failed to put custom data! ');\n        },\n      }, headers);\n    }\n  };\n\n  /**\n   * Broadcast message to all tabs\n   * @param {string} message to post to all the tabs\n   */\n  const broadcastMessage = function(message) {\n    for (const portId in ports) {\n      if (Object.prototype.hasOwnProperty.call(ports, portId)) {\n        ports[portId].postMessage(message);\n      }\n    }\n  };\n\n  const postRequest = function(url, data, callbacks, headers) {\n    csm.Util.assertExist(url, 'url');\n    csm.Util.assertExist(data, 'data');\n\n    callbacks = callbacks || {};\n    callbacks.success = callbacks.success || function() {};\n    callbacks.failure = callbacks.failure || function() {};\n\n    const request = new XMLHttpRequest(); // new HttpRequest instance\n    request.onreadystatechange = function() {\n      const errorList = request.response ? JSON.parse(request.response): [];\n      if (request.readyState === XHR_DONE_READY_STATE) { // request finished and response is ready\n        if (request.status === 200) {\n          callbacks.success(errorList);\n        } else {\n          broadcastMessage('AJAX request failed with status: ' + request.status);\n          callbacks.failure(errorList);\n        }\n      }\n    };\n\n    request.open('POST', url);\n    if (headers && typeof headers === 'object') {\n      Object.keys(headers).forEach((header) => request.setRequestHeader(header, headers[header]));\n    } else {\n      request.setRequestHeader('Content-Type', 'application/json');\n    }\n    request.send(JSON.stringify(data));\n  };\n})()".replace(/\\/g, ""), n2 = URL.createObjectURL(new Blob([t3], { type: "text/javascript" })), r2 = ((e4) => "https://ieluqbvv.telemetry.connect.".concat(e4, ".amazonaws.com/prod"))(e3), i = { endpoint: r2, namespace: "chat-widget", sharedWorkerUrl: n2 };
            csm.initCSM(i), this.logger.info("CSMService is initialized in ".concat(e3)), this.csmInitialized = true, this.metricsToBePublished && (this.metricsToBePublished.forEach((e4) => {
              csm.API.addMetric(e4);
            }), this.metricsToBePublished = null);
          } catch (e4) {
            this.logger.error("Failed to initialize csm: ", e4);
          }
        }
        updateCsmConfig(e3) {
          this.widgetType = "object" != typeof e3 || null === e3 || Array.isArray(e3) ? this.widgetType : e3.widgetType;
        }
        getDefaultDimensions() {
          return [{ name: "WidgetType", value: this.widgetType }];
        }
        addMetric(e3) {
          if (this.csmInitialized)
            try {
              csm.API.addMetric(e3);
            } catch (e4) {
              this.logger.error("Failed to addMetric csm: ", e4);
            }
          else
            this.metricsToBePublished && (this.metricsToBePublished.push(e3), this.logger.info("CSMService is not initialized yet. Adding metrics to queue to be published once CSMService is initialized"));
        }
        setDimensions(e3, t3) {
          t3.forEach((t4) => {
            e3.addDimension(t4.name, t4.value);
          });
        }
        addLatencyMetric(e3, t3, n2) {
          var r2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
          try {
            var i = new csm.Metric(e3, csm.UNIT.MILLISECONDS, t3), o = [...this.getDefaultDimensions(), { name: "Metric", value: "Latency" }, { name: te, value: n2 }, ...r2];
            this.setDimensions(i, o), this.addMetric(i), this.logger.debug("Successfully published latency API metrics for method ".concat(e3));
          } catch (e4) {
            this.logger.error("Failed to addLatencyMetric csm: ", e4);
          }
        }
        addLatencyMetricWithStartTime(e3, t3, n2) {
          var r2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [], i = (/* @__PURE__ */ new Date()).getTime() - t3;
          this.addLatencyMetric(e3, i, n2, r2), this.logger.debug("Successfully published latency API metrics for method ".concat(e3));
        }
        addCountAndErrorMetric(e3, t3, n2) {
          var r2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : [];
          try {
            var i = [...this.getDefaultDimensions(), { name: te, value: t3 }, ...r2], o = new csm.Metric(e3, csm.UNIT.COUNT, 1);
            this.setDimensions(o, [...i, { name: "Metric", value: "Count" }]);
            var s2 = n2 ? 1 : 0, a2 = new csm.Metric(e3, csm.UNIT.COUNT, s2);
            this.setDimensions(a2, [...i, { name: "Metric", value: "Error" }]), this.addMetric(o), this.addMetric(a2), this.logger.debug("Successfully published count and error metrics for method ".concat(e3));
          } catch (e4) {
            this.logger.error("Failed to addCountAndErrorMetric csm: ", e4);
          }
        }
        addCountMetric(e3, t3) {
          var n2 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
          try {
            var r2 = [...this.getDefaultDimensions(), { name: te, value: t3 }, { name: "Metric", value: "Count" }, ...n2], i = new csm.Metric(e3, csm.UNIT.COUNT, 1);
            this.setDimensions(i, r2), this.addMetric(i), this.logger.debug("Successfully published count metrics for method ".concat(e3));
          } catch (e4) {
            this.logger.error("Failed to addCountMetric csm: ", e4);
          }
        }
        addAgentCountMetric(e3, t3) {
          try {
            var n2 = this;
            csm && csm.API.addCount && e3 ? (csm.API.addCount(e3, t3), n2.MAX_RETRY = 5) : (e3 && this.agentMetricToBePublished.push({ metricName: e3, count: t3 }), setTimeout(() => {
              csm && csm.API.addCount ? (this.agentMetricToBePublished.forEach((e4) => {
                csm.API.addCount(e4.metricName, e4.count);
              }), this.agentMetricToBePublished = []) : n2.MAX_RETRY > 0 && (n2.MAX_RETRY -= 1, n2.addAgentCountMetric());
            }, 3e3));
          } catch (e4) {
            this.logger.error("Failed to addAgentCountMetric csm: ", e4);
          }
        }
      }();
      function re(e3, t3, n2, r2, i, o, s2) {
        try {
          var a2 = e3[o](s2), c2 = a2.value;
        } catch (e4) {
          return void n2(e4);
        }
        a2.done ? t3(c2) : Promise.resolve(c2).then(r2, i);
      }
      class ie {
        constructor(e3, t3, n2) {
          var r2 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
          this.chatClient = t3, this.participantToken = e3 || null, this.connectionDetails = null, this.connectionToken = null, this.connectionTokenExpiry = null, this.sessionType = n2, this.getConnectionToken = r2;
        }
        getFetchedConnectionToken() {
          return this.connectionToken;
        }
        getConnectionTokenExpiry() {
          return this.connectionTokenExpiry;
        }
        getConnectionDetails() {
          return this.connectionDetails;
        }
        fetchConnectionDetails() {
          return this._fetchConnectionDetails().then((e3) => e3);
        }
        _handleCreateParticipantConnectionResponse(e3, t3) {
          return this.connectionDetails = { url: e3.Websocket.Url, expiry: e3.Websocket.ConnectionExpiry, transportLifeTimeInSeconds: E, connectionAcknowledged: t3, connectionToken: e3.ConnectionCredentials.ConnectionToken, connectionTokenExpiry: e3.ConnectionCredentials.Expiry }, this.connectionToken = e3.ConnectionCredentials.ConnectionToken, this.connectionTokenExpiry = e3.ConnectionCredentials.Expiry, this.connectionDetails;
        }
        _handleGetConnectionTokenResponse(e3) {
          return this.connectionDetails = { url: null, expiry: null, connectionToken: e3.participantToken, connectionTokenExpiry: e3.expiry, transportLifeTimeInSeconds: E, connectionAcknowledged: false }, this.connectionToken = e3.participantToken, this.connectionTokenExpiry = e3.expiry, Promise.resolve(this.connectionDetails);
        }
        callCreateParticipantConnection() {
          var { Type: e3 = true, ConnectParticipant: t3 = false } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n2 = (/* @__PURE__ */ new Date()).getTime();
          return this.chatClient.createParticipantConnection(this.participantToken, e3 ? ["WEBSOCKET", "CONNECTION_CREDENTIALS"] : null, t3 || null).then((r2) => {
            if (e3)
              return this._addParticipantConnectionMetric(n2), this._handleCreateParticipantConnectionResponse(r2.data, t3);
          }).catch((t4) => (e3 && this._addParticipantConnectionMetric(n2, true), Promise.reject({ reason: "Failed to fetch connectionDetails with createParticipantConnection", _debug: t4 })));
        }
        _addParticipantConnectionMetric(e3) {
          var t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          ne.addLatencyMetricWithStartTime(g, e3, u), ne.addCountAndErrorMetric(g, u, t3);
        }
        _fetchConnectionDetails() {
          var e3, t3 = this;
          return (e3 = function* () {
            return t3.sessionType === c.CUSTOMER ? t3.callCreateParticipantConnection() : t3.sessionType === c.AGENT ? t3.getConnectionToken().then((e4) => t3._handleGetConnectionTokenResponse(e4.chatTokenTransport)).catch(() => t3.callCreateParticipantConnection({ Type: true, ConnectParticipant: true }).catch((e4) => {
              throw new Error({ type: "CONN_ACK_FAILED", errorMessage: e4 });
            })) : Promise.reject({ reason: "Failed to fetch connectionDetails.", _debug: new r("Failed to fetch connectionDetails.") });
          }, function() {
            var t4 = this, n2 = arguments;
            return new Promise(function(r2, i) {
              var o = e3.apply(t4, n2);
              function s2(e4) {
                re(o, r2, i, s2, a2, "next", e4);
              }
              function a2(e4) {
                re(o, r2, i, s2, a2, "throw", e4);
              }
              s2(void 0);
            });
          })();
        }
      }
      var oe = void 0 !== oe ? oe : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
      oe.connect = oe.connect || {};
      var se = connect.WebSocketManager;
      !function(e3) {
        var t3 = {};
        function n2(r2) {
          if (t3[r2])
            return t3[r2].exports;
          var i = t3[r2] = { i: r2, l: false, exports: {} };
          return e3[r2].call(i.exports, i, i.exports, n2), i.l = true, i.exports;
        }
        n2.m = e3, n2.c = t3, n2.d = function(e4, t4, r2) {
          n2.o(e4, t4) || Object.defineProperty(e4, t4, { enumerable: true, get: r2 });
        }, n2.r = function(e4) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e4, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e4, "__esModule", { value: true });
        }, n2.t = function(e4, t4) {
          if (1 & t4 && (e4 = n2(e4)), 8 & t4)
            return e4;
          if (4 & t4 && "object" == typeof e4 && e4 && e4.__esModule)
            return e4;
          var r2 = /* @__PURE__ */ Object.create(null);
          if (n2.r(r2), Object.defineProperty(r2, "default", { enumerable: true, value: e4 }), 2 & t4 && "string" != typeof e4)
            for (var i in e4)
              n2.d(r2, i, (function(t5) {
                return e4[t5];
              }).bind(null, i));
          return r2;
        }, n2.n = function(e4) {
          var t4 = e4 && e4.__esModule ? function() {
            return e4.default;
          } : function() {
            return e4;
          };
          return n2.d(t4, "a", t4), t4;
        }, n2.o = function(e4, t4) {
          return Object.prototype.hasOwnProperty.call(e4, t4);
        }, n2.p = "", n2(n2.s = 10);
      }([function(e3, t3) {
        function n2(t4) {
          return e3.exports = n2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e4) {
            return typeof e4;
          } : function(e4) {
            return e4 && "function" == typeof Symbol && e4.constructor === Symbol && e4 !== Symbol.prototype ? "symbol" : typeof e4;
          }, e3.exports.__esModule = true, e3.exports.default = e3.exports, n2(t4);
        }
        e3.exports = n2, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3) {
        e3.exports = function(e4, t4) {
          if (!(e4 instanceof t4))
            throw new TypeError("Cannot call a class as a function");
        }, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3) {
        function n2(e4, t4) {
          for (var n3 = 0; n3 < t4.length; n3++) {
            var r2 = t4[n3];
            r2.enumerable = r2.enumerable || false, r2.configurable = true, "value" in r2 && (r2.writable = true), Object.defineProperty(e4, r2.key, r2);
          }
        }
        e3.exports = function(e4, t4, r2) {
          return t4 && n2(e4.prototype, t4), r2 && n2(e4, r2), Object.defineProperty(e4, "prototype", { writable: false }), e4;
        }, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3) {
        function n2(t4) {
          return e3.exports = n2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e4) {
            return e4.__proto__ || Object.getPrototypeOf(e4);
          }, e3.exports.__esModule = true, e3.exports.default = e3.exports, n2(t4);
        }
        e3.exports = n2, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3, n2) {
        var r2;
        !function() {
          var i = { not_string: /[^s]/, not_bool: /[^t]/, not_type: /[^T]/, not_primitive: /[^v]/, number: /[diefg]/, numeric_arg: /[bcdiefguxX]/, json: /[j]/, not_json: /[^j]/, text: /^[^\x25]+/, modulo: /^\x25{2}/, placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/, key: /^([a-z_][a-z_\d]*)/i, key_access: /^\.([a-z_][a-z_\d]*)/i, index_access: /^\[(\d+)\]/, sign: /^[+-]/ };
          function o(e4) {
            return function(e5, t4) {
              var n3, r3, s3, a3, c2, u2, l2, p2, d2, h2 = 1, f2 = e5.length, m2 = "";
              for (r3 = 0; r3 < f2; r3++)
                if ("string" == typeof e5[r3])
                  m2 += e5[r3];
                else if ("object" == typeof e5[r3]) {
                  if ((a3 = e5[r3]).keys)
                    for (n3 = t4[h2], s3 = 0; s3 < a3.keys.length; s3++) {
                      if (null == n3)
                        throw new Error(o('[sprintf] Cannot access property "%s" of undefined value "%s"', a3.keys[s3], a3.keys[s3 - 1]));
                      n3 = n3[a3.keys[s3]];
                    }
                  else
                    n3 = a3.param_no ? t4[a3.param_no] : t4[h2++];
                  if (i.not_type.test(a3.type) && i.not_primitive.test(a3.type) && n3 instanceof Function && (n3 = n3()), i.numeric_arg.test(a3.type) && "number" != typeof n3 && isNaN(n3))
                    throw new TypeError(o("[sprintf] expecting number but found %T", n3));
                  switch (i.number.test(a3.type) && (p2 = n3 >= 0), a3.type) {
                    case "b":
                      n3 = parseInt(n3, 10).toString(2);
                      break;
                    case "c":
                      n3 = String.fromCharCode(parseInt(n3, 10));
                      break;
                    case "d":
                    case "i":
                      n3 = parseInt(n3, 10);
                      break;
                    case "j":
                      n3 = JSON.stringify(n3, null, a3.width ? parseInt(a3.width) : 0);
                      break;
                    case "e":
                      n3 = a3.precision ? parseFloat(n3).toExponential(a3.precision) : parseFloat(n3).toExponential();
                      break;
                    case "f":
                      n3 = a3.precision ? parseFloat(n3).toFixed(a3.precision) : parseFloat(n3);
                      break;
                    case "g":
                      n3 = a3.precision ? String(Number(n3.toPrecision(a3.precision))) : parseFloat(n3);
                      break;
                    case "o":
                      n3 = (parseInt(n3, 10) >>> 0).toString(8);
                      break;
                    case "s":
                      n3 = String(n3), n3 = a3.precision ? n3.substring(0, a3.precision) : n3;
                      break;
                    case "t":
                      n3 = String(!!n3), n3 = a3.precision ? n3.substring(0, a3.precision) : n3;
                      break;
                    case "T":
                      n3 = Object.prototype.toString.call(n3).slice(8, -1).toLowerCase(), n3 = a3.precision ? n3.substring(0, a3.precision) : n3;
                      break;
                    case "u":
                      n3 = parseInt(n3, 10) >>> 0;
                      break;
                    case "v":
                      n3 = n3.valueOf(), n3 = a3.precision ? n3.substring(0, a3.precision) : n3;
                      break;
                    case "x":
                      n3 = (parseInt(n3, 10) >>> 0).toString(16);
                      break;
                    case "X":
                      n3 = (parseInt(n3, 10) >>> 0).toString(16).toUpperCase();
                  }
                  i.json.test(a3.type) ? m2 += n3 : (!i.number.test(a3.type) || p2 && !a3.sign ? d2 = "" : (d2 = p2 ? "+" : "-", n3 = n3.toString().replace(i.sign, "")), u2 = a3.pad_char ? "0" === a3.pad_char ? "0" : a3.pad_char.charAt(1) : " ", l2 = a3.width - (d2 + n3).length, c2 = a3.width && l2 > 0 ? u2.repeat(l2) : "", m2 += a3.align ? d2 + n3 + c2 : "0" === u2 ? d2 + c2 + n3 : c2 + d2 + n3);
                }
              return m2;
            }(function(e5) {
              if (a2[e5])
                return a2[e5];
              for (var t4, n3 = e5, r3 = [], o2 = 0; n3; ) {
                if (null !== (t4 = i.text.exec(n3)))
                  r3.push(t4[0]);
                else if (null !== (t4 = i.modulo.exec(n3)))
                  r3.push("%");
                else {
                  if (null === (t4 = i.placeholder.exec(n3)))
                    throw new SyntaxError("[sprintf] unexpected placeholder");
                  if (t4[2]) {
                    o2 |= 1;
                    var s3 = [], c2 = t4[2], u2 = [];
                    if (null === (u2 = i.key.exec(c2)))
                      throw new SyntaxError("[sprintf] failed to parse named argument key");
                    for (s3.push(u2[1]); "" !== (c2 = c2.substring(u2[0].length)); )
                      if (null !== (u2 = i.key_access.exec(c2)))
                        s3.push(u2[1]);
                      else {
                        if (null === (u2 = i.index_access.exec(c2)))
                          throw new SyntaxError("[sprintf] failed to parse named argument key");
                        s3.push(u2[1]);
                      }
                    t4[2] = s3;
                  } else
                    o2 |= 2;
                  if (3 === o2)
                    throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                  r3.push({ placeholder: t4[0], param_no: t4[1], keys: t4[2], sign: t4[3], pad_char: t4[4], align: t4[5], width: t4[6], precision: t4[7], type: t4[8] });
                }
                n3 = n3.substring(t4[0].length);
              }
              return a2[e5] = r3;
            }(e4), arguments);
          }
          function s2(e4, t4) {
            return o.apply(null, [e4].concat(t4 || []));
          }
          var a2 = /* @__PURE__ */ Object.create(null);
          t3.sprintf = o, t3.vsprintf = s2, "undefined" != typeof window && (window.sprintf = o, window.vsprintf = s2, void 0 === (r2 = (function() {
            return { sprintf: o, vsprintf: s2 };
          }).call(t3, n2, t3, e3)) || (e3.exports = r2));
        }();
      }, function(e3, t3, n2) {
        var r2 = n2(8);
        e3.exports = function(e4, t4) {
          if ("function" != typeof t4 && null !== t4)
            throw new TypeError("Super expression must either be null or a function");
          e4.prototype = Object.create(t4 && t4.prototype, { constructor: { value: e4, writable: true, configurable: true } }), Object.defineProperty(e4, "prototype", { writable: false }), t4 && r2(e4, t4);
        }, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3, n2) {
        var r2 = n2(0).default, i = n2(9);
        e3.exports = function(e4, t4) {
          if (t4 && ("object" === r2(t4) || "function" == typeof t4))
            return t4;
          if (void 0 !== t4)
            throw new TypeError("Derived constructors may only return object or undefined");
          return i(e4);
        }, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3) {
        e3.exports = function(e4, t4, n2) {
          return t4 in e4 ? Object.defineProperty(e4, t4, { value: n2, enumerable: true, configurable: true, writable: true }) : e4[t4] = n2, e4;
        }, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3) {
        function n2(t4, r2) {
          return e3.exports = n2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e4, t5) {
            return e4.__proto__ = t5, e4;
          }, e3.exports.__esModule = true, e3.exports.default = e3.exports, n2(t4, r2);
        }
        e3.exports = n2, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3) {
        e3.exports = function(e4) {
          if (void 0 === e4)
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e4;
        }, e3.exports.__esModule = true, e3.exports.default = e3.exports;
      }, function(e3, t3, n2) {
        n2.r(t3), n2.d(t3, "WebSocketManager", function() {
          return ce2;
        });
        var r2 = n2(0), i = n2.n(r2), o = n2(4), s2 = "AMZ_WEB_SOCKET_MANAGER:", a2 = "Network offline", c2 = "Network online, connecting to WebSocket server", u2 = "Network offline, ignoring this getWebSocketConnConfig request", l2 = "Heartbeat response not received", p2 = "aws/ping deep heartbeat response not received", d2 = "Failed to send heartbeat since WebSocket is not open", h2 = "Failed to send aws/ping deep heartbeat since WebSocket is not open", f2 = "WebSocket connection established!", m2 = "WebSocket connection is closed", g2 = "WebSocketManager Error, error_event: ", v2 = "Scheduling WebSocket reinitialization, after delay ", y2 = "WebSocket URL cannot be used to establish connection", b2 = "WebSocket Initialization failed - Terminating and cleaning subscriptions", w2 = "Fetching new WebSocket connection configuration", E2 = "Successfully fetched webSocket connection configuration", S2 = "Failed to fetch webSocket connection configuration", C2 = "Retrying fetching new WebSocket connection configuration", T2 = "Initializing Websocket Manager", I2 = "WebSocketManager Message Error", k2 = "Message received for topic ", _2 = "Invalid incoming message", x2 = "aws/subscribe", A2 = "aws/heartbeat", R2 = "aws/ping", O2 = "disconnected", N2 = { assertTrue: function(e4, t4) {
          if (!e4)
            throw new Error(t4);
        }, assertNotNull: function(e4, t4) {
          return N2.assertTrue(null !== e4 && void 0 !== i()(e4), Object(o.sprintf)("%s must be provided", t4 || "A value")), e4;
        }, isNonEmptyString: function(e4) {
          return "string" == typeof e4 && e4.length > 0;
        }, assertIsList: function(e4, t4) {
          if (!Array.isArray(e4))
            throw new Error(t4 + " is not an array");
        }, isFunction: function(e4) {
          return !!(e4 && e4.constructor && e4.call && e4.apply);
        }, isObject: function(e4) {
          return !("object" !== i()(e4) || null === e4);
        }, isString: function(e4) {
          return "string" == typeof e4;
        }, isNumber: function(e4) {
          return "number" == typeof e4;
        } }, L2 = new RegExp("^(wss://)\\w*"), M2 = new RegExp("^(ws://127.0.0.1:)");
        N2.validWSUrl = function(e4) {
          return L2.test(e4) || M2.test(e4);
        }, N2.getSubscriptionResponse = function(e4, t4, n3) {
          return { topic: e4, content: { status: t4 ? "success" : "failure", topics: n3 } };
        }, N2.assertIsObject = function(e4, t4) {
          if (!N2.isObject(e4))
            throw new Error(t4 + " is not an object!");
        }, N2.addJitter = function(e4) {
          var t4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          t4 = Math.min(t4, 1);
          var n3 = Math.random() > 0.5 ? 1 : -1;
          return Math.floor(e4 + n3 * e4 * Math.random() * t4);
        }, N2.isNetworkOnline = function() {
          return navigator.onLine;
        }, N2.isNetworkFailure = function(e4) {
          return !(!e4._debug || !e4._debug.type) && "NetworkingError" === e4._debug.type;
        };
        var P2 = N2, D2 = n2(5), U2 = n2.n(D2), q2 = n2(6), j2 = n2.n(q2), F2 = n2(3), W2 = n2.n(F2), B2 = n2(7), z2 = n2.n(B2), H2 = n2(1), V2 = n2.n(H2), G2 = n2(2), K2 = n2.n(G2);
        function X2(e4, t4) {
          var n3 = Object.keys(e4);
          if (Object.getOwnPropertySymbols) {
            var r3 = Object.getOwnPropertySymbols(e4);
            t4 && (r3 = r3.filter(function(t5) {
              return Object.getOwnPropertyDescriptor(e4, t5).enumerable;
            })), n3.push.apply(n3, r3);
          }
          return n3;
        }
        var J2 = function() {
          function e4() {
            V2()(this, e4);
          }
          return K2()(e4, [{ key: "debug", value: function(e5) {
          } }, { key: "info", value: function(e5) {
          } }, { key: "warn", value: function(e5) {
          } }, { key: "error", value: function(e5) {
          } }, { key: "advancedLog", value: function(e5) {
          } }]), e4;
        }(), Y2 = s2, $2 = { DEBUG: 10, INFO: 20, WARN: 30, ERROR: 40, ADVANCED_LOG: 50 }, Q2 = function() {
          function e4(t4) {
            V2()(this, e4), this.logMetaData = t4 || "", this.updateLoggerConfig();
          }
          return K2()(e4, [{ key: "hasLogMetaData", value: function() {
            return !!this.logMetaData;
          } }, { key: "writeToClientLogger", value: function(e5) {
            var t4 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
            if (this.hasClientLogger()) {
              var n3 = "string" == typeof t4 ? t4 : JSON.stringify(t4, te2()), r3 = "string" == typeof this.logMetaData ? this.logMetaData : JSON.stringify(this.logMetaData, te2()), i2 = "".concat(function(e6) {
                switch (e6) {
                  case 10:
                    return "DEBUG";
                  case 20:
                    return "INFO";
                  case 30:
                    return "WARN";
                  case 40:
                    return "ERROR";
                  case 50:
                    return "ADVANCED_LOG";
                }
              }(e5), " ").concat(n3, " ").concat(r3);
              switch (e5) {
                case $2.DEBUG:
                  return this._clientLogger.debug(i2) || i2;
                case $2.INFO:
                  return this._clientLogger.info(i2) || i2;
                case $2.WARN:
                  return this._clientLogger.warn(i2) || i2;
                case $2.ERROR:
                  return this._clientLogger.error(i2) || i2;
                case $2.ADVANCED_LOG:
                  return this._advancedLogWriter ? this._clientLogger[this._advancedLogWriter](i2) || i2 : "";
              }
            }
          } }, { key: "isLevelEnabled", value: function(e5) {
            return e5 >= this._level;
          } }, { key: "hasClientLogger", value: function() {
            return null !== this._clientLogger;
          } }, { key: "getLogger", value: function() {
            var e5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t4 = e5.prefix || Y2;
            return e5.logMetaData && this.setLogMetaData(e5.logMetaData), this.logMetaData || console.info("*********Missing required option: WebSocketManager:logMetaData**********"), new ee2(this, function(e6) {
              for (var t5 = 1; t5 < arguments.length; t5++) {
                var n3 = null != arguments[t5] ? arguments[t5] : {};
                t5 % 2 ? X2(Object(n3), true).forEach(function(t6) {
                  z2()(e6, t6, n3[t6]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e6, Object.getOwnPropertyDescriptors(n3)) : X2(Object(n3)).forEach(function(t6) {
                  Object.defineProperty(e6, t6, Object.getOwnPropertyDescriptor(n3, t6));
                });
              }
              return e6;
            }({ prefix: t4, logMetaData: this.logMetaData }, e5));
          } }, { key: "setLogMetaData", value: function(e5) {
            this.logMetaData = e5;
          } }, { key: "updateLoggerConfig", value: function(e5) {
            var t4 = e5 || {};
            this._level = t4.level || $2.INFO, this._advancedLogWriter = "warn", t4.advancedLogWriter && (this._advancedLogWriter = t4.advancedLogWriter), t4.customizedLogger && "object" === i()(t4.customizedLogger) && (this.useClientLogger = true), this._clientLogger = t4.logger || this.selectLogger(t4), this._logsDestination = "NULL", t4.debug && (this._logsDestination = "DEBUG"), t4.logger && (this._logsDestination = "CLIENT_LOGGER");
          } }, { key: "selectLogger", value: function(e5) {
            return e5.customizedLogger && "object" === i()(e5.customizedLogger) ? e5.customizedLogger : e5.useDefaultLogger ? ne2() : null;
          } }]), e4;
        }(), Z2 = function() {
          function e4() {
            V2()(this, e4);
          }
          return K2()(e4, [{ key: "debug", value: function() {
          } }, { key: "info", value: function() {
          } }, { key: "warn", value: function() {
          } }, { key: "error", value: function() {
          } }, { key: "advancedLog", value: function() {
          } }]), e4;
        }(), ee2 = function(e4) {
          U2()(n3, e4);
          var t4 = function(e5) {
            var t5 = function() {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                return false;
              if (Reflect.construct.sham)
                return false;
              if ("function" == typeof Proxy)
                return true;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                })), true;
              } catch (e6) {
                return false;
              }
            }();
            return function() {
              var n4, r3 = W2()(e5);
              if (t5) {
                var i2 = W2()(this).constructor;
                n4 = Reflect.construct(r3, arguments, i2);
              } else
                n4 = r3.apply(this, arguments);
              return j2()(this, n4);
            };
          }(n3);
          function n3(e5, r3) {
            var i2;
            return V2()(this, n3), (i2 = t4.call(this)).options = r3 || {}, i2.prefix = r3.prefix || Y2, i2.logManager = e5, i2;
          }
          return K2()(n3, [{ key: "debug", value: function() {
            for (var e5 = arguments.length, t5 = new Array(e5), n4 = 0; n4 < e5; n4++)
              t5[n4] = arguments[n4];
            return this._log($2.DEBUG, t5);
          } }, { key: "info", value: function() {
            for (var e5 = arguments.length, t5 = new Array(e5), n4 = 0; n4 < e5; n4++)
              t5[n4] = arguments[n4];
            return this._log($2.INFO, t5);
          } }, { key: "warn", value: function() {
            for (var e5 = arguments.length, t5 = new Array(e5), n4 = 0; n4 < e5; n4++)
              t5[n4] = arguments[n4];
            return this._log($2.WARN, t5);
          } }, { key: "error", value: function() {
            for (var e5 = arguments.length, t5 = new Array(e5), n4 = 0; n4 < e5; n4++)
              t5[n4] = arguments[n4];
            return this._log($2.ERROR, t5);
          } }, { key: "advancedLog", value: function() {
            for (var e5 = arguments.length, t5 = new Array(e5), n4 = 0; n4 < e5; n4++)
              t5[n4] = arguments[n4];
            return this._log($2.ADVANCED_LOG, t5);
          } }, { key: "_shouldLog", value: function(e5) {
            return this.logManager.hasClientLogger() && this.logManager.isLevelEnabled(e5);
          } }, { key: "_writeToClientLogger", value: function(e5, t5) {
            return this.logManager.writeToClientLogger(e5, t5);
          } }, { key: "_log", value: function(e5, t5) {
            if (this._shouldLog(e5)) {
              var n4 = this.logManager.useClientLogger ? t5 : this._convertToSingleStatement(t5);
              return this._writeToClientLogger(e5, n4);
            }
          } }, { key: "_convertToSingleStatement", value: function(e5) {
            var t5 = new Date(Date.now()).toISOString(), n4 = "[".concat(t5, "]");
            this.prefix && (n4 += this.prefix + " "), this.options && (this.options.prefix ? n4 += " " + this.options.prefix + ":" : n4 += "");
            for (var r3 = 0; r3 < e5.length; r3++) {
              var i2 = e5[r3];
              n4 += this._convertToString(i2) + " ";
            }
            return n4;
          } }, { key: "_convertToString", value: function(e5) {
            try {
              if (!e5)
                return "";
              if (P2.isString(e5))
                return e5;
              if (P2.isObject(e5) && P2.isFunction(e5.toString)) {
                var t5 = e5.toString();
                if ("[object Object]" !== t5)
                  return t5;
              }
              return JSON.stringify(e5);
            } catch (t6) {
              return console.error("Error while converting argument to string", e5, t6), "";
            }
          } }]), n3;
        }(Z2);
        function te2() {
          var e4 = /* @__PURE__ */ new WeakSet();
          return function(t4, n3) {
            if ("object" === i()(n3) && null !== n3) {
              if (e4.has(n3))
                return;
              e4.add(n3);
            }
            return n3;
          };
        }
        var ne2 = function() {
          var e4 = new Z2();
          return e4.debug = function() {
            for (var e5 = arguments.length, t4 = new Array(e5), n3 = 0; n3 < e5; n3++)
              t4[n3] = arguments[n3];
            return console.debug.apply(window.console, [].concat(t4));
          }, e4.info = function() {
            for (var e5 = arguments.length, t4 = new Array(e5), n3 = 0; n3 < e5; n3++)
              t4[n3] = arguments[n3];
            return console.info.apply(window.console, [].concat(t4));
          }, e4.warn = function() {
            for (var e5 = arguments.length, t4 = new Array(e5), n3 = 0; n3 < e5; n3++)
              t4[n3] = arguments[n3];
            return console.warn.apply(window.console, [].concat(t4));
          }, e4.error = function() {
            for (var e5 = arguments.length, t4 = new Array(e5), n3 = 0; n3 < e5; n3++)
              t4[n3] = arguments[n3];
            return console.error.apply(window.console, [].concat(t4));
          }, e4;
        }, re2 = function() {
          function e4(t4) {
            var n3 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2e3;
            V2()(this, e4), this.numAttempts = 0, this.executor = t4, this.hasActiveReconnection = false, this.defaultRetry = n3;
          }
          return K2()(e4, [{ key: "retry", value: function() {
            var e5 = this;
            this.hasActiveReconnection || (this.hasActiveReconnection = true, setTimeout(function() {
              e5._execute();
            }, this._getDelay()));
          } }, { key: "_execute", value: function() {
            this.hasActiveReconnection = false, this.executor(), this.numAttempts++;
          } }, { key: "connected", value: function() {
            this.numAttempts = 0;
          } }, { key: "_getDelay", value: function() {
            var e5 = Math.pow(2, this.numAttempts) * this.defaultRetry;
            return e5 <= 3e4 ? e5 : 3e4;
          } }, { key: "getIsConnected", value: function() {
            return !this.numAttempts;
          } }]), e4;
        }(), ie2 = null, se2 = function() {
          var e4 = false, t4 = ie2.getLogger({ prefix: s2 }), n3 = P2.isNetworkOnline(), r3 = { primary: null, secondary: null }, i2 = { reconnectWebSocket: true, websocketInitFailed: false, exponentialBackOffTime: 1e3, exponentialTimeoutHandle: null, lifeTimeTimeoutHandle: null, webSocketInitCheckerTimeoutId: null, connState: null }, o2 = { connectWebSocketRetryCount: 0, connectionAttemptStartTime: null, noOpenConnectionsTimestamp: null }, N3 = { pendingResponse: false, intervalHandle: null }, L3 = { pendingResponse: false, intervalHandle: null }, M3 = { initFailure: /* @__PURE__ */ new Set(), getWebSocketTransport: null, subscriptionUpdate: /* @__PURE__ */ new Set(), subscriptionFailure: /* @__PURE__ */ new Set(), topic: /* @__PURE__ */ new Map(), allMessage: /* @__PURE__ */ new Set(), connectionGain: /* @__PURE__ */ new Set(), connectionLost: /* @__PURE__ */ new Set(), connectionOpen: /* @__PURE__ */ new Set(), connectionClose: /* @__PURE__ */ new Set(), deepHeartbeatSuccess: /* @__PURE__ */ new Set(), deepHeartbeatFailure: /* @__PURE__ */ new Set(), topicFailure: /* @__PURE__ */ new Set() }, D3 = { connConfig: null, promiseHandle: null, promiseCompleted: true }, U3 = { subscribed: /* @__PURE__ */ new Set(), pending: /* @__PURE__ */ new Set(), subscriptionHistory: /* @__PURE__ */ new Set() }, q3 = { responseCheckIntervalId: null, requestCompleted: true, reSubscribeIntervalId: null, consecutiveFailedSubscribeAttempts: 0, consecutiveNoResponseRequest: 0 }, j3 = new re2(function() {
            pe2();
          }), F3 = /* @__PURE__ */ new Set([x2, "aws/unsubscribe", A2, R2]), W3 = setInterval(function() {
            if (n3 !== P2.isNetworkOnline()) {
              if (!(n3 = P2.isNetworkOnline()))
                return t4.advancedLog(a2), void fe2(t4.info(a2));
              var e5 = X3();
              n3 && (!e5 || V3(e5, WebSocket.CLOSING) || V3(e5, WebSocket.CLOSED)) && (t4.advancedLog(c2), fe2(t4.info(c2)), pe2());
            }
          }, 250), B3 = function(e5, n4) {
            e5.forEach(function(e6) {
              try {
                e6(n4);
              } catch (e7) {
                fe2(t4.error("Error executing callback", e7));
              }
            });
          }, z3 = function(e5) {
            if (null === e5)
              return "NULL";
            switch (e5.readyState) {
              case WebSocket.CONNECTING:
                return "CONNECTING";
              case WebSocket.OPEN:
                return "OPEN";
              case WebSocket.CLOSING:
                return "CLOSING";
              case WebSocket.CLOSED:
                return "CLOSED";
              default:
                return "UNDEFINED";
            }
          }, H3 = function() {
            var e5 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            fe2(t4.debug("[" + e5 + "] Primary WebSocket: " + z3(r3.primary) + " | Secondary WebSocket: " + z3(r3.secondary)));
          }, V3 = function(e5, t5) {
            return e5 && e5.readyState === t5;
          }, G3 = function(e5) {
            return V3(e5, WebSocket.OPEN);
          }, K3 = function(e5) {
            return null === e5 || void 0 === e5.readyState || V3(e5, WebSocket.CLOSED);
          }, X3 = function() {
            return null !== r3.secondary ? r3.secondary : r3.primary;
          }, J3 = function() {
            return G3(X3());
          }, Y3 = function() {
            if (e4 && L3.pendingResponse && (t4.advancedLog(p2), fe2(t4.warn(p2)), B3(M3.deepHeartbeatFailure, { timestamp: Date.now(), error: "aws/ping response is not received" }), clearInterval(L3.intervalHandle), L3.pendingResponse = false), N3.pendingResponse)
              return t4.advancedLog(l2), fe2(t4.warn(l2)), clearInterval(N3.intervalHandle), N3.intervalHandle = null, N3.pendingResponse = false, void pe2();
            J3() ? (e4 && (fe2(t4.debug("Sending aws/ping deep heartbeat")), X3().send(ue2(R2)), L3.pendingResponse = true), fe2(t4.debug("Sending heartbeat")), X3().send(ue2(A2)), N3.pendingResponse = true) : (e4 && (t4.advancedLog(h2), fe2(t4.warn(h2)), B3(M3.deepHeartbeatFailure, { timestamp: Date.now(), error: "Unable to send message to aws/ping because websocket connection is not established." })), t4.advancedLog(d2), fe2(t4.warn(d2)), H3("sendHeartBeat"), pe2());
          }, $3 = function() {
            t4.advancedLog("Reset Websocket state"), i2.exponentialBackOffTime = 1e3, N3.pendingResponse = false, L3.pendingResponse = false, i2.reconnectWebSocket = true, clearTimeout(i2.lifeTimeTimeoutHandle), clearInterval(N3.intervalHandle), clearInterval(L3.intervalHandle), clearTimeout(i2.exponentialTimeoutHandle), clearTimeout(i2.webSocketInitCheckerTimeoutId), N3.intervalHandle = null;
          }, Q3 = function() {
            q3.consecutiveFailedSubscribeAttempts = 0, q3.consecutiveNoResponseRequest = 0, clearInterval(q3.responseCheckIntervalId), clearInterval(q3.reSubscribeIntervalId);
          }, Z3 = function() {
            o2.connectWebSocketRetryCount = 0, o2.connectionAttemptStartTime = null, o2.noOpenConnectionsTimestamp = null;
          }, ee3 = function() {
            j3.connected();
            try {
              t4.advancedLog(f2), fe2(t4.info(f2)), H3("webSocketOnOpen"), null !== i2.connState && i2.connState !== O2 || B3(M3.connectionGain), i2.connState = "connected";
              var e5 = Date.now();
              B3(M3.connectionOpen, { connectWebSocketRetryCount: o2.connectWebSocketRetryCount, connectionAttemptStartTime: o2.connectionAttemptStartTime, noOpenConnectionsTimestamp: o2.noOpenConnectionsTimestamp, connectionEstablishedTime: e5, timeToConnect: e5 - o2.connectionAttemptStartTime, timeWithoutConnection: o2.noOpenConnectionsTimestamp ? e5 - o2.noOpenConnectionsTimestamp : null }), Z3(), $3(), X3().openTimestamp = Date.now(), 0 === U3.subscribed.size && G3(r3.secondary) && se3(r3.primary, "[Primary WebSocket] Closing WebSocket"), (U3.subscribed.size > 0 || U3.pending.size > 0) && (G3(r3.secondary) && fe2(t4.info("Subscribing secondary websocket to topics of primary websocket")), U3.subscribed.forEach(function(e6) {
                U3.subscriptionHistory.add(e6), U3.pending.add(e6);
              }), U3.subscribed.clear(), oe2()), Y3(), null !== N3.intervalHandle && clearInterval(N3.intervalHandle), N3.intervalHandle = setInterval(Y3, 1e4);
              var n4 = 1e3 * D3.connConfig.webSocketTransport.transportLifeTimeInSeconds;
              fe2(t4.debug("Scheduling WebSocket manager reconnection, after delay " + n4 + " ms")), i2.lifeTimeTimeoutHandle = setTimeout(function() {
                fe2(t4.debug("Starting scheduled WebSocket manager reconnection")), pe2();
              }, n4);
            } catch (e6) {
              fe2(t4.error("Error after establishing WebSocket connection", e6));
            }
          }, te3 = function(e5) {
            H3("webSocketOnError"), t4.advancedLog(g2, JSON.stringify(e5)), fe2(t4.error(g2, JSON.stringify(e5))), j3.getIsConnected() ? pe2() : j3.retry();
          }, ne3 = function(e5) {
            var n4 = JSON.parse(e5.data);
            switch (n4.topic) {
              case x2:
                if (fe2(t4.debug("Subscription Message received from webSocket server", e5.data)), q3.requestCompleted = true, q3.consecutiveNoResponseRequest = 0, "success" === n4.content.status)
                  q3.consecutiveFailedSubscribeAttempts = 0, n4.content.topics.forEach(function(e6) {
                    U3.subscriptionHistory.delete(e6), U3.pending.delete(e6), U3.subscribed.add(e6);
                  }), 0 === U3.subscriptionHistory.size ? G3(r3.secondary) && (fe2(t4.info("Successfully subscribed secondary websocket to all topics of primary websocket")), se3(r3.primary, "[Primary WebSocket] Closing WebSocket")) : oe2(), B3(M3.subscriptionUpdate, n4);
                else {
                  if (clearInterval(q3.reSubscribeIntervalId), ++q3.consecutiveFailedSubscribeAttempts, 5 === q3.consecutiveFailedSubscribeAttempts)
                    return B3(M3.subscriptionFailure, n4), void (q3.consecutiveFailedSubscribeAttempts = 0);
                  q3.reSubscribeIntervalId = setInterval(function() {
                    oe2();
                  }, 500);
                }
                break;
              case A2:
                fe2(t4.debug("Heartbeat response received")), N3.pendingResponse = false, null === N3.intervalHandle && (N3.intervalHandle = setInterval(Y3, 1e4));
                break;
              case R2:
                fe2(t4.debug("aws/ping deep heartbeat received")), L3.pendingResponse = false, 200 === n4.statusCode ? B3(M3.deepHeartbeatSuccess, { timestamp: Date.now() }) : B3(M3.deepHeartbeatFailure, { timestamp: Date.now(), statusCode: n4.statusCode, statusContent: n4.statusContent });
                break;
              default:
                if (n4.topic) {
                  if (t4.advancedLog(k2, n4.topic), fe2(t4.debug(k2 + n4.topic)), G3(r3.primary) && G3(r3.secondary) && 0 === U3.subscriptionHistory.size && this === r3.primary)
                    return void fe2(t4.warn("Ignoring Message for Topic " + n4.topic + ", to avoid duplicates"));
                  if (0 === M3.allMessage.size && 0 === M3.topic.size)
                    return void fe2(t4.warn("No registered callback listener for Topic", n4.topic));
                  t4.advancedLog("WebsocketManager invoke callbacks for topic success ", n4.topic), B3(M3.allMessage, n4), M3.topic.has(n4.topic) && B3(M3.topic.get(n4.topic), n4);
                } else
                  n4.message ? (t4.advancedLog(I2, n4), fe2(t4.warn(I2, n4)), B3(M3.topicFailure, { timestamp: Date.now(), errorMessage: n4.message, connectionId: n4.connectionId, requestId: n4.requestId })) : (t4.advancedLog(_2, n4), fe2(t4.warn(_2, n4)));
            }
          }, oe2 = function e5() {
            if (q3.consecutiveNoResponseRequest > 3)
              return fe2(t4.warn("Ignoring subscribePendingTopics since we have exhausted max subscription retries with no response")), void B3(M3.subscriptionFailure, P2.getSubscriptionResponse(x2, false, Array.from(U3.pending)));
            J3() ? 0 !== Array.from(U3.pending).length && (clearInterval(q3.responseCheckIntervalId), X3().send(ue2(x2, { topics: Array.from(U3.pending) })), q3.requestCompleted = false, q3.responseCheckIntervalId = setInterval(function() {
              q3.requestCompleted || (++q3.consecutiveNoResponseRequest, e5());
            }, 1e3)) : fe2(t4.warn("Ignoring subscribePendingTopics call since Default WebSocket is not open"));
          }, se3 = function(e5, n4) {
            V3(e5, WebSocket.CONNECTING) || V3(e5, WebSocket.OPEN) ? e5.close(1e3, n4) : fe2(t4.warn("Ignoring WebSocket Close request, WebSocket State: " + z3(e5)));
          }, ae3 = function(e5) {
            se3(r3.primary, "[Primary] WebSocket " + e5), se3(r3.secondary, "[Secondary] WebSocket " + e5);
          }, ce3 = function(e5) {
            $3(), Q3(), t4.advancedLog(b2, e5), fe2(t4.error(b2)), i2.websocketInitFailed = true, ae3("Terminating WebSocket Manager"), clearInterval(W3), B3(M3.initFailure, { connectWebSocketRetryCount: o2.connectWebSocketRetryCount, connectionAttemptStartTime: o2.connectionAttemptStartTime, reason: e5 }), Z3();
          }, ue2 = function(e5, t5) {
            return JSON.stringify({ topic: e5, content: t5 });
          }, le2 = function(e5) {
            return !!(P2.isObject(e5) && P2.isObject(e5.webSocketTransport) && P2.isNonEmptyString(e5.webSocketTransport.url) && P2.validWSUrl(e5.webSocketTransport.url) && 1e3 * e5.webSocketTransport.transportLifeTimeInSeconds >= 3e5) || (fe2(t4.error("Invalid WebSocket Connection Configuration", e5)), false);
          }, pe2 = function() {
            if (!P2.isNetworkOnline())
              return t4.advancedLog(u2), void fe2(t4.info(u2));
            if (i2.websocketInitFailed)
              fe2(t4.debug("WebSocket Init had failed, ignoring this getWebSocketConnConfig request"));
            else {
              if (D3.promiseCompleted)
                return $3(), t4.advancedLog(w2), fe2(t4.info(w2)), o2.connectionAttemptStartTime = o2.connectionAttemptStartTime || Date.now(), D3.promiseCompleted = false, D3.promiseHandle = M3.getWebSocketTransport(), D3.promiseHandle.then(function(e5) {
                  return D3.promiseCompleted = true, t4.advancedLog(E2), fe2(t4.debug(E2, e5)), le2(e5) ? (D3.connConfig = e5, D3.connConfig.urlConnValidTime = Date.now() + 85e3, de2()) : (ce3("Invalid WebSocket connection configuration: " + e5), { webSocketConnectionFailed: true });
                }, function(e5) {
                  return D3.promiseCompleted = true, t4.advancedLog(S2), fe2(t4.error(S2, e5)), P2.isNetworkFailure(e5) ? (t4.advancedLog(C2 + JSON.stringify(e5)), fe2(t4.info(C2 + JSON.stringify(e5))), j3.retry()) : ce3("Failed to fetch webSocket connection configuration: " + JSON.stringify(e5)), { webSocketConnectionFailed: true };
                });
              fe2(t4.debug("There is an ongoing getWebSocketConnConfig request, this request will be ignored"));
            }
          }, de2 = function() {
            if (i2.websocketInitFailed)
              return fe2(t4.info("web-socket initializing had failed, aborting re-init")), { webSocketConnectionFailed: true };
            if (!P2.isNetworkOnline())
              return fe2(t4.warn("System is offline aborting web-socket init")), { webSocketConnectionFailed: true };
            t4.advancedLog(T2), fe2(t4.info(T2)), H3("initWebSocket");
            try {
              if (le2(D3.connConfig)) {
                var e5 = null;
                return G3(r3.primary) ? (fe2(t4.debug("Primary Socket connection is already open")), V3(r3.secondary, WebSocket.CONNECTING) || (fe2(t4.debug("Establishing a secondary web-socket connection")), j3.numAttempts = 0, r3.secondary = he2()), e5 = r3.secondary) : (V3(r3.primary, WebSocket.CONNECTING) || (fe2(t4.debug("Establishing a primary web-socket connection")), r3.primary = he2()), e5 = r3.primary), i2.webSocketInitCheckerTimeoutId = setTimeout(function() {
                  G3(e5) || function() {
                    o2.connectWebSocketRetryCount++;
                    var e6 = P2.addJitter(i2.exponentialBackOffTime, 0.3);
                    Date.now() + e6 <= D3.connConfig.urlConnValidTime ? (t4.advancedLog(v2), fe2(t4.debug(v2 + e6 + " ms")), i2.exponentialTimeoutHandle = setTimeout(function() {
                      return de2();
                    }, e6), i2.exponentialBackOffTime *= 2) : (t4.advancedLog(y2), fe2(t4.warn(y2)), pe2());
                  }();
                }, 1e3), { webSocketConnectionFailed: false };
              }
            } catch (e6) {
              return fe2(t4.error("Error Initializing web-socket-manager", e6)), ce3("Failed to initialize new WebSocket: " + e6.message), { webSocketConnectionFailed: true };
            }
          }, he2 = function() {
            var e5 = new WebSocket(D3.connConfig.webSocketTransport.url);
            return e5.addEventListener("open", ee3), e5.addEventListener("message", ne3), e5.addEventListener("error", te3), e5.addEventListener("close", function(n4) {
              return function(e6, n5) {
                t4.advancedLog(m2, JSON.stringify(e6)), fe2(t4.info(m2, JSON.stringify(e6))), H3("webSocketOnClose before-cleanup"), B3(M3.connectionClose, { openTimestamp: n5.openTimestamp, closeTimestamp: Date.now(), connectionDuration: Date.now() - n5.openTimestamp, code: e6.code, reason: e6.reason }), K3(r3.primary) && (r3.primary = null), K3(r3.secondary) && (r3.secondary = null), i2.reconnectWebSocket && (G3(r3.primary) || G3(r3.secondary) ? K3(r3.primary) && G3(r3.secondary) && (fe2(t4.info("[Primary] WebSocket Cleanly Closed")), r3.primary = r3.secondary, r3.secondary = null) : (fe2(t4.warn("Neither primary websocket and nor secondary websocket have open connections, attempting to re-establish connection")), i2.connState === O2 ? fe2(t4.info("Ignoring connectionLost callback invocation")) : (B3(M3.connectionLost, { openTimestamp: n5.openTimestamp, closeTimestamp: Date.now(), connectionDuration: Date.now() - n5.openTimestamp, code: e6.code, reason: e6.reason }), o2.noOpenConnectionsTimestamp = Date.now()), i2.connState = O2, pe2()), H3("webSocketOnClose after-cleanup"));
              }(n4, e5);
            }), e5;
          }, fe2 = function(e5) {
            return e5 && "function" == typeof e5.sendInternalLogToServer && e5.sendInternalLogToServer(), e5;
          };
          this.init = function(e5) {
            if (P2.assertTrue(P2.isFunction(e5), "transportHandle must be a function"), null === M3.getWebSocketTransport)
              return M3.getWebSocketTransport = e5, pe2();
            fe2(t4.warn("Web Socket Manager was already initialized"));
          }, this.onInitFailure = function(e5) {
            return t4.advancedLog("Initializing Websocket Manager Failure callback registered"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.initFailure.add(e5), i2.websocketInitFailed && e5(), function() {
              return M3.initFailure.delete(e5);
            };
          }, this.onConnectionOpen = function(e5) {
            return t4.advancedLog("Websocket connection open callback registered"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.connectionOpen.add(e5), function() {
              return M3.connectionOpen.delete(e5);
            };
          }, this.onConnectionClose = function(e5) {
            return t4.advancedLog("Websocket connection close callback registered"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.connectionClose.add(e5), function() {
              return M3.connectionClose.delete(e5);
            };
          }, this.onConnectionGain = function(e5) {
            return t4.advancedLog("Websocket connection gain callback registered"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.connectionGain.add(e5), J3() && e5(), function() {
              return M3.connectionGain.delete(e5);
            };
          }, this.onConnectionLost = function(e5) {
            return t4.advancedLog("Websocket connection lost callback registered"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.connectionLost.add(e5), i2.connState === O2 && e5(), function() {
              return M3.connectionLost.delete(e5);
            };
          }, this.onSubscriptionUpdate = function(e5) {
            return P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.subscriptionUpdate.add(e5), function() {
              return M3.subscriptionUpdate.delete(e5);
            };
          }, this.onSubscriptionFailure = function(e5) {
            return t4.advancedLog("Websocket subscription failure callback registered"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.subscriptionFailure.add(e5), function() {
              return M3.subscriptionFailure.delete(e5);
            };
          }, this.onMessage = function(e5, t5) {
            return P2.assertNotNull(e5, "topicName"), P2.assertTrue(P2.isFunction(t5), "cb must be a function"), M3.topic.has(e5) ? M3.topic.get(e5).add(t5) : M3.topic.set(e5, /* @__PURE__ */ new Set([t5])), function() {
              return M3.topic.get(e5).delete(t5);
            };
          }, this.onAllMessage = function(e5) {
            return P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.allMessage.add(e5), function() {
              return M3.allMessage.delete(e5);
            };
          }, this.subscribeTopics = function(e5) {
            P2.assertNotNull(e5, "topics"), P2.assertIsList(e5), e5.forEach(function(e6) {
              U3.subscribed.has(e6) || U3.pending.add(e6);
            }), q3.consecutiveNoResponseRequest = 0, oe2();
          }, this.sendMessage = function(e5) {
            if (P2.assertIsObject(e5, "payload"), void 0 === e5.topic || F3.has(e5.topic))
              fe2(t4.warn("Cannot send message, Invalid topic", e5));
            else {
              try {
                e5 = JSON.stringify(e5);
              } catch (n4) {
                return void fe2(t4.warn("Error stringify message", e5));
              }
              J3() ? X3().send(e5) : fe2(t4.warn("Cannot send message, web socket connection is not open"));
            }
          }, this.deepHeartbeatHandler = function() {
            e4 = true;
          }, this.onDeepHeartbeatSuccess = function(e5) {
            return t4.advancedLog("Deep Heartbeat is successful. WebSocketManager has received 200 response from aws/ping"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.deepHeartbeatSuccess.add(e5), function() {
              return M3.deepHeartbeatSuccess.delete(e5);
            };
          }, this.onDeepHeartbeatFailure = function(e5) {
            return t4.advancedLog("Deep Heartbeat failed. WebSocketManager does not receive 200 response from aws/ping"), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.deepHeartbeatFailure.add(e5), function() {
              return M3.deepHeartbeatFailure.delete(e5);
            };
          }, this.onTopicFailure = function(e5) {
            return t4.advancedLog("Generic topic failed."), P2.assertTrue(P2.isFunction(e5), "cb must be a function"), M3.topicFailure.add(e5), function() {
              return M3.topicFailure.delete(e5);
            };
          }, this.closeWebSocket = function() {
            $3(), Q3(), i2.reconnectWebSocket = false, clearInterval(W3), ae3("User request to close WebSocket");
          }, this.terminateWebSocketManager = ce3;
        }, ae2 = { create: function(e4) {
          return ie2 || (ie2 = new Q2(e4)), ie2.hasLogMetaData() || ie2.setLogMetaData(e4), e4 || console.info("********Missing metaData for logs from websocketManager: initialize websocketManager using create(metaData)*******"), new se2();
        }, setGlobalConfig: function(e4) {
          var t4 = e4 && e4.loggerConfig;
          ie2 || (ie2 = new Q2()), ie2.updateLoggerConfig(t4);
          var n3 = e4 && e4.webSocketManagerConfig, r3 = n3 && n3.isNetworkOnline;
          r3 && "function" == typeof r3 && (P2.isNetworkOnline = r3);
        }, LogLevel: $2, Logger: J2 };
        oe.connect = oe.connect || {}, connect.WebSocketManager = ae2;
        var ce2 = ae2;
        t3.default = ce2;
      }]);
      var ae = connect.WebSocketManager;
      connect.WebSocketManager = se || ae;
      const ce = ae;
      class ue extends Y {
        constructor(e3, t3, n2, r2, i, o) {
          super(n2, i), this.customerConnection = !r2, this.customerConnection ? (ue.customerBaseInstances[e3] || (ue.customerBaseInstances[e3] = new le(n2, void 0, i, o)), this.baseInstance = ue.customerBaseInstances[e3]) : (ue.agentBaseInstance && ue.agentBaseInstance.getWebsocketManager() !== r2 && (ue.agentBaseInstance.end(), ue.agentBaseInstance = null), ue.agentBaseInstance || (ue.agentBaseInstance = new le(void 0, r2, i)), this.baseInstance = ue.agentBaseInstance), this.contactId = e3, this.initialContactId = t3, this.status = null, this.eventBus = new ee(), this.subscriptions = [this.baseInstance.onEnded(this.handleEnded.bind(this)), this.baseInstance.onConnectionGain(this.handleConnectionGain.bind(this)), this.baseInstance.onConnectionLost(this.handleConnectionLost.bind(this)), this.baseInstance.onMessage(this.handleMessage.bind(this))];
        }
        start() {
          return super.start(), this.baseInstance.start();
        }
        end() {
          super.end(), this.eventBus.unsubscribeAll(), this.subscriptions.forEach((e3) => e3()), this.status = V, this.tryCleanup();
        }
        tryCleanup() {
          this.customerConnection && !this.baseInstance.hasMessageSubscribers() && (this.baseInstance.end(), delete ue.customerBaseInstances[this.contactId]);
        }
        getStatus() {
          return this.status || this.baseInstance.getStatus();
        }
        onEnded(e3) {
          return this.eventBus.subscribe(X, e3);
        }
        handleEnded() {
          this.eventBus.trigger(X, {});
        }
        onConnectionGain(e3) {
          return this.eventBus.subscribe(K, e3);
        }
        handleConnectionGain() {
          this.eventBus.trigger(K, {});
        }
        onConnectionLost(e3) {
          return this.eventBus.subscribe(G, e3);
        }
        handleConnectionLost() {
          this.eventBus.trigger(G, {});
        }
        onMessage(e3) {
          return this.eventBus.subscribe(J, e3);
        }
        handleMessage(e3) {
          e3.InitialContactId !== this.initialContactId && e3.ContactId !== this.contactId && e3.Type !== y.MESSAGE_METADATA || this.eventBus.trigger(J, e3);
        }
      }
      ue.customerBaseInstances = {}, ue.agentBaseInstance = null;
      class le {
        constructor(e3, t3, n2, r2) {
          this.status = W, this.eventBus = new ee(), this.logger = k.getLogger({ prefix: "ChatJS-LPCConnectionHelperBase", logMetaData: n2 }), this.initialConnectionDetails = r2, this.initWebsocketManager(t3, e3, n2);
        }
        initWebsocketManager(e3, t3, n2) {
          if (this.websocketManager = e3 || ce.create(n2), this.websocketManager.subscribeTopics(["aws/chat"]), this.subscriptions = [this.websocketManager.onMessage("aws/chat", this.handleMessage.bind(this)), this.websocketManager.onConnectionGain(this.handleConnectionGain.bind(this)), this.websocketManager.onConnectionLost(this.handleConnectionLost.bind(this)), this.websocketManager.onInitFailure(this.handleEnded.bind(this))], this.logger.info("Initializing websocket manager."), !e3) {
            var r2 = (/* @__PURE__ */ new Date()).getTime();
            this.websocketManager.init(() => this._getConnectionDetails(t3, this.initialConnectionDetails, r2).then((e4) => (this.initialConnectionDetails = null, e4)));
          }
        }
        _getConnectionDetails(e3, t3, n2) {
          if (null !== t3 && "object" == typeof t3 && t3.expiry && t3.connectionTokenExpiry) {
            var r2 = { expiry: t3.expiry, transportLifeTimeInSeconds: E };
            return this.logger.debug("Websocket manager initialized. Connection details:", r2), Promise.resolve({ webSocketTransport: { url: t3.url, expiry: t3.expiry, transportLifeTimeInSeconds: E } });
          }
          return e3.fetchConnectionDetails().then((e4) => {
            var t4 = { webSocketTransport: { url: e4.url, expiry: e4.expiry, transportLifeTimeInSeconds: E } }, r3 = { expiry: e4.expiry, transportLifeTimeInSeconds: E };
            return this.logger.debug("Websocket manager initialized. Connection details:", r3), this._addWebsocketInitCSMMetric(n2), t4;
          }).catch((e4) => {
            throw this.logger.error("Initializing Websocket Manager failed:", e4), this._addWebsocketInitCSMMetric(n2, true), e4;
          });
        }
        _addWebsocketInitCSMMetric(e3) {
          var t3 = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          ne.addLatencyMetric(v, e3, u), ne.addCountAndErrorMetric(v, u, t3);
        }
        end() {
          this.websocketManager.closeWebSocket && this.websocketManager.closeWebSocket(), this.eventBus.unsubscribeAll(), this.subscriptions.forEach((e3) => e3()), this.logger.info("Websocket closed. All event subscriptions are cleared.");
        }
        start() {
          return this.status === W && (this.status = B), Promise.resolve({ websocketStatus: this.status });
        }
        onEnded(e3) {
          return this.eventBus.subscribe(X, e3);
        }
        handleEnded() {
          this.status = V, this.eventBus.trigger(X, {}), ne.addCountMetric("WebsocketEnded", u), this.logger.info("Websocket connection ended.");
        }
        onConnectionGain(e3) {
          return this.eventBus.subscribe(K, e3);
        }
        handleConnectionGain() {
          this.status = z, this.eventBus.trigger(K, {}), ne.addCountMetric("WebsocketConnectionGained", u), this.logger.info("Websocket connection gained.");
        }
        onConnectionLost(e3) {
          return this.eventBus.subscribe(G, e3);
        }
        handleConnectionLost() {
          this.status = H, this.eventBus.trigger(G, {}), ne.addCountMetric("WebsocketConnectionLost", u), this.logger.info("Websocket connection lost.");
        }
        onMessage(e3) {
          return this.eventBus.subscribe(J, e3);
        }
        handleMessage(e3) {
          var t3;
          try {
            t3 = JSON.parse(e3.content), this.eventBus.trigger(J, t3), ne.addCountMetric("WebsocketIncomingMessage", u), this.logger.info("this.eventBus trigger Websocket incoming message", J, t3);
          } catch (e4) {
            this._sendInternalLogToServer(this.logger.error("Wrong message format"));
          }
        }
        getStatus() {
          return this.status;
        }
        getWebsocketManager() {
          return this.websocketManager;
        }
        hasMessageSubscribers() {
          return this.eventBus.getSubscriptions(J).length > 0;
        }
        _sendInternalLogToServer(e3) {
          return e3 && "function" == typeof e3.sendInternalLogToServer && e3.sendInternalLogToServer(), e3;
        }
      }
      const pe = ue;
      function de(e3, t3) {
        var n2 = Object.keys(e3);
        if (Object.getOwnPropertySymbols) {
          var r2 = Object.getOwnPropertySymbols(e3);
          t3 && (r2 = r2.filter(function(t4) {
            return Object.getOwnPropertyDescriptor(e3, t4).enumerable;
          })), n2.push.apply(n2, r2);
        }
        return n2;
      }
      function he(e3, t3, n2) {
        return (t3 = function(e4) {
          var t4 = function(e5, t5) {
            if ("object" != typeof e5 || null === e5)
              return e5;
            var n3 = e5[Symbol.toPrimitive];
            if (void 0 !== n3) {
              var r2 = n3.call(e5, "string");
              if ("object" != typeof r2)
                return r2;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(e5);
          }(e4);
          return "symbol" == typeof t4 ? t4 : String(t4);
        }(t3)) in e3 ? Object.defineProperty(e3, t3, { value: n2, enumerable: true, configurable: true, writable: true }) : e3[t3] = n2, e3;
      }
      class fe {
        constructor(e3) {
          this.logger = k.getLogger({ prefix: "ChatJS-MessageReceiptUtil", logMetaData: e3 }), this.timeout = null, this.timeoutId = null, this.readSet = /* @__PURE__ */ new Set(), this.deliveredSet = /* @__PURE__ */ new Set(), this.readPromiseMap = /* @__PURE__ */ new Map(), this.deliveredPromiseMap = /* @__PURE__ */ new Map(), this.lastReadArgs = null, this.throttleInitialEventsToPrioritizeRead = null, this.throttleSendEventApiCall = null;
        }
        isMessageReceipt(e3, t3) {
          return -1 !== [y.INCOMING_READ_RECEIPT, y.INCOMING_DELIVERED_RECEIPT].indexOf(e3) || t3.Type === y.MESSAGE_METADATA;
        }
        getEventTypeFromMessageMetaData(e3) {
          return Array.isArray(e3.Receipts) && e3.Receipts[0] && e3.Receipts[0].ReadTimestamp ? y.INCOMING_READ_RECEIPT : e3.Receipts[0].DeliveredTimestamp ? y.INCOMING_DELIVERED_RECEIPT : null;
        }
        shouldShowMessageReceiptForCurrentParticipantId(e3, t3) {
          return e3 !== (t3.MessageMetadata && Array.isArray(t3.MessageMetadata.Receipts) && t3.MessageMetadata.Receipts[0] && t3.MessageMetadata.Receipts[0].RecipientParticipantId);
        }
        prioritizeAndSendMessageReceipt(e3, t3) {
          for (var n2 = arguments.length, r2 = new Array(n2 > 2 ? n2 - 2 : 0), i = 2; i < n2; i++)
            r2[i - 2] = arguments[i];
          try {
            var o, s2, a2 = this, c2 = r2[3], u2 = "string" == typeof r2[2] ? JSON.parse(r2[2]) : r2[2], l2 = "object" == typeof u2 ? u2.messageId : "";
            if (a2.readSet.has(l2) || c2 === y.INCOMING_DELIVERED_RECEIPT && a2.deliveredSet.has(l2) || !l2)
              return this.logger.info("Event already fired ".concat(l2, ": sending messageReceipt ").concat(c2)), Promise.resolve({ message: "Event already fired" });
            var p2 = new Promise(function(e4, t4) {
              o = e4, s2 = t4;
            });
            return c2 === y.INCOMING_DELIVERED_RECEIPT ? a2.deliveredPromiseMap.set(l2, [o, s2]) : a2.readPromiseMap.set(l2, [o, s2]), a2.throttleInitialEventsToPrioritizeRead = function() {
              return c2 === y.INCOMING_DELIVERED_RECEIPT && (a2.deliveredSet.add(l2), a2.readSet.has(l2)) ? (a2.resolveDeliveredPromises(l2, "Event already fired"), o({ message: "Event already fired" })) : a2.readSet.has(l2) ? (a2.resolveReadPromises(l2, "Event already fired"), o({ message: "Event already fired" })) : (c2 === y.INCOMING_READ_RECEIPT && a2.readSet.add(l2), u2.disableThrottle ? (this.logger.info("throttleFn disabled for ".concat(l2, ": sending messageReceipt ").concat(c2)), o(t3.call(e3, ...r2))) : (a2.logger.debug("call next throttleFn sendMessageReceipts", r2), void a2.sendMessageReceipts.call(a2, e3, t3, ...r2)));
            }, a2.timeout || (a2.timeout = setTimeout(function() {
              a2.timeout = null, a2.throttleInitialEventsToPrioritizeRead();
            }, 300)), c2 !== y.INCOMING_READ_RECEIPT || a2.readSet.has(l2) || (clearTimeout(a2.timeout), a2.timeout = null, a2.throttleInitialEventsToPrioritizeRead()), p2;
          } catch (e4) {
            return Promise.reject(function(e5) {
              for (var t4 = 1; t4 < arguments.length; t4++) {
                var n3 = null != arguments[t4] ? arguments[t4] : {};
                t4 % 2 ? de(Object(n3), true).forEach(function(t5) {
                  he(e5, t5, n3[t5]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e5, Object.getOwnPropertyDescriptors(n3)) : de(Object(n3)).forEach(function(t5) {
                  Object.defineProperty(e5, t5, Object.getOwnPropertyDescriptor(n3, t5));
                });
              }
              return e5;
            }({ message: "Failed to send messageReceipt", args: r2 }, e4));
          }
        }
        sendMessageReceipts(e3, t3) {
          for (var n2 = arguments.length, r2 = new Array(n2 > 2 ? n2 - 2 : 0), i = 2; i < n2; i++)
            r2[i - 2] = arguments[i];
          var o = this, a2 = r2[4] || s.getMessageReceiptsThrottleTime(), c2 = r2[3], u2 = ("string" == typeof r2[2] ? JSON.parse(r2[2]) : r2[2]).messageId;
          this.lastReadArgs = c2 === y.INCOMING_READ_RECEIPT ? r2 : this.lastReadArgs, o.throttleSendEventApiCall = function() {
            try {
              if (c2 === y.INCOMING_READ_RECEIPT) {
                var n3 = t3.call(e3, ...r2);
                o.resolveReadPromises(u2, n3), o.logger.debug("send Read event:", t3, r2);
              } else {
                var i2 = [t3.call(e3, ...r2)];
                if (this.lastReadArgs) {
                  var s2 = "string" == typeof this.lastReadArgs[2] ? JSON.parse(this.lastReadArgs[2]) : this.lastReadArgs[2], a3 = s2.messageId;
                  o.readPromiseMap.has(a3) && i2.push(t3.call(e3, ...this.lastReadArgs));
                }
                o.logger.debug("send Delivered event:", r2, "read event:", this.lastReadArgs), Promise.all(i2).then((e4) => {
                  o.resolveReadPromises(s2.messageId, e4[0]), o.resolveDeliveredPromises(u2, e4[0]);
                });
              }
            } catch (e4) {
              o.logger.error("send message receipt failed", e4), o.resolveReadPromises(u2, e4, true), o.resolveDeliveredPromises(u2, e4, true);
            }
          }, o.timeoutId || (o.timeoutId = setTimeout(function() {
            o.timeoutId = null, o.throttleSendEventApiCall();
          }, a2));
        }
        resolveDeliveredPromises(e3, t3, n2) {
          return this.resolvePromises(this.deliveredPromiseMap, e3, t3, n2);
        }
        resolveReadPromises(e3, t3, n2) {
          return this.resolvePromises(this.readPromiseMap, e3, t3, n2);
        }
        resolvePromises(e3, t3, n2, r2) {
          var i = Array.from(e3.keys()), o = i.indexOf(t3);
          if (-1 !== o)
            for (var s2 = 0; s2 <= o; s2++) {
              var a2, c2 = null === (a2 = e3.get(i[s2])) || void 0 === a2 ? void 0 : a2[r2 ? 1 : 0];
              "function" == typeof c2 && (e3.delete(i[s2]), c2(n2));
            }
          else
            this.logger.debug("Promise for messageId: ".concat(t3, " already resolved"));
        }
        rehydrateReceiptMappers(e3, t3) {
          var n2 = this;
          return (r2) => {
            if (n2.logger.debug("rehydrate chat", null == r2 ? void 0 : r2.data), t3) {
              var { Transcript: i = [] } = (null == r2 ? void 0 : r2.data) || {};
              i.forEach((e4) => {
                if ((null == e4 ? void 0 : e4.Type) === y.MESSAGE_METADATA) {
                  var t4, n3, r3, i2 = null == e4 || null === (t4 = e4.MessageMetadata) || void 0 === t4 || null === (n3 = t4.Receipts) || void 0 === n3 ? void 0 : n3[0], o = null == e4 || null === (r3 = e4.MessageMetadata) || void 0 === r3 ? void 0 : r3.MessageId;
                  null != i2 && i2.ReadTimestamp && this.readSet.add(o), null != i2 && i2.DeliveredTimestamp && this.deliveredSet.add(o);
                }
              });
            }
            return e3(r2);
          };
        }
      }
      class me {
        constructor(e3) {
          this.argsValidator = new F(), this.pubsub = new ee(), this.sessionType = e3.sessionType, this.getConnectionToken = e3.chatDetails.getConnectionToken, this.connectionDetails = e3.chatDetails.connectionDetails, this.initialContactId = e3.chatDetails.initialContactId, this.contactId = e3.chatDetails.contactId, this.participantId = e3.chatDetails.participantId, this.chatClient = e3.chatClient, this.participantToken = e3.chatDetails.participantToken, this.websocketManager = e3.websocketManager, this._participantDisconnected = false, this.sessionMetadata = {}, this.logger = k.getLogger({ prefix: "ChatJS-ChatController", logMetaData: e3.logMetaData }), this.logMetaData = e3.logMetaData, this.messageReceiptUtil = new fe(e3.logMetaData), this.logger.info("Browser info:", window.navigator.userAgent);
        }
        subscribe(e3, t3) {
          this.pubsub.subscribe(e3, t3), this._sendInternalLogToServer(this.logger.info("Subscribed successfully to event:", e3));
        }
        handleRequestSuccess(e3, t3, n2, r2) {
          return (i) => {
            var o = r2 ? [{ name: "ContentType", value: r2 }] : [];
            return ne.addLatencyMetricWithStartTime(t3, n2, u, o), ne.addCountAndErrorMetric(t3, u, false, o), i.metadata = e3, i;
          };
        }
        handleRequestFailure(e3, t3, n2, r2) {
          return (i) => {
            var o = r2 ? [{ name: "ContentType", value: r2 }] : [];
            return ne.addLatencyMetricWithStartTime(t3, n2, u, o), ne.addCountAndErrorMetric(t3, u, true, o), i.metadata = e3, Promise.reject(i);
          };
        }
        sendMessage(e3) {
          var t3 = (/* @__PURE__ */ new Date()).getTime(), n2 = e3.metadata || null;
          this.argsValidator.validateSendMessage(e3);
          var r2 = this.connectionHelper.getConnectionToken();
          return this.chatClient.sendMessage(r2, e3.message, e3.contentType).then(this.handleRequestSuccess(n2, l, t3, e3.contentType)).catch(this.handleRequestFailure(n2, l, t3, e3.contentType));
        }
        sendAttachment(e3) {
          var t3 = (/* @__PURE__ */ new Date()).getTime(), n2 = e3.metadata || null, r2 = this.connectionHelper.getConnectionToken();
          return this.chatClient.sendAttachment(r2, e3.attachment, e3.metadata).then(this.handleRequestSuccess(n2, p, t3, e3.attachment.type)).catch(this.handleRequestFailure(n2, p, t3, e3.attachment.type));
        }
        downloadAttachment(e3) {
          var t3 = (/* @__PURE__ */ new Date()).getTime(), n2 = e3.metadata || null, r2 = this.connectionHelper.getConnectionToken();
          return this.chatClient.downloadAttachment(r2, e3.attachmentId).then(this.handleRequestSuccess(n2, d, t3)).catch(this.handleRequestFailure(n2, d, t3));
        }
        sendEvent(e3) {
          var t3 = (/* @__PURE__ */ new Date()).getTime(), n2 = e3.metadata || null;
          this.argsValidator.validateSendEvent(e3);
          var r2 = this.connectionHelper.getConnectionToken(), i = e3.content || null, o = ge(e3.contentType), c2 = "string" == typeof i ? JSON.parse(i) : i;
          return this.messageReceiptUtil.isMessageReceipt(o, e3) ? s.isFeatureEnabled(a) && c2.messageId ? this.messageReceiptUtil.prioritizeAndSendMessageReceipt(this.chatClient, this.chatClient.sendEvent, r2, e3.contentType, i, o, s.getMessageReceiptsThrottleTime()).then(this.handleRequestSuccess(n2, h, t3, e3.contentType)).catch(this.handleRequestFailure(n2, h, t3, e3.contentType)) : (this.logger.warn("Ignoring messageReceipt: ".concat(s.isFeatureEnabled(a) && "missing messageId"), e3), Promise.reject({ errorMessage: "Ignoring messageReceipt: ".concat(s.isFeatureEnabled(a) && "missing messageId"), data: e3 })) : this.chatClient.sendEvent(r2, e3.contentType, i).then(this.handleRequestSuccess(n2, h, t3, e3.contentType)).catch(this.handleRequestFailure(n2, h, t3, e3.contentType));
        }
        getTranscript(e3) {
          var t3 = (/* @__PURE__ */ new Date()).getTime(), n2 = e3.metadata || null, r2 = { startPosition: e3.startPosition || {}, scanDirection: e3.scanDirection || "BACKWARD", sortOrder: e3.sortOrder || "ASCENDING", maxResults: e3.maxResults || 15 };
          e3.nextToken && (r2.nextToken = e3.nextToken), e3.contactId && (r2.contactId = e3.contactId);
          var i = this.connectionHelper.getConnectionToken();
          return this.chatClient.getTranscript(i, r2).then(this.messageReceiptUtil.rehydrateReceiptMappers(this.handleRequestSuccess(n2, f, t3), s.isFeatureEnabled(a))).catch(this.handleRequestFailure(n2, f, t3));
        }
        connect() {
          var e3 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          this.sessionMetadata = e3.metadata || null, this.argsValidator.validateConnectChat(e3);
          var t3 = this._getConnectionDetailsProvider();
          return t3.fetchConnectionDetails().then((e4) => this._initConnectionHelper(t3, e4)).then((e4) => this._onConnectSuccess(e4, t3)).catch((e4) => this._onConnectFailure(e4));
        }
        _initConnectionHelper(e3, t3) {
          return this.connectionHelper = new pe(this.contactId, this.initialContactId, e3, this.websocketManager, this.logMetaData, t3), this.connectionHelper.onEnded(this._handleEndedConnection.bind(this)), this.connectionHelper.onConnectionLost(this._handleLostConnection.bind(this)), this.connectionHelper.onConnectionGain(this._handleGainedConnection.bind(this)), this.connectionHelper.onMessage(this._handleIncomingMessage.bind(this)), this.connectionHelper.start();
        }
        _getConnectionDetailsProvider() {
          return new ie(this.participantToken, this.chatClient, this.sessionType, this.getConnectionToken);
        }
        _handleEndedConnection(e3) {
          this._forwardChatEvent(y.CONNECTION_BROKEN, { data: e3, chatDetails: this.getChatDetails() }), this.breakConnection();
        }
        _handleLostConnection(e3) {
          this._forwardChatEvent(y.CONNECTION_LOST, { data: e3, chatDetails: this.getChatDetails() });
        }
        _handleGainedConnection(e3) {
          this._forwardChatEvent(y.CONNECTION_ESTABLISHED, { data: e3, chatDetails: this.getChatDetails() });
        }
        _handleIncomingMessage(e3) {
          try {
            var t3 = ge(null == e3 ? void 0 : e3.ContentType);
            if (this.messageReceiptUtil.isMessageReceipt(t3, e3) && (!(t3 = this.messageReceiptUtil.getEventTypeFromMessageMetaData(null == e3 ? void 0 : e3.MessageMetadata)) || !this.messageReceiptUtil.shouldShowMessageReceiptForCurrentParticipantId(this.participantId, e3)))
              return;
            this._forwardChatEvent(t3, { data: e3, chatDetails: this.getChatDetails() }), e3.ContentType === b.chatEnded && (this._forwardChatEvent(y.CHAT_ENDED, { data: null, chatDetails: this.getChatDetails() }), this.breakConnection());
          } catch (t4) {
            this._sendInternalLogToServer(this.logger.error("Error occured while handling message from Connection. eventData:", e3, " Causing exception:", t4));
          }
        }
        _forwardChatEvent(e3, t3) {
          this.pubsub.triggerAsync(e3, t3);
        }
        _onConnectSuccess(e3, t3) {
          var n2;
          this._sendInternalLogToServer(this.logger.info("Connect successful!")), console.warn("onConnectionSuccess response", e3);
          var r2 = { _debug: e3, connectSuccess: true, connectCalled: true, metadata: this.sessionMetadata }, i = Object.assign({ chatDetails: this.getChatDetails() }, r2);
          this.pubsub.triggerAsync(y.CONNECTION_ESTABLISHED, i);
          var o = null === (n2 = t3.getConnectionDetails()) || void 0 === n2 ? void 0 : n2.connectionAcknowledged;
          return this._shouldAcknowledgeContact() && !o && (ne.addAgentCountMetric("CREATE_PARTICIPANT_CONACK_CALL_COUNT", 1), t3.callCreateParticipantConnection({ Type: false, ConnectParticipant: true }).catch((e4) => {
            this.logger.warn("ConnectParticipant failed to acknowledge Agent connection in CreateParticipantConnection: ", e4), ne.addAgentCountMetric("CREATE_PARTICIPANT_CONACK_FAILURE", 1);
          })), console.warn("onConnectionSuccess responseObject", r2), r2;
        }
        _onConnectFailure(e3) {
          var t3 = { _debug: e3, connectSuccess: false, connectCalled: true, metadata: this.sessionMetadata };
          return this._sendInternalLogToServer(this.logger.error("Connect Failed. Error: ", t3)), Promise.reject(t3);
        }
        _shouldAcknowledgeContact() {
          return this.sessionType === c.AGENT;
        }
        breakConnection() {
          return this.connectionHelper ? this.connectionHelper.end() : Promise.resolve();
        }
        cleanUpOnParticipantDisconnect() {
          this.pubsub.unsubscribeAll();
        }
        disconnectParticipant() {
          var e3 = (/* @__PURE__ */ new Date()).getTime(), t3 = this.connectionHelper.getConnectionToken();
          return this.chatClient.disconnectParticipant(t3).then((t4) => (this._sendInternalLogToServer(this.logger.info("Disconnect participant successfully")), this._participantDisconnected = true, this.cleanUpOnParticipantDisconnect(), this.breakConnection(), ne.addLatencyMetricWithStartTime(m, e3, u), ne.addCountAndErrorMetric(m, u, false), t4), (t4) => (this._sendInternalLogToServer(this.logger.error("Disconnect participant failed. Error:", t4)), ne.addLatencyMetricWithStartTime(m, e3, u), ne.addCountAndErrorMetric(m, u, true), Promise.reject(t4)));
        }
        getChatDetails() {
          return { initialContactId: this.initialContactId, contactId: this.contactId, participantId: this.participantId, participantToken: this.participantToken, connectionDetails: this.connectionDetails };
        }
        _convertConnectionHelperStatus(e3) {
          switch (e3) {
            case W:
              return "NeverEstablished";
            case B:
              return "Establishing";
            case V:
            case H:
              return "Broken";
            case z:
              return "Established";
          }
          this._sendInternalLogToServer(this.logger.error("Reached invalid state. Unknown connectionHelperStatus: ", e3));
        }
        getConnectionStatus() {
          return this._convertConnectionHelperStatus(this.connectionHelper.getStatus());
        }
        _sendInternalLogToServer(e3) {
          return e3 && "function" == typeof e3.sendInternalLogToServer && e3.sendInternalLogToServer(), e3;
        }
      }
      var ge = (e3) => w[e3] || w.default;
      class ve {
        createAgentChatController(e3, n2) {
          throw new t2("createAgentChatController in ChatControllerFactory.");
        }
        createCustomerChatController(e3, n2) {
          throw new t2("createCustomerChatController in ChatControllerFactory.");
        }
      }
      class ye {
        constructor(e3) {
          this.controller = e3;
        }
        onMessage(e3) {
          this.controller.subscribe(y.INCOMING_MESSAGE, e3);
        }
        onTyping(e3) {
          this.controller.subscribe(y.INCOMING_TYPING, e3);
        }
        onReadReceipt(e3) {
          this.controller.subscribe(y.INCOMING_READ_RECEIPT, e3);
        }
        onDeliveredReceipt(e3) {
          this.controller.subscribe(y.INCOMING_DELIVERED_RECEIPT, e3);
        }
        onConnectionBroken(e3) {
          this.controller.subscribe(y.CONNECTION_BROKEN, e3);
        }
        onConnectionEstablished(e3) {
          this.controller.subscribe(y.CONNECTION_ESTABLISHED, e3);
        }
        onEnded(e3) {
          this.controller.subscribe(y.CHAT_ENDED, e3);
        }
        onParticipantIdle(e3) {
          this.controller.subscribe(y.PARTICIPANT_IDLE, e3);
        }
        onParticipantReturned(e3) {
          this.controller.subscribe(y.PARTICIPANT_RETURNED, e3);
        }
        onAutoDisconnection(e3) {
          this.controller.subscribe(y.AUTODISCONNECTION, e3);
        }
        onConnectionLost(e3) {
          this.controller.subscribe(y.CONNECTION_LOST, e3);
        }
        sendMessage(e3) {
          return this.controller.sendMessage(e3);
        }
        sendAttachment(e3) {
          return this.controller.sendAttachment(e3);
        }
        downloadAttachment(e3) {
          return this.controller.downloadAttachment(e3);
        }
        connect(e3) {
          return this.controller.connect(e3);
        }
        sendEvent(e3) {
          return this.controller.sendEvent(e3);
        }
        getTranscript(e3) {
          return this.controller.getTranscript(e3);
        }
        getChatDetails() {
          return this.controller.getChatDetails();
        }
      }
      class be extends ye {
        constructor(e3) {
          super(e3);
        }
        cleanUpOnParticipantDisconnect() {
          return this.controller.cleanUpOnParticipantDisconnect();
        }
      }
      class we extends ye {
        constructor(e3) {
          super(e3);
        }
        disconnectParticipant() {
          return this.controller.disconnectParticipant();
        }
      }
      var Ee = new class extends ve {
        constructor() {
          super(), this.argsValidator = new F();
        }
        createChatSession(e3, t3, n2, i) {
          var o = this._createChatController(e3, t3, n2, i);
          if (e3 === c.AGENT)
            return new be(o);
          if (e3 === c.CUSTOMER)
            return new we(o);
          throw new r("Unkown value for session type, Allowed values are: " + Object.values(c), e3);
        }
        _createChatController(e3, t3, n2, r2) {
          var i = this.argsValidator.normalizeChatDetails(t3), o = { contactId: i.contactId, participantId: i.participantId, sessionType: e3 }, s2 = q.getCachedClient(n2, o);
          return new me({ sessionType: e3, chatDetails: i, chatClient: s2, websocketManager: r2, logMetaData: o });
        }
      }(), Se = (e3) => {
        s.setFeatureFlag(e3);
      }, Ce = { create: (e3) => {
        var t3 = e3.options || {}, n2 = e3.type || c.AGENT;
        return s.updateStageRegion(t3), e3.disableCSM || n2 !== c.CUSTOMER || ne.loadCsmScriptAndExecute(), Ee.createChatSession(n2, e3.chatDetails, t3, e3.websocketManager);
      }, setGlobalConfig: (e3) => {
        var t3, n2, r2, i, o = e3.loggerConfig, c2 = e3.csmConfig;
        s.update(e3), ce.setGlobalConfig(e3), k.updateLoggerConfig(o), c2 && ne.updateCsmConfig(c2), false !== (null === (t3 = e3.features) || void 0 === t3 || null === (n2 = t3.messageReceipts) || void 0 === n2 ? void 0 : n2.shouldSendMessageReceipts) && (console.warn("enabling message-receipts by default; to disable set config.features.messageReceipts.shouldSendMessageReceipts = false"), Se(a), s.updateThrottleTime(null === (r2 = e3.features) || void 0 === r2 || null === (i = r2.messageReceipts) || void 0 === i ? void 0 : i.thorttleTime));
      }, LogLevel: I, Logger: class {
        debug(e3) {
        }
        info(e3) {
        }
        warn(e3) {
        }
        error(e3) {
        }
        advancedLog(e3) {
        }
      }, SessionTypes: c, csmService: ne, setFeatureFlag: Se }, Te = void 0 !== Te ? Te : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {};
      Te.connect = Te.connect || {}, connect.ChatSession = Ce, connect.LogManager = k, connect.LogLevel = I, connect.csmService = Ce.csmService;
    })();
  })();
  return amazonConnectChat;
}
requireAmazonConnectChat();
(() => {
  var t = {};
  t.g = function() {
    if ("object" == typeof globalThis)
      return globalThis;
    try {
      return this || new Function("return this")();
    } catch (t2) {
      if ("object" == typeof window)
        return window;
    }
  }();
  const n = "NeverStarted", e = "Ended", s = "ConnectionLost", o = "ConnectionGained", c = "Ended", i = "IncomingMessage";
  class a {
    constructor(t2, n2, e2) {
      a.baseInstance || (a.baseInstance = new r(e2)), this.contactId = t2, this.initialContactId = n2, this.status = null, this.eventBus = new connect.EventBus(), this.subscriptions = [a.baseInstance.onEnded(this.handleEnded.bind(this)), a.baseInstance.onConnectionGain(this.handleConnectionGain.bind(this)), a.baseInstance.onConnectionLost(this.handleConnectionLost.bind(this)), a.baseInstance.onMessage(this.handleMessage.bind(this))];
    }
    start() {
      return a.baseInstance.start();
    }
    end() {
      this.eventBus.unsubscribeAll(), this.subscriptions.forEach((t2) => t2.unsubscribe()), this.status = e;
    }
    getStatus() {
      return this.status || a.baseInstance.getStatus();
    }
    onEnded(t2) {
      return this.eventBus.subscribe(c, t2);
    }
    handleEnded() {
      this.eventBus.trigger(c, {});
    }
    onConnectionGain(t2) {
      return this.eventBus.subscribe(o, t2);
    }
    handleConnectionGain() {
      this.eventBus.trigger(o, {});
    }
    onConnectionLost(t2) {
      return this.eventBus.subscribe(s, t2);
    }
    handleConnectionLost() {
      this.eventBus.trigger(s, {});
    }
    onMessage(t2) {
      return this.eventBus.subscribe(i, t2);
    }
    handleMessage(t2) {
      t2.InitialContactId !== this.initialContactId && t2.ContactId !== this.contactId || this.eventBus.trigger(i, t2);
    }
  }
  a.baseInstance = null;
  class r {
    constructor(t2) {
      this.status = n, this.eventBus = new connect.EventBus(), this.initWebsocketManager(t2);
    }
    initWebsocketManager(t2) {
      this.websocketManager = t2, this.websocketManager.subscribeTopics(["aws/task"]), this.subscriptions = [this.websocketManager.onMessage("aws/task", this.handleMessage.bind(this)), this.websocketManager.onConnectionGain(this.handleConnectionGain.bind(this)), this.websocketManager.onConnectionLost(this.handleConnectionLost.bind(this)), this.websocketManager.onInitFailure(this.handleEnded.bind(this))];
    }
    start() {
      return this.status === n && (this.status = "Starting"), Promise.resolve();
    }
    onEnded(t2) {
      return this.eventBus.subscribe(c, t2);
    }
    handleEnded() {
      this.status = e, this.eventBus.trigger(c, {});
    }
    onConnectionGain(t2) {
      return this.eventBus.subscribe(o, t2);
    }
    handleConnectionGain() {
      this.status = "Connected", this.eventBus.trigger(o, {});
    }
    onConnectionLost(t2) {
      return this.eventBus.subscribe(s, t2);
    }
    handleConnectionLost() {
      this.status = "ConnectionLost", this.eventBus.trigger(s, {});
    }
    onMessage(t2) {
      return this.eventBus.subscribe(i, t2);
    }
    handleMessage(t2) {
      let n2;
      try {
        n2 = JSON.parse(t2.content), this.eventBus.trigger(i, n2);
      } catch (n3) {
        connect.getLog().error("Wrong message format: %s", t2);
      }
    }
    getStatus() {
      return this.status;
    }
  }
  const l = a, h = "INCOMING_MESSAGE", u = "TRANSFER_FAILED", d = "TRANSFER_SUCCEEDED", g = "TRANSFER_INITIATED", b = "CONNECTION_ESTABLISHED", p = "CONNECTION_BROKEN", C = "TASK_EXPIRING", T = "TASK_EXPIRED", E = { "application/vnd.amazonaws.connect.event.transfer.initiated": g, "application/vnd.amazonaws.connect.event.transfer.succeeded": d, "application/vnd.amazonaws.connect.event.transfer.failed": u, "application/vnd.amazonaws.connect.event.expire.warning": C, "application/vnd.amazonaws.connect.event.expire.complete": T };
  class I {
    constructor(t2) {
      this.pubsub = new connect.EventBus(), this.initialContactId = t2.initialContactId, this.contactId = t2.contactId, this.websocketManager = t2.websocketManager;
    }
    subscribe(t2, n2) {
      this.pubsub.subscribe(t2, n2), connect.getLog().info(connect.LogComponent.TASK, "Subscribed successfully to eventName: %s", t2);
    }
    connect() {
      return this._initConnectionHelper().then(this._onConnectSuccess.bind(this), this._onConnectFailure.bind(this));
    }
    getTaskDetails() {
      return { initialContactId: this.initialContactId, contactId: this.contactId };
    }
    unsubscribeAll() {
      this.pubsub.unsubscribeAll(), this.connectionHelper.end();
    }
    _triggerEvent(t2, n2) {
      connect.getLog().debug(connect.LogComponent.TASK, "Triggering event for subscribers: %s", t2).withObject({ data: n2, taskDetails: this.getTaskDetails() }), this.pubsub.trigger(t2, n2);
    }
    _onConnectSuccess(t2) {
      connect.getLog().info(connect.LogComponent.TASK, "Connect successful!");
      const n2 = { _debug: t2, connectSuccess: true, connectCalled: true };
      return this._triggerEvent(b, n2), n2;
    }
    _onConnectFailure(t2) {
      const n2 = { _debug: t2, connectSuccess: false, connectCalled: true, metadata: this.sessionMetadata };
      return connect.getLog().error(connect.LogComponent.TASK, "Connect Failed").withException(n2), Promise.reject(n2);
    }
    _initConnectionHelper() {
      return this.connectionHelper = new l(this.contactId, this.initialContactId, this.websocketManager), this.connectionHelper.onEnded(this._handleEndedConnection.bind(this)), this.connectionHelper.onConnectionLost(this._handleLostConnection.bind(this)), this.connectionHelper.onConnectionGain(this._handleGainedConnection.bind(this)), this.connectionHelper.onMessage(this._handleIncomingMessage.bind(this)), this.connectionHelper.start();
    }
    _handleEndedConnection(t2) {
      this._triggerEvent(p, t2);
    }
    _handleGainedConnection(t2) {
      this._triggerEvent(b, t2);
    }
    _handleLostConnection(t2) {
      this._triggerEvent("CONNECTION_LOST", t2);
    }
    _handleIncomingMessage(t2) {
      const n2 = t2.ContentType;
      E[n2] && this._triggerEvent(E[n2], t2), this._triggerEvent(h, t2);
    }
  }
  class v {
    constructor(t2) {
      this.controller = t2;
    }
    onMessage(t2) {
      this.controller.subscribe(h, t2);
    }
    onTransferSucceeded(t2) {
      this.controller.subscribe(d, t2);
    }
    onTransferFailed(t2) {
      this.controller.subscribe(u, t2);
    }
    onTransferInitiated(t2) {
      this.controller.subscribe(g, t2);
    }
    onTaskExpiring(t2) {
      this.controller.subscribe(C, t2);
    }
    onTaskExpired(t2) {
      this.controller.subscribe(T, t2);
    }
    onConnectionBroken(t2) {
      this.controller.subscribe(p, t2);
    }
    onConnectionEstablished(t2) {
      this.controller.subscribe(b, t2);
    }
    connect(t2) {
      return this.controller.connect(t2);
    }
    cleanUp() {
      this.controller.unsubscribeAll();
    }
  }
  const A = { create: (t2) => {
    const n2 = new I(t2);
    return new v(n2);
  } }, k = connect.makeEnum(["URL", "EMAIL", "NUMBER", "STRING", "DATE"]);
  function m(t2) {
    Object.keys(t2).forEach((n2) => {
      const e2 = (s2 = n2).charAt(0).toUpperCase() + s2.slice(1);
      var s2;
      e2 !== n2 && (t2[e2] = t2[n2], delete t2[n2]), "References" === e2 && Object.values(t2[e2]).forEach((t3) => m(t3));
    });
  }
  t.g.connect = t.g.connect || {}, connect.TaskSession = A, connect.Agent.prototype.createTask || (connect.Agent.prototype.createTask = function(t2, n2) {
    connect.assertNotNull(t2, "Task contact object"), connect.assertNotNull(t2.name, "Task name");
    var e2 = connect.core.getClient();
    t2.taskTemplateId ? (t2.endpoint && (t2.quickConnectId = t2.endpoint.endpointARN.split("/").pop(), delete t2.endpoint), m(t2), e2.call(connect.TaskTemplatesClientMethods.CREATE_TEMPLATED_TASK, t2, n2)) : (connect.assertNotNull(t2.endpoint, "Task endpoint"), t2.idempotencyToken = AWS.util.uuid.v4(), delete t2.endpoint.endpointId, e2.call(connect.ClientMethods.CREATE_TASK_CONTACT, t2, n2));
  }), connect.Agent.prototype.getTaskTemplate || (connect.Agent.prototype.getTaskTemplate = function(t2, n2) {
    connect.assertNotNull(t2, "Task template params"), connect.assertNotNull(t2.id, "Task template id");
    var e2 = connect.core.getClient(), s2 = connect.core.getAgentDataProvider().getInstanceId();
    e2.call(connect.TaskTemplatesClientMethods.GET_TASK_TEMPLATE, { instanceId: s2, templateParams: t2 }, n2);
  }), connect.Agent.prototype.listTaskTemplates || (connect.Agent.prototype.listTaskTemplates = function(t2, n2) {
    connect.assertNotNull(t2, "Query params for listTaskTemplates");
    var e2 = connect.core.getClient(), s2 = connect.core.getAgentDataProvider().getInstanceId();
    e2.call(connect.TaskTemplatesClientMethods.LIST_TASK_TEMPLATES, { instanceId: s2, queryParams: t2 }, n2);
  }), connect.Agent.prototype.updateContact || (connect.Agent.prototype.updateContact = function(t2, n2) {
    connect.assertNotNull(t2, "Update for templated task"), connect.assertNotNull(t2.contactId, "Task contact id");
    var e2 = connect.core.getClient();
    m(t2), e2.call(connect.TaskTemplatesClientMethods.UPDATE_CONTACT, t2, n2);
  }), connect.ReferenceType = k;
})();
const plusGreen = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='24px'%20height='24px'%20viewBox='0%200%2024%2024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!--%20Generator:%20Sketch%2060.1%20(88133)%20-%20https://sketch.com%20--%3e%3ctitle%3eGraphic%20/%20Icon%20/%20Toggle%20/%20Plus%20/%20Fill%3c/title%3e%3cdesc%3eCreated%20with%20Sketch.%3c/desc%3e%3cdefs%3e%3cpath%20d='M12,1%20C18.0751322,1%2023,5.92486775%2023,12%20C23,18.0751322%2018.0751322,23%2012,23%20C5.92486775,23%201,18.0751322%201,12%20C1,5.92486775%205.92486775,1%2012,1%20Z%20M13,5.98339844%20L11,5.98339844%20L11,10.9993984%20L6,11%20L6,13%20L11,12.9993984%20L11,17.9984266%20L13,17.9984266%20L13,12.9993984%20L18,13%20L18,11%20L13,10.9993984%20L13,5.98339844%20Z'%20id='path-1'%3e%3c/path%3e%3c/defs%3e%3cg%20id='Graphic-/-Icon-/-Toggle-/-Plus-/-Fill'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cmask%20id='mask-2'%20fill='white'%3e%3cuse%20xlink:href='%23path-1'%3e%3c/use%3e%3c/mask%3e%3cuse%20id='Icon'%20fill='%2300957a'%20fill-rule='nonzero'%20xlink:href='%23path-1'%3e%3c/use%3e%3c/g%3e%3c/svg%3e";
const plusOutline = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20width='24px'%20height='24px'%20viewBox='0%200%2024%2024'%20version='1.1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!--%20Generator:%20Sketch%2060.1%20(88133)%20-%20https://sketch.com%20--%3e%3ctitle%3eGraphic%20/%20Icon%20/%20Toggle%20/%20Plus%20/%20Outline%3c/title%3e%3cdesc%3eCreated%20with%20Sketch.%3c/desc%3e%3cg%20id='Graphic-/-Icon-/-Toggle-/-Plus-/-Outline'%20stroke='none'%20stroke-width='1'%20fill='none'%20fill-rule='evenodd'%3e%3cpath%20d='M12,1%20C18.0751322,1%2023,5.92486775%2023,12%20C23,18.0751322%2018.0751322,23%2012,23%20C5.92486775,23%201,18.0751322%201,12%20C1,5.92486775%205.92486775,1%2012,1%20Z%20M12.0012479,2.44889415%20C6.72700705,2.44889415%202.45139003,6.72451118%202.45139003,11.9987521%20C2.45139003,17.272993%206.72700705,21.54861%2012.0012479,21.54861%20C17.2754888,21.54861%2021.5511058,17.272993%2021.5511058,11.9987521%20C21.5511058,6.72451118%2017.2754888,2.44889415%2012.0012479,2.44889415%20Z'%20id='Outer'%20fill='%23A0A0A0'%20fill-rule='nonzero'%3e%3c/path%3e%3cpath%20d='M13,6.06068735%20L12.999,10.9996873%20L18,11%20L18,13%20L12.999,12.9996873%20L13,18.0064732%20L11,18.0064732%20L10.999,12.9996873%20L6,13%20L6,11%20L10.999,10.9996873%20L11,6.06068735%20L13,6.06068735%20Z'%20id='Inner'%20fill='%2369696E'%20fill-rule='nonzero'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";
const collapsedIcon = "data:image/svg+xml,%3csvg%20width='5'%20height='5'%20viewBox='0%200%205%2010'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M4.54%204.793l-4-3.85C.378.789.125.915.125%201.15v7.7c0%20.236.253.362.415.206l4-3.85a.293.293%200%20000-.413z'%20fill='%23A0A0A0'%20fill-rule='nonzero'/%3e%3c/svg%3e";
const expandedIcon = "data:image/svg+xml,%3csvg%20width='5'%20height='5'%20viewBox='0%200%2010%205'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M5.207%204.54l3.85-4c.155-.162.029-.415-.207-.415h-7.7C.914.125.788.378.944.54l3.85%204c.109.113.303.113.413%200z'%20fill='%23A0A0A0'%20fill-rule='nonzero'/%3e%3c/svg%3e";
const LEFT_PADDING = 15;
const _Option = class _Option extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "optionLabelRef", React.createRef());
    __publicField(this, "state", {
      expanded: !!this.props.expandOptions,
      parentHeight: 0,
      showTooltip: false
    });
    __publicField(this, "toggleExpanded", () => this.setState({ expanded: !this.state.expanded }));
    __publicField(this, "onClickExpand", (e) => {
      e.stopPropagation();
      if (e.type === "click") {
        e.preventDefault();
        return this.toggleExpanded();
      }
      if (e.type === "keydown" && SUBMIT_KEYS.has(e.key)) {
        e.preventDefault();
        return this.toggleExpanded();
      }
    });
    __publicField(this, "isLabelOverflowing", () => {
      const { current: currentOptionLabelRef } = this.optionLabelRef;
      if (!currentOptionLabelRef)
        return false;
      const { offsetWidth, scrollWidth } = currentOptionLabelRef;
      return scrollWidth > offsetWidth;
    });
    __publicField(this, "componentDidMount", () => {
      this.setState({ showTooltip: this.isLabelOverflowing() });
    });
    __publicField(this, "componentDidUpdate", () => {
      this.setState({ showTooltip: this.isLabelOverflowing() });
    });
    __publicField(this, "onClickParent", () => {
      if (!this.props.selectParents) {
        return this.toggleExpanded();
      }
      const opt = { ...this.props.option };
      delete opt.children;
      this.props.onOptionClick(opt);
    });
    __publicField(this, "getIndent", (depth, onset = 0, padding = 8) => ({
      paddingLeft: depth * LEFT_PADDING + padding + onset + "px"
    }));
    __publicField(this, "optionSelected", (option) => {
      return Array.isArray(this.props.value) ? !!this.props.value.find((o) => _Option.isSame(o, option)) : false;
    });
    __publicField(this, "onParentSelect", (e) => {
      if (!e.key || e.type === "click" || e.type === "keydown" && SUBMIT_KEYS.has(e.key)) {
        e.stopPropagation();
        e.preventDefault();
        return this.onClickParent();
      }
    });
    __publicField(this, "selectOption", (e, actions, option) => {
      if (e.type === "keydown" && SUBMIT_KEYS.has(e.key)) {
        e.preventDefault();
        actions.onOptionClick(option);
      }
    });
    __publicField(this, "renderOptionLabel", () => {
      const { option, renderOptionLabel } = this.props;
      if (renderOptionLabel)
        return renderOptionLabel(option);
      return /* @__PURE__ */ jsx("span", { ref: this.optionLabelRef, className: "sa-dropdown-options-option-label", children: option.label });
    });
    __publicField(this, "wrapWithTooltip", (text, children) => {
      return /* @__PURE__ */ jsx(Tooltip, { text, customWidth: true, className: "autoWidth", children });
    });
  }
  render() {
    var _a, _b;
    const { option, expanded, depth, onOptionRemove, onOptionAdd, ...actions } = {
      ...this.props,
      ...this.state
    };
    if (this.optionSelected(option))
      return null;
    const toggleExpandLabel = `${expanded ? "Collapse" : "Expand"} category "${option.label}"`;
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      ((_a = option.children) == null ? void 0 : _a.length) ? (
        // if parent
        /* @__PURE__ */ jsx(
          ConditionalWrapper,
          {
            condition: this.state.showTooltip,
            wrapper: (children) => this.wrapWithTooltip(option.label, children),
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                style: this.getIndent(depth - 1),
                className: classNames({
                  "sa-dropdown-options-option": true,
                  expanded
                }),
                children: [
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "button",
                      className: "icon-button",
                      onKeyDown: this.onClickExpand,
                      onClick: this.onClickExpand,
                      title: toggleExpandLabel,
                      "aria-label": toggleExpandLabel,
                      children: /* @__PURE__ */ jsx("img", { src: expanded ? expandedIcon : collapsedIcon, alt: "Expand" })
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      role: "option",
                      "aria-selected": this.optionSelected(option),
                      tabIndex: this.props.selectParents ? 0 : -1,
                      className: "option-button alt-font",
                      onKeyDown: this.onParentSelect,
                      onClick: this.onParentSelect,
                      "data-testid": `option-depth-${depth}`,
                      children: this.renderOptionLabel()
                    }
                  )
                ]
              }
            )
          }
        )
      ) : this.optionSelected(option) ? null : (
        // if child
        /* @__PURE__ */ jsx(
          ConditionalWrapper,
          {
            condition: this.state.showTooltip,
            wrapper: (children) => this.wrapWithTooltip(option.label, children),
            children: /* @__PURE__ */ jsx(
              "div",
              {
                style: this.getIndent(depth - 1),
                className: classNames({
                  "sa-dropdown-options-option": true
                }),
                children: /* @__PURE__ */ jsxs(
                  "div",
                  {
                    role: "option",
                    "aria-selected": this.optionSelected(option),
                    tabIndex: 0,
                    className: "option-button alt-font",
                    onKeyDown: (e) => this.selectOption(e, actions, option),
                    onClick: () => actions.onOptionClick(option),
                    "data-testid": `option-depth-${depth}`,
                    children: [
                      this.renderOptionLabel(),
                      onOptionRemove && /* @__PURE__ */ jsx(
                        Button,
                        {
                          type: "button",
                          className: "sa-dropdown-options-option remove",
                          onClick: (e) => {
                            e.stopPropagation();
                            return onOptionRemove(option, e);
                          },
                          children: /* @__PURE__ */ jsx(
                            "img",
                            {
                              src: plusOutline,
                              className: "sa-dropdown-options-option remove-icon",
                              title: "Remove",
                              alt: "Remove"
                            }
                          )
                        }
                      ),
                      onOptionAdd && /* @__PURE__ */ jsx(
                        Button,
                        {
                          type: "button",
                          className: "sa-dropdown-options-option add",
                          onClick: (e) => {
                            e.stopPropagation();
                            return onOptionAdd(option, e);
                          },
                          children: /* @__PURE__ */ jsx(
                            "img",
                            {
                              src: plusGreen,
                              className: "sa-dropdown-options-option add-icon",
                              title: "Add",
                              alt: "Add"
                            }
                          )
                        }
                      )
                    ]
                  }
                )
              }
            )
          }
        )
      ),
      expanded && /* @__PURE__ */ jsx(Fragment, { children: (_b = option.children) == null ? void 0 : _b.map((option2, i) => /* @__PURE__ */ createElement(_Option, { ...this.props, depth: depth + 1, option: option2, key: i })) })
    ] });
  }
};
__publicField(_Option, "defaultProps", {
  depth: 1
});
__publicField(_Option, "isSame", (op1, op2) => {
  if (op1.key)
    return op1.key === op2.key;
  return op1.label === op2.label;
});
let Option = _Option;
const CrossIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='8'%20height='8'%3e%3cdefs%3e%3cpath%20d='M14.862%208.195a.667.667%200%2001.943.943L12.943%2012l2.862%202.862c.234.234.257.6.07.86l-.07.083a.667.667%200%2001-.943%200L12%2012.943l-2.862%202.862a.667.667%200%2001-.86.07l-.083-.07a.667.667%200%20010-.943L11.057%2012%208.195%209.138a.667.667%200%2001-.07-.86l.07-.083c.26-.26.683-.26.943%200L12%2011.057z'%20id='a'/%3e%3c/defs%3e%3cuse%20fill='%23556272'%20fill-rule='nonzero'%20xlink:href='%23a'%20transform='translate(-8%20-8)'/%3e%3c/svg%3e";
const DropdownIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='24'%20height='24'%3e%3cdefs%3e%3cpath%20d='M8.323%2013.668l3.686%203.686%203.702-3.573a.77.77%200%20011.093.026.77.77%200%2001-.012%201.092L12.547%2019a.768.768%200%2001-.965.08.855.855%200%2001-.186-.139l-4.172-4.172a.77.77%200%2001.007-1.093.77.77%200%20011.092-.007zm4.136-9.526l.088.072%204.245%204.1a.77.77%200%2001.012%201.092.772.772%200%2001-1.005.099l-.088-.073-3.701-3.575-3.687%203.688a.767.767%200%2001-1.005.068l-.087-.075a.77.77%200%2001-.007-1.093l4.172-4.172a.768.768%200%2001.185-.137l-.04.027a.77.77%200%2001.918-.021z'%20id='a'/%3e%3c/defs%3e%3cuse%20fill='%2369696e'%20fill-rule='nonzero'%20xlink:href='%23a'/%3e%3c/svg%3e";
const SearchIcon = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='22'%20height='22'%3e%3cdefs%3e%3cpath%20d='M9.656%201c4.772%200%208.656%203.883%208.656%208.656a8.604%208.604%200%2001-1.52%204.886l5.743%205.742A1.592%201.592%200%200121.41%2023a1.58%201.58%200%2001-1.124-.466l-5.742-5.742a8.604%208.604%200%2001-4.888%201.519C4.883%2018.311%201%2014.428%201%209.656%201%204.883%204.883%201%209.656%201zM9.6%203C5.96%203%203%205.96%203%209.598a6.606%206.606%200%20006.6%206.598%206.606%206.606%200%20006.597-6.598A6.605%206.605%200%20009.6%203z'%20id='a'/%3e%3c/defs%3e%3cuse%20fill='%23959DA7'%20fill-rule='nonzero'%20xlink:href='%23a'%20transform='translate(-1%20-1)'/%3e%3c/svg%3e";
const MAX_HEIGHT = 200;
class Dropdown extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      open: false,
      filterString: "",
      error: "",
      touched: false,
      focus: 0
    });
    __publicField(this, "dropdown", null);
    __publicField(this, "options", null);
    __publicField(this, "input", null);
    __publicField(this, "initialHeight", 0);
    __publicField(this, "dropdownIcon", null);
    __publicField(this, "tags", null);
    __publicField(this, "getRef", () => {
      return this.dropdown;
    });
    __publicField(this, "onOptionClick", (clickedOption) => {
      var _a, _b;
      this.setState({
        open: false
      });
      (_b = (_a = this.props).onClose) == null ? void 0 : _b.call(_a);
      this.props.onChange(clickedOption);
    });
    __publicField(this, "checkOutsideClick", (e) => {
      var _a, _b, _c, _d, _e, _f, _g;
      if (this.state.open && !((_a = this.options) == null ? void 0 : _a.contains(e.target))) {
        if (((_d = (_c = (_b = this.input) == null ? void 0 : _b.input) == null ? void 0 : _c.current) == null ? void 0 : _d.contains(e.target)) || ((_e = this.dropdownIcon) == null ? void 0 : _e.contains(e.target)))
          return;
        this.setState(
          {
            open: false
          },
          this.onBlur
        );
        (_g = (_f = this.props).onClose) == null ? void 0 : _g.call(_f);
      }
    });
    __publicField(this, "isValid", () => {
      const { value, required } = this.props;
      if (!required)
        return true;
      else
        this.setState({ ...this.state, error: "This field is required" });
      if (this.state.open)
        return true;
      if (Array.isArray(value)) {
        return !!value.length;
      }
      return !!value;
    });
    __publicField(this, "onBlur", () => {
      this.setState({ touched: true });
    });
    __publicField(this, "focus", () => {
      var _a;
      (_a = this.dropdown) == null ? void 0 : _a.focus();
    });
    __publicField(this, "reset", () => {
      var _a, _b;
      this.props.hierarchyClear ? null : (_b = (_a = this.props).onClear) == null ? void 0 : _b.call(_a);
    });
    __publicField(this, "onClick", (e) => {
      var _a, _b, _c, _d, _e, _f;
      e.stopPropagation();
      if (this.tags !== e.target && ((_a = this.tags) == null ? void 0 : _a.contains(e.target)))
        return;
      if (this.props.disabled || this.state.open && this.props.filter && !((_b = this.dropdownIcon) == null ? void 0 : _b.contains(e.target)))
        return;
      this.state.open ? (_d = (_c = this.props).onClose) == null ? void 0 : _d.call(_c) : (_f = (_e = this.props).onOpen) == null ? void 0 : _f.call(_e);
      this.setState(
        {
          open: !this.state.open,
          error: "",
          filterString: !this.state.open ? "" : this.state.filterString
        },
        () => {
          var _a2;
          return (_a2 = this.input) == null ? void 0 : _a2.focus();
        }
      );
    });
    __publicField(this, "onClear", () => {
      var _a, _b, _c, _d;
      this.setState({ filterString: "", open: false });
      (_b = (_a = this.props).onClose) == null ? void 0 : _b.call(_a);
      (_d = (_c = this.props).onClear) == null ? void 0 : _d.call(_c);
    });
    __publicField(this, "renderValue", () => {
      const { value, placeholder } = this.props;
      if (Array.isArray(value)) {
        return value.length ? /* @__PURE__ */ jsx("div", { ref: (r) => this.tags = r, className: "sa-dropdown-tags", children: value.map((opt, i) => /* @__PURE__ */ jsxs(Tag, { title: opt.label, square: true, small: true, type: "grey", children: [
          opt.label,
          /* @__PURE__ */ jsx(
            Button,
            {
              title: `${opt.label} clear button`,
              "aria-label": `${opt.label}. clear`,
              type: "button",
              tabIndex: this.state.open ? -1 : 0,
              className: "clear-button high-contrast-focus",
              elastic: true,
              onClick: () => {
                var _a, _b;
                return (_b = (_a = this.props).onDeleteTag) == null ? void 0 : _b.call(_a, opt, i);
              },
              onKeyDown: (evt) => {
                var _a, _b;
                if (evt.key === "Enter" || evt.key === " ") {
                  evt.preventDefault();
                  (_b = (_a = this.props).onDeleteTag) == null ? void 0 : _b.call(_a, opt, i);
                }
              },
              children: /* @__PURE__ */ jsx("img", { src: CrossIcon, alt: "Clear" })
            }
          )
        ] }, i)) }) : /* @__PURE__ */ jsx("span", { className: "sa-dropdown-placeholder", children: placeholder ?? "" });
      }
      return /* @__PURE__ */ jsx(
        "span",
        {
          className: classNames({
            "sa-dropdown-placeholder": !value,
            "sa-selected": !!value
          }),
          "data-testid": "dropdown-value",
          "aria-label": "Placeholder",
          children: this.state.open ? "" : value || placeholder || ""
        }
      );
    });
    __publicField(this, "renderOptions", () => {
      const {
        options,
        value,
        maxFilterOptions,
        expandOptions,
        filterString,
        onAdd,
        onSort,
        minWordLength
      } = {
        ...this.props,
        ...this.state
      };
      const rendered = options.filter(function recursiveFilter(option) {
        var _a;
        if (option.label.toLowerCase().includes(filterString.toLowerCase().trim()))
          return true;
        if ((_a = option.children) == null ? void 0 : _a.length) {
          return !!option.children.filter(recursiveFilter).length;
        }
        return false;
      }).filter(
        (option) => Array.isArray(value) ? !value.map((v) => v.label).includes(option.label) : option
      ).slice(0, maxFilterOptions).sort((a, b) => onSort ? onSort(a, b) : 0).map((option, i) => /* @__PURE__ */ jsx(
        Option,
        {
          renderOptionLabel: this.props.renderOptionLabel,
          expandOptions: !!expandOptions,
          selectParents: !!this.props.selectParents,
          value,
          onOptionClick: this.onOptionClick,
          onOptionRemove: this.props.onRemove,
          option
        },
        i
      ));
      if (filterString && filterString.length >= (minWordLength || 0) && onAdd)
        rendered.unshift(
          /* @__PURE__ */ jsx(
            Option,
            {
              renderOptionLabel: this.props.renderOptionLabel,
              expandOptions: !!expandOptions,
              selectParents: !!this.props.selectParents,
              value: filterString,
              onOptionClick: (e) => {
                onAdd(e);
                this.setState({ filterString: "" });
              },
              onOptionAdd: (e) => {
                onAdd(e);
                this.setState({ filterString: "" });
              },
              option: {
                label: `Add '${filterString}'`,
                data: filterString
              }
            },
            "add"
          )
        );
      return rendered.length ? rendered : /* @__PURE__ */ jsx("div", { className: "sa-dropdown-options-option no-results", children: "No results" });
    });
    __publicField(this, "setDropdown", (r) => {
      this.dropdown = r;
    });
    __publicField(this, "onFocusChange", () => {
      var _a;
      const child = (_a = this.options) == null ? void 0 : _a.children[this.state.focus];
      const optionButton = child == null ? void 0 : child.querySelector(".option-button");
      optionButton == null ? void 0 : optionButton.focus();
    });
    __publicField(this, "handleKeypressOnClear", (evt) => {
      if (evt.key === "Enter" || evt.key === " ") {
        this.onClear();
      }
    });
    __publicField(this, "onKeypress", (evt) => {
      var _a, _b, _c, _d;
      const { focus } = this.state;
      const KEY_CODES = {
        UP: 38,
        DOWN: 40
      };
      if (evt.key === "Enter" || evt.key === " ") {
        if (this.props.preventDefaultInputOnEnterKey)
          evt.preventDefault();
        this.onClick(evt);
      }
      if (evt.key === "Escape") {
        this.setState({
          open: false,
          error: "",
          filterString: ""
        });
        (_b = (_a = this.props).onClose) == null ? void 0 : _b.call(_a);
      }
      if (evt.keyCode === KEY_CODES.UP) {
        if (focus === 0)
          return;
        evt.preventDefault();
        this.setState({ focus: focus - 1 }, this.onFocusChange);
      }
      if (evt.keyCode === KEY_CODES.DOWN) {
        if (focus === ((_d = (_c = this.options) == null ? void 0 : _c.children) == null ? void 0 : _d.length) - 1)
          return;
        evt.preventDefault();
        this.setState({ focus: focus + 1 }, this.onFocusChange);
      }
    });
    __publicField(this, "renderListboxClasses", () => {
      return classNames({
        "sa-dropdown-options": true,
        "from-bottom": this.props.forceOpenDown ? false : this.isDropdownFromBottom(),
        "dropdown-down": !this.props.forceOpenDown && this.isDropdownFromBottom(),
        "dropdown-up": this.props.forceOpenDown || !this.isDropdownFromBottom()
      });
    });
  }
  componentDidMount() {
    document.addEventListener("mouseup", this.checkOutsideClick, false);
    if (this.props.autoFocus) {
      this.focus();
    }
    if (this.props.attachToForm) {
      this.props.attachToForm(this);
    }
  }
  componentWillUnmount() {
    document.removeEventListener("mouseup", this.checkOutsideClick, false);
    if (this.props.removeFromForm) {
      this.props.removeFromForm(this);
    }
  }
  isDropdownFromBottom() {
    const y = this.dropdown.getBoundingClientRect().y;
    const body = document.getElementsByTagName("body")[0];
    if (body.scrollHeight <= MAX_HEIGHT)
      return false;
    return body.scrollHeight - y < MAX_HEIGHT;
  }
  render() {
    const { open, filterString, error, touched } = this.state;
    const {
      value,
      ariaLabel,
      label,
      filter,
      disabled,
      showError,
      className,
      curved,
      iconRight,
      title,
      hierarchyClear,
      onAdd,
      required,
      truncateSelected,
      forceOpenDown,
      ...actions
    } = this.props;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames({
          "sa-dropdown-wrapper": className !== "input",
          [className]: !!className
        }),
        children: [
          label && /* @__PURE__ */ jsxs("label", { children: [
            label,
            required ? /* @__PURE__ */ jsx("span", { "aria-hidden": "true", children: "*" }) : null
          ] }),
          required && /* @__PURE__ */ jsx("span", { className: "sa-dropdown-label-hidden", children: "required" }),
          /* @__PURE__ */ jsxs(
            "div",
            {
              "aria-label": ariaLabel ?? `${title || label || ""} dropdown`,
              "aria-expanded": open,
              "aria-haspopup": "listbox",
              "aria-controls": "dropdown-listbox",
              title: title || label || "Dropdown",
              tabIndex: 0,
              role: "combobox",
              ref: this.setDropdown,
              onBlur: this.onBlur,
              onClick: this.onClick,
              onKeyDown: this.onKeypress,
              className: classNames({
                "sa-dropdown": true,
                "contains-tags": Array.isArray(value) && value.length,
                error: touched && !this.isValid(),
                curved,
                disabled,
                open,
                "show-scrollable": truncateSelected
              }),
              children: [
                open && filter ? /* @__PURE__ */ jsxs("div", { className: "sa-dropdown-filter", children: [
                  /* @__PURE__ */ jsx(
                    forwardRef$1,
                    {
                      ref: (r) => this.input = r,
                      placeholder: this.props.placeholder,
                      value: filterString,
                      preventDefaultOnEnterKey: this.props.preventDefaultInputOnEnterKey,
                      onChange: (filterString2) => this.setState({ filterString: filterString2 }),
                      onSubmit: (filterString2) => {
                        if (onAdd) {
                          onAdd({ label: filterString2, data: filterString2 });
                          this.setState({ filterString: "" });
                        }
                      }
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "img",
                    {
                      className: "sa-dropdown-filter-icon",
                      src: SearchIcon,
                      height: 16,
                      width: 16,
                      alt: "Search"
                    }
                  )
                ] }) : null,
                this.renderValue(),
                /* @__PURE__ */ jsxs("div", { className: "sa-dropdown-icons", children: [
                  actions.onClear && (value == null ? void 0 : value.length) ? /* @__PURE__ */ jsx(
                    Button,
                    {
                      type: "button",
                      className: "full-width",
                      onKeyDown: this.handleKeypressOnClear,
                      onClick: this.onClear,
                      children: /* @__PURE__ */ jsx(
                        "img",
                        {
                          className: "sa-dropdown-icons-cross",
                          src: CrossIcon,
                          alt: "Clear",
                          title: "Clear"
                        }
                      )
                    }
                  ) : null,
                  /* @__PURE__ */ jsx(
                    "img",
                    {
                      src: DropdownIcon,
                      ref: (r) => this.dropdownIcon = r,
                      alt: "Dropdown icon",
                      title: "Dropdown icon",
                      "aria-hidden": "true"
                    }
                  )
                ] }),
                open && /* @__PURE__ */ jsx(
                  "div",
                  {
                    role: "listbox",
                    ref: (r) => this.options = r,
                    style: {
                      position: "absolute",
                      width: "100%"
                    },
                    className: this.renderListboxClasses(),
                    children: this.renderOptions()
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx("div", { "aria-live": "assertive", "aria-atomic": true, className: "input-error", children: showError && touched && !this.isValid() && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("span", { className: "only-visible-to-screen-readers", children: `Error for dropdown ${label}: ` }),
            error
          ] }) })
        ]
      }
    );
  }
}
const forwardRef = React.forwardRef(
  function forwardRef2(props, ref) {
    return /* @__PURE__ */ jsx(FormConsumer, { children: (context) => /* @__PURE__ */ jsx(
      Dropdown,
      {
        ...props,
        ref,
        attachToForm: context == null ? void 0 : context.attachToForm,
        removeFromForm: context == null ? void 0 : context.removeFromForm
      }
    ) });
  }
);
const infoButton = "data:image/svg+xml,%3csvg%20width='14'%20height='14'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cpath%20d='M7%20.583a6.417%206.417%200%20110%2012.834A6.417%206.417%200%20017%20.583zm0%20.755a5.662%205.662%200%20100%2011.324A5.662%205.662%200%20007%201.338zm.802%204.86v4.01H6.198v-4.01h1.604zM7%203.792a.802.802%200%20110%201.604.802.802%200%20010-1.604z'%20id='a'/%3e%3c/defs%3e%3cuse%20fill='%23B9C1CB'%20fill-rule='nonzero'%20xlink:href='%23a'/%3e%3c/svg%3e";
var SAFormBuilderFieldType = /* @__PURE__ */ ((SAFormBuilderFieldType2) => {
  SAFormBuilderFieldType2["Radio"] = "radio";
  SAFormBuilderFieldType2["Checkbox"] = "checkbox";
  SAFormBuilderFieldType2["Text"] = "text";
  SAFormBuilderFieldType2["DropDown"] = "dropdown";
  SAFormBuilderFieldType2["Hierarchy"] = "hierarchy";
  SAFormBuilderFieldType2["Datepicker"] = "datepicker";
  SAFormBuilderFieldType2["Timepicker"] = "timepicker";
  return SAFormBuilderFieldType2;
})(SAFormBuilderFieldType || {});
const withHandleError = (Component2) => {
  return class withHandleError extends React.PureComponent {
    constructor() {
      super(...arguments);
      __publicField(this, "state", {
        error: void 0
      });
    }
    componentDidCatch(err) {
      console.error(err);
      this.setState({ error: "Unable to display contact log form" });
    }
    render() {
      if (this.state.error)
        return /* @__PURE__ */ jsx("p", { children: this.state.error });
      return /* @__PURE__ */ jsx(Component2, { ...this.props });
    }
  };
};
const __FormBuilder = class __FormBuilder extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "shouldDisplay", (condition) => {
      const { values } = this.state;
      if (!condition)
        return true;
      const field = values[condition.field];
      const value = condition.value || values[condition.compareField];
      switch (condition.comparator) {
        case "!exists":
          return Array.isArray(field) ? !field.length : !field;
        case "exists":
          return Array.isArray(field) ? !!field.length : !!field;
        case "=":
          return Array.isArray(field) ? !!field.find((f) => (f.data || f) === value) : field === value;
        case "!=":
          return Array.isArray(field) ? field.find((f) => (f.data || f) === value) : field !== value;
        case "<":
          return Array.isArray(field) ? field.find((f) => Number(f.data || f) < Number(value)) : Number(field) < Number(value);
        case ">":
          return Array.isArray(field) ? field.find((f) => Number(f.data || f) > Number(value)) : Number(field) > Number(value);
        case "begins-with":
          return Array.isArray(field) ? field.find((f) => (f.data || f).indexOf(value) === 0) : field.indexOf(value) === 0;
        default:
          return true;
      }
    });
    __publicField(this, "Common", ({
      children,
      comments,
      name,
      text,
      info,
      condition
    }) => {
      const currentComments = this.state.comments;
      const { onChange } = this.props;
      if (!this.shouldDisplay(condition))
        return null;
      return /* @__PURE__ */ jsxs("div", { className: "sa-form-field", children: [
        text ? /* @__PURE__ */ jsxs("div", { className: "sa-form-field-title", children: [
          /* @__PURE__ */ jsx("span", { children: text }),
          info && /* @__PURE__ */ jsx(
            TriggeredPopup,
            {
              closeOnClickOutside: true,
              fromRight: true,
              trigger: /* @__PURE__ */ jsx(
                "img",
                {
                  className: "sa-form-field-info",
                  alt: "Info",
                  src: infoButton
                }
              ),
              children: info
            }
          )
        ] }) : null,
        children,
        comments && /* @__PURE__ */ jsx(
          forwardRef$1,
          {
            onBlur: () => onChange == null ? void 0 : onChange(`${name}-comments`, this.state.comments[name]),
            textarea: true,
            rows: 3,
            name: "Comments text area",
            placeholder: "Comments",
            value: currentComments[name] || "",
            className: "sa-form-field-comments",
            onChange: (value) => this.setState({
              comments: {
                ...currentComments,
                [name]: value
              }
            })
          }
        )
      ] });
    });
    __publicField(this, "onSubmit", (event) => {
      const { data, values, comments } = this.state;
      const blob = Object.keys(values).map((name) => {
        const field = this.props.data.fields.find((field2) => field2.name === name);
        let value = values[name];
        if (value && (field.type === "dropdown" || field.type === "hierarchy")) {
          value = Array.isArray(values[name]) ? values[name] : data[name];
          value = this.getDropdownValue(value);
        }
        return {
          name,
          value,
          comments: comments[name]
        };
      });
      if (this.props.preventDefault && event) {
        event.preventDefault();
      }
      this.props.onSubmit && this.props.onSubmit(blob);
    });
    __publicField(this, "onCancel", () => {
      this.props.onCancel && this.props.onCancel();
    });
    __publicField(this, "getDropdownValue", (values) => {
      if (Array.isArray(values)) {
        return values.map((v) => v.data);
      }
      return values;
    });
    __publicField(this, "onSubmitError", (invalid) => {
      requestAnimationFrame(() => {
        var _a, _b;
        (_b = (_a = invalid[0].getRef()) == null ? void 0 : _a.closest(".sa-form-field")) == null ? void 0 : _b.scrollIntoView();
      });
    });
    __publicField(this, "normaliseOptions", (options, prefix = "") => {
      return options.map((opt, index) => {
        const key = typeof opt.key === "string" ? opt.key : `${prefix}${index}-${opt.label}`;
        return {
          ...opt,
          key,
          children: opt.children ? this.normaliseOptions(opt.children, `${prefix}${index}-`) : void 0
        };
      });
    });
    this.state = {
      values: __FormBuilder.getInitialValuesFromProps(props),
      data: {},
      comments: {}
    };
  }
  static convertToArray(val) {
    return Array.isArray(val) ? val : [val];
  }
  render() {
    const { data, renderSubmit, onChange } = this.props;
    const title = data.title || this.props.title;
    const { values } = this.state;
    return /* @__PURE__ */ jsxs(Form, { onSubmit: this.onSubmit, onSubmitError: this.onSubmitError, children: [
      /* @__PURE__ */ jsxs("div", { className: "sa-form-content", children: [
        title && /* @__PURE__ */ jsx("h1", { children: title }),
        data.fields.map((field, i) => {
          const { name } = field;
          return (() => {
            switch (field.type) {
              case "text":
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: /* @__PURE__ */ jsx(
                  forwardRef$1,
                  {
                    onBlur: () => onChange == null ? void 0 : onChange(name, this.state.values[name]),
                    type: "text",
                    name: field.name,
                    label: field.label,
                    textarea: field.multiline,
                    rows: field.rows,
                    required: field.required,
                    placeholder: field.placeholder,
                    value: values[name],
                    onChange: (value) => this.setState({
                      values: {
                        ...values,
                        [name]: value
                      }
                    })
                  }
                ) }, i);
              case "checkbox": {
                const selectedValues = values[name];
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: field.options.map((value, i2) => {
                  return /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      square: true,
                      label: value,
                      checked: selectedValues.includes(value),
                      onChange: (checked) => this.setState(
                        {
                          values: {
                            ...values,
                            [name]: checked ? [
                              ...selectedValues,
                              value
                            ] : selectedValues.filter(
                              (v) => v !== value
                            )
                          }
                        },
                        () => onChange == null ? void 0 : onChange(
                          name,
                          this.state.values[name]
                        )
                      )
                    },
                    `${i2}-${value}`
                  );
                }) });
              }
              case "radio":
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: field.options.map((value, i2) => {
                  return /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      label: value,
                      checked: values[name] === value,
                      onChange: (checked) => checked && this.setState(
                        {
                          values: {
                            ...values,
                            [name]: value
                          }
                        },
                        () => onChange == null ? void 0 : onChange(
                          name,
                          this.state.values[name]
                        )
                      )
                    },
                    `${i2}-${value}`
                  );
                }) });
              case "dropdown": {
                const selectedValues = values[name];
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: /* @__PURE__ */ jsx(
                  forwardRef,
                  {
                    filter: field.filter,
                    options: field.options,
                    value: values[name],
                    placeholder: field.placeholder,
                    label: field.label,
                    maxFilterOptions: field.maxFilterOptions,
                    required: field.required,
                    preventDefaultInputOnEnterKey: this.props.preventDefault,
                    onChange: (option) => {
                      const isArray = Array.isArray(selectedValues);
                      this.setState(
                        {
                          values: {
                            ...values,
                            [name]: isArray ? [...selectedValues, option] : option.label
                          },
                          data: {
                            ...this.state.data,
                            [name]: isArray ? [...selectedValues, option] : option.data
                          }
                        },
                        () => onChange == null ? void 0 : onChange(
                          name,
                          this.getDropdownValue(
                            this.state.data[name]
                          )
                        )
                      );
                    },
                    onDeleteTag: (option) => {
                      this.setState(
                        {
                          values: {
                            ...values,
                            [name]: values[name].filter(
                              (v) => v.label !== option.label
                            )
                          },
                          data: {
                            ...this.state.data,
                            [name]: this.state.data[name].filter(
                              (v) => v.data !== option.data
                            )
                          }
                        },
                        () => onChange == null ? void 0 : onChange(
                          name,
                          this.getDropdownValue(
                            this.state.data[name]
                          )
                        )
                      );
                    }
                  }
                ) });
              }
              case "hierarchy": {
                const options = this.normaliseOptions(field.options);
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: /* @__PURE__ */ jsx(
                  SearchableDropdown,
                  {
                    options,
                    title: field.label,
                    placeholder: field.placeholder,
                    required: field.required || false,
                    autoSave: false,
                    selected: values[name],
                    onChange: (option) => {
                      if (!option)
                        return;
                      this.setState(
                        {
                          values: {
                            ...values,
                            [name]: option.label
                          },
                          data: {
                            ...this.state.data,
                            [name]: option.data
                          }
                        },
                        () => onChange == null ? void 0 : onChange(
                          name,
                          this.getDropdownValue(
                            this.state.data[name]
                          )
                        )
                      );
                    }
                  }
                ) });
              }
              case "datepicker": {
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: /* @__PURE__ */ jsx(
                  ReactDatePicker,
                  {
                    onBlur: () => onChange == null ? void 0 : onChange(name, this.state.values[name]),
                    name: field.name,
                    required: field.required,
                    value: values[name],
                    onChange: (value) => {
                      this.setState(
                        {
                          values: {
                            ...values,
                            [name]: value.toString()
                          }
                        },
                        () => onChange == null ? void 0 : onChange(
                          name,
                          this.state.values[name]
                        )
                      );
                    },
                    label: field.label
                  }
                ) }, i);
              }
              case "timepicker": {
                return /* @__PURE__ */ jsx(this.Common, { ...field, children: /* @__PURE__ */ jsx(
                  forwardRef$1,
                  {
                    onBlur: () => onChange == null ? void 0 : onChange(name, this.state.values[name]),
                    name: field.name,
                    required: field.required,
                    value: values[name],
                    onChange: (value) => this.setState({
                      values: {
                        ...values,
                        [name]: value
                      }
                    }),
                    type: "time",
                    label: field.label
                  }
                ) }, i);
              }
              default:
                return null;
            }
          })();
        })
      ] }),
      renderSubmit ? renderSubmit() : /* @__PURE__ */ jsxs("div", { className: "sa-form-controls", children: [
        /* @__PURE__ */ jsx(Button, { round: true, styling: "secondary", onClick: this.onCancel, children: "Cancel" }),
        /* @__PURE__ */ jsx(Button, { round: true, styling: "primary", onClick: this.onSubmit, children: "Submit" })
      ] })
    ] });
  }
};
__publicField(__FormBuilder, "getInitialValuesFromProps", (props) => {
  const { fields } = props.data;
  const { defaultValues } = props;
  const names = fields.map((field) => field.name);
  if ([...new Set(names)].length < names.length)
    throw new Error("No duplicate names allowed");
  return fields.reduce((prevFields, field) => {
    const defaultValue = defaultValues == null ? void 0 : defaultValues[field.name];
    switch (field.type) {
      case "text":
      case "radio":
      case "datepicker":
      case "timepicker":
        return {
          ...prevFields,
          [field.name]: defaultValue ?? ""
        };
      case "checkbox":
        return {
          ...prevFields,
          [field.name]: defaultValue ? __FormBuilder.convertToArray(defaultValue) : []
        };
      case "dropdown":
        return {
          ...prevFields,
          [field.name]: field.multi ? defaultValue ? __FormBuilder.convertToArray(defaultValue) : [] : defaultValue ?? ""
        };
      case "hierarchy":
        return {
          ...prevFields,
          [field.name]: field.multi ? defaultValue ? __FormBuilder.convertToArray(defaultValue) : [] : defaultValue ?? ""
        };
      default:
        throw new Error("Unknown field type");
    }
  }, {});
});
let _FormBuilder = __FormBuilder;
const FormBuilder = withHandleError(_FormBuilder);
export {
  Dropdown as D,
  FormBuilder as F,
  Option as O,
  SAFormBuilderFieldType as S,
  _FormBuilder as _,
  forwardRef as f
};
